// This file is auto-generated by @hey-api/openapi-ts
import * as z from 'zod';
export const zHealthResponseDto = z.object({
    status: z.string(),
    release: z.string(),
    uptime: z.number().gte(0)
});
export const zReadinessResponseDto = z.object({
    status: z.enum(['ready', 'degraded']),
    dependencies: z.array(z.object({
        name: z.string(),
        status: z.enum(['up', 'down']),
        latencyMs: z.number().gte(0).optional()
    }))
});
export const zStartGenerationDto = z.object({
    rows: z.array(z.object({
        course: z.string().min(3).max(120),
        module: z.string().min(3).max(120),
        courseSlug: z.string().min(1).max(80).optional(),
        moduleSlug: z.string().min(1).max(80).optional(),
        subject: z.enum([
            'MARKETING',
            'FINANCE',
            'STRATEGY',
            'LEADERSHIP',
            'SALES',
            'NEGOTIATION',
            'ENTREPRENEURSHIP',
            'PUBLIC_SPEAKING',
            'COMMUNICATION',
            'OPERATIONS',
            'DECISIONS',
            'BUSINESS_FUNDAMENTALS',
            'TEAM_MANAGEMENT',
            'HIRING',
            'ORGANIZATIONAL_BEHAVIOR',
            'PRODUCT_MANAGEMENT',
            'AI',
            'INNOVATION',
            'PROJECT_MANAGEMENT',
            'BUSINESS_ANALYTICS',
            'CAREER',
            'PERSONAL_FINANCE',
            'ECONOMICS'
        ]).optional(),
        source: z.string().max(500).optional(),
        description: z.string().max(1000).optional(),
        difficulty: z.enum([
            'BEGINNER',
            'INTERMEDIATE',
            'ADVANCED'
        ]).optional(),
        story: z.object({
            text: z.string().min(1).max(50000).optional(),
            revision: z.int().gte(1).lte(9007199254740991),
            notes: z.string().min(1).max(2000).optional(),
            figures: z.array(z.string().min(1).max(200)).min(1).max(12).optional(),
            facts: z.array(z.string().min(1).max(500)).min(1).max(30).optional()
        }).optional(),
        cast: z.array(z.object({
            id: z.string().min(1).max(64),
            character: z.enum([
                'betty',
                'david',
                'rosa',
                'kofi',
                'priya',
                'sam',
                'noor',
                'tomi',
                'biscuit',
                'bolt'
            ]).optional(),
            name: z.string().min(1).max(60).optional(),
            part: z.enum(['lead', 'supporting']),
            role: z.string().min(1).max(60),
            goal: z.string().max(500).optional().default(''),
            constraint: z.string().max(500).optional().default(''),
            relationship: z.string().max(500).optional().default(''),
            continuity: z.array(z.string().min(1).max(200)).max(10).optional().default([])
        })).min(1).max(3).optional(),
        lessons: z.array(z.object({
            title: z.string().min(3).max(120),
            summary: z.string().max(1000).optional(),
            source: z.string().max(500).optional(),
            curriculumLessonId: z.string().min(1).max(64).optional(),
            brief: z.string().max(4000).optional(),
            sources: z.array(z.object({
                title: z.string().min(1).max(500),
                citation: z.string().max(500)
            })).max(5).optional(),
            storyBeat: z.string().max(10000).optional(),
            cast: z.array(z.string().min(1).max(64)).max(3).optional()
        })).min(1).max(20).optional()
    })).min(1).max(50),
    priority: z.enum(['NORMAL', 'HIGH']).optional(),
    fileName: z.string().min(1).max(255).optional()
});
export const zGenerationDetailDtoOutput = z.object({
    id: z.string().min(1),
    kind: z.enum([
        'INGEST',
        'REGENERATE',
        'VERIFY',
        'REVIEW'
    ]),
    priority: z.enum(['NORMAL', 'HIGH']),
    status: z.enum([
        'QUEUED',
        'RUNNING',
        'REVIEWING',
        'SUCCEEDED',
        'PARTIAL',
        'FAILED',
        'CANCELLED'
    ]),
    planner: z.string().min(1),
    skillSet: z.array(z.string().min(1)),
    skillDigest: z.string().min(1),
    reviewerSkillSet: z.array(z.string().min(1)),
    reviewerSkillDigest: z.string().min(1),
    editorSkillSet: z.array(z.string().min(1)),
    editorSkillDigest: z.string().min(1),
    rowsTotal: z.int().gte(0).lte(9007199254740991),
    rowsSucceeded: z.int().gte(0).lte(9007199254740991),
    label: z.string().min(1),
    modules: z.array(z.string().min(1)),
    fileName: z.string().min(1).optional(),
    queuedBy: z.string().min(1).optional(),
    research: z.boolean(),
    lessons: z.object({
        total: z.int().gte(0).lte(9007199254740991),
        pending: z.int().gte(0).lte(9007199254740991),
        running: z.int().gte(0).lte(9007199254740991),
        succeeded: z.int().gte(0).lte(9007199254740991),
        partial: z.int().gte(0).lte(9007199254740991),
        failed: z.int().gte(0).lte(9007199254740991),
        skipped: z.int().gte(0).lte(9007199254740991)
    }),
    startedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).optional(),
    finishedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).optional(),
    error: z.string().optional(),
    createdAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
    rows: z.array(z.object({
        id: z.string().min(1),
        position: z.int().gte(0).lte(9007199254740991),
        kind: z.enum([
            'MODULE',
            'RESEARCH',
            'PLAN',
            'LESSON',
            'REVIEW',
            'SCENE',
            'VERIFY'
        ]),
        courseSlug: z.string().min(1),
        moduleSlug: z.string().min(1),
        lessonTitle: z.string().optional(),
        status: z.enum([
            'PENDING',
            'RUNNING',
            'SUCCEEDED',
            'PARTIAL',
            'FAILED',
            'SKIPPED'
        ]),
        collectionId: z.string().optional(),
        error: z.string().optional(),
        changes: z.object({
            changes: z.array(z.object({
                field: z.string(),
                before: z.string(),
                after: z.string()
            })),
            rationale: z.string().optional()
        }).optional(),
        planned: z.int().gte(0).lte(9007199254740991).optional(),
        completed: z.int().gte(0).lte(9007199254740991),
        writing: z.string().optional(),
        attempts: z.int().gte(0).lte(9007199254740991),
        lessonId: z.string().min(1).max(64).optional(),
        stage: z.enum([
            'READING_PLAN',
            'WRITING_SCENES',
            'ILLUSTRATING',
            'REVIEWING',
            'REVISING',
            'RECHECKING',
            'SAVING',
            'READING_CONTENT',
            'IDENTIFYING_CLAIMS',
            'ACCESSING_SOURCES',
            'COMPARING_EVIDENCE',
            'CHECKING_QUALITY',
            'PREPARING_FINDINGS'
        ]).optional(),
        activity: z.enum([
            'WORKING',
            'RETRYING',
            'BLOCKED'
        ]).optional(),
        activityReason: z.string().optional(),
        progressAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).optional(),
        startedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).optional(),
        finishedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).optional(),
        calls: z.array(z.object({
            tool: z.string().min(1),
            input: z.string(),
            failed: z.string().optional()
        })).optional()
    })),
    units: z.object({
        total: z.int().gte(0).lte(9007199254740991),
        pending: z.int().gte(0).lte(9007199254740991),
        running: z.int().gte(0).lte(9007199254740991),
        succeeded: z.int().gte(0).lte(9007199254740991),
        partial: z.int().gte(0).lte(9007199254740991),
        failed: z.int().gte(0).lte(9007199254740991),
        skipped: z.int().gte(0).lte(9007199254740991)
    }),
    reviews: z.object({
        total: z.int().gte(0).lte(9007199254740991),
        pending: z.int().gte(0).lte(9007199254740991),
        running: z.int().gte(0).lte(9007199254740991),
        succeeded: z.int().gte(0).lte(9007199254740991),
        partial: z.int().gte(0).lte(9007199254740991),
        failed: z.int().gte(0).lte(9007199254740991),
        skipped: z.int().gte(0).lte(9007199254740991)
    }),
    waitingOn: z.object({
        id: z.string().min(1),
        label: z.string().min(1)
    }).optional(),
    pausedUntil: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).optional(),
    current: z.object({
        rowId: z.string().min(1),
        kind: z.enum([
            'MODULE',
            'RESEARCH',
            'PLAN',
            'LESSON',
            'REVIEW',
            'SCENE',
            'VERIFY'
        ]),
        stage: z.enum([
            'READING_PLAN',
            'WRITING_SCENES',
            'ILLUSTRATING',
            'REVIEWING',
            'REVISING',
            'RECHECKING',
            'SAVING',
            'READING_CONTENT',
            'IDENTIFYING_CLAIMS',
            'ACCESSING_SOURCES',
            'COMPARING_EVIDENCE',
            'CHECKING_QUALITY',
            'PREPARING_FINDINGS'
        ]).optional(),
        lessonId: z.string().min(1).max(64).optional(),
        lessonName: z.string().min(1).optional(),
        activity: z.enum([
            'WORKING',
            'RETRYING',
            'BLOCKED'
        ]),
        activityReason: z.string().optional(),
        startedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).optional(),
        progressAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).optional()
    }).optional(),
    progressAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).optional(),
    completedLessons: z.array(z.object({
        rowId: z.string().min(1),
        lessonId: z.string().min(1).max(64).optional(),
        name: z.string().min(1),
        picturesPending: z.int().gte(1).lte(9007199254740991).optional()
    })),
    failedLessons: z.array(z.object({
        rowId: z.string().min(1),
        lessonId: z.string().min(1).max(64).optional(),
        name: z.string().min(1),
        picturesPending: z.int().gte(1).lte(9007199254740991).optional()
    })),
    remainingLessons: z.array(z.object({
        rowId: z.string().min(1),
        lessonId: z.string().min(1).max(64).optional(),
        name: z.string().min(1),
        picturesPending: z.int().gte(1).lte(9007199254740991).optional()
    })),
    pictures: z.array(z.object({
        moduleSlug: z.string().min(1),
        pending: z.boolean(),
        requested: z.int().gte(0).lte(9007199254740991),
        received: z.int().gte(0).lte(9007199254740991),
        batchUsd: z.number().gte(0),
        standardUsd: z.number().gte(0),
        redrawn: z.int().gte(0).lte(9007199254740991),
        overbilled: z.boolean(),
        missing: z.array(z.string().min(1)),
        findings: z.array(z.string().min(1))
    }))
});
export const zProblemDocumentDto = z.object({
    type: z.string().regex(/^[A-Z][A-Z0-9_]*$/),
    title: z.string(),
    status: z.int().gte(400).lte(599),
    detail: z.string(),
    instance: z.string(),
    details: z.array(z.object({
        path: z.string(),
        message: z.string()
    })).optional(),
    retryable: z.boolean(),
    resetAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).optional()
});
export const zExistingSlugsDto = z.object({
    slugs: z.array(z.string().min(1).max(200).regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/)).min(1).max(100)
});
export const zExistingCollectionsDtoOutput = z.object({
    collections: z.array(z.object({
        slug: z.string().min(1).max(200).regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/),
        title: z.string(),
        status: z.enum([
            'DRAFT',
            'PUBLISHED',
            'ARCHIVED'
        ])
    }))
});
export const zRegenerateDto = z.object({
    target: z.union([
        z.object({
            targetType: z.string(),
            lessonId: z.string().min(1),
            sceneId: z.string().min(1)
        }),
        z.object({
            targetType: z.string(),
            sceneId: z.string().min(1),
            questionId: z.string().min(1)
        }),
        z.object({
            targetType: z.string(),
            sceneId: z.string().min(1),
            questionId: z.string().min(1)
        }),
        z.object({
            targetType: z.string(),
            lessonId: z.string().min(1),
            sceneId: z.string().min(1),
            itemId: z.string().min(1)
        }),
        z.object({
            targetType: z.string(),
            lessonId: z.string().min(1)
        })
    ]),
    instruction: z.string().min(1).max(500)
});
export const zGenerationListDtoOutput = z.object({
    jobs: z.array(z.object({
        id: z.string().min(1),
        kind: z.enum([
            'INGEST',
            'REGENERATE',
            'VERIFY',
            'REVIEW'
        ]),
        priority: z.enum(['NORMAL', 'HIGH']),
        status: z.enum([
            'QUEUED',
            'RUNNING',
            'REVIEWING',
            'SUCCEEDED',
            'PARTIAL',
            'FAILED',
            'CANCELLED'
        ]),
        planner: z.string().min(1),
        skillSet: z.array(z.string().min(1)),
        skillDigest: z.string().min(1),
        reviewerSkillSet: z.array(z.string().min(1)),
        reviewerSkillDigest: z.string().min(1),
        editorSkillSet: z.array(z.string().min(1)),
        editorSkillDigest: z.string().min(1),
        rowsTotal: z.int().gte(0).lte(9007199254740991),
        rowsSucceeded: z.int().gte(0).lte(9007199254740991),
        label: z.string().min(1),
        modules: z.array(z.string().min(1)),
        fileName: z.string().min(1).optional(),
        queuedBy: z.string().min(1).optional(),
        research: z.boolean(),
        lessons: z.object({
            total: z.int().gte(0).lte(9007199254740991),
            pending: z.int().gte(0).lte(9007199254740991),
            running: z.int().gte(0).lte(9007199254740991),
            succeeded: z.int().gte(0).lte(9007199254740991),
            partial: z.int().gte(0).lte(9007199254740991),
            failed: z.int().gte(0).lte(9007199254740991),
            skipped: z.int().gte(0).lte(9007199254740991)
        }),
        startedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).optional(),
        finishedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).optional(),
        error: z.string().optional(),
        createdAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
        mine: z.boolean()
    })),
    pausedUntil: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).optional(),
    plannerNext: z.string().min(1),
    plannerDeclined: z.string().min(1).optional()
});
export const zRetriedDtoOutput = z.object({
    retried: z.int().gte(0).lte(9007199254740991)
});
export const zDiscardedDtoOutput = z.object({
    restored: z.boolean()
});
export const zKeptDtoOutput = z.object({
    status: z.enum([
        'OPEN',
        'PROPOSED',
        'ACCEPTED',
        'DISMISSED',
        'SUPERSEDED'
    ])
});
export const zGenerationLedgerPageDtoOutput = z.object({
    rows: z.array(z.object({
        id: z.string(),
        createdAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
        lessonId: z.union([
            z.string(),
            z.unknown()
        ]),
        lessonSlug: z.string(),
        lessonTitle: z.string(),
        jobId: z.string(),
        rowId: z.string(),
        release: z.string(),
        research: z.boolean(),
        researcher: z.object({
            model: z.union([
                z.string(),
                z.unknown()
            ]),
            effort: z.union([
                z.string(),
                z.unknown()
            ]),
            path: z.union([
                z.enum(['claude-code', 'api']),
                z.unknown()
            ]),
            turns: z.int().gte(0).lte(9007199254740991)
        }),
        writer: z.object({
            model: z.union([
                z.string(),
                z.unknown()
            ]),
            effort: z.union([
                z.string(),
                z.unknown()
            ]),
            path: z.union([
                z.enum(['claude-code', 'api']),
                z.unknown()
            ]),
            turns: z.int().gte(0).lte(9007199254740991)
        }),
        reviewer: z.object({
            model: z.union([
                z.string(),
                z.unknown()
            ]),
            effort: z.union([
                z.string(),
                z.unknown()
            ]),
            path: z.union([
                z.enum(['claude-code', 'api']),
                z.unknown()
            ]),
            turns: z.int().gte(0).lte(9007199254740991)
        }),
        editor: z.object({
            model: z.union([
                z.string(),
                z.unknown()
            ]),
            effort: z.union([
                z.string(),
                z.unknown()
            ]),
            path: z.union([
                z.enum(['claude-code', 'api']),
                z.unknown()
            ]),
            turns: z.int().gte(0).lte(9007199254740991)
        }),
        lessonsReviewed: z.int().gte(1).lte(9007199254740991),
        qa: z.object({
            overall: z.int().gte(0).lte(100),
            status: z.enum([
                'PASSED',
                'NEEDS_REVIEW',
                'FAILED'
            ]),
            blockers: z.int().gte(0).lte(9007199254740991),
            scores: z.object({
                GROUNDING: z.int().gte(0).lte(100),
                COMPREHENSION: z.int().gte(0).lte(100),
                INSTRUCTIONAL_DESIGN: z.int().gte(0).lte(100),
                MECHANICS: z.int().gte(0).lte(100),
                WRITING: z.int().gte(0).lte(100),
                RELEVANCE: z.int().gte(0).lte(100)
            })
        }),
        costs: z.object({
            GROUNDING: z.object({
                storyBudget: z.int().gte(0).lte(9007199254740991),
                readability: z.int().gte(0).lte(9007199254740991),
                coachVoice: z.int().gte(0).lte(9007199254740991),
                visuals: z.int().gte(0).lte(9007199254740991),
                cast: z.int().gte(0).lte(9007199254740991),
                model: z.int().gte(0).lte(9007199254740991)
            }),
            COMPREHENSION: z.object({
                storyBudget: z.int().gte(0).lte(9007199254740991),
                readability: z.int().gte(0).lte(9007199254740991),
                coachVoice: z.int().gte(0).lte(9007199254740991),
                visuals: z.int().gte(0).lte(9007199254740991),
                cast: z.int().gte(0).lte(9007199254740991),
                model: z.int().gte(0).lte(9007199254740991)
            }),
            INSTRUCTIONAL_DESIGN: z.object({
                storyBudget: z.int().gte(0).lte(9007199254740991),
                readability: z.int().gte(0).lte(9007199254740991),
                coachVoice: z.int().gte(0).lte(9007199254740991),
                visuals: z.int().gte(0).lte(9007199254740991),
                cast: z.int().gte(0).lte(9007199254740991),
                model: z.int().gte(0).lte(9007199254740991)
            }),
            MECHANICS: z.object({
                storyBudget: z.int().gte(0).lte(9007199254740991),
                readability: z.int().gte(0).lte(9007199254740991),
                coachVoice: z.int().gte(0).lte(9007199254740991),
                visuals: z.int().gte(0).lte(9007199254740991),
                cast: z.int().gte(0).lte(9007199254740991),
                model: z.int().gte(0).lte(9007199254740991)
            }),
            WRITING: z.object({
                storyBudget: z.int().gte(0).lte(9007199254740991),
                readability: z.int().gte(0).lte(9007199254740991),
                coachVoice: z.int().gte(0).lte(9007199254740991),
                visuals: z.int().gte(0).lte(9007199254740991),
                cast: z.int().gte(0).lte(9007199254740991),
                model: z.int().gte(0).lte(9007199254740991)
            }),
            RELEVANCE: z.object({
                storyBudget: z.int().gte(0).lte(9007199254740991),
                readability: z.int().gte(0).lte(9007199254740991),
                coachVoice: z.int().gte(0).lte(9007199254740991),
                visuals: z.int().gte(0).lte(9007199254740991),
                cast: z.int().gte(0).lte(9007199254740991),
                model: z.int().gte(0).lte(9007199254740991)
            })
        }),
        repairs: z.array(z.object({
            round: z.int().gte(1).lte(9007199254740991),
            fixed: z.int().gte(0).lte(9007199254740991),
            unresolved: z.int().gte(0).lte(9007199254740991),
            unsent: z.int().gte(0).lte(9007199254740991),
            failed: z.int().gte(0).lte(9007199254740991),
            disputed: z.int().gte(0).lte(9007199254740991),
            new: z.int().gte(0).lte(9007199254740991)
        })),
        minutes: z.number().gte(0),
        waitedMs: z.int().gte(0).lte(9007199254740991)
    })),
    total: z.int().gte(0).lte(9007199254740991),
    models: z.array(z.string())
});
export const zGenerationPatternsDtoOutput = z.object({
    days: z.int().gte(1).lte(9007199254740991),
    builds: z.int().gte(0).lte(9007199254740991),
    categories: z.array(z.object({
        category: z.enum([
            'GROUNDING',
            'COMPREHENSION',
            'INSTRUCTIONAL_DESIGN',
            'MECHANICS',
            'WRITING',
            'RELEVANCE'
        ]),
        below: z.int().gte(0).lte(9007199254740991),
        costliest: z.union([
            z.enum([
                'storyBudget',
                'readability',
                'coachVoice',
                'visuals',
                'cast',
                'model'
            ]),
            z.unknown()
        ]),
        costliestBuilds: z.int().gte(0).lte(9007199254740991)
    })),
    repairs: z.object({
        rounds: z.int().gte(0).lte(9007199254740991),
        newPerRound: z.number().gte(0),
        unsent: z.int().gte(0).lte(9007199254740991),
        failed: z.int().gte(0).lte(9007199254740991)
    }),
    models: z.array(z.object({
        writer: z.union([
            z.string(),
            z.unknown()
        ]),
        reviewer: z.union([
            z.string(),
            z.unknown()
        ]),
        builds: z.int().gte(0).lte(9007199254740991),
        medianQa: z.number()
    })),
    patterns: z.array(z.object({
        kind: z.enum([
            'category',
            'repairs',
            'models'
        ]),
        text: z.string(),
        proposal: z.union([
            z.string(),
            z.unknown()
        ])
    }))
});
export const zAskPlannerDto = z.object({
    turns: z.array(z.object({
        role: z.enum(['operator', 'planner']),
        text: z.string().min(1).max(4000)
    })).min(1).max(20),
    lessonIds: z.array(z.string().min(1)).min(1).max(8).optional(),
    collectionId: z.string().min(1).optional(),
    scene: z.object({
        lessonId: z.string().min(1),
        sceneId: z.string().min(1)
    }).optional(),
    onboarding: z.object({
        stepId: z.string().min(1).max(40)
    }).optional()
});
export const zPlannerAnswerDtoOutput = z.object({
    text: z.string().min(1),
    costUsd: z.number().gte(0),
    inputTokens: z.int().gte(0).lte(9007199254740991),
    outputTokens: z.int().gte(0).lte(9007199254740991),
    proposals: z.array(z.union([
        z.object({
            kind: z.string(),
            lessonId: z.string().min(1),
            body: z.object({
                title: z.string().min(3).max(120).optional(),
                summary: z.string().min(3).max(300).optional(),
                personas: z.array(z.object({
                    persona: z.enum([
                        'CAREER_STARTER',
                        'RISING_MANAGER',
                        'FUTURE_EXECUTIVE',
                        'FOUNDER_OWNER',
                        'EXPERIENCED_IC',
                        'CAREER_SWITCHER'
                    ]),
                    fit: z.enum([
                        'IDEAL',
                        'SUITABLE',
                        'STRETCH',
                        'UNSUITABLE'
                    ]).optional()
                })).max(6).optional(),
                tags: z.array(z.string().min(2).max(60).regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/)).max(12).optional()
            })
        }),
        z.object({
            kind: z.string(),
            lessonId: z.string().min(1),
            sceneId: z.string().min(1),
            body: z.object({
                prompt: z.string().min(3).max(400).optional(),
                body: z.string().max(2000).optional(),
                items: z.array(z.object({
                    id: z.string().min(1),
                    label: z.string().min(1).max(200)
                })).max(12).optional(),
                keys: z.array(z.object({
                    id: z.string().min(1),
                    isCorrect: z.boolean().optional(),
                    correctPosition: z.int().gte(1).lte(12).optional(),
                    correctAmount: z.number().gte(0).lte(1000000).optional(),
                    amountTolerance: z.number().gte(0).lte(1000000).optional()
                })).max(12).optional(),
                min: z.number().optional(),
                max: z.number().optional(),
                step: z.number().optional(),
                targetMin: z.number().optional(),
                targetMax: z.number().optional(),
                poolTotal: z.number().optional()
            })
        }),
        z.object({
            kind: z.string(),
            lessonId: z.string().min(1),
            questionId: z.string().min(1),
            body: z.object({
                explanation: z.string().min(3).max(1200)
            })
        }),
        z.object({
            kind: z.string(),
            lessonId: z.string().min(1),
            change: z.union([
                z.object({
                    op: z.string(),
                    scene: z.object({
                        kind: z.enum([
                            'HOOK',
                            'CONCEPT',
                            'CASE',
                            'ARTICLE',
                            'RECAP',
                            'CHOICE',
                            'RANK',
                            'BUCKET',
                            'SLIDER',
                            'ALLOCATE',
                            'SPEAK'
                        ]),
                        prompt: z.string().min(3).max(400),
                        body: z.string().max(2000).optional(),
                        bodyEnabled: z.boolean().optional(),
                        hint: z.string().max(600).optional(),
                        hintEnabled: z.boolean().optional(),
                        objectName: z.enum([
                            'balance',
                            'funnel',
                            'stack',
                            'bridge',
                            'steps',
                            'podium',
                            'chart',
                            'pie',
                            'gauge',
                            'magnifier',
                            'beaker',
                            'hourglass',
                            'calendar',
                            'clock',
                            'stopwatch',
                            'vault',
                            'wallet',
                            'receipt',
                            'calculator',
                            'ledger',
                            'compass',
                            'telescope',
                            'map',
                            'flag',
                            'chess',
                            'target',
                            'gavel',
                            'puzzle',
                            'team',
                            'network',
                            'roundtable',
                            'mic',
                            'iceberg',
                            'chat',
                            'gears',
                            'pipeline',
                            'crate',
                            'factory',
                            'server',
                            'spool',
                            'clipboard',
                            'tray',
                            'basket',
                            'folder',
                            'bin',
                            'lightbulb',
                            'rocket',
                            'key',
                            'trophy',
                            'briefcase'
                        ]).optional(),
                        maxSelections: z.int().gte(1).lte(8).optional(),
                        requireSubmit: z.boolean().optional(),
                        min: z.number().optional(),
                        max: z.number().optional(),
                        step: z.number().optional(),
                        unit: z.string().max(24).optional(),
                        targetMin: z.number().optional(),
                        targetMax: z.number().optional(),
                        poolTotal: z.number().optional(),
                        counterpartBrief: z.string().max(2000).optional(),
                        items: z.array(z.object({
                            position: z.int().gte(1).lte(12),
                            label: z.string().min(1).max(200),
                            imageUrl: z.url().optional(),
                            isCorrect: z.boolean().optional(),
                            correctPosition: z.int().gte(1).lte(12).optional(),
                            correctBucketId: z.string().min(1).optional(),
                            correctAmount: z.number().gte(0).lte(1000000).optional(),
                            amountTolerance: z.number().gte(0).lte(1000000).optional(),
                            feedback: z.string().min(3).max(190).optional()
                        })).max(12).optional(),
                        buckets: z.array(z.object({
                            position: z.int().gte(1).lte(4),
                            label: z.string().min(1).max(120)
                        })).max(4).optional()
                    }),
                    position: z.int().gte(1).lte(64).optional()
                }),
                z.object({
                    op: z.string(),
                    sceneId: z.string().min(1)
                }),
                z.object({
                    op: z.string(),
                    sceneId: z.string().min(1),
                    position: z.int().gte(1).lte(64)
                }),
                z.object({
                    op: z.string(),
                    sceneId: z.string().min(1),
                    scene: z.object({
                        kind: z.enum([
                            'HOOK',
                            'CONCEPT',
                            'CASE',
                            'ARTICLE',
                            'RECAP',
                            'CHOICE',
                            'RANK',
                            'BUCKET',
                            'SLIDER',
                            'ALLOCATE',
                            'SPEAK'
                        ]),
                        prompt: z.string().min(3).max(400),
                        body: z.string().max(2000).optional(),
                        bodyEnabled: z.boolean().optional(),
                        hint: z.string().max(600).optional(),
                        hintEnabled: z.boolean().optional(),
                        objectName: z.enum([
                            'balance',
                            'funnel',
                            'stack',
                            'bridge',
                            'steps',
                            'podium',
                            'chart',
                            'pie',
                            'gauge',
                            'magnifier',
                            'beaker',
                            'hourglass',
                            'calendar',
                            'clock',
                            'stopwatch',
                            'vault',
                            'wallet',
                            'receipt',
                            'calculator',
                            'ledger',
                            'compass',
                            'telescope',
                            'map',
                            'flag',
                            'chess',
                            'target',
                            'gavel',
                            'puzzle',
                            'team',
                            'network',
                            'roundtable',
                            'mic',
                            'iceberg',
                            'chat',
                            'gears',
                            'pipeline',
                            'crate',
                            'factory',
                            'server',
                            'spool',
                            'clipboard',
                            'tray',
                            'basket',
                            'folder',
                            'bin',
                            'lightbulb',
                            'rocket',
                            'key',
                            'trophy',
                            'briefcase'
                        ]).optional(),
                        maxSelections: z.int().gte(1).lte(8).optional(),
                        requireSubmit: z.boolean().optional(),
                        min: z.number().optional(),
                        max: z.number().optional(),
                        step: z.number().optional(),
                        unit: z.string().max(24).optional(),
                        targetMin: z.number().optional(),
                        targetMax: z.number().optional(),
                        poolTotal: z.number().optional(),
                        counterpartBrief: z.string().max(2000).optional(),
                        items: z.array(z.object({
                            position: z.int().gte(1).lte(12),
                            label: z.string().min(1).max(200),
                            imageUrl: z.url().optional(),
                            isCorrect: z.boolean().optional(),
                            correctPosition: z.int().gte(1).lte(12).optional(),
                            correctBucketId: z.string().min(1).optional(),
                            correctAmount: z.number().gte(0).lte(1000000).optional(),
                            amountTolerance: z.number().gte(0).lte(1000000).optional(),
                            feedback: z.string().min(3).max(190).optional()
                        })).max(12).optional(),
                        buckets: z.array(z.object({
                            position: z.int().gte(1).lte(4),
                            label: z.string().min(1).max(120)
                        })).max(4).optional()
                    })
                })
            ])
        }),
        z.object({
            kind: z.string(),
            key: z.string().max(80).regex(/^[A-Za-z0-9_.]+$/),
            text: z.string().min(1).max(300)
        }),
        z.object({
            kind: z.string(),
            stepId: z.string().min(1).max(40),
            body: z.object({
                name: z.string().min(1).max(300).optional(),
                title: z.string().min(1).max(300).optional(),
                body: z.string().min(1).max(300).optional(),
                button: z.string().min(1).max(300).optional(),
                skipLabel: z.string().min(1).max(300).optional()
            })
        })
    ])).max(16)
});
export const zCourseFilledDtoOutput = z.object({
    id: z.string().min(1),
    filled: z.array(z.enum([
        'title',
        'summary',
        'subject',
        'difficulty',
        'objectName'
    ]))
});
export const zFixSceneDto = z.object({
    lessonId: z.string().min(1),
    field: z.enum([
        'prompt',
        'body',
        'hint',
        'items',
        'explanation'
    ])
});
export const zSceneFixDtoOutput = z.object({
    field: z.enum([
        'prompt',
        'body',
        'hint',
        'items',
        'explanation'
    ]),
    changes: z.array(z.object({
        key: z.string(),
        before: z.string(),
        after: z.string()
    })),
    cleared: z.array(z.string()),
    remaining: z.array(z.object({
        field: z.string(),
        message: z.string(),
        fixable: z.boolean(),
        blocks: z.boolean()
    }))
});
export const zStartVerificationDto = z.object({
    lessonIds: z.array(z.string().min(1)).min(1).max(60)
});
export const zLessonVerificationsDtoOutput = z.object({
    verified: z.object({
        runId: z.string().min(1),
        lessonVersion: z.int().gte(1).lte(9007199254740991)
    }).optional(),
    runs: z.array(z.object({
        id: z.string().min(1),
        jobId: z.string().min(1).optional(),
        lessonVersion: z.int().gte(1).lte(9007199254740991),
        fingerprint: z.string().min(1),
        passed: z.boolean(),
        current: z.boolean(),
        createdAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/)
    }))
});
export const zLessonSourceChecksDtoOutput = z.object({
    sources: z.array(z.object({
        title: z.string().min(1),
        url: z.string().min(1).optional(),
        type: z.enum([
            'ARTICLE',
            'RESEARCH',
            'LINK',
            'TEXT'
        ]),
        check: z.object({
            title: z.string().min(1),
            url: z.string().min(1),
            finalUrl: z.string().min(1).optional(),
            pageTitle: z.string().min(1).optional(),
            status: z.enum([
                'UNREACHABLE',
                'UNREADABLE',
                'UNJUDGED',
                'CHECKED'
            ]),
            failure: z.string().min(1).optional(),
            depth: z.enum([
                'FULL_TEXT',
                'PASSAGES',
                'ABSTRACT',
                'METADATA_ONLY'
            ]),
            claims: z.array(z.object({
                claim: z.string().min(1).max(300),
                scenes: z.array(z.int().gte(1).lte(9007199254740991)),
                verdict: z.enum([
                    'SUPPORTED',
                    'UNSUPPORTED',
                    'UNRESOLVED'
                ]),
                passage: z.string().min(1).optional(),
                blocking: z.boolean(),
                reason: z.string().min(1),
                proposal: z.union([
                    z.object({
                        kind: z.string(),
                        cite: z.object({
                            title: z.string().min(1),
                            url: z.string().min(1)
                        }),
                        reason: z.string().min(1)
                    }),
                    z.object({
                        kind: z.string(),
                        needs: z.string().min(1),
                        reason: z.string().min(1)
                    }),
                    z.object({
                        kind: z.string(),
                        passage: z.string().min(1),
                        reason: z.string().min(1)
                    })
                ]).optional()
            })),
            advisories: z.array(z.string().min(1)),
            current: z.boolean(),
            checkedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/)
        }).optional()
    }))
});
export const zCheckSourcesDto = z.object({
    url: z.string().min(1).optional(),
    claim: z.string().min(1).max(300).optional()
});
export const zJobVerificationsDtoOutput = z.object({
    guidance: z.array(z.object({
        name: z.string().min(1),
        digest: z.string().min(1).optional(),
        status: z.enum([
            'APPLIED',
            'NOT_RELEVANT',
            'UNAVAILABLE'
        ]),
        blocking: z.boolean(),
        affects: z.array(z.enum([
            'READING_CONTENT',
            'IDENTIFYING_CLAIMS',
            'ACCESSING_SOURCES',
            'COMPARING_EVIDENCE',
            'CHECKING_QUALITY'
        ])).optional()
    })),
    runs: z.array(z.object({
        id: z.string().min(1),
        jobId: z.string().min(1).optional(),
        lessonVersion: z.int().gte(1).lte(9007199254740991),
        fingerprint: z.string().min(1),
        passed: z.boolean(),
        current: z.boolean(),
        createdAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
        lessonId: z.string().min(1),
        lessonTitle: z.string().min(1)
    }))
});
export const zVerificationRunDtoOutput = z.object({
    scope: z.array(z.string().min(1)),
    checks: z.array(z.object({
        check: z.enum([
            'READING_CONTENT',
            'IDENTIFYING_CLAIMS',
            'ACCESSING_SOURCES',
            'COMPARING_EVIDENCE',
            'CHECKING_QUALITY'
        ]),
        completed: z.boolean(),
        reason: z.string().min(1).optional()
    })),
    sources: z.array(z.object({
        title: z.string().min(1),
        url: z.string().min(1).optional(),
        type: z.enum([
            'ARTICLE',
            'RESEARCH',
            'LINK',
            'TEXT'
        ]),
        original: z.boolean(),
        originalBasis: z.string().min(1),
        reached: z.boolean(),
        failure: z.string().min(1).optional(),
        depth: z.enum([
            'FULL_TEXT',
            'PASSAGES',
            'ABSTRACT',
            'METADATA_ONLY'
        ]),
        supported: z.array(z.string().min(1).max(300)),
        unsupported: z.array(z.string().min(1).max(300)),
        unresolved: z.array(z.string().min(1).max(300)),
        limitations: z.array(z.string().min(1)),
        replacement: z.string().min(1).optional()
    })),
    claims: z.array(z.string().min(1).max(300)),
    unsupported: z.array(z.string().min(1).max(300)),
    unresolved: z.array(z.string().min(1).max(300)),
    findings: z.array(z.object({
        targetType: z.enum([
            'COLLECTION',
            'LESSON',
            'SCENE',
            'QUESTION'
        ]),
        targetRef: z.string().min(1),
        severity: z.enum([
            'BLOCKER',
            'WARN',
            'NOTE'
        ]),
        category: z.enum([
            'GROUNDING',
            'COMPREHENSION',
            'INSTRUCTIONAL_DESIGN',
            'MECHANICS',
            'WRITING',
            'RELEVANCE'
        ]).optional(),
        finding: z.string().min(1).max(300),
        suggestion: z.string().min(1).max(300),
        raisedBy: z.union([
            z.enum([
                'REVIEWER',
                'JEV_LABELS',
                'JEV_CLAIMS',
                'JEV_RUBRIC'
            ]),
            z.unknown()
        ])
    })),
    manualReview: z.array(z.string().min(1)),
    limitations: z.array(z.string().min(1)),
    guidance: z.array(z.object({
        name: z.string().min(1),
        digest: z.string().min(1).optional(),
        status: z.enum([
            'APPLIED',
            'NOT_RELEVANT',
            'UNAVAILABLE'
        ]),
        blocking: z.boolean(),
        affects: z.array(z.enum([
            'READING_CONTENT',
            'IDENTIFYING_CLAIMS',
            'ACCESSING_SOURCES',
            'COMPARING_EVIDENCE',
            'CHECKING_QUALITY'
        ])).optional()
    })),
    id: z.string().min(1),
    lessonId: z.string().min(1),
    jobId: z.string().min(1).optional(),
    lessonVersion: z.int().gte(1).lte(9007199254740991),
    fingerprint: z.string().min(1),
    passed: z.boolean(),
    current: z.boolean(),
    createdAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/)
});
export const zLessonFixesDtoOutput = z.object({
    fixes: z.array(z.object({
        id: z.string().min(1),
        lessonId: z.string().min(1),
        status: z.enum([
            'PROPOSED',
            'FAILED',
            'RESOLVED',
            'UNRESOLVED',
            'REVERTED',
            'DISCARDED'
        ]),
        finding: z.object({
            kind: z.enum([
                'LESSON',
                'SCENE',
                'SOURCE'
            ]),
            findingId: z.string().min(1).optional(),
            severity: z.enum([
                'BLOCKER',
                'WARN',
                'NOTE'
            ]),
            finding: z.string().min(1),
            suggestion: z.string().min(1),
            position: z.int().gte(1).lte(9007199254740991).optional(),
            url: z.string().min(1).optional(),
            claim: z.string().min(1).optional()
        }),
        why: z.string().min(1).optional(),
        title: z.object({
            before: z.string(),
            after: z.string()
        }).optional(),
        summary: z.object({
            before: z.string(),
            after: z.string()
        }).optional(),
        scenes: z.array(z.object({
            position: z.int().gte(1).lte(9007199254740991),
            from: z.int().gte(1).lte(9007199254740991).optional(),
            change: z.enum([
                'UNCHANGED',
                'REWRITTEN',
                'ADDED'
            ]),
            changes: z.array(z.object({
                field: z.string(),
                before: z.string(),
                after: z.string()
            })).optional(),
            source: z.object({
                before: z.union([
                    z.string(),
                    z.unknown()
                ]),
                after: z.union([
                    z.string(),
                    z.unknown()
                ])
            }).optional()
        })),
        removed: z.array(z.int().gte(1).lte(9007199254740991)),
        sources: z.object({
            added: z.array(z.object({
                title: z.string().min(1),
                url: z.string().min(1)
            })),
            removed: z.array(z.object({
                title: z.string().min(1),
                url: z.string().min(1)
            }))
        }),
        claim: z.union([
            z.string().min(1),
            z.unknown()
        ]).optional(),
        rechecked: z.array(z.enum([
            'REVIEWER',
            'CLAIMS',
            'LABELS',
            'RUBRIC',
            'RULES',
            'SOURCES'
        ])).optional(),
        remaining: z.array(z.string().min(1)),
        nextStep: z.string().min(1).optional(),
        createdAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
        appliedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).optional(),
        revertedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).optional()
    }))
});
export const zRequestFixDto = z.object({
    findingId: z.string().min(1).optional(),
    source: z.object({
        url: z.string().min(1),
        claim: z.string().min(1).max(300)
    }).optional()
});
export const zLessonFixDtoOutput = z.object({
    id: z.string().min(1),
    lessonId: z.string().min(1),
    status: z.enum([
        'PROPOSED',
        'FAILED',
        'RESOLVED',
        'UNRESOLVED',
        'REVERTED',
        'DISCARDED'
    ]),
    finding: z.object({
        kind: z.enum([
            'LESSON',
            'SCENE',
            'SOURCE'
        ]),
        findingId: z.string().min(1).optional(),
        severity: z.enum([
            'BLOCKER',
            'WARN',
            'NOTE'
        ]),
        finding: z.string().min(1),
        suggestion: z.string().min(1),
        position: z.int().gte(1).lte(9007199254740991).optional(),
        url: z.string().min(1).optional(),
        claim: z.string().min(1).optional()
    }),
    why: z.string().min(1).optional(),
    title: z.object({
        before: z.string(),
        after: z.string()
    }).optional(),
    summary: z.object({
        before: z.string(),
        after: z.string()
    }).optional(),
    scenes: z.array(z.object({
        position: z.int().gte(1).lte(9007199254740991),
        from: z.int().gte(1).lte(9007199254740991).optional(),
        change: z.enum([
            'UNCHANGED',
            'REWRITTEN',
            'ADDED'
        ]),
        changes: z.array(z.object({
            field: z.string(),
            before: z.string(),
            after: z.string()
        })).optional(),
        source: z.object({
            before: z.union([
                z.string(),
                z.unknown()
            ]),
            after: z.union([
                z.string(),
                z.unknown()
            ])
        }).optional()
    })),
    removed: z.array(z.int().gte(1).lte(9007199254740991)),
    sources: z.object({
        added: z.array(z.object({
            title: z.string().min(1),
            url: z.string().min(1)
        })),
        removed: z.array(z.object({
            title: z.string().min(1),
            url: z.string().min(1)
        }))
    }),
    claim: z.union([
        z.string().min(1),
        z.unknown()
    ]).optional(),
    rechecked: z.array(z.enum([
        'REVIEWER',
        'CLAIMS',
        'LABELS',
        'RUBRIC',
        'RULES',
        'SOURCES'
    ])).optional(),
    remaining: z.array(z.string().min(1)),
    nextStep: z.string().min(1).optional(),
    createdAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
    appliedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).optional(),
    revertedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).optional()
});
export const zLessonReviewsDtoOutput = z.object({
    outOfDate: z.boolean(),
    reviewing: z.string().min(1).optional(),
    reviews: z.array(z.object({
        versionId: z.string().min(1),
        jobId: z.string().min(1),
        reviewedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
        findings: z.array(z.object({
            id: z.string().min(1),
            targetType: z.enum([
                'COLLECTION',
                'LESSON',
                'SCENE',
                'QUESTION'
            ]),
            targetId: z.string().min(1),
            severity: z.enum([
                'BLOCKER',
                'WARN',
                'NOTE'
            ]),
            category: z.enum([
                'GROUNDING',
                'COMPREHENSION',
                'INSTRUCTIONAL_DESIGN',
                'MECHANICS',
                'WRITING',
                'RELEVANCE'
            ]).optional(),
            finding: z.string().min(1),
            suggestion: z.string().min(1),
            status: z.enum([
                'OPEN',
                'PROPOSED',
                'ACCEPTED',
                'DISMISSED',
                'SUPERSEDED'
            ]),
            appliedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).optional(),
            revertedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).optional(),
            changes: z.object({
                changes: z.array(z.object({
                    field: z.string(),
                    before: z.string(),
                    after: z.string()
                })),
                rationale: z.string().optional()
            }).optional(),
            editorNote: z.string().optional(),
            outcome: z.enum([
                'FIXED',
                'UNRESOLVED',
                'DISPUTED',
                'NEW'
            ]).optional(),
            lessonVersionId: z.string().optional(),
            recheckedVersionId: z.string().optional(),
            createdAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/)
        }))
    }))
});
export const zGenerationPromptDtoOutput = z.object({
    digest: z.string(),
    text: z.string()
});
export const zSystemPromptsDtoOutput = z.object({
    agents: z.array(z.object({
        agent: z.enum([
            'plan',
            'outline',
            'review',
            'edit',
            'fix',
            'fix-visual',
            'recast',
            'draft-story',
            'course-write',
            'course-review',
            'chat',
            'illustrate',
            'tutor',
            'tutor-check',
            'consultant',
            'train-brief',
            'train-audit',
            'train-suggest',
            'train-twist',
            'counterpart',
            'debrief',
            'train-help'
        ]),
        label: z.string(),
        group: z.enum([
            'lessons',
            'modules',
            'collections',
            'images',
            'learner'
        ]),
        usedIn: z.string(),
        skills: z.array(z.string()),
        digest: z.string(),
        taskRules: z.array(z.string()).optional(),
        perRequest: z.string().optional(),
        preset: z.object({
            characters: z.int().lte(9007199254740991),
            claudeCode: z.string()
        }).optional()
    })),
    answerRule: z.string(),
    texts: z.array(z.object({
        digest: z.string(),
        text: z.string()
    }))
});
export const zVisualFixesDtoOutput = z.object({
    fixes: z.array(z.object({
        id: z.string().min(1),
        lessonId: z.string().min(1),
        sceneId: z.string().min(1),
        position: z.int().gte(1).lte(9007199254740991),
        request: z.string(),
        status: z.enum([
            'PROPOSED',
            'APPLIED',
            'REVERTED',
            'DISCARDED'
        ]),
        why: z.string(),
        changes: z.array(z.object({
            field: z.string(),
            before: z.string(),
            after: z.string()
        })),
        createdAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
        appliedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).optional(),
        revertedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).optional()
    }))
});
export const zRequestVisualFixDto = z.object({
    lessonId: z.string().min(1),
    request: z.string().min(1).max(300)
});
export const zVisualFixDtoOutput = z.object({
    id: z.string().min(1),
    lessonId: z.string().min(1),
    sceneId: z.string().min(1),
    position: z.int().gte(1).lte(9007199254740991),
    request: z.string(),
    status: z.enum([
        'PROPOSED',
        'APPLIED',
        'REVERTED',
        'DISCARDED'
    ]),
    why: z.string(),
    changes: z.array(z.object({
        field: z.string(),
        before: z.string(),
        after: z.string()
    })),
    createdAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
    appliedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).optional(),
    revertedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).optional()
});
export const zCollectionPageDtoOutput = z.object({
    items: z.array(z.object({
        slug: z.string().min(1).max(200).regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/),
        title: z.string().min(1).max(120),
        summary: z.string().min(1).max(300),
        difficulty: z.enum([
            'BEGINNER',
            'INTERMEDIATE',
            'ADVANCED'
        ]).optional(),
        objectName: z.enum([
            'balance',
            'funnel',
            'stack',
            'bridge',
            'steps',
            'podium',
            'chart',
            'pie',
            'gauge',
            'magnifier',
            'beaker',
            'hourglass',
            'calendar',
            'clock',
            'stopwatch',
            'vault',
            'wallet',
            'receipt',
            'calculator',
            'ledger',
            'compass',
            'telescope',
            'map',
            'flag',
            'chess',
            'target',
            'gavel',
            'puzzle',
            'team',
            'network',
            'roundtable',
            'mic',
            'iceberg',
            'chat',
            'gears',
            'pipeline',
            'crate',
            'factory',
            'server',
            'spool',
            'clipboard',
            'tray',
            'basket',
            'folder',
            'bin',
            'lightbulb',
            'rocket',
            'key',
            'trophy',
            'briefcase'
        ]).optional(),
        id: z.string().min(1),
        kind: z.enum([
            'COURSE',
            'MODULE',
            'PATH'
        ]),
        subject: z.enum([
            'MARKETING',
            'FINANCE',
            'STRATEGY',
            'LEADERSHIP',
            'SALES',
            'NEGOTIATION',
            'ENTREPRENEURSHIP',
            'PUBLIC_SPEAKING',
            'COMMUNICATION',
            'OPERATIONS',
            'DECISIONS',
            'BUSINESS_FUNDAMENTALS',
            'TEAM_MANAGEMENT',
            'HIRING',
            'ORGANIZATIONAL_BEHAVIOR',
            'PRODUCT_MANAGEMENT',
            'AI',
            'INNOVATION',
            'PROJECT_MANAGEMENT',
            'BUSINESS_ANALYTICS',
            'CAREER',
            'PERSONAL_FINANCE',
            'ECONOMICS'
        ]).optional(),
        imageUrl: z.url().optional(),
        palette: z.object({
            primary: z.string().regex(/^#[0-9a-f]{6}$/),
            secondary: z.string().regex(/^#[0-9a-f]{6}$/)
        }).optional(),
        lessonCount: z.int().gte(0).lte(9007199254740991)
    })),
    nextCursor: z.union([
        z.string().min(1),
        z.unknown()
    ])
});
export const zCollectionDetailDtoOutput = z.object({
    slug: z.string().min(1).max(200).regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/),
    title: z.string().min(1).max(120),
    summary: z.string().min(1).max(300),
    difficulty: z.enum([
        'BEGINNER',
        'INTERMEDIATE',
        'ADVANCED'
    ]).optional(),
    objectName: z.enum([
        'balance',
        'funnel',
        'stack',
        'bridge',
        'steps',
        'podium',
        'chart',
        'pie',
        'gauge',
        'magnifier',
        'beaker',
        'hourglass',
        'calendar',
        'clock',
        'stopwatch',
        'vault',
        'wallet',
        'receipt',
        'calculator',
        'ledger',
        'compass',
        'telescope',
        'map',
        'flag',
        'chess',
        'target',
        'gavel',
        'puzzle',
        'team',
        'network',
        'roundtable',
        'mic',
        'iceberg',
        'chat',
        'gears',
        'pipeline',
        'crate',
        'factory',
        'server',
        'spool',
        'clipboard',
        'tray',
        'basket',
        'folder',
        'bin',
        'lightbulb',
        'rocket',
        'key',
        'trophy',
        'briefcase'
    ]).optional(),
    id: z.string().min(1),
    kind: z.enum([
        'COURSE',
        'MODULE',
        'PATH'
    ]),
    subject: z.enum([
        'MARKETING',
        'FINANCE',
        'STRATEGY',
        'LEADERSHIP',
        'SALES',
        'NEGOTIATION',
        'ENTREPRENEURSHIP',
        'PUBLIC_SPEAKING',
        'COMMUNICATION',
        'OPERATIONS',
        'DECISIONS',
        'BUSINESS_FUNDAMENTALS',
        'TEAM_MANAGEMENT',
        'HIRING',
        'ORGANIZATIONAL_BEHAVIOR',
        'PRODUCT_MANAGEMENT',
        'AI',
        'INNOVATION',
        'PROJECT_MANAGEMENT',
        'BUSINESS_ANALYTICS',
        'CAREER',
        'PERSONAL_FINANCE',
        'ECONOMICS'
    ]).optional(),
    imageUrl: z.url().optional(),
    palette: z.object({
        primary: z.string().regex(/^#[0-9a-f]{6}$/),
        secondary: z.string().regex(/^#[0-9a-f]{6}$/)
    }).optional(),
    lessonCount: z.int().gte(0).lte(9007199254740991),
    children: z.array(z.object({
        slug: z.string().min(1).max(200).regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/),
        title: z.string().min(1).max(120),
        summary: z.string().min(1).max(300),
        difficulty: z.enum([
            'BEGINNER',
            'INTERMEDIATE',
            'ADVANCED'
        ]).optional(),
        objectName: z.enum([
            'balance',
            'funnel',
            'stack',
            'bridge',
            'steps',
            'podium',
            'chart',
            'pie',
            'gauge',
            'magnifier',
            'beaker',
            'hourglass',
            'calendar',
            'clock',
            'stopwatch',
            'vault',
            'wallet',
            'receipt',
            'calculator',
            'ledger',
            'compass',
            'telescope',
            'map',
            'flag',
            'chess',
            'target',
            'gavel',
            'puzzle',
            'team',
            'network',
            'roundtable',
            'mic',
            'iceberg',
            'chat',
            'gears',
            'pipeline',
            'crate',
            'factory',
            'server',
            'spool',
            'clipboard',
            'tray',
            'basket',
            'folder',
            'bin',
            'lightbulb',
            'rocket',
            'key',
            'trophy',
            'briefcase'
        ]).optional(),
        id: z.string().min(1),
        kind: z.enum([
            'COURSE',
            'MODULE',
            'PATH'
        ]),
        subject: z.enum([
            'MARKETING',
            'FINANCE',
            'STRATEGY',
            'LEADERSHIP',
            'SALES',
            'NEGOTIATION',
            'ENTREPRENEURSHIP',
            'PUBLIC_SPEAKING',
            'COMMUNICATION',
            'OPERATIONS',
            'DECISIONS',
            'BUSINESS_FUNDAMENTALS',
            'TEAM_MANAGEMENT',
            'HIRING',
            'ORGANIZATIONAL_BEHAVIOR',
            'PRODUCT_MANAGEMENT',
            'AI',
            'INNOVATION',
            'PROJECT_MANAGEMENT',
            'BUSINESS_ANALYTICS',
            'CAREER',
            'PERSONAL_FINANCE',
            'ECONOMICS'
        ]).optional(),
        imageUrl: z.url().optional(),
        palette: z.object({
            primary: z.string().regex(/^#[0-9a-f]{6}$/),
            secondary: z.string().regex(/^#[0-9a-f]{6}$/)
        }).optional(),
        lessonCount: z.int().gte(0).lte(9007199254740991),
        lessons: z.array(z.object({
            slug: z.string().min(1).max(200).regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/),
            title: z.string().min(1).max(120),
            summary: z.string().min(1).max(300),
            difficulty: z.enum([
                'BEGINNER',
                'INTERMEDIATE',
                'ADVANCED'
            ]).optional(),
            objectName: z.enum([
                'balance',
                'funnel',
                'stack',
                'bridge',
                'steps',
                'podium',
                'chart',
                'pie',
                'gauge',
                'magnifier',
                'beaker',
                'hourglass',
                'calendar',
                'clock',
                'stopwatch',
                'vault',
                'wallet',
                'receipt',
                'calculator',
                'ledger',
                'compass',
                'telescope',
                'map',
                'flag',
                'chess',
                'target',
                'gavel',
                'puzzle',
                'team',
                'network',
                'roundtable',
                'mic',
                'iceberg',
                'chat',
                'gears',
                'pipeline',
                'crate',
                'factory',
                'server',
                'spool',
                'clipboard',
                'tray',
                'basket',
                'folder',
                'bin',
                'lightbulb',
                'rocket',
                'key',
                'trophy',
                'briefcase'
            ]).optional(),
            id: z.string().min(1),
            format: z.enum([
                'STANDARD',
                'FLASHCARDS',
                'DRILL'
            ]),
            verb: z.enum([
                'decide',
                'allocate',
                'rank',
                'match',
                'predict',
                'diagnose',
                'negotiate',
                'rephrase',
                'pitch',
                'speak',
                'simulate'
            ]).optional(),
            estimatedMinutes: z.int().gte(1).lte(60),
            family: z.enum([
                'growth',
                'finance',
                'people'
            ]),
            palette: z.object({
                primary: z.string().regex(/^#[0-9a-f]{6}$/),
                secondary: z.string().regex(/^#[0-9a-f]{6}$/)
            }).optional()
        }))
    })),
    lessons: z.array(z.object({
        slug: z.string().min(1).max(200).regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/),
        title: z.string().min(1).max(120),
        summary: z.string().min(1).max(300),
        difficulty: z.enum([
            'BEGINNER',
            'INTERMEDIATE',
            'ADVANCED'
        ]).optional(),
        objectName: z.enum([
            'balance',
            'funnel',
            'stack',
            'bridge',
            'steps',
            'podium',
            'chart',
            'pie',
            'gauge',
            'magnifier',
            'beaker',
            'hourglass',
            'calendar',
            'clock',
            'stopwatch',
            'vault',
            'wallet',
            'receipt',
            'calculator',
            'ledger',
            'compass',
            'telescope',
            'map',
            'flag',
            'chess',
            'target',
            'gavel',
            'puzzle',
            'team',
            'network',
            'roundtable',
            'mic',
            'iceberg',
            'chat',
            'gears',
            'pipeline',
            'crate',
            'factory',
            'server',
            'spool',
            'clipboard',
            'tray',
            'basket',
            'folder',
            'bin',
            'lightbulb',
            'rocket',
            'key',
            'trophy',
            'briefcase'
        ]).optional(),
        id: z.string().min(1),
        format: z.enum([
            'STANDARD',
            'FLASHCARDS',
            'DRILL'
        ]),
        verb: z.enum([
            'decide',
            'allocate',
            'rank',
            'match',
            'predict',
            'diagnose',
            'negotiate',
            'rephrase',
            'pitch',
            'speak',
            'simulate'
        ]).optional(),
        estimatedMinutes: z.int().gte(1).lte(60),
        family: z.enum([
            'growth',
            'finance',
            'people'
        ]),
        palette: z.object({
            primary: z.string().regex(/^#[0-9a-f]{6}$/),
            secondary: z.string().regex(/^#[0-9a-f]{6}$/)
        }).optional()
    }))
});
export const zTopicsResponseDtoOutput = z.object({
    groups: z.array(z.object({
        id: z.enum([
            'BUSINESS',
            'PEOPLE',
            'PRODUCT',
            'PLANNING',
            'CAREER',
            'FINANCE'
        ]),
        topics: z.array(z.enum([
            'MARKETING',
            'FINANCE',
            'STRATEGY',
            'LEADERSHIP',
            'SALES',
            'NEGOTIATION',
            'ENTREPRENEURSHIP',
            'PUBLIC_SPEAKING',
            'COMMUNICATION',
            'OPERATIONS',
            'DECISIONS',
            'BUSINESS_FUNDAMENTALS',
            'TEAM_MANAGEMENT',
            'HIRING',
            'ORGANIZATIONAL_BEHAVIOR',
            'PRODUCT_MANAGEMENT',
            'AI',
            'INNOVATION',
            'PROJECT_MANAGEMENT',
            'BUSINESS_ANALYTICS',
            'CAREER',
            'PERSONAL_FINANCE',
            'ECONOMICS'
        ])).min(1)
    }))
});
export const zLessonPageDtoOutput = z.object({
    items: z.array(z.object({
        slug: z.string().min(1).max(200).regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/),
        title: z.string().min(1).max(120),
        summary: z.string().min(1).max(300),
        difficulty: z.enum([
            'BEGINNER',
            'INTERMEDIATE',
            'ADVANCED'
        ]).optional(),
        objectName: z.enum([
            'balance',
            'funnel',
            'stack',
            'bridge',
            'steps',
            'podium',
            'chart',
            'pie',
            'gauge',
            'magnifier',
            'beaker',
            'hourglass',
            'calendar',
            'clock',
            'stopwatch',
            'vault',
            'wallet',
            'receipt',
            'calculator',
            'ledger',
            'compass',
            'telescope',
            'map',
            'flag',
            'chess',
            'target',
            'gavel',
            'puzzle',
            'team',
            'network',
            'roundtable',
            'mic',
            'iceberg',
            'chat',
            'gears',
            'pipeline',
            'crate',
            'factory',
            'server',
            'spool',
            'clipboard',
            'tray',
            'basket',
            'folder',
            'bin',
            'lightbulb',
            'rocket',
            'key',
            'trophy',
            'briefcase'
        ]).optional(),
        id: z.string().min(1),
        format: z.enum([
            'STANDARD',
            'FLASHCARDS',
            'DRILL'
        ]),
        verb: z.enum([
            'decide',
            'allocate',
            'rank',
            'match',
            'predict',
            'diagnose',
            'negotiate',
            'rephrase',
            'pitch',
            'speak',
            'simulate'
        ]).optional(),
        estimatedMinutes: z.int().gte(1).lte(60)
    })),
    nextCursor: z.union([
        z.string().min(1),
        z.unknown()
    ])
});
export const zLessonFilterDto = z.object({
    difficulty: z.enum([
        'BEGINNER',
        'INTERMEDIATE',
        'ADVANCED'
    ]).optional(),
    format: z.enum([
        'STANDARD',
        'FLASHCARDS',
        'DRILL'
    ]).optional(),
    collectionSlug: z.string().min(1).max(80).optional(),
    subject: z.enum([
        'MARKETING',
        'FINANCE',
        'STRATEGY',
        'LEADERSHIP',
        'SALES',
        'NEGOTIATION',
        'ENTREPRENEURSHIP',
        'PUBLIC_SPEAKING',
        'COMMUNICATION',
        'OPERATIONS',
        'DECISIONS',
        'BUSINESS_FUNDAMENTALS',
        'TEAM_MANAGEMENT',
        'HIRING',
        'ORGANIZATIONAL_BEHAVIOR',
        'PRODUCT_MANAGEMENT',
        'AI',
        'INNOVATION',
        'PROJECT_MANAGEMENT',
        'BUSINESS_ANALYTICS',
        'CAREER',
        'PERSONAL_FINANCE',
        'ECONOMICS'
    ]).optional(),
    sceneKind: z.enum([
        'HOOK',
        'CONCEPT',
        'CASE',
        'ARTICLE',
        'RECAP',
        'REWARD',
        'CHOICE',
        'RANK',
        'BUCKET',
        'SLIDER',
        'ALLOCATE',
        'SPEAK'
    ]).optional(),
    cursor: z.string().min(1).optional(),
    limit: z.int().gte(1).lte(100).optional().default(20)
});
export const zLessonDetailDtoOutput = z.object({
    slug: z.string().min(1).max(200).regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/),
    title: z.string().min(1).max(120),
    summary: z.string().min(1).max(300),
    difficulty: z.enum([
        'BEGINNER',
        'INTERMEDIATE',
        'ADVANCED'
    ]).optional(),
    objectName: z.enum([
        'balance',
        'funnel',
        'stack',
        'bridge',
        'steps',
        'podium',
        'chart',
        'pie',
        'gauge',
        'magnifier',
        'beaker',
        'hourglass',
        'calendar',
        'clock',
        'stopwatch',
        'vault',
        'wallet',
        'receipt',
        'calculator',
        'ledger',
        'compass',
        'telescope',
        'map',
        'flag',
        'chess',
        'target',
        'gavel',
        'puzzle',
        'team',
        'network',
        'roundtable',
        'mic',
        'iceberg',
        'chat',
        'gears',
        'pipeline',
        'crate',
        'factory',
        'server',
        'spool',
        'clipboard',
        'tray',
        'basket',
        'folder',
        'bin',
        'lightbulb',
        'rocket',
        'key',
        'trophy',
        'briefcase'
    ]).optional(),
    id: z.string().min(1),
    format: z.enum([
        'STANDARD',
        'FLASHCARDS',
        'DRILL'
    ]),
    verb: z.enum([
        'decide',
        'allocate',
        'rank',
        'match',
        'predict',
        'diagnose',
        'negotiate',
        'rephrase',
        'pitch',
        'speak',
        'simulate'
    ]).optional(),
    estimatedMinutes: z.int().gte(1).lte(60),
    family: z.enum([
        'growth',
        'finance',
        'people'
    ]),
    palette: z.object({
        primary: z.string().regex(/^#[0-9a-f]{6}$/),
        secondary: z.string().regex(/^#[0-9a-f]{6}$/)
    }).optional(),
    subject: z.enum([
        'MARKETING',
        'FINANCE',
        'STRATEGY',
        'LEADERSHIP',
        'SALES',
        'NEGOTIATION',
        'ENTREPRENEURSHIP',
        'PUBLIC_SPEAKING',
        'COMMUNICATION',
        'OPERATIONS',
        'DECISIONS',
        'BUSINESS_FUNDAMENTALS',
        'TEAM_MANAGEMENT',
        'HIRING',
        'ORGANIZATIONAL_BEHAVIOR',
        'PRODUCT_MANAGEMENT',
        'AI',
        'INNOVATION',
        'PROJECT_MANAGEMENT',
        'BUSINESS_ANALYTICS',
        'CAREER',
        'PERSONAL_FINANCE',
        'ECONOMICS'
    ]).optional(),
    scenes: z.array(z.union([
        z.object({
            id: z.string().min(1),
            position: z.int().gte(1).lte(9007199254740991),
            prompt: z.string().min(1).max(400),
            verb: z.enum([
                'decide',
                'allocate',
                'rank',
                'match',
                'predict',
                'diagnose',
                'negotiate',
                'rephrase',
                'pitch',
                'speak',
                'simulate'
            ]).optional(),
            rung: z.enum([
                'RECOGNIZE',
                'DECIDE',
                'MANIPULATE',
                'CREATE',
                'SPEAK',
                'APPLY',
                'SIMULATE'
            ]).optional(),
            timeLimitMs: z.int().gte(1000).lte(9007199254740991).optional(),
            visual: z.union([
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    max: z.number(),
                    rows: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        previous: z.number().optional(),
                        display: z.string().min(1).max(24)
                    })).min(1).max(4)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    figures: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.string().min(1).max(24),
                        tone: z.enum([
                            'default',
                            'up',
                            'down',
                            'accent',
                            'streak'
                        ]).optional()
                    })).min(2).max(4)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    shares: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.number().gte(0),
                        display: z.string().min(1).max(24).optional()
                    })).min(2).max(6)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    stages: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.number().gte(0),
                        display: z.string().min(1).max(24)
                    })).min(2).max(5)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    start: z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24)
                    }),
                    steps: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24)
                    })).min(1).max(5),
                    end: z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24)
                    })
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    max: z.number(),
                    min: z.number().optional(),
                    rows: z.array(z.object({
                        label: z.string().min(1).max(60),
                        before: z.number(),
                        after: z.number(),
                        beforeDisplay: z.string().min(1).max(24),
                        afterDisplay: z.string().min(1).max(24)
                    })).min(1).max(4)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    x: z.object({
                        label: z.string().min(1).max(60),
                        low: z.string().min(1).max(40),
                        high: z.string().min(1).max(40)
                    }),
                    y: z.object({
                        label: z.string().min(1).max(60),
                        low: z.string().min(1).max(40),
                        high: z.string().min(1).max(40)
                    }),
                    quadrants: z.tuple([
                        z.string().min(1).max(40),
                        z.string().min(1).max(40),
                        z.string().min(1).max(40),
                        z.string().min(1).max(40)
                    ]).optional(),
                    items: z.array(z.object({
                        label: z.string().min(1).max(60),
                        x: z.number().gte(0).lte(1),
                        y: z.number().gte(0).lte(1)
                    })).min(1).max(4)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    steps: z.array(z.object({
                        label: z.string().min(1).max(60),
                        note: z.string().min(1).max(80).optional()
                    })).min(2).max(5)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    at: z.array(z.string().min(1).max(16)).min(2).max(8),
                    min: z.number(),
                    max: z.number(),
                    series: z.array(z.object({
                        label: z.string().min(1).max(60),
                        values: z.array(z.number()).min(2).max(8),
                        display: z.string().min(1).max(24)
                    })).min(1).max(6)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    columns: z.array(z.string().min(1).max(40)).min(2).max(3),
                    rows: z.array(z.object({
                        label: z.string().min(1).max(60),
                        cells: z.array(z.string().min(1).max(40)).max(3)
                    })).min(2).max(6)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    left: z.object({
                        name: z.string().min(1).max(60),
                        you: z.boolean().optional(),
                        character: z.enum([
                            'betty',
                            'david',
                            'rosa',
                            'kofi',
                            'priya',
                            'sam',
                            'noor',
                            'tomi',
                            'biscuit',
                            'bolt'
                        ]).optional(),
                        pose: z.enum([
                            'sit',
                            'lean-in',
                            'arms-crossed',
                            'hand-on-chin',
                            'wave'
                        ]).optional(),
                        facing: z.enum(['left', 'right']).optional(),
                        slot: z.enum([
                            'left',
                            'center',
                            'right'
                        ]).optional(),
                        reaction: z.enum([
                            'happy',
                            'worried',
                            'thinking'
                        ]).optional()
                    }),
                    right: z.object({
                        name: z.string().min(1).max(60),
                        you: z.boolean().optional(),
                        character: z.enum([
                            'betty',
                            'david',
                            'rosa',
                            'kofi',
                            'priya',
                            'sam',
                            'noor',
                            'tomi',
                            'biscuit',
                            'bolt'
                        ]).optional(),
                        pose: z.enum([
                            'sit',
                            'lean-in',
                            'arms-crossed',
                            'hand-on-chin',
                            'wave'
                        ]).optional(),
                        facing: z.enum(['left', 'right']).optional(),
                        slot: z.enum([
                            'left',
                            'center',
                            'right'
                        ]).optional(),
                        reaction: z.enum([
                            'happy',
                            'worried',
                            'thinking'
                        ]).optional()
                    }),
                    lines: z.array(z.object({
                        by: z.enum(['left', 'right']),
                        text: z.string().min(1).max(80).optional(),
                        sound: z.enum([
                            'bark',
                            'whine',
                            'growl',
                            'pant',
                            'meow',
                            'purr',
                            'hiss'
                        ]).optional(),
                        mood: z.enum([
                            'happy',
                            'worried',
                            'thinking'
                        ]).optional(),
                        thought: z.boolean().optional()
                    })).min(1).max(4),
                    awaiting: z.enum(['left', 'right']).optional(),
                    props: z.array(z.string().max(40).regex(/^[a-z0-9]+(-[a-z0-9]+)*$/)).min(1).max(3).optional()
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    cast: z.array(z.object({
                        name: z.string().min(1).max(60),
                        you: z.boolean().optional(),
                        character: z.enum([
                            'betty',
                            'david',
                            'rosa',
                            'kofi',
                            'priya',
                            'sam',
                            'noor',
                            'tomi',
                            'biscuit',
                            'bolt'
                        ]).optional(),
                        pose: z.enum([
                            'sit',
                            'lean-in',
                            'arms-crossed',
                            'hand-on-chin',
                            'wave'
                        ]).optional(),
                        facing: z.enum(['left', 'right']).optional(),
                        slot: z.enum([
                            'left',
                            'center',
                            'right'
                        ]).optional(),
                        reaction: z.enum([
                            'happy',
                            'worried',
                            'thinking'
                        ]).optional(),
                        thought: z.string().min(1).max(80).optional()
                    })).min(1).max(3),
                    stakes: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.string().min(1).max(24),
                        tone: z.enum([
                            'default',
                            'up',
                            'down',
                            'accent',
                            'streak'
                        ]).optional()
                    })).min(1).max(4).optional(),
                    props: z.array(z.string().max(40).regex(/^[a-z0-9]+(-[a-z0-9]+)*$/)).min(1).max(3).optional()
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    left: z.object({
                        label: z.string().min(1).max(60),
                        gains: z.array(z.string().min(1).max(40)).min(1).max(3),
                        costs: z.array(z.string().min(1).max(40)).min(1).max(3)
                    }),
                    right: z.object({
                        label: z.string().min(1).max(60),
                        gains: z.array(z.string().min(1).max(40)).min(1).max(3),
                        costs: z.array(z.string().min(1).max(40)).min(1).max(3)
                    })
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    fork: z.string().min(1).max(80),
                    branches: z.array(z.object({
                        label: z.string().min(1).max(60),
                        outcome: z.string().min(1).max(60),
                        tone: z.enum(['up', 'down']).optional()
                    })).min(2).max(3)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    moments: z.array(z.object({
                        at: z.string().min(1).max(16),
                        label: z.string().min(1).max(60)
                    })).min(2).max(5),
                    now: z.int().gte(0).lte(9007199254740991).optional()
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    start: z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24)
                    }),
                    steps: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24),
                        op: z.enum([
                            'plus',
                            'minus',
                            'times',
                            'divide'
                        ])
                    })).min(1).max(2),
                    result: z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24)
                    })
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    price: z.object({
                        low: z.number(),
                        high: z.number()
                    }),
                    demand: z.object({
                        atLow: z.number().gte(0),
                        atHigh: z.number().gte(0)
                    }),
                    readoutLabel: z.string().min(1).max(60),
                    unit: z.string().max(8),
                    from: z.string().min(1).max(40),
                    to: z.string().min(1).max(40)
                })
            ]).optional(),
            hint: z.string().min(1).max(600).optional(),
            body: z.string().optional(),
            imageUrl: z.url().optional(),
            objectName: z.enum([
                'balance',
                'funnel',
                'stack',
                'bridge',
                'steps',
                'podium',
                'chart',
                'pie',
                'gauge',
                'magnifier',
                'beaker',
                'hourglass',
                'calendar',
                'clock',
                'stopwatch',
                'vault',
                'wallet',
                'receipt',
                'calculator',
                'ledger',
                'compass',
                'telescope',
                'map',
                'flag',
                'chess',
                'target',
                'gavel',
                'puzzle',
                'team',
                'network',
                'roundtable',
                'mic',
                'iceberg',
                'chat',
                'gears',
                'pipeline',
                'crate',
                'factory',
                'server',
                'spool',
                'clipboard',
                'tray',
                'basket',
                'folder',
                'bin',
                'lightbulb',
                'rocket',
                'key',
                'trophy',
                'briefcase'
            ]).optional(),
            kind: z.string()
        }),
        z.object({
            id: z.string().min(1),
            position: z.int().gte(1).lte(9007199254740991),
            prompt: z.string().min(1).max(400),
            verb: z.enum([
                'decide',
                'allocate',
                'rank',
                'match',
                'predict',
                'diagnose',
                'negotiate',
                'rephrase',
                'pitch',
                'speak',
                'simulate'
            ]).optional(),
            rung: z.enum([
                'RECOGNIZE',
                'DECIDE',
                'MANIPULATE',
                'CREATE',
                'SPEAK',
                'APPLY',
                'SIMULATE'
            ]).optional(),
            timeLimitMs: z.int().gte(1000).lte(9007199254740991).optional(),
            visual: z.union([
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    max: z.number(),
                    rows: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        previous: z.number().optional(),
                        display: z.string().min(1).max(24)
                    })).min(1).max(4)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    figures: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.string().min(1).max(24),
                        tone: z.enum([
                            'default',
                            'up',
                            'down',
                            'accent',
                            'streak'
                        ]).optional()
                    })).min(2).max(4)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    shares: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.number().gte(0),
                        display: z.string().min(1).max(24).optional()
                    })).min(2).max(6)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    stages: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.number().gte(0),
                        display: z.string().min(1).max(24)
                    })).min(2).max(5)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    start: z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24)
                    }),
                    steps: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24)
                    })).min(1).max(5),
                    end: z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24)
                    })
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    max: z.number(),
                    min: z.number().optional(),
                    rows: z.array(z.object({
                        label: z.string().min(1).max(60),
                        before: z.number(),
                        after: z.number(),
                        beforeDisplay: z.string().min(1).max(24),
                        afterDisplay: z.string().min(1).max(24)
                    })).min(1).max(4)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    x: z.object({
                        label: z.string().min(1).max(60),
                        low: z.string().min(1).max(40),
                        high: z.string().min(1).max(40)
                    }),
                    y: z.object({
                        label: z.string().min(1).max(60),
                        low: z.string().min(1).max(40),
                        high: z.string().min(1).max(40)
                    }),
                    quadrants: z.tuple([
                        z.string().min(1).max(40),
                        z.string().min(1).max(40),
                        z.string().min(1).max(40),
                        z.string().min(1).max(40)
                    ]).optional(),
                    items: z.array(z.object({
                        label: z.string().min(1).max(60),
                        x: z.number().gte(0).lte(1),
                        y: z.number().gte(0).lte(1)
                    })).min(1).max(4)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    steps: z.array(z.object({
                        label: z.string().min(1).max(60),
                        note: z.string().min(1).max(80).optional()
                    })).min(2).max(5)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    at: z.array(z.string().min(1).max(16)).min(2).max(8),
                    min: z.number(),
                    max: z.number(),
                    series: z.array(z.object({
                        label: z.string().min(1).max(60),
                        values: z.array(z.number()).min(2).max(8),
                        display: z.string().min(1).max(24)
                    })).min(1).max(6)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    columns: z.array(z.string().min(1).max(40)).min(2).max(3),
                    rows: z.array(z.object({
                        label: z.string().min(1).max(60),
                        cells: z.array(z.string().min(1).max(40)).max(3)
                    })).min(2).max(6)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    left: z.object({
                        name: z.string().min(1).max(60),
                        you: z.boolean().optional(),
                        character: z.enum([
                            'betty',
                            'david',
                            'rosa',
                            'kofi',
                            'priya',
                            'sam',
                            'noor',
                            'tomi',
                            'biscuit',
                            'bolt'
                        ]).optional(),
                        pose: z.enum([
                            'sit',
                            'lean-in',
                            'arms-crossed',
                            'hand-on-chin',
                            'wave'
                        ]).optional(),
                        facing: z.enum(['left', 'right']).optional(),
                        slot: z.enum([
                            'left',
                            'center',
                            'right'
                        ]).optional(),
                        reaction: z.enum([
                            'happy',
                            'worried',
                            'thinking'
                        ]).optional()
                    }),
                    right: z.object({
                        name: z.string().min(1).max(60),
                        you: z.boolean().optional(),
                        character: z.enum([
                            'betty',
                            'david',
                            'rosa',
                            'kofi',
                            'priya',
                            'sam',
                            'noor',
                            'tomi',
                            'biscuit',
                            'bolt'
                        ]).optional(),
                        pose: z.enum([
                            'sit',
                            'lean-in',
                            'arms-crossed',
                            'hand-on-chin',
                            'wave'
                        ]).optional(),
                        facing: z.enum(['left', 'right']).optional(),
                        slot: z.enum([
                            'left',
                            'center',
                            'right'
                        ]).optional(),
                        reaction: z.enum([
                            'happy',
                            'worried',
                            'thinking'
                        ]).optional()
                    }),
                    lines: z.array(z.object({
                        by: z.enum(['left', 'right']),
                        text: z.string().min(1).max(80).optional(),
                        sound: z.enum([
                            'bark',
                            'whine',
                            'growl',
                            'pant',
                            'meow',
                            'purr',
                            'hiss'
                        ]).optional(),
                        mood: z.enum([
                            'happy',
                            'worried',
                            'thinking'
                        ]).optional(),
                        thought: z.boolean().optional()
                    })).min(1).max(4),
                    awaiting: z.enum(['left', 'right']).optional(),
                    props: z.array(z.string().max(40).regex(/^[a-z0-9]+(-[a-z0-9]+)*$/)).min(1).max(3).optional()
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    cast: z.array(z.object({
                        name: z.string().min(1).max(60),
                        you: z.boolean().optional(),
                        character: z.enum([
                            'betty',
                            'david',
                            'rosa',
                            'kofi',
                            'priya',
                            'sam',
                            'noor',
                            'tomi',
                            'biscuit',
                            'bolt'
                        ]).optional(),
                        pose: z.enum([
                            'sit',
                            'lean-in',
                            'arms-crossed',
                            'hand-on-chin',
                            'wave'
                        ]).optional(),
                        facing: z.enum(['left', 'right']).optional(),
                        slot: z.enum([
                            'left',
                            'center',
                            'right'
                        ]).optional(),
                        reaction: z.enum([
                            'happy',
                            'worried',
                            'thinking'
                        ]).optional(),
                        thought: z.string().min(1).max(80).optional()
                    })).min(1).max(3),
                    stakes: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.string().min(1).max(24),
                        tone: z.enum([
                            'default',
                            'up',
                            'down',
                            'accent',
                            'streak'
                        ]).optional()
                    })).min(1).max(4).optional(),
                    props: z.array(z.string().max(40).regex(/^[a-z0-9]+(-[a-z0-9]+)*$/)).min(1).max(3).optional()
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    left: z.object({
                        label: z.string().min(1).max(60),
                        gains: z.array(z.string().min(1).max(40)).min(1).max(3),
                        costs: z.array(z.string().min(1).max(40)).min(1).max(3)
                    }),
                    right: z.object({
                        label: z.string().min(1).max(60),
                        gains: z.array(z.string().min(1).max(40)).min(1).max(3),
                        costs: z.array(z.string().min(1).max(40)).min(1).max(3)
                    })
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    fork: z.string().min(1).max(80),
                    branches: z.array(z.object({
                        label: z.string().min(1).max(60),
                        outcome: z.string().min(1).max(60),
                        tone: z.enum(['up', 'down']).optional()
                    })).min(2).max(3)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    moments: z.array(z.object({
                        at: z.string().min(1).max(16),
                        label: z.string().min(1).max(60)
                    })).min(2).max(5),
                    now: z.int().gte(0).lte(9007199254740991).optional()
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    start: z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24)
                    }),
                    steps: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24),
                        op: z.enum([
                            'plus',
                            'minus',
                            'times',
                            'divide'
                        ])
                    })).min(1).max(2),
                    result: z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24)
                    })
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    price: z.object({
                        low: z.number(),
                        high: z.number()
                    }),
                    demand: z.object({
                        atLow: z.number().gte(0),
                        atHigh: z.number().gte(0)
                    }),
                    readoutLabel: z.string().min(1).max(60),
                    unit: z.string().max(8),
                    from: z.string().min(1).max(40),
                    to: z.string().min(1).max(40)
                })
            ]).optional(),
            hint: z.string().min(1).max(600).optional(),
            body: z.string().optional(),
            imageUrl: z.url().optional(),
            objectName: z.enum([
                'balance',
                'funnel',
                'stack',
                'bridge',
                'steps',
                'podium',
                'chart',
                'pie',
                'gauge',
                'magnifier',
                'beaker',
                'hourglass',
                'calendar',
                'clock',
                'stopwatch',
                'vault',
                'wallet',
                'receipt',
                'calculator',
                'ledger',
                'compass',
                'telescope',
                'map',
                'flag',
                'chess',
                'target',
                'gavel',
                'puzzle',
                'team',
                'network',
                'roundtable',
                'mic',
                'iceberg',
                'chat',
                'gears',
                'pipeline',
                'crate',
                'factory',
                'server',
                'spool',
                'clipboard',
                'tray',
                'basket',
                'folder',
                'bin',
                'lightbulb',
                'rocket',
                'key',
                'trophy',
                'briefcase'
            ]).optional(),
            kind: z.string()
        }),
        z.object({
            id: z.string().min(1),
            position: z.int().gte(1).lte(9007199254740991),
            prompt: z.string().min(1).max(400),
            verb: z.enum([
                'decide',
                'allocate',
                'rank',
                'match',
                'predict',
                'diagnose',
                'negotiate',
                'rephrase',
                'pitch',
                'speak',
                'simulate'
            ]).optional(),
            rung: z.enum([
                'RECOGNIZE',
                'DECIDE',
                'MANIPULATE',
                'CREATE',
                'SPEAK',
                'APPLY',
                'SIMULATE'
            ]).optional(),
            timeLimitMs: z.int().gte(1000).lte(9007199254740991).optional(),
            visual: z.union([
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    max: z.number(),
                    rows: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        previous: z.number().optional(),
                        display: z.string().min(1).max(24)
                    })).min(1).max(4)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    figures: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.string().min(1).max(24),
                        tone: z.enum([
                            'default',
                            'up',
                            'down',
                            'accent',
                            'streak'
                        ]).optional()
                    })).min(2).max(4)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    shares: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.number().gte(0),
                        display: z.string().min(1).max(24).optional()
                    })).min(2).max(6)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    stages: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.number().gte(0),
                        display: z.string().min(1).max(24)
                    })).min(2).max(5)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    start: z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24)
                    }),
                    steps: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24)
                    })).min(1).max(5),
                    end: z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24)
                    })
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    max: z.number(),
                    min: z.number().optional(),
                    rows: z.array(z.object({
                        label: z.string().min(1).max(60),
                        before: z.number(),
                        after: z.number(),
                        beforeDisplay: z.string().min(1).max(24),
                        afterDisplay: z.string().min(1).max(24)
                    })).min(1).max(4)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    x: z.object({
                        label: z.string().min(1).max(60),
                        low: z.string().min(1).max(40),
                        high: z.string().min(1).max(40)
                    }),
                    y: z.object({
                        label: z.string().min(1).max(60),
                        low: z.string().min(1).max(40),
                        high: z.string().min(1).max(40)
                    }),
                    quadrants: z.tuple([
                        z.string().min(1).max(40),
                        z.string().min(1).max(40),
                        z.string().min(1).max(40),
                        z.string().min(1).max(40)
                    ]).optional(),
                    items: z.array(z.object({
                        label: z.string().min(1).max(60),
                        x: z.number().gte(0).lte(1),
                        y: z.number().gte(0).lte(1)
                    })).min(1).max(4)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    steps: z.array(z.object({
                        label: z.string().min(1).max(60),
                        note: z.string().min(1).max(80).optional()
                    })).min(2).max(5)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    at: z.array(z.string().min(1).max(16)).min(2).max(8),
                    min: z.number(),
                    max: z.number(),
                    series: z.array(z.object({
                        label: z.string().min(1).max(60),
                        values: z.array(z.number()).min(2).max(8),
                        display: z.string().min(1).max(24)
                    })).min(1).max(6)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    columns: z.array(z.string().min(1).max(40)).min(2).max(3),
                    rows: z.array(z.object({
                        label: z.string().min(1).max(60),
                        cells: z.array(z.string().min(1).max(40)).max(3)
                    })).min(2).max(6)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    left: z.object({
                        name: z.string().min(1).max(60),
                        you: z.boolean().optional(),
                        character: z.enum([
                            'betty',
                            'david',
                            'rosa',
                            'kofi',
                            'priya',
                            'sam',
                            'noor',
                            'tomi',
                            'biscuit',
                            'bolt'
                        ]).optional(),
                        pose: z.enum([
                            'sit',
                            'lean-in',
                            'arms-crossed',
                            'hand-on-chin',
                            'wave'
                        ]).optional(),
                        facing: z.enum(['left', 'right']).optional(),
                        slot: z.enum([
                            'left',
                            'center',
                            'right'
                        ]).optional(),
                        reaction: z.enum([
                            'happy',
                            'worried',
                            'thinking'
                        ]).optional()
                    }),
                    right: z.object({
                        name: z.string().min(1).max(60),
                        you: z.boolean().optional(),
                        character: z.enum([
                            'betty',
                            'david',
                            'rosa',
                            'kofi',
                            'priya',
                            'sam',
                            'noor',
                            'tomi',
                            'biscuit',
                            'bolt'
                        ]).optional(),
                        pose: z.enum([
                            'sit',
                            'lean-in',
                            'arms-crossed',
                            'hand-on-chin',
                            'wave'
                        ]).optional(),
                        facing: z.enum(['left', 'right']).optional(),
                        slot: z.enum([
                            'left',
                            'center',
                            'right'
                        ]).optional(),
                        reaction: z.enum([
                            'happy',
                            'worried',
                            'thinking'
                        ]).optional()
                    }),
                    lines: z.array(z.object({
                        by: z.enum(['left', 'right']),
                        text: z.string().min(1).max(80).optional(),
                        sound: z.enum([
                            'bark',
                            'whine',
                            'growl',
                            'pant',
                            'meow',
                            'purr',
                            'hiss'
                        ]).optional(),
                        mood: z.enum([
                            'happy',
                            'worried',
                            'thinking'
                        ]).optional(),
                        thought: z.boolean().optional()
                    })).min(1).max(4),
                    awaiting: z.enum(['left', 'right']).optional(),
                    props: z.array(z.string().max(40).regex(/^[a-z0-9]+(-[a-z0-9]+)*$/)).min(1).max(3).optional()
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    cast: z.array(z.object({
                        name: z.string().min(1).max(60),
                        you: z.boolean().optional(),
                        character: z.enum([
                            'betty',
                            'david',
                            'rosa',
                            'kofi',
                            'priya',
                            'sam',
                            'noor',
                            'tomi',
                            'biscuit',
                            'bolt'
                        ]).optional(),
                        pose: z.enum([
                            'sit',
                            'lean-in',
                            'arms-crossed',
                            'hand-on-chin',
                            'wave'
                        ]).optional(),
                        facing: z.enum(['left', 'right']).optional(),
                        slot: z.enum([
                            'left',
                            'center',
                            'right'
                        ]).optional(),
                        reaction: z.enum([
                            'happy',
                            'worried',
                            'thinking'
                        ]).optional(),
                        thought: z.string().min(1).max(80).optional()
                    })).min(1).max(3),
                    stakes: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.string().min(1).max(24),
                        tone: z.enum([
                            'default',
                            'up',
                            'down',
                            'accent',
                            'streak'
                        ]).optional()
                    })).min(1).max(4).optional(),
                    props: z.array(z.string().max(40).regex(/^[a-z0-9]+(-[a-z0-9]+)*$/)).min(1).max(3).optional()
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    left: z.object({
                        label: z.string().min(1).max(60),
                        gains: z.array(z.string().min(1).max(40)).min(1).max(3),
                        costs: z.array(z.string().min(1).max(40)).min(1).max(3)
                    }),
                    right: z.object({
                        label: z.string().min(1).max(60),
                        gains: z.array(z.string().min(1).max(40)).min(1).max(3),
                        costs: z.array(z.string().min(1).max(40)).min(1).max(3)
                    })
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    fork: z.string().min(1).max(80),
                    branches: z.array(z.object({
                        label: z.string().min(1).max(60),
                        outcome: z.string().min(1).max(60),
                        tone: z.enum(['up', 'down']).optional()
                    })).min(2).max(3)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    moments: z.array(z.object({
                        at: z.string().min(1).max(16),
                        label: z.string().min(1).max(60)
                    })).min(2).max(5),
                    now: z.int().gte(0).lte(9007199254740991).optional()
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    start: z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24)
                    }),
                    steps: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24),
                        op: z.enum([
                            'plus',
                            'minus',
                            'times',
                            'divide'
                        ])
                    })).min(1).max(2),
                    result: z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24)
                    })
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    price: z.object({
                        low: z.number(),
                        high: z.number()
                    }),
                    demand: z.object({
                        atLow: z.number().gte(0),
                        atHigh: z.number().gte(0)
                    }),
                    readoutLabel: z.string().min(1).max(60),
                    unit: z.string().max(8),
                    from: z.string().min(1).max(40),
                    to: z.string().min(1).max(40)
                })
            ]).optional(),
            hint: z.string().min(1).max(600).optional(),
            body: z.string().optional(),
            imageUrl: z.url().optional(),
            objectName: z.enum([
                'balance',
                'funnel',
                'stack',
                'bridge',
                'steps',
                'podium',
                'chart',
                'pie',
                'gauge',
                'magnifier',
                'beaker',
                'hourglass',
                'calendar',
                'clock',
                'stopwatch',
                'vault',
                'wallet',
                'receipt',
                'calculator',
                'ledger',
                'compass',
                'telescope',
                'map',
                'flag',
                'chess',
                'target',
                'gavel',
                'puzzle',
                'team',
                'network',
                'roundtable',
                'mic',
                'iceberg',
                'chat',
                'gears',
                'pipeline',
                'crate',
                'factory',
                'server',
                'spool',
                'clipboard',
                'tray',
                'basket',
                'folder',
                'bin',
                'lightbulb',
                'rocket',
                'key',
                'trophy',
                'briefcase'
            ]).optional(),
            kind: z.string()
        }),
        z.object({
            id: z.string().min(1),
            position: z.int().gte(1).lte(9007199254740991),
            prompt: z.string().min(1).max(400),
            verb: z.enum([
                'decide',
                'allocate',
                'rank',
                'match',
                'predict',
                'diagnose',
                'negotiate',
                'rephrase',
                'pitch',
                'speak',
                'simulate'
            ]).optional(),
            rung: z.enum([
                'RECOGNIZE',
                'DECIDE',
                'MANIPULATE',
                'CREATE',
                'SPEAK',
                'APPLY',
                'SIMULATE'
            ]).optional(),
            timeLimitMs: z.int().gte(1000).lte(9007199254740991).optional(),
            visual: z.union([
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    max: z.number(),
                    rows: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        previous: z.number().optional(),
                        display: z.string().min(1).max(24)
                    })).min(1).max(4)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    figures: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.string().min(1).max(24),
                        tone: z.enum([
                            'default',
                            'up',
                            'down',
                            'accent',
                            'streak'
                        ]).optional()
                    })).min(2).max(4)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    shares: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.number().gte(0),
                        display: z.string().min(1).max(24).optional()
                    })).min(2).max(6)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    stages: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.number().gte(0),
                        display: z.string().min(1).max(24)
                    })).min(2).max(5)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    start: z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24)
                    }),
                    steps: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24)
                    })).min(1).max(5),
                    end: z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24)
                    })
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    max: z.number(),
                    min: z.number().optional(),
                    rows: z.array(z.object({
                        label: z.string().min(1).max(60),
                        before: z.number(),
                        after: z.number(),
                        beforeDisplay: z.string().min(1).max(24),
                        afterDisplay: z.string().min(1).max(24)
                    })).min(1).max(4)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    x: z.object({
                        label: z.string().min(1).max(60),
                        low: z.string().min(1).max(40),
                        high: z.string().min(1).max(40)
                    }),
                    y: z.object({
                        label: z.string().min(1).max(60),
                        low: z.string().min(1).max(40),
                        high: z.string().min(1).max(40)
                    }),
                    quadrants: z.tuple([
                        z.string().min(1).max(40),
                        z.string().min(1).max(40),
                        z.string().min(1).max(40),
                        z.string().min(1).max(40)
                    ]).optional(),
                    items: z.array(z.object({
                        label: z.string().min(1).max(60),
                        x: z.number().gte(0).lte(1),
                        y: z.number().gte(0).lte(1)
                    })).min(1).max(4)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    steps: z.array(z.object({
                        label: z.string().min(1).max(60),
                        note: z.string().min(1).max(80).optional()
                    })).min(2).max(5)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    at: z.array(z.string().min(1).max(16)).min(2).max(8),
                    min: z.number(),
                    max: z.number(),
                    series: z.array(z.object({
                        label: z.string().min(1).max(60),
                        values: z.array(z.number()).min(2).max(8),
                        display: z.string().min(1).max(24)
                    })).min(1).max(6)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    columns: z.array(z.string().min(1).max(40)).min(2).max(3),
                    rows: z.array(z.object({
                        label: z.string().min(1).max(60),
                        cells: z.array(z.string().min(1).max(40)).max(3)
                    })).min(2).max(6)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    left: z.object({
                        name: z.string().min(1).max(60),
                        you: z.boolean().optional(),
                        character: z.enum([
                            'betty',
                            'david',
                            'rosa',
                            'kofi',
                            'priya',
                            'sam',
                            'noor',
                            'tomi',
                            'biscuit',
                            'bolt'
                        ]).optional(),
                        pose: z.enum([
                            'sit',
                            'lean-in',
                            'arms-crossed',
                            'hand-on-chin',
                            'wave'
                        ]).optional(),
                        facing: z.enum(['left', 'right']).optional(),
                        slot: z.enum([
                            'left',
                            'center',
                            'right'
                        ]).optional(),
                        reaction: z.enum([
                            'happy',
                            'worried',
                            'thinking'
                        ]).optional()
                    }),
                    right: z.object({
                        name: z.string().min(1).max(60),
                        you: z.boolean().optional(),
                        character: z.enum([
                            'betty',
                            'david',
                            'rosa',
                            'kofi',
                            'priya',
                            'sam',
                            'noor',
                            'tomi',
                            'biscuit',
                            'bolt'
                        ]).optional(),
                        pose: z.enum([
                            'sit',
                            'lean-in',
                            'arms-crossed',
                            'hand-on-chin',
                            'wave'
                        ]).optional(),
                        facing: z.enum(['left', 'right']).optional(),
                        slot: z.enum([
                            'left',
                            'center',
                            'right'
                        ]).optional(),
                        reaction: z.enum([
                            'happy',
                            'worried',
                            'thinking'
                        ]).optional()
                    }),
                    lines: z.array(z.object({
                        by: z.enum(['left', 'right']),
                        text: z.string().min(1).max(80).optional(),
                        sound: z.enum([
                            'bark',
                            'whine',
                            'growl',
                            'pant',
                            'meow',
                            'purr',
                            'hiss'
                        ]).optional(),
                        mood: z.enum([
                            'happy',
                            'worried',
                            'thinking'
                        ]).optional(),
                        thought: z.boolean().optional()
                    })).min(1).max(4),
                    awaiting: z.enum(['left', 'right']).optional(),
                    props: z.array(z.string().max(40).regex(/^[a-z0-9]+(-[a-z0-9]+)*$/)).min(1).max(3).optional()
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    cast: z.array(z.object({
                        name: z.string().min(1).max(60),
                        you: z.boolean().optional(),
                        character: z.enum([
                            'betty',
                            'david',
                            'rosa',
                            'kofi',
                            'priya',
                            'sam',
                            'noor',
                            'tomi',
                            'biscuit',
                            'bolt'
                        ]).optional(),
                        pose: z.enum([
                            'sit',
                            'lean-in',
                            'arms-crossed',
                            'hand-on-chin',
                            'wave'
                        ]).optional(),
                        facing: z.enum(['left', 'right']).optional(),
                        slot: z.enum([
                            'left',
                            'center',
                            'right'
                        ]).optional(),
                        reaction: z.enum([
                            'happy',
                            'worried',
                            'thinking'
                        ]).optional(),
                        thought: z.string().min(1).max(80).optional()
                    })).min(1).max(3),
                    stakes: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.string().min(1).max(24),
                        tone: z.enum([
                            'default',
                            'up',
                            'down',
                            'accent',
                            'streak'
                        ]).optional()
                    })).min(1).max(4).optional(),
                    props: z.array(z.string().max(40).regex(/^[a-z0-9]+(-[a-z0-9]+)*$/)).min(1).max(3).optional()
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    left: z.object({
                        label: z.string().min(1).max(60),
                        gains: z.array(z.string().min(1).max(40)).min(1).max(3),
                        costs: z.array(z.string().min(1).max(40)).min(1).max(3)
                    }),
                    right: z.object({
                        label: z.string().min(1).max(60),
                        gains: z.array(z.string().min(1).max(40)).min(1).max(3),
                        costs: z.array(z.string().min(1).max(40)).min(1).max(3)
                    })
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    fork: z.string().min(1).max(80),
                    branches: z.array(z.object({
                        label: z.string().min(1).max(60),
                        outcome: z.string().min(1).max(60),
                        tone: z.enum(['up', 'down']).optional()
                    })).min(2).max(3)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    moments: z.array(z.object({
                        at: z.string().min(1).max(16),
                        label: z.string().min(1).max(60)
                    })).min(2).max(5),
                    now: z.int().gte(0).lte(9007199254740991).optional()
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    start: z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24)
                    }),
                    steps: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24),
                        op: z.enum([
                            'plus',
                            'minus',
                            'times',
                            'divide'
                        ])
                    })).min(1).max(2),
                    result: z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24)
                    })
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    price: z.object({
                        low: z.number(),
                        high: z.number()
                    }),
                    demand: z.object({
                        atLow: z.number().gte(0),
                        atHigh: z.number().gte(0)
                    }),
                    readoutLabel: z.string().min(1).max(60),
                    unit: z.string().max(8),
                    from: z.string().min(1).max(40),
                    to: z.string().min(1).max(40)
                })
            ]).optional(),
            hint: z.string().min(1).max(600).optional(),
            body: z.string().optional(),
            imageUrl: z.url().optional(),
            objectName: z.enum([
                'balance',
                'funnel',
                'stack',
                'bridge',
                'steps',
                'podium',
                'chart',
                'pie',
                'gauge',
                'magnifier',
                'beaker',
                'hourglass',
                'calendar',
                'clock',
                'stopwatch',
                'vault',
                'wallet',
                'receipt',
                'calculator',
                'ledger',
                'compass',
                'telescope',
                'map',
                'flag',
                'chess',
                'target',
                'gavel',
                'puzzle',
                'team',
                'network',
                'roundtable',
                'mic',
                'iceberg',
                'chat',
                'gears',
                'pipeline',
                'crate',
                'factory',
                'server',
                'spool',
                'clipboard',
                'tray',
                'basket',
                'folder',
                'bin',
                'lightbulb',
                'rocket',
                'key',
                'trophy',
                'briefcase'
            ]).optional(),
            kind: z.string(),
            sourceId: z.string().min(1),
            sourceTitle: z.string().min(1),
            sourceUrl: z.url().optional(),
            citation: z.string().optional()
        }),
        z.object({
            id: z.string().min(1),
            position: z.int().gte(1).lte(9007199254740991),
            prompt: z.string().min(1).max(400),
            verb: z.enum([
                'decide',
                'allocate',
                'rank',
                'match',
                'predict',
                'diagnose',
                'negotiate',
                'rephrase',
                'pitch',
                'speak',
                'simulate'
            ]).optional(),
            rung: z.enum([
                'RECOGNIZE',
                'DECIDE',
                'MANIPULATE',
                'CREATE',
                'SPEAK',
                'APPLY',
                'SIMULATE'
            ]).optional(),
            timeLimitMs: z.int().gte(1000).lte(9007199254740991).optional(),
            visual: z.union([
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    max: z.number(),
                    rows: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        previous: z.number().optional(),
                        display: z.string().min(1).max(24)
                    })).min(1).max(4)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    figures: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.string().min(1).max(24),
                        tone: z.enum([
                            'default',
                            'up',
                            'down',
                            'accent',
                            'streak'
                        ]).optional()
                    })).min(2).max(4)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    shares: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.number().gte(0),
                        display: z.string().min(1).max(24).optional()
                    })).min(2).max(6)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    stages: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.number().gte(0),
                        display: z.string().min(1).max(24)
                    })).min(2).max(5)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    start: z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24)
                    }),
                    steps: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24)
                    })).min(1).max(5),
                    end: z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24)
                    })
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    max: z.number(),
                    min: z.number().optional(),
                    rows: z.array(z.object({
                        label: z.string().min(1).max(60),
                        before: z.number(),
                        after: z.number(),
                        beforeDisplay: z.string().min(1).max(24),
                        afterDisplay: z.string().min(1).max(24)
                    })).min(1).max(4)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    x: z.object({
                        label: z.string().min(1).max(60),
                        low: z.string().min(1).max(40),
                        high: z.string().min(1).max(40)
                    }),
                    y: z.object({
                        label: z.string().min(1).max(60),
                        low: z.string().min(1).max(40),
                        high: z.string().min(1).max(40)
                    }),
                    quadrants: z.tuple([
                        z.string().min(1).max(40),
                        z.string().min(1).max(40),
                        z.string().min(1).max(40),
                        z.string().min(1).max(40)
                    ]).optional(),
                    items: z.array(z.object({
                        label: z.string().min(1).max(60),
                        x: z.number().gte(0).lte(1),
                        y: z.number().gte(0).lte(1)
                    })).min(1).max(4)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    steps: z.array(z.object({
                        label: z.string().min(1).max(60),
                        note: z.string().min(1).max(80).optional()
                    })).min(2).max(5)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    at: z.array(z.string().min(1).max(16)).min(2).max(8),
                    min: z.number(),
                    max: z.number(),
                    series: z.array(z.object({
                        label: z.string().min(1).max(60),
                        values: z.array(z.number()).min(2).max(8),
                        display: z.string().min(1).max(24)
                    })).min(1).max(6)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    columns: z.array(z.string().min(1).max(40)).min(2).max(3),
                    rows: z.array(z.object({
                        label: z.string().min(1).max(60),
                        cells: z.array(z.string().min(1).max(40)).max(3)
                    })).min(2).max(6)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    left: z.object({
                        name: z.string().min(1).max(60),
                        you: z.boolean().optional(),
                        character: z.enum([
                            'betty',
                            'david',
                            'rosa',
                            'kofi',
                            'priya',
                            'sam',
                            'noor',
                            'tomi',
                            'biscuit',
                            'bolt'
                        ]).optional(),
                        pose: z.enum([
                            'sit',
                            'lean-in',
                            'arms-crossed',
                            'hand-on-chin',
                            'wave'
                        ]).optional(),
                        facing: z.enum(['left', 'right']).optional(),
                        slot: z.enum([
                            'left',
                            'center',
                            'right'
                        ]).optional(),
                        reaction: z.enum([
                            'happy',
                            'worried',
                            'thinking'
                        ]).optional()
                    }),
                    right: z.object({
                        name: z.string().min(1).max(60),
                        you: z.boolean().optional(),
                        character: z.enum([
                            'betty',
                            'david',
                            'rosa',
                            'kofi',
                            'priya',
                            'sam',
                            'noor',
                            'tomi',
                            'biscuit',
                            'bolt'
                        ]).optional(),
                        pose: z.enum([
                            'sit',
                            'lean-in',
                            'arms-crossed',
                            'hand-on-chin',
                            'wave'
                        ]).optional(),
                        facing: z.enum(['left', 'right']).optional(),
                        slot: z.enum([
                            'left',
                            'center',
                            'right'
                        ]).optional(),
                        reaction: z.enum([
                            'happy',
                            'worried',
                            'thinking'
                        ]).optional()
                    }),
                    lines: z.array(z.object({
                        by: z.enum(['left', 'right']),
                        text: z.string().min(1).max(80).optional(),
                        sound: z.enum([
                            'bark',
                            'whine',
                            'growl',
                            'pant',
                            'meow',
                            'purr',
                            'hiss'
                        ]).optional(),
                        mood: z.enum([
                            'happy',
                            'worried',
                            'thinking'
                        ]).optional(),
                        thought: z.boolean().optional()
                    })).min(1).max(4),
                    awaiting: z.enum(['left', 'right']).optional(),
                    props: z.array(z.string().max(40).regex(/^[a-z0-9]+(-[a-z0-9]+)*$/)).min(1).max(3).optional()
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    cast: z.array(z.object({
                        name: z.string().min(1).max(60),
                        you: z.boolean().optional(),
                        character: z.enum([
                            'betty',
                            'david',
                            'rosa',
                            'kofi',
                            'priya',
                            'sam',
                            'noor',
                            'tomi',
                            'biscuit',
                            'bolt'
                        ]).optional(),
                        pose: z.enum([
                            'sit',
                            'lean-in',
                            'arms-crossed',
                            'hand-on-chin',
                            'wave'
                        ]).optional(),
                        facing: z.enum(['left', 'right']).optional(),
                        slot: z.enum([
                            'left',
                            'center',
                            'right'
                        ]).optional(),
                        reaction: z.enum([
                            'happy',
                            'worried',
                            'thinking'
                        ]).optional(),
                        thought: z.string().min(1).max(80).optional()
                    })).min(1).max(3),
                    stakes: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.string().min(1).max(24),
                        tone: z.enum([
                            'default',
                            'up',
                            'down',
                            'accent',
                            'streak'
                        ]).optional()
                    })).min(1).max(4).optional(),
                    props: z.array(z.string().max(40).regex(/^[a-z0-9]+(-[a-z0-9]+)*$/)).min(1).max(3).optional()
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    left: z.object({
                        label: z.string().min(1).max(60),
                        gains: z.array(z.string().min(1).max(40)).min(1).max(3),
                        costs: z.array(z.string().min(1).max(40)).min(1).max(3)
                    }),
                    right: z.object({
                        label: z.string().min(1).max(60),
                        gains: z.array(z.string().min(1).max(40)).min(1).max(3),
                        costs: z.array(z.string().min(1).max(40)).min(1).max(3)
                    })
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    fork: z.string().min(1).max(80),
                    branches: z.array(z.object({
                        label: z.string().min(1).max(60),
                        outcome: z.string().min(1).max(60),
                        tone: z.enum(['up', 'down']).optional()
                    })).min(2).max(3)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    moments: z.array(z.object({
                        at: z.string().min(1).max(16),
                        label: z.string().min(1).max(60)
                    })).min(2).max(5),
                    now: z.int().gte(0).lte(9007199254740991).optional()
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    start: z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24)
                    }),
                    steps: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24),
                        op: z.enum([
                            'plus',
                            'minus',
                            'times',
                            'divide'
                        ])
                    })).min(1).max(2),
                    result: z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24)
                    })
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    price: z.object({
                        low: z.number(),
                        high: z.number()
                    }),
                    demand: z.object({
                        atLow: z.number().gte(0),
                        atHigh: z.number().gte(0)
                    }),
                    readoutLabel: z.string().min(1).max(60),
                    unit: z.string().max(8),
                    from: z.string().min(1).max(40),
                    to: z.string().min(1).max(40)
                })
            ]).optional(),
            hint: z.string().min(1).max(600).optional(),
            body: z.string().optional(),
            imageUrl: z.url().optional(),
            objectName: z.enum([
                'balance',
                'funnel',
                'stack',
                'bridge',
                'steps',
                'podium',
                'chart',
                'pie',
                'gauge',
                'magnifier',
                'beaker',
                'hourglass',
                'calendar',
                'clock',
                'stopwatch',
                'vault',
                'wallet',
                'receipt',
                'calculator',
                'ledger',
                'compass',
                'telescope',
                'map',
                'flag',
                'chess',
                'target',
                'gavel',
                'puzzle',
                'team',
                'network',
                'roundtable',
                'mic',
                'iceberg',
                'chat',
                'gears',
                'pipeline',
                'crate',
                'factory',
                'server',
                'spool',
                'clipboard',
                'tray',
                'basket',
                'folder',
                'bin',
                'lightbulb',
                'rocket',
                'key',
                'trophy',
                'briefcase'
            ]).optional(),
            kind: z.string()
        }),
        z.object({
            id: z.string().min(1),
            position: z.int().gte(1).lte(9007199254740991),
            prompt: z.string().min(1).max(400),
            verb: z.enum([
                'decide',
                'allocate',
                'rank',
                'match',
                'predict',
                'diagnose',
                'negotiate',
                'rephrase',
                'pitch',
                'speak',
                'simulate'
            ]).optional(),
            rung: z.enum([
                'RECOGNIZE',
                'DECIDE',
                'MANIPULATE',
                'CREATE',
                'SPEAK',
                'APPLY',
                'SIMULATE'
            ]).optional(),
            timeLimitMs: z.int().gte(1000).lte(9007199254740991).optional(),
            visual: z.union([
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    max: z.number(),
                    rows: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        previous: z.number().optional(),
                        display: z.string().min(1).max(24)
                    })).min(1).max(4)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    figures: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.string().min(1).max(24),
                        tone: z.enum([
                            'default',
                            'up',
                            'down',
                            'accent',
                            'streak'
                        ]).optional()
                    })).min(2).max(4)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    shares: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.number().gte(0),
                        display: z.string().min(1).max(24).optional()
                    })).min(2).max(6)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    stages: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.number().gte(0),
                        display: z.string().min(1).max(24)
                    })).min(2).max(5)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    start: z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24)
                    }),
                    steps: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24)
                    })).min(1).max(5),
                    end: z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24)
                    })
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    max: z.number(),
                    min: z.number().optional(),
                    rows: z.array(z.object({
                        label: z.string().min(1).max(60),
                        before: z.number(),
                        after: z.number(),
                        beforeDisplay: z.string().min(1).max(24),
                        afterDisplay: z.string().min(1).max(24)
                    })).min(1).max(4)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    x: z.object({
                        label: z.string().min(1).max(60),
                        low: z.string().min(1).max(40),
                        high: z.string().min(1).max(40)
                    }),
                    y: z.object({
                        label: z.string().min(1).max(60),
                        low: z.string().min(1).max(40),
                        high: z.string().min(1).max(40)
                    }),
                    quadrants: z.tuple([
                        z.string().min(1).max(40),
                        z.string().min(1).max(40),
                        z.string().min(1).max(40),
                        z.string().min(1).max(40)
                    ]).optional(),
                    items: z.array(z.object({
                        label: z.string().min(1).max(60),
                        x: z.number().gte(0).lte(1),
                        y: z.number().gte(0).lte(1)
                    })).min(1).max(4)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    steps: z.array(z.object({
                        label: z.string().min(1).max(60),
                        note: z.string().min(1).max(80).optional()
                    })).min(2).max(5)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    at: z.array(z.string().min(1).max(16)).min(2).max(8),
                    min: z.number(),
                    max: z.number(),
                    series: z.array(z.object({
                        label: z.string().min(1).max(60),
                        values: z.array(z.number()).min(2).max(8),
                        display: z.string().min(1).max(24)
                    })).min(1).max(6)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    columns: z.array(z.string().min(1).max(40)).min(2).max(3),
                    rows: z.array(z.object({
                        label: z.string().min(1).max(60),
                        cells: z.array(z.string().min(1).max(40)).max(3)
                    })).min(2).max(6)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    left: z.object({
                        name: z.string().min(1).max(60),
                        you: z.boolean().optional(),
                        character: z.enum([
                            'betty',
                            'david',
                            'rosa',
                            'kofi',
                            'priya',
                            'sam',
                            'noor',
                            'tomi',
                            'biscuit',
                            'bolt'
                        ]).optional(),
                        pose: z.enum([
                            'sit',
                            'lean-in',
                            'arms-crossed',
                            'hand-on-chin',
                            'wave'
                        ]).optional(),
                        facing: z.enum(['left', 'right']).optional(),
                        slot: z.enum([
                            'left',
                            'center',
                            'right'
                        ]).optional(),
                        reaction: z.enum([
                            'happy',
                            'worried',
                            'thinking'
                        ]).optional()
                    }),
                    right: z.object({
                        name: z.string().min(1).max(60),
                        you: z.boolean().optional(),
                        character: z.enum([
                            'betty',
                            'david',
                            'rosa',
                            'kofi',
                            'priya',
                            'sam',
                            'noor',
                            'tomi',
                            'biscuit',
                            'bolt'
                        ]).optional(),
                        pose: z.enum([
                            'sit',
                            'lean-in',
                            'arms-crossed',
                            'hand-on-chin',
                            'wave'
                        ]).optional(),
                        facing: z.enum(['left', 'right']).optional(),
                        slot: z.enum([
                            'left',
                            'center',
                            'right'
                        ]).optional(),
                        reaction: z.enum([
                            'happy',
                            'worried',
                            'thinking'
                        ]).optional()
                    }),
                    lines: z.array(z.object({
                        by: z.enum(['left', 'right']),
                        text: z.string().min(1).max(80).optional(),
                        sound: z.enum([
                            'bark',
                            'whine',
                            'growl',
                            'pant',
                            'meow',
                            'purr',
                            'hiss'
                        ]).optional(),
                        mood: z.enum([
                            'happy',
                            'worried',
                            'thinking'
                        ]).optional(),
                        thought: z.boolean().optional()
                    })).min(1).max(4),
                    awaiting: z.enum(['left', 'right']).optional(),
                    props: z.array(z.string().max(40).regex(/^[a-z0-9]+(-[a-z0-9]+)*$/)).min(1).max(3).optional()
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    cast: z.array(z.object({
                        name: z.string().min(1).max(60),
                        you: z.boolean().optional(),
                        character: z.enum([
                            'betty',
                            'david',
                            'rosa',
                            'kofi',
                            'priya',
                            'sam',
                            'noor',
                            'tomi',
                            'biscuit',
                            'bolt'
                        ]).optional(),
                        pose: z.enum([
                            'sit',
                            'lean-in',
                            'arms-crossed',
                            'hand-on-chin',
                            'wave'
                        ]).optional(),
                        facing: z.enum(['left', 'right']).optional(),
                        slot: z.enum([
                            'left',
                            'center',
                            'right'
                        ]).optional(),
                        reaction: z.enum([
                            'happy',
                            'worried',
                            'thinking'
                        ]).optional(),
                        thought: z.string().min(1).max(80).optional()
                    })).min(1).max(3),
                    stakes: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.string().min(1).max(24),
                        tone: z.enum([
                            'default',
                            'up',
                            'down',
                            'accent',
                            'streak'
                        ]).optional()
                    })).min(1).max(4).optional(),
                    props: z.array(z.string().max(40).regex(/^[a-z0-9]+(-[a-z0-9]+)*$/)).min(1).max(3).optional()
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    left: z.object({
                        label: z.string().min(1).max(60),
                        gains: z.array(z.string().min(1).max(40)).min(1).max(3),
                        costs: z.array(z.string().min(1).max(40)).min(1).max(3)
                    }),
                    right: z.object({
                        label: z.string().min(1).max(60),
                        gains: z.array(z.string().min(1).max(40)).min(1).max(3),
                        costs: z.array(z.string().min(1).max(40)).min(1).max(3)
                    })
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    fork: z.string().min(1).max(80),
                    branches: z.array(z.object({
                        label: z.string().min(1).max(60),
                        outcome: z.string().min(1).max(60),
                        tone: z.enum(['up', 'down']).optional()
                    })).min(2).max(3)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    moments: z.array(z.object({
                        at: z.string().min(1).max(16),
                        label: z.string().min(1).max(60)
                    })).min(2).max(5),
                    now: z.int().gte(0).lte(9007199254740991).optional()
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    start: z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24)
                    }),
                    steps: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24),
                        op: z.enum([
                            'plus',
                            'minus',
                            'times',
                            'divide'
                        ])
                    })).min(1).max(2),
                    result: z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24)
                    })
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    price: z.object({
                        low: z.number(),
                        high: z.number()
                    }),
                    demand: z.object({
                        atLow: z.number().gte(0),
                        atHigh: z.number().gte(0)
                    }),
                    readoutLabel: z.string().min(1).max(60),
                    unit: z.string().max(8),
                    from: z.string().min(1).max(40),
                    to: z.string().min(1).max(40)
                })
            ]).optional(),
            hint: z.string().min(1).max(600).optional(),
            body: z.string().optional(),
            imageUrl: z.url().optional(),
            objectName: z.enum([
                'balance',
                'funnel',
                'stack',
                'bridge',
                'steps',
                'podium',
                'chart',
                'pie',
                'gauge',
                'magnifier',
                'beaker',
                'hourglass',
                'calendar',
                'clock',
                'stopwatch',
                'vault',
                'wallet',
                'receipt',
                'calculator',
                'ledger',
                'compass',
                'telescope',
                'map',
                'flag',
                'chess',
                'target',
                'gavel',
                'puzzle',
                'team',
                'network',
                'roundtable',
                'mic',
                'iceberg',
                'chat',
                'gears',
                'pipeline',
                'crate',
                'factory',
                'server',
                'spool',
                'clipboard',
                'tray',
                'basket',
                'folder',
                'bin',
                'lightbulb',
                'rocket',
                'key',
                'trophy',
                'briefcase'
            ]).optional(),
            kind: z.string()
        }),
        z.object({
            id: z.string().min(1),
            position: z.int().gte(1).lte(9007199254740991),
            prompt: z.string().min(1).max(400),
            verb: z.enum([
                'decide',
                'allocate',
                'rank',
                'match',
                'predict',
                'diagnose',
                'negotiate',
                'rephrase',
                'pitch',
                'speak',
                'simulate'
            ]).optional(),
            rung: z.enum([
                'RECOGNIZE',
                'DECIDE',
                'MANIPULATE',
                'CREATE',
                'SPEAK',
                'APPLY',
                'SIMULATE'
            ]).optional(),
            timeLimitMs: z.int().gte(1000).lte(9007199254740991).optional(),
            visual: z.union([
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    max: z.number(),
                    rows: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        previous: z.number().optional(),
                        display: z.string().min(1).max(24)
                    })).min(1).max(4)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    figures: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.string().min(1).max(24),
                        tone: z.enum([
                            'default',
                            'up',
                            'down',
                            'accent',
                            'streak'
                        ]).optional()
                    })).min(2).max(4)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    shares: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.number().gte(0),
                        display: z.string().min(1).max(24).optional()
                    })).min(2).max(6)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    stages: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.number().gte(0),
                        display: z.string().min(1).max(24)
                    })).min(2).max(5)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    start: z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24)
                    }),
                    steps: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24)
                    })).min(1).max(5),
                    end: z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24)
                    })
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    max: z.number(),
                    min: z.number().optional(),
                    rows: z.array(z.object({
                        label: z.string().min(1).max(60),
                        before: z.number(),
                        after: z.number(),
                        beforeDisplay: z.string().min(1).max(24),
                        afterDisplay: z.string().min(1).max(24)
                    })).min(1).max(4)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    x: z.object({
                        label: z.string().min(1).max(60),
                        low: z.string().min(1).max(40),
                        high: z.string().min(1).max(40)
                    }),
                    y: z.object({
                        label: z.string().min(1).max(60),
                        low: z.string().min(1).max(40),
                        high: z.string().min(1).max(40)
                    }),
                    quadrants: z.tuple([
                        z.string().min(1).max(40),
                        z.string().min(1).max(40),
                        z.string().min(1).max(40),
                        z.string().min(1).max(40)
                    ]).optional(),
                    items: z.array(z.object({
                        label: z.string().min(1).max(60),
                        x: z.number().gte(0).lte(1),
                        y: z.number().gte(0).lte(1)
                    })).min(1).max(4)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    steps: z.array(z.object({
                        label: z.string().min(1).max(60),
                        note: z.string().min(1).max(80).optional()
                    })).min(2).max(5)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    at: z.array(z.string().min(1).max(16)).min(2).max(8),
                    min: z.number(),
                    max: z.number(),
                    series: z.array(z.object({
                        label: z.string().min(1).max(60),
                        values: z.array(z.number()).min(2).max(8),
                        display: z.string().min(1).max(24)
                    })).min(1).max(6)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    columns: z.array(z.string().min(1).max(40)).min(2).max(3),
                    rows: z.array(z.object({
                        label: z.string().min(1).max(60),
                        cells: z.array(z.string().min(1).max(40)).max(3)
                    })).min(2).max(6)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    left: z.object({
                        name: z.string().min(1).max(60),
                        you: z.boolean().optional(),
                        character: z.enum([
                            'betty',
                            'david',
                            'rosa',
                            'kofi',
                            'priya',
                            'sam',
                            'noor',
                            'tomi',
                            'biscuit',
                            'bolt'
                        ]).optional(),
                        pose: z.enum([
                            'sit',
                            'lean-in',
                            'arms-crossed',
                            'hand-on-chin',
                            'wave'
                        ]).optional(),
                        facing: z.enum(['left', 'right']).optional(),
                        slot: z.enum([
                            'left',
                            'center',
                            'right'
                        ]).optional(),
                        reaction: z.enum([
                            'happy',
                            'worried',
                            'thinking'
                        ]).optional()
                    }),
                    right: z.object({
                        name: z.string().min(1).max(60),
                        you: z.boolean().optional(),
                        character: z.enum([
                            'betty',
                            'david',
                            'rosa',
                            'kofi',
                            'priya',
                            'sam',
                            'noor',
                            'tomi',
                            'biscuit',
                            'bolt'
                        ]).optional(),
                        pose: z.enum([
                            'sit',
                            'lean-in',
                            'arms-crossed',
                            'hand-on-chin',
                            'wave'
                        ]).optional(),
                        facing: z.enum(['left', 'right']).optional(),
                        slot: z.enum([
                            'left',
                            'center',
                            'right'
                        ]).optional(),
                        reaction: z.enum([
                            'happy',
                            'worried',
                            'thinking'
                        ]).optional()
                    }),
                    lines: z.array(z.object({
                        by: z.enum(['left', 'right']),
                        text: z.string().min(1).max(80).optional(),
                        sound: z.enum([
                            'bark',
                            'whine',
                            'growl',
                            'pant',
                            'meow',
                            'purr',
                            'hiss'
                        ]).optional(),
                        mood: z.enum([
                            'happy',
                            'worried',
                            'thinking'
                        ]).optional(),
                        thought: z.boolean().optional()
                    })).min(1).max(4),
                    awaiting: z.enum(['left', 'right']).optional(),
                    props: z.array(z.string().max(40).regex(/^[a-z0-9]+(-[a-z0-9]+)*$/)).min(1).max(3).optional()
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    cast: z.array(z.object({
                        name: z.string().min(1).max(60),
                        you: z.boolean().optional(),
                        character: z.enum([
                            'betty',
                            'david',
                            'rosa',
                            'kofi',
                            'priya',
                            'sam',
                            'noor',
                            'tomi',
                            'biscuit',
                            'bolt'
                        ]).optional(),
                        pose: z.enum([
                            'sit',
                            'lean-in',
                            'arms-crossed',
                            'hand-on-chin',
                            'wave'
                        ]).optional(),
                        facing: z.enum(['left', 'right']).optional(),
                        slot: z.enum([
                            'left',
                            'center',
                            'right'
                        ]).optional(),
                        reaction: z.enum([
                            'happy',
                            'worried',
                            'thinking'
                        ]).optional(),
                        thought: z.string().min(1).max(80).optional()
                    })).min(1).max(3),
                    stakes: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.string().min(1).max(24),
                        tone: z.enum([
                            'default',
                            'up',
                            'down',
                            'accent',
                            'streak'
                        ]).optional()
                    })).min(1).max(4).optional(),
                    props: z.array(z.string().max(40).regex(/^[a-z0-9]+(-[a-z0-9]+)*$/)).min(1).max(3).optional()
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    left: z.object({
                        label: z.string().min(1).max(60),
                        gains: z.array(z.string().min(1).max(40)).min(1).max(3),
                        costs: z.array(z.string().min(1).max(40)).min(1).max(3)
                    }),
                    right: z.object({
                        label: z.string().min(1).max(60),
                        gains: z.array(z.string().min(1).max(40)).min(1).max(3),
                        costs: z.array(z.string().min(1).max(40)).min(1).max(3)
                    })
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    fork: z.string().min(1).max(80),
                    branches: z.array(z.object({
                        label: z.string().min(1).max(60),
                        outcome: z.string().min(1).max(60),
                        tone: z.enum(['up', 'down']).optional()
                    })).min(2).max(3)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    moments: z.array(z.object({
                        at: z.string().min(1).max(16),
                        label: z.string().min(1).max(60)
                    })).min(2).max(5),
                    now: z.int().gte(0).lte(9007199254740991).optional()
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    start: z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24)
                    }),
                    steps: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24),
                        op: z.enum([
                            'plus',
                            'minus',
                            'times',
                            'divide'
                        ])
                    })).min(1).max(2),
                    result: z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24)
                    })
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    price: z.object({
                        low: z.number(),
                        high: z.number()
                    }),
                    demand: z.object({
                        atLow: z.number().gte(0),
                        atHigh: z.number().gte(0)
                    }),
                    readoutLabel: z.string().min(1).max(60),
                    unit: z.string().max(8),
                    from: z.string().min(1).max(40),
                    to: z.string().min(1).max(40)
                })
            ]).optional(),
            hint: z.string().min(1).max(600).optional(),
            body: z.string().optional(),
            kind: z.string(),
            imageUrl: z.url().optional(),
            options: z.array(z.object({
                id: z.string().min(1),
                label: z.string().min(1).max(200)
            })).min(2).max(8),
            maxSelections: z.int().gte(1).lte(9007199254740991),
            requireSubmit: z.boolean().optional()
        }),
        z.object({
            id: z.string().min(1),
            position: z.int().gte(1).lte(9007199254740991),
            prompt: z.string().min(1).max(400),
            verb: z.enum([
                'decide',
                'allocate',
                'rank',
                'match',
                'predict',
                'diagnose',
                'negotiate',
                'rephrase',
                'pitch',
                'speak',
                'simulate'
            ]).optional(),
            rung: z.enum([
                'RECOGNIZE',
                'DECIDE',
                'MANIPULATE',
                'CREATE',
                'SPEAK',
                'APPLY',
                'SIMULATE'
            ]).optional(),
            timeLimitMs: z.int().gte(1000).lte(9007199254740991).optional(),
            visual: z.union([
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    max: z.number(),
                    rows: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        previous: z.number().optional(),
                        display: z.string().min(1).max(24)
                    })).min(1).max(4)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    figures: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.string().min(1).max(24),
                        tone: z.enum([
                            'default',
                            'up',
                            'down',
                            'accent',
                            'streak'
                        ]).optional()
                    })).min(2).max(4)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    shares: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.number().gte(0),
                        display: z.string().min(1).max(24).optional()
                    })).min(2).max(6)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    stages: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.number().gte(0),
                        display: z.string().min(1).max(24)
                    })).min(2).max(5)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    start: z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24)
                    }),
                    steps: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24)
                    })).min(1).max(5),
                    end: z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24)
                    })
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    max: z.number(),
                    min: z.number().optional(),
                    rows: z.array(z.object({
                        label: z.string().min(1).max(60),
                        before: z.number(),
                        after: z.number(),
                        beforeDisplay: z.string().min(1).max(24),
                        afterDisplay: z.string().min(1).max(24)
                    })).min(1).max(4)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    x: z.object({
                        label: z.string().min(1).max(60),
                        low: z.string().min(1).max(40),
                        high: z.string().min(1).max(40)
                    }),
                    y: z.object({
                        label: z.string().min(1).max(60),
                        low: z.string().min(1).max(40),
                        high: z.string().min(1).max(40)
                    }),
                    quadrants: z.tuple([
                        z.string().min(1).max(40),
                        z.string().min(1).max(40),
                        z.string().min(1).max(40),
                        z.string().min(1).max(40)
                    ]).optional(),
                    items: z.array(z.object({
                        label: z.string().min(1).max(60),
                        x: z.number().gte(0).lte(1),
                        y: z.number().gte(0).lte(1)
                    })).min(1).max(4)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    steps: z.array(z.object({
                        label: z.string().min(1).max(60),
                        note: z.string().min(1).max(80).optional()
                    })).min(2).max(5)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    at: z.array(z.string().min(1).max(16)).min(2).max(8),
                    min: z.number(),
                    max: z.number(),
                    series: z.array(z.object({
                        label: z.string().min(1).max(60),
                        values: z.array(z.number()).min(2).max(8),
                        display: z.string().min(1).max(24)
                    })).min(1).max(6)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    columns: z.array(z.string().min(1).max(40)).min(2).max(3),
                    rows: z.array(z.object({
                        label: z.string().min(1).max(60),
                        cells: z.array(z.string().min(1).max(40)).max(3)
                    })).min(2).max(6)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    left: z.object({
                        name: z.string().min(1).max(60),
                        you: z.boolean().optional(),
                        character: z.enum([
                            'betty',
                            'david',
                            'rosa',
                            'kofi',
                            'priya',
                            'sam',
                            'noor',
                            'tomi',
                            'biscuit',
                            'bolt'
                        ]).optional(),
                        pose: z.enum([
                            'sit',
                            'lean-in',
                            'arms-crossed',
                            'hand-on-chin',
                            'wave'
                        ]).optional(),
                        facing: z.enum(['left', 'right']).optional(),
                        slot: z.enum([
                            'left',
                            'center',
                            'right'
                        ]).optional(),
                        reaction: z.enum([
                            'happy',
                            'worried',
                            'thinking'
                        ]).optional()
                    }),
                    right: z.object({
                        name: z.string().min(1).max(60),
                        you: z.boolean().optional(),
                        character: z.enum([
                            'betty',
                            'david',
                            'rosa',
                            'kofi',
                            'priya',
                            'sam',
                            'noor',
                            'tomi',
                            'biscuit',
                            'bolt'
                        ]).optional(),
                        pose: z.enum([
                            'sit',
                            'lean-in',
                            'arms-crossed',
                            'hand-on-chin',
                            'wave'
                        ]).optional(),
                        facing: z.enum(['left', 'right']).optional(),
                        slot: z.enum([
                            'left',
                            'center',
                            'right'
                        ]).optional(),
                        reaction: z.enum([
                            'happy',
                            'worried',
                            'thinking'
                        ]).optional()
                    }),
                    lines: z.array(z.object({
                        by: z.enum(['left', 'right']),
                        text: z.string().min(1).max(80).optional(),
                        sound: z.enum([
                            'bark',
                            'whine',
                            'growl',
                            'pant',
                            'meow',
                            'purr',
                            'hiss'
                        ]).optional(),
                        mood: z.enum([
                            'happy',
                            'worried',
                            'thinking'
                        ]).optional(),
                        thought: z.boolean().optional()
                    })).min(1).max(4),
                    awaiting: z.enum(['left', 'right']).optional(),
                    props: z.array(z.string().max(40).regex(/^[a-z0-9]+(-[a-z0-9]+)*$/)).min(1).max(3).optional()
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    cast: z.array(z.object({
                        name: z.string().min(1).max(60),
                        you: z.boolean().optional(),
                        character: z.enum([
                            'betty',
                            'david',
                            'rosa',
                            'kofi',
                            'priya',
                            'sam',
                            'noor',
                            'tomi',
                            'biscuit',
                            'bolt'
                        ]).optional(),
                        pose: z.enum([
                            'sit',
                            'lean-in',
                            'arms-crossed',
                            'hand-on-chin',
                            'wave'
                        ]).optional(),
                        facing: z.enum(['left', 'right']).optional(),
                        slot: z.enum([
                            'left',
                            'center',
                            'right'
                        ]).optional(),
                        reaction: z.enum([
                            'happy',
                            'worried',
                            'thinking'
                        ]).optional(),
                        thought: z.string().min(1).max(80).optional()
                    })).min(1).max(3),
                    stakes: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.string().min(1).max(24),
                        tone: z.enum([
                            'default',
                            'up',
                            'down',
                            'accent',
                            'streak'
                        ]).optional()
                    })).min(1).max(4).optional(),
                    props: z.array(z.string().max(40).regex(/^[a-z0-9]+(-[a-z0-9]+)*$/)).min(1).max(3).optional()
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    left: z.object({
                        label: z.string().min(1).max(60),
                        gains: z.array(z.string().min(1).max(40)).min(1).max(3),
                        costs: z.array(z.string().min(1).max(40)).min(1).max(3)
                    }),
                    right: z.object({
                        label: z.string().min(1).max(60),
                        gains: z.array(z.string().min(1).max(40)).min(1).max(3),
                        costs: z.array(z.string().min(1).max(40)).min(1).max(3)
                    })
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    fork: z.string().min(1).max(80),
                    branches: z.array(z.object({
                        label: z.string().min(1).max(60),
                        outcome: z.string().min(1).max(60),
                        tone: z.enum(['up', 'down']).optional()
                    })).min(2).max(3)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    moments: z.array(z.object({
                        at: z.string().min(1).max(16),
                        label: z.string().min(1).max(60)
                    })).min(2).max(5),
                    now: z.int().gte(0).lte(9007199254740991).optional()
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    start: z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24)
                    }),
                    steps: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24),
                        op: z.enum([
                            'plus',
                            'minus',
                            'times',
                            'divide'
                        ])
                    })).min(1).max(2),
                    result: z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24)
                    })
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    price: z.object({
                        low: z.number(),
                        high: z.number()
                    }),
                    demand: z.object({
                        atLow: z.number().gte(0),
                        atHigh: z.number().gte(0)
                    }),
                    readoutLabel: z.string().min(1).max(60),
                    unit: z.string().max(8),
                    from: z.string().min(1).max(40),
                    to: z.string().min(1).max(40)
                })
            ]).optional(),
            hint: z.string().min(1).max(600).optional(),
            body: z.string().optional(),
            kind: z.string(),
            items: z.array(z.object({
                id: z.string().min(1),
                label: z.string().min(1).max(200)
            })).min(2).max(8)
        }),
        z.object({
            id: z.string().min(1),
            position: z.int().gte(1).lte(9007199254740991),
            prompt: z.string().min(1).max(400),
            verb: z.enum([
                'decide',
                'allocate',
                'rank',
                'match',
                'predict',
                'diagnose',
                'negotiate',
                'rephrase',
                'pitch',
                'speak',
                'simulate'
            ]).optional(),
            rung: z.enum([
                'RECOGNIZE',
                'DECIDE',
                'MANIPULATE',
                'CREATE',
                'SPEAK',
                'APPLY',
                'SIMULATE'
            ]).optional(),
            timeLimitMs: z.int().gte(1000).lte(9007199254740991).optional(),
            visual: z.union([
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    max: z.number(),
                    rows: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        previous: z.number().optional(),
                        display: z.string().min(1).max(24)
                    })).min(1).max(4)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    figures: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.string().min(1).max(24),
                        tone: z.enum([
                            'default',
                            'up',
                            'down',
                            'accent',
                            'streak'
                        ]).optional()
                    })).min(2).max(4)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    shares: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.number().gte(0),
                        display: z.string().min(1).max(24).optional()
                    })).min(2).max(6)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    stages: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.number().gte(0),
                        display: z.string().min(1).max(24)
                    })).min(2).max(5)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    start: z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24)
                    }),
                    steps: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24)
                    })).min(1).max(5),
                    end: z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24)
                    })
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    max: z.number(),
                    min: z.number().optional(),
                    rows: z.array(z.object({
                        label: z.string().min(1).max(60),
                        before: z.number(),
                        after: z.number(),
                        beforeDisplay: z.string().min(1).max(24),
                        afterDisplay: z.string().min(1).max(24)
                    })).min(1).max(4)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    x: z.object({
                        label: z.string().min(1).max(60),
                        low: z.string().min(1).max(40),
                        high: z.string().min(1).max(40)
                    }),
                    y: z.object({
                        label: z.string().min(1).max(60),
                        low: z.string().min(1).max(40),
                        high: z.string().min(1).max(40)
                    }),
                    quadrants: z.tuple([
                        z.string().min(1).max(40),
                        z.string().min(1).max(40),
                        z.string().min(1).max(40),
                        z.string().min(1).max(40)
                    ]).optional(),
                    items: z.array(z.object({
                        label: z.string().min(1).max(60),
                        x: z.number().gte(0).lte(1),
                        y: z.number().gte(0).lte(1)
                    })).min(1).max(4)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    steps: z.array(z.object({
                        label: z.string().min(1).max(60),
                        note: z.string().min(1).max(80).optional()
                    })).min(2).max(5)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    at: z.array(z.string().min(1).max(16)).min(2).max(8),
                    min: z.number(),
                    max: z.number(),
                    series: z.array(z.object({
                        label: z.string().min(1).max(60),
                        values: z.array(z.number()).min(2).max(8),
                        display: z.string().min(1).max(24)
                    })).min(1).max(6)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    columns: z.array(z.string().min(1).max(40)).min(2).max(3),
                    rows: z.array(z.object({
                        label: z.string().min(1).max(60),
                        cells: z.array(z.string().min(1).max(40)).max(3)
                    })).min(2).max(6)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    left: z.object({
                        name: z.string().min(1).max(60),
                        you: z.boolean().optional(),
                        character: z.enum([
                            'betty',
                            'david',
                            'rosa',
                            'kofi',
                            'priya',
                            'sam',
                            'noor',
                            'tomi',
                            'biscuit',
                            'bolt'
                        ]).optional(),
                        pose: z.enum([
                            'sit',
                            'lean-in',
                            'arms-crossed',
                            'hand-on-chin',
                            'wave'
                        ]).optional(),
                        facing: z.enum(['left', 'right']).optional(),
                        slot: z.enum([
                            'left',
                            'center',
                            'right'
                        ]).optional(),
                        reaction: z.enum([
                            'happy',
                            'worried',
                            'thinking'
                        ]).optional()
                    }),
                    right: z.object({
                        name: z.string().min(1).max(60),
                        you: z.boolean().optional(),
                        character: z.enum([
                            'betty',
                            'david',
                            'rosa',
                            'kofi',
                            'priya',
                            'sam',
                            'noor',
                            'tomi',
                            'biscuit',
                            'bolt'
                        ]).optional(),
                        pose: z.enum([
                            'sit',
                            'lean-in',
                            'arms-crossed',
                            'hand-on-chin',
                            'wave'
                        ]).optional(),
                        facing: z.enum(['left', 'right']).optional(),
                        slot: z.enum([
                            'left',
                            'center',
                            'right'
                        ]).optional(),
                        reaction: z.enum([
                            'happy',
                            'worried',
                            'thinking'
                        ]).optional()
                    }),
                    lines: z.array(z.object({
                        by: z.enum(['left', 'right']),
                        text: z.string().min(1).max(80).optional(),
                        sound: z.enum([
                            'bark',
                            'whine',
                            'growl',
                            'pant',
                            'meow',
                            'purr',
                            'hiss'
                        ]).optional(),
                        mood: z.enum([
                            'happy',
                            'worried',
                            'thinking'
                        ]).optional(),
                        thought: z.boolean().optional()
                    })).min(1).max(4),
                    awaiting: z.enum(['left', 'right']).optional(),
                    props: z.array(z.string().max(40).regex(/^[a-z0-9]+(-[a-z0-9]+)*$/)).min(1).max(3).optional()
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    cast: z.array(z.object({
                        name: z.string().min(1).max(60),
                        you: z.boolean().optional(),
                        character: z.enum([
                            'betty',
                            'david',
                            'rosa',
                            'kofi',
                            'priya',
                            'sam',
                            'noor',
                            'tomi',
                            'biscuit',
                            'bolt'
                        ]).optional(),
                        pose: z.enum([
                            'sit',
                            'lean-in',
                            'arms-crossed',
                            'hand-on-chin',
                            'wave'
                        ]).optional(),
                        facing: z.enum(['left', 'right']).optional(),
                        slot: z.enum([
                            'left',
                            'center',
                            'right'
                        ]).optional(),
                        reaction: z.enum([
                            'happy',
                            'worried',
                            'thinking'
                        ]).optional(),
                        thought: z.string().min(1).max(80).optional()
                    })).min(1).max(3),
                    stakes: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.string().min(1).max(24),
                        tone: z.enum([
                            'default',
                            'up',
                            'down',
                            'accent',
                            'streak'
                        ]).optional()
                    })).min(1).max(4).optional(),
                    props: z.array(z.string().max(40).regex(/^[a-z0-9]+(-[a-z0-9]+)*$/)).min(1).max(3).optional()
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    left: z.object({
                        label: z.string().min(1).max(60),
                        gains: z.array(z.string().min(1).max(40)).min(1).max(3),
                        costs: z.array(z.string().min(1).max(40)).min(1).max(3)
                    }),
                    right: z.object({
                        label: z.string().min(1).max(60),
                        gains: z.array(z.string().min(1).max(40)).min(1).max(3),
                        costs: z.array(z.string().min(1).max(40)).min(1).max(3)
                    })
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    fork: z.string().min(1).max(80),
                    branches: z.array(z.object({
                        label: z.string().min(1).max(60),
                        outcome: z.string().min(1).max(60),
                        tone: z.enum(['up', 'down']).optional()
                    })).min(2).max(3)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    moments: z.array(z.object({
                        at: z.string().min(1).max(16),
                        label: z.string().min(1).max(60)
                    })).min(2).max(5),
                    now: z.int().gte(0).lte(9007199254740991).optional()
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    start: z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24)
                    }),
                    steps: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24),
                        op: z.enum([
                            'plus',
                            'minus',
                            'times',
                            'divide'
                        ])
                    })).min(1).max(2),
                    result: z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24)
                    })
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    price: z.object({
                        low: z.number(),
                        high: z.number()
                    }),
                    demand: z.object({
                        atLow: z.number().gte(0),
                        atHigh: z.number().gte(0)
                    }),
                    readoutLabel: z.string().min(1).max(60),
                    unit: z.string().max(8),
                    from: z.string().min(1).max(40),
                    to: z.string().min(1).max(40)
                })
            ]).optional(),
            hint: z.string().min(1).max(600).optional(),
            body: z.string().optional(),
            kind: z.string(),
            items: z.array(z.object({
                id: z.string().min(1),
                label: z.string().min(1).max(200)
            })).min(2).max(12),
            buckets: z.array(z.object({
                id: z.string().min(1),
                label: z.string().min(1).max(120)
            })).min(2).max(4)
        }),
        z.object({
            id: z.string().min(1),
            position: z.int().gte(1).lte(9007199254740991),
            prompt: z.string().min(1).max(400),
            verb: z.enum([
                'decide',
                'allocate',
                'rank',
                'match',
                'predict',
                'diagnose',
                'negotiate',
                'rephrase',
                'pitch',
                'speak',
                'simulate'
            ]).optional(),
            rung: z.enum([
                'RECOGNIZE',
                'DECIDE',
                'MANIPULATE',
                'CREATE',
                'SPEAK',
                'APPLY',
                'SIMULATE'
            ]).optional(),
            timeLimitMs: z.int().gte(1000).lte(9007199254740991).optional(),
            visual: z.union([
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    max: z.number(),
                    rows: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        previous: z.number().optional(),
                        display: z.string().min(1).max(24)
                    })).min(1).max(4)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    figures: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.string().min(1).max(24),
                        tone: z.enum([
                            'default',
                            'up',
                            'down',
                            'accent',
                            'streak'
                        ]).optional()
                    })).min(2).max(4)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    shares: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.number().gte(0),
                        display: z.string().min(1).max(24).optional()
                    })).min(2).max(6)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    stages: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.number().gte(0),
                        display: z.string().min(1).max(24)
                    })).min(2).max(5)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    start: z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24)
                    }),
                    steps: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24)
                    })).min(1).max(5),
                    end: z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24)
                    })
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    max: z.number(),
                    min: z.number().optional(),
                    rows: z.array(z.object({
                        label: z.string().min(1).max(60),
                        before: z.number(),
                        after: z.number(),
                        beforeDisplay: z.string().min(1).max(24),
                        afterDisplay: z.string().min(1).max(24)
                    })).min(1).max(4)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    x: z.object({
                        label: z.string().min(1).max(60),
                        low: z.string().min(1).max(40),
                        high: z.string().min(1).max(40)
                    }),
                    y: z.object({
                        label: z.string().min(1).max(60),
                        low: z.string().min(1).max(40),
                        high: z.string().min(1).max(40)
                    }),
                    quadrants: z.tuple([
                        z.string().min(1).max(40),
                        z.string().min(1).max(40),
                        z.string().min(1).max(40),
                        z.string().min(1).max(40)
                    ]).optional(),
                    items: z.array(z.object({
                        label: z.string().min(1).max(60),
                        x: z.number().gte(0).lte(1),
                        y: z.number().gte(0).lte(1)
                    })).min(1).max(4)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    steps: z.array(z.object({
                        label: z.string().min(1).max(60),
                        note: z.string().min(1).max(80).optional()
                    })).min(2).max(5)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    at: z.array(z.string().min(1).max(16)).min(2).max(8),
                    min: z.number(),
                    max: z.number(),
                    series: z.array(z.object({
                        label: z.string().min(1).max(60),
                        values: z.array(z.number()).min(2).max(8),
                        display: z.string().min(1).max(24)
                    })).min(1).max(6)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    columns: z.array(z.string().min(1).max(40)).min(2).max(3),
                    rows: z.array(z.object({
                        label: z.string().min(1).max(60),
                        cells: z.array(z.string().min(1).max(40)).max(3)
                    })).min(2).max(6)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    left: z.object({
                        name: z.string().min(1).max(60),
                        you: z.boolean().optional(),
                        character: z.enum([
                            'betty',
                            'david',
                            'rosa',
                            'kofi',
                            'priya',
                            'sam',
                            'noor',
                            'tomi',
                            'biscuit',
                            'bolt'
                        ]).optional(),
                        pose: z.enum([
                            'sit',
                            'lean-in',
                            'arms-crossed',
                            'hand-on-chin',
                            'wave'
                        ]).optional(),
                        facing: z.enum(['left', 'right']).optional(),
                        slot: z.enum([
                            'left',
                            'center',
                            'right'
                        ]).optional(),
                        reaction: z.enum([
                            'happy',
                            'worried',
                            'thinking'
                        ]).optional()
                    }),
                    right: z.object({
                        name: z.string().min(1).max(60),
                        you: z.boolean().optional(),
                        character: z.enum([
                            'betty',
                            'david',
                            'rosa',
                            'kofi',
                            'priya',
                            'sam',
                            'noor',
                            'tomi',
                            'biscuit',
                            'bolt'
                        ]).optional(),
                        pose: z.enum([
                            'sit',
                            'lean-in',
                            'arms-crossed',
                            'hand-on-chin',
                            'wave'
                        ]).optional(),
                        facing: z.enum(['left', 'right']).optional(),
                        slot: z.enum([
                            'left',
                            'center',
                            'right'
                        ]).optional(),
                        reaction: z.enum([
                            'happy',
                            'worried',
                            'thinking'
                        ]).optional()
                    }),
                    lines: z.array(z.object({
                        by: z.enum(['left', 'right']),
                        text: z.string().min(1).max(80).optional(),
                        sound: z.enum([
                            'bark',
                            'whine',
                            'growl',
                            'pant',
                            'meow',
                            'purr',
                            'hiss'
                        ]).optional(),
                        mood: z.enum([
                            'happy',
                            'worried',
                            'thinking'
                        ]).optional(),
                        thought: z.boolean().optional()
                    })).min(1).max(4),
                    awaiting: z.enum(['left', 'right']).optional(),
                    props: z.array(z.string().max(40).regex(/^[a-z0-9]+(-[a-z0-9]+)*$/)).min(1).max(3).optional()
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    cast: z.array(z.object({
                        name: z.string().min(1).max(60),
                        you: z.boolean().optional(),
                        character: z.enum([
                            'betty',
                            'david',
                            'rosa',
                            'kofi',
                            'priya',
                            'sam',
                            'noor',
                            'tomi',
                            'biscuit',
                            'bolt'
                        ]).optional(),
                        pose: z.enum([
                            'sit',
                            'lean-in',
                            'arms-crossed',
                            'hand-on-chin',
                            'wave'
                        ]).optional(),
                        facing: z.enum(['left', 'right']).optional(),
                        slot: z.enum([
                            'left',
                            'center',
                            'right'
                        ]).optional(),
                        reaction: z.enum([
                            'happy',
                            'worried',
                            'thinking'
                        ]).optional(),
                        thought: z.string().min(1).max(80).optional()
                    })).min(1).max(3),
                    stakes: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.string().min(1).max(24),
                        tone: z.enum([
                            'default',
                            'up',
                            'down',
                            'accent',
                            'streak'
                        ]).optional()
                    })).min(1).max(4).optional(),
                    props: z.array(z.string().max(40).regex(/^[a-z0-9]+(-[a-z0-9]+)*$/)).min(1).max(3).optional()
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    left: z.object({
                        label: z.string().min(1).max(60),
                        gains: z.array(z.string().min(1).max(40)).min(1).max(3),
                        costs: z.array(z.string().min(1).max(40)).min(1).max(3)
                    }),
                    right: z.object({
                        label: z.string().min(1).max(60),
                        gains: z.array(z.string().min(1).max(40)).min(1).max(3),
                        costs: z.array(z.string().min(1).max(40)).min(1).max(3)
                    })
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    fork: z.string().min(1).max(80),
                    branches: z.array(z.object({
                        label: z.string().min(1).max(60),
                        outcome: z.string().min(1).max(60),
                        tone: z.enum(['up', 'down']).optional()
                    })).min(2).max(3)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    moments: z.array(z.object({
                        at: z.string().min(1).max(16),
                        label: z.string().min(1).max(60)
                    })).min(2).max(5),
                    now: z.int().gte(0).lte(9007199254740991).optional()
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    start: z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24)
                    }),
                    steps: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24),
                        op: z.enum([
                            'plus',
                            'minus',
                            'times',
                            'divide'
                        ])
                    })).min(1).max(2),
                    result: z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24)
                    })
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    price: z.object({
                        low: z.number(),
                        high: z.number()
                    }),
                    demand: z.object({
                        atLow: z.number().gte(0),
                        atHigh: z.number().gte(0)
                    }),
                    readoutLabel: z.string().min(1).max(60),
                    unit: z.string().max(8),
                    from: z.string().min(1).max(40),
                    to: z.string().min(1).max(40)
                })
            ]).optional(),
            hint: z.string().min(1).max(600).optional(),
            body: z.string().optional(),
            kind: z.string(),
            min: z.number(),
            max: z.number(),
            step: z.number(),
            unit: z.string().max(24)
        }),
        z.object({
            id: z.string().min(1),
            position: z.int().gte(1).lte(9007199254740991),
            prompt: z.string().min(1).max(400),
            verb: z.enum([
                'decide',
                'allocate',
                'rank',
                'match',
                'predict',
                'diagnose',
                'negotiate',
                'rephrase',
                'pitch',
                'speak',
                'simulate'
            ]).optional(),
            rung: z.enum([
                'RECOGNIZE',
                'DECIDE',
                'MANIPULATE',
                'CREATE',
                'SPEAK',
                'APPLY',
                'SIMULATE'
            ]).optional(),
            timeLimitMs: z.int().gte(1000).lte(9007199254740991).optional(),
            visual: z.union([
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    max: z.number(),
                    rows: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        previous: z.number().optional(),
                        display: z.string().min(1).max(24)
                    })).min(1).max(4)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    figures: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.string().min(1).max(24),
                        tone: z.enum([
                            'default',
                            'up',
                            'down',
                            'accent',
                            'streak'
                        ]).optional()
                    })).min(2).max(4)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    shares: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.number().gte(0),
                        display: z.string().min(1).max(24).optional()
                    })).min(2).max(6)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    stages: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.number().gte(0),
                        display: z.string().min(1).max(24)
                    })).min(2).max(5)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    start: z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24)
                    }),
                    steps: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24)
                    })).min(1).max(5),
                    end: z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24)
                    })
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    max: z.number(),
                    min: z.number().optional(),
                    rows: z.array(z.object({
                        label: z.string().min(1).max(60),
                        before: z.number(),
                        after: z.number(),
                        beforeDisplay: z.string().min(1).max(24),
                        afterDisplay: z.string().min(1).max(24)
                    })).min(1).max(4)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    x: z.object({
                        label: z.string().min(1).max(60),
                        low: z.string().min(1).max(40),
                        high: z.string().min(1).max(40)
                    }),
                    y: z.object({
                        label: z.string().min(1).max(60),
                        low: z.string().min(1).max(40),
                        high: z.string().min(1).max(40)
                    }),
                    quadrants: z.tuple([
                        z.string().min(1).max(40),
                        z.string().min(1).max(40),
                        z.string().min(1).max(40),
                        z.string().min(1).max(40)
                    ]).optional(),
                    items: z.array(z.object({
                        label: z.string().min(1).max(60),
                        x: z.number().gte(0).lte(1),
                        y: z.number().gte(0).lte(1)
                    })).min(1).max(4)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    steps: z.array(z.object({
                        label: z.string().min(1).max(60),
                        note: z.string().min(1).max(80).optional()
                    })).min(2).max(5)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    at: z.array(z.string().min(1).max(16)).min(2).max(8),
                    min: z.number(),
                    max: z.number(),
                    series: z.array(z.object({
                        label: z.string().min(1).max(60),
                        values: z.array(z.number()).min(2).max(8),
                        display: z.string().min(1).max(24)
                    })).min(1).max(6)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    columns: z.array(z.string().min(1).max(40)).min(2).max(3),
                    rows: z.array(z.object({
                        label: z.string().min(1).max(60),
                        cells: z.array(z.string().min(1).max(40)).max(3)
                    })).min(2).max(6)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    left: z.object({
                        name: z.string().min(1).max(60),
                        you: z.boolean().optional(),
                        character: z.enum([
                            'betty',
                            'david',
                            'rosa',
                            'kofi',
                            'priya',
                            'sam',
                            'noor',
                            'tomi',
                            'biscuit',
                            'bolt'
                        ]).optional(),
                        pose: z.enum([
                            'sit',
                            'lean-in',
                            'arms-crossed',
                            'hand-on-chin',
                            'wave'
                        ]).optional(),
                        facing: z.enum(['left', 'right']).optional(),
                        slot: z.enum([
                            'left',
                            'center',
                            'right'
                        ]).optional(),
                        reaction: z.enum([
                            'happy',
                            'worried',
                            'thinking'
                        ]).optional()
                    }),
                    right: z.object({
                        name: z.string().min(1).max(60),
                        you: z.boolean().optional(),
                        character: z.enum([
                            'betty',
                            'david',
                            'rosa',
                            'kofi',
                            'priya',
                            'sam',
                            'noor',
                            'tomi',
                            'biscuit',
                            'bolt'
                        ]).optional(),
                        pose: z.enum([
                            'sit',
                            'lean-in',
                            'arms-crossed',
                            'hand-on-chin',
                            'wave'
                        ]).optional(),
                        facing: z.enum(['left', 'right']).optional(),
                        slot: z.enum([
                            'left',
                            'center',
                            'right'
                        ]).optional(),
                        reaction: z.enum([
                            'happy',
                            'worried',
                            'thinking'
                        ]).optional()
                    }),
                    lines: z.array(z.object({
                        by: z.enum(['left', 'right']),
                        text: z.string().min(1).max(80).optional(),
                        sound: z.enum([
                            'bark',
                            'whine',
                            'growl',
                            'pant',
                            'meow',
                            'purr',
                            'hiss'
                        ]).optional(),
                        mood: z.enum([
                            'happy',
                            'worried',
                            'thinking'
                        ]).optional(),
                        thought: z.boolean().optional()
                    })).min(1).max(4),
                    awaiting: z.enum(['left', 'right']).optional(),
                    props: z.array(z.string().max(40).regex(/^[a-z0-9]+(-[a-z0-9]+)*$/)).min(1).max(3).optional()
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    cast: z.array(z.object({
                        name: z.string().min(1).max(60),
                        you: z.boolean().optional(),
                        character: z.enum([
                            'betty',
                            'david',
                            'rosa',
                            'kofi',
                            'priya',
                            'sam',
                            'noor',
                            'tomi',
                            'biscuit',
                            'bolt'
                        ]).optional(),
                        pose: z.enum([
                            'sit',
                            'lean-in',
                            'arms-crossed',
                            'hand-on-chin',
                            'wave'
                        ]).optional(),
                        facing: z.enum(['left', 'right']).optional(),
                        slot: z.enum([
                            'left',
                            'center',
                            'right'
                        ]).optional(),
                        reaction: z.enum([
                            'happy',
                            'worried',
                            'thinking'
                        ]).optional(),
                        thought: z.string().min(1).max(80).optional()
                    })).min(1).max(3),
                    stakes: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.string().min(1).max(24),
                        tone: z.enum([
                            'default',
                            'up',
                            'down',
                            'accent',
                            'streak'
                        ]).optional()
                    })).min(1).max(4).optional(),
                    props: z.array(z.string().max(40).regex(/^[a-z0-9]+(-[a-z0-9]+)*$/)).min(1).max(3).optional()
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    left: z.object({
                        label: z.string().min(1).max(60),
                        gains: z.array(z.string().min(1).max(40)).min(1).max(3),
                        costs: z.array(z.string().min(1).max(40)).min(1).max(3)
                    }),
                    right: z.object({
                        label: z.string().min(1).max(60),
                        gains: z.array(z.string().min(1).max(40)).min(1).max(3),
                        costs: z.array(z.string().min(1).max(40)).min(1).max(3)
                    })
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    fork: z.string().min(1).max(80),
                    branches: z.array(z.object({
                        label: z.string().min(1).max(60),
                        outcome: z.string().min(1).max(60),
                        tone: z.enum(['up', 'down']).optional()
                    })).min(2).max(3)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    moments: z.array(z.object({
                        at: z.string().min(1).max(16),
                        label: z.string().min(1).max(60)
                    })).min(2).max(5),
                    now: z.int().gte(0).lte(9007199254740991).optional()
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    start: z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24)
                    }),
                    steps: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24),
                        op: z.enum([
                            'plus',
                            'minus',
                            'times',
                            'divide'
                        ])
                    })).min(1).max(2),
                    result: z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24)
                    })
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    price: z.object({
                        low: z.number(),
                        high: z.number()
                    }),
                    demand: z.object({
                        atLow: z.number().gte(0),
                        atHigh: z.number().gte(0)
                    }),
                    readoutLabel: z.string().min(1).max(60),
                    unit: z.string().max(8),
                    from: z.string().min(1).max(40),
                    to: z.string().min(1).max(40)
                })
            ]).optional(),
            hint: z.string().min(1).max(600).optional(),
            body: z.string().optional(),
            kind: z.string(),
            categories: z.array(z.object({
                id: z.string().min(1),
                label: z.string().min(1).max(200)
            })).min(2).max(8),
            poolTotal: z.number(),
            unit: z.string().max(24).optional()
        }),
        z.object({
            id: z.string().min(1),
            position: z.int().gte(1).lte(9007199254740991),
            prompt: z.string().min(1).max(400),
            verb: z.enum([
                'decide',
                'allocate',
                'rank',
                'match',
                'predict',
                'diagnose',
                'negotiate',
                'rephrase',
                'pitch',
                'speak',
                'simulate'
            ]).optional(),
            rung: z.enum([
                'RECOGNIZE',
                'DECIDE',
                'MANIPULATE',
                'CREATE',
                'SPEAK',
                'APPLY',
                'SIMULATE'
            ]).optional(),
            timeLimitMs: z.int().gte(1000).lte(9007199254740991).optional(),
            visual: z.union([
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    max: z.number(),
                    rows: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        previous: z.number().optional(),
                        display: z.string().min(1).max(24)
                    })).min(1).max(4)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    figures: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.string().min(1).max(24),
                        tone: z.enum([
                            'default',
                            'up',
                            'down',
                            'accent',
                            'streak'
                        ]).optional()
                    })).min(2).max(4)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    shares: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.number().gte(0),
                        display: z.string().min(1).max(24).optional()
                    })).min(2).max(6)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    stages: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.number().gte(0),
                        display: z.string().min(1).max(24)
                    })).min(2).max(5)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    start: z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24)
                    }),
                    steps: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24)
                    })).min(1).max(5),
                    end: z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24)
                    })
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    max: z.number(),
                    min: z.number().optional(),
                    rows: z.array(z.object({
                        label: z.string().min(1).max(60),
                        before: z.number(),
                        after: z.number(),
                        beforeDisplay: z.string().min(1).max(24),
                        afterDisplay: z.string().min(1).max(24)
                    })).min(1).max(4)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    x: z.object({
                        label: z.string().min(1).max(60),
                        low: z.string().min(1).max(40),
                        high: z.string().min(1).max(40)
                    }),
                    y: z.object({
                        label: z.string().min(1).max(60),
                        low: z.string().min(1).max(40),
                        high: z.string().min(1).max(40)
                    }),
                    quadrants: z.tuple([
                        z.string().min(1).max(40),
                        z.string().min(1).max(40),
                        z.string().min(1).max(40),
                        z.string().min(1).max(40)
                    ]).optional(),
                    items: z.array(z.object({
                        label: z.string().min(1).max(60),
                        x: z.number().gte(0).lte(1),
                        y: z.number().gte(0).lte(1)
                    })).min(1).max(4)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    steps: z.array(z.object({
                        label: z.string().min(1).max(60),
                        note: z.string().min(1).max(80).optional()
                    })).min(2).max(5)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    at: z.array(z.string().min(1).max(16)).min(2).max(8),
                    min: z.number(),
                    max: z.number(),
                    series: z.array(z.object({
                        label: z.string().min(1).max(60),
                        values: z.array(z.number()).min(2).max(8),
                        display: z.string().min(1).max(24)
                    })).min(1).max(6)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    columns: z.array(z.string().min(1).max(40)).min(2).max(3),
                    rows: z.array(z.object({
                        label: z.string().min(1).max(60),
                        cells: z.array(z.string().min(1).max(40)).max(3)
                    })).min(2).max(6)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    left: z.object({
                        name: z.string().min(1).max(60),
                        you: z.boolean().optional(),
                        character: z.enum([
                            'betty',
                            'david',
                            'rosa',
                            'kofi',
                            'priya',
                            'sam',
                            'noor',
                            'tomi',
                            'biscuit',
                            'bolt'
                        ]).optional(),
                        pose: z.enum([
                            'sit',
                            'lean-in',
                            'arms-crossed',
                            'hand-on-chin',
                            'wave'
                        ]).optional(),
                        facing: z.enum(['left', 'right']).optional(),
                        slot: z.enum([
                            'left',
                            'center',
                            'right'
                        ]).optional(),
                        reaction: z.enum([
                            'happy',
                            'worried',
                            'thinking'
                        ]).optional()
                    }),
                    right: z.object({
                        name: z.string().min(1).max(60),
                        you: z.boolean().optional(),
                        character: z.enum([
                            'betty',
                            'david',
                            'rosa',
                            'kofi',
                            'priya',
                            'sam',
                            'noor',
                            'tomi',
                            'biscuit',
                            'bolt'
                        ]).optional(),
                        pose: z.enum([
                            'sit',
                            'lean-in',
                            'arms-crossed',
                            'hand-on-chin',
                            'wave'
                        ]).optional(),
                        facing: z.enum(['left', 'right']).optional(),
                        slot: z.enum([
                            'left',
                            'center',
                            'right'
                        ]).optional(),
                        reaction: z.enum([
                            'happy',
                            'worried',
                            'thinking'
                        ]).optional()
                    }),
                    lines: z.array(z.object({
                        by: z.enum(['left', 'right']),
                        text: z.string().min(1).max(80).optional(),
                        sound: z.enum([
                            'bark',
                            'whine',
                            'growl',
                            'pant',
                            'meow',
                            'purr',
                            'hiss'
                        ]).optional(),
                        mood: z.enum([
                            'happy',
                            'worried',
                            'thinking'
                        ]).optional(),
                        thought: z.boolean().optional()
                    })).min(1).max(4),
                    awaiting: z.enum(['left', 'right']).optional(),
                    props: z.array(z.string().max(40).regex(/^[a-z0-9]+(-[a-z0-9]+)*$/)).min(1).max(3).optional()
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    cast: z.array(z.object({
                        name: z.string().min(1).max(60),
                        you: z.boolean().optional(),
                        character: z.enum([
                            'betty',
                            'david',
                            'rosa',
                            'kofi',
                            'priya',
                            'sam',
                            'noor',
                            'tomi',
                            'biscuit',
                            'bolt'
                        ]).optional(),
                        pose: z.enum([
                            'sit',
                            'lean-in',
                            'arms-crossed',
                            'hand-on-chin',
                            'wave'
                        ]).optional(),
                        facing: z.enum(['left', 'right']).optional(),
                        slot: z.enum([
                            'left',
                            'center',
                            'right'
                        ]).optional(),
                        reaction: z.enum([
                            'happy',
                            'worried',
                            'thinking'
                        ]).optional(),
                        thought: z.string().min(1).max(80).optional()
                    })).min(1).max(3),
                    stakes: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.string().min(1).max(24),
                        tone: z.enum([
                            'default',
                            'up',
                            'down',
                            'accent',
                            'streak'
                        ]).optional()
                    })).min(1).max(4).optional(),
                    props: z.array(z.string().max(40).regex(/^[a-z0-9]+(-[a-z0-9]+)*$/)).min(1).max(3).optional()
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    left: z.object({
                        label: z.string().min(1).max(60),
                        gains: z.array(z.string().min(1).max(40)).min(1).max(3),
                        costs: z.array(z.string().min(1).max(40)).min(1).max(3)
                    }),
                    right: z.object({
                        label: z.string().min(1).max(60),
                        gains: z.array(z.string().min(1).max(40)).min(1).max(3),
                        costs: z.array(z.string().min(1).max(40)).min(1).max(3)
                    })
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    fork: z.string().min(1).max(80),
                    branches: z.array(z.object({
                        label: z.string().min(1).max(60),
                        outcome: z.string().min(1).max(60),
                        tone: z.enum(['up', 'down']).optional()
                    })).min(2).max(3)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    moments: z.array(z.object({
                        at: z.string().min(1).max(16),
                        label: z.string().min(1).max(60)
                    })).min(2).max(5),
                    now: z.int().gte(0).lte(9007199254740991).optional()
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    start: z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24)
                    }),
                    steps: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24),
                        op: z.enum([
                            'plus',
                            'minus',
                            'times',
                            'divide'
                        ])
                    })).min(1).max(2),
                    result: z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24)
                    })
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    price: z.object({
                        low: z.number(),
                        high: z.number()
                    }),
                    demand: z.object({
                        atLow: z.number().gte(0),
                        atHigh: z.number().gte(0)
                    }),
                    readoutLabel: z.string().min(1).max(60),
                    unit: z.string().max(8),
                    from: z.string().min(1).max(40),
                    to: z.string().min(1).max(40)
                })
            ]).optional(),
            hint: z.string().min(1).max(600).optional(),
            body: z.string().optional(),
            kind: z.string()
        })
    ])),
    terms: z.array(z.object({
        term: z.string().min(1).max(80),
        definition: z.string().min(1),
        taughtIn: z.object({
            id: z.string().min(1),
            slug: z.string().min(1).max(200).regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/),
            title: z.string().min(1)
        }).optional()
    })),
    cast: z.array(z.object({
        character: z.enum([
            'betty',
            'david',
            'rosa',
            'kofi',
            'priya',
            'sam',
            'noor',
            'tomi',
            'biscuit',
            'bolt'
        ]),
        role: z.string().min(1).max(60)
    })).max(3).optional(),
    props: z.array(z.object({
        slug: z.string().max(40).regex(/^[a-z0-9]+(-[a-z0-9]+)*$/),
        label: z.string().min(1).max(40),
        readiness: z.enum([
            'ready',
            'limited',
            'pending'
        ])
    })).optional(),
    coverUrl: z.url().optional()
});
export const zAttentionQueueDtoOutput = z.object({
    summary: z.object({
        ISSUES: z.int().gte(0).lte(9007199254740991),
        DRAFTS: z.int().gte(0).lte(9007199254740991),
        WARNINGS: z.int().gte(0).lte(9007199254740991),
        NEEDS_REVIEW: z.int().gte(0).lte(9007199254740991),
        READY_TO_PUBLISH: z.int().gte(0).lte(9007199254740991),
        PROCESSING: z.int().gte(0).lte(9007199254740991)
    }),
    items: z.array(z.object({
        target: z.union([
            z.object({
                kind: z.string(),
                id: z.string().min(1)
            }),
            z.object({
                kind: z.string(),
                id: z.string().min(1)
            })
        ]),
        bucket: z.enum([
            'ISSUES',
            'DRAFTS',
            'WARNINGS',
            'NEEDS_REVIEW',
            'READY_TO_PUBLISH',
            'PROCESSING'
        ]),
        priority: z.enum([
            'CRITICAL',
            'NEEDS_ATTENTION',
            'NORMAL'
        ]),
        title: z.string().min(1),
        context: z.string(),
        reason: z.string().min(1),
        updatedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/)
    })),
    total: z.int().gte(0).lte(9007199254740991),
    lastImport: z.object({
        jobId: z.string().min(1),
        status: z.enum([
            'QUEUED',
            'RUNNING',
            'REVIEWING',
            'SUCCEEDED',
            'PARTIAL',
            'FAILED',
            'CANCELLED'
        ]),
        finishedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
        rowsTotal: z.int().gte(0).lte(9007199254740991),
        rowsSucceeded: z.int().gte(0).lte(9007199254740991),
        lessonsCreated: z.int().gte(0).lte(9007199254740991)
    }).optional()
});
export const zQaAuditDtoOutput = z.object({
    lessons: z.array(z.object({
        id: z.string(),
        slug: z.string(),
        title: z.string(),
        scenes: z.array(z.object({
            sceneId: z.string(),
            position: z.int().gte(-9007199254740991).lte(9007199254740991),
            prompt: z.string(),
            findings: z.array(z.object({
                id: z.string(),
                severity: z.enum(['BLOCKER', 'WARN']),
                finding: z.string(),
                suggestion: z.string()
            }))
        }))
    }))
});
export const zBrowsedCollectionsDtoOutput = z.object({
    collections: z.array(z.object({
        id: z.string().min(1),
        slug: z.string().min(3).max(80).regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/),
        title: z.string().min(3).max(120),
        summary: z.string().min(3).max(300),
        kind: z.enum([
            'COURSE',
            'MODULE',
            'PATH'
        ]),
        status: z.enum([
            'DRAFT',
            'PUBLISHED',
            'ARCHIVED'
        ]),
        subject: z.enum([
            'MARKETING',
            'FINANCE',
            'STRATEGY',
            'LEADERSHIP',
            'SALES',
            'NEGOTIATION',
            'ENTREPRENEURSHIP',
            'PUBLIC_SPEAKING',
            'COMMUNICATION',
            'OPERATIONS',
            'DECISIONS',
            'BUSINESS_FUNDAMENTALS',
            'TEAM_MANAGEMENT',
            'HIRING',
            'ORGANIZATIONAL_BEHAVIOR',
            'PRODUCT_MANAGEMENT',
            'AI',
            'INNOVATION',
            'PROJECT_MANAGEMENT',
            'BUSINESS_ANALYTICS',
            'CAREER',
            'PERSONAL_FINANCE',
            'ECONOMICS'
        ]).optional(),
        difficulty: z.enum([
            'BEGINNER',
            'INTERMEDIATE',
            'ADVANCED'
        ]).optional(),
        objectName: z.enum([
            'balance',
            'funnel',
            'stack',
            'bridge',
            'steps',
            'podium',
            'chart',
            'pie',
            'gauge',
            'magnifier',
            'beaker',
            'hourglass',
            'calendar',
            'clock',
            'stopwatch',
            'vault',
            'wallet',
            'receipt',
            'calculator',
            'ledger',
            'compass',
            'telescope',
            'map',
            'flag',
            'chess',
            'target',
            'gavel',
            'puzzle',
            'team',
            'network',
            'roundtable',
            'mic',
            'iceberg',
            'chat',
            'gears',
            'pipeline',
            'crate',
            'factory',
            'server',
            'spool',
            'clipboard',
            'tray',
            'basket',
            'folder',
            'bin',
            'lightbulb',
            'rocket',
            'key',
            'trophy',
            'briefcase'
        ]).optional(),
        parentId: z.string().min(1).optional(),
        parentTitle: z.string().min(3).max(120).optional(),
        lessons: z.int().gte(0).lte(9007199254740991),
        modules: z.int().gte(0).lte(9007199254740991),
        paths: z.array(z.object({
            id: z.string().min(1),
            slug: z.string().min(3).max(80).regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/),
            title: z.string().min(3).max(120),
            status: z.enum([
                'DRAFT',
                'PUBLISHED',
                'ARCHIVED'
            ]),
            position: z.int().gte(1).lte(9007199254740991),
            of: z.int().gte(1).lte(9007199254740991)
        })),
        updatedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/)
    })),
    total: z.int().gte(0).lte(9007199254740991)
});
export const zAuthoringCollectionDtoOutput = z.object({
    id: z.string().min(1),
    slug: z.string().min(3).max(80).regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/),
    title: z.string().min(3).max(120),
    summary: z.string().min(3).max(300),
    kind: z.enum([
        'COURSE',
        'MODULE',
        'PATH'
    ]),
    status: z.enum([
        'DRAFT',
        'PUBLISHED',
        'ARCHIVED'
    ]),
    subject: z.enum([
        'MARKETING',
        'FINANCE',
        'STRATEGY',
        'LEADERSHIP',
        'SALES',
        'NEGOTIATION',
        'ENTREPRENEURSHIP',
        'PUBLIC_SPEAKING',
        'COMMUNICATION',
        'OPERATIONS',
        'DECISIONS',
        'BUSINESS_FUNDAMENTALS',
        'TEAM_MANAGEMENT',
        'HIRING',
        'ORGANIZATIONAL_BEHAVIOR',
        'PRODUCT_MANAGEMENT',
        'AI',
        'INNOVATION',
        'PROJECT_MANAGEMENT',
        'BUSINESS_ANALYTICS',
        'CAREER',
        'PERSONAL_FINANCE',
        'ECONOMICS'
    ]).optional(),
    difficulty: z.enum([
        'BEGINNER',
        'INTERMEDIATE',
        'ADVANCED'
    ]).optional(),
    objectName: z.enum([
        'balance',
        'funnel',
        'stack',
        'bridge',
        'steps',
        'podium',
        'chart',
        'pie',
        'gauge',
        'magnifier',
        'beaker',
        'hourglass',
        'calendar',
        'clock',
        'stopwatch',
        'vault',
        'wallet',
        'receipt',
        'calculator',
        'ledger',
        'compass',
        'telescope',
        'map',
        'flag',
        'chess',
        'target',
        'gavel',
        'puzzle',
        'team',
        'network',
        'roundtable',
        'mic',
        'iceberg',
        'chat',
        'gears',
        'pipeline',
        'crate',
        'factory',
        'server',
        'spool',
        'clipboard',
        'tray',
        'basket',
        'folder',
        'bin',
        'lightbulb',
        'rocket',
        'key',
        'trophy',
        'briefcase'
    ]).optional(),
    parentId: z.string().min(1).optional(),
    parentTitle: z.string().min(3).max(120).optional(),
    lessons: z.int().gte(0).lte(9007199254740991),
    modules: z.int().gte(0).lte(9007199254740991),
    paths: z.array(z.object({
        id: z.string().min(1),
        slug: z.string().min(3).max(80).regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/),
        title: z.string().min(3).max(120),
        status: z.enum([
            'DRAFT',
            'PUBLISHED',
            'ARCHIVED'
        ]),
        position: z.int().gte(1).lte(9007199254740991),
        of: z.int().gte(1).lte(9007199254740991)
    })),
    updatedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
    palette: z.object({
        primary: z.string().regex(/^#[0-9a-f]{6}$/),
        secondary: z.string().regex(/^#[0-9a-f]{6}$/)
    }).optional(),
    sharedLessons: z.array(z.object({
        id: z.string().min(1),
        slug: z.string().min(3).max(80).regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/),
        title: z.string().min(3).max(120),
        otherCourses: z.array(z.string().min(3).max(120)).min(1)
    }))
});
export const zBrowsedLessonsDtoOutput = z.object({
    lessons: z.array(z.object({
        id: z.string().min(1),
        slug: z.string().min(3).max(80).regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/),
        title: z.string().min(3).max(120),
        status: z.enum([
            'DRAFT',
            'PUBLISHED',
            'ARCHIVED'
        ]),
        difficulty: z.enum([
            'BEGINNER',
            'INTERMEDIATE',
            'ADVANCED'
        ]).optional(),
        scenes: z.int().gte(0).lte(9007199254740991),
        blockers: z.int().gte(0).lte(9007199254740991),
        personas: z.array(z.enum([
            'CAREER_STARTER',
            'RISING_MANAGER',
            'FUTURE_EXECUTIVE',
            'FOUNDER_OWNER',
            'EXPERIENCED_IC',
            'CAREER_SWITCHER'
        ])),
        tags: z.array(z.string().min(2).max(60).regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/)),
        module: z.object({
            id: z.string().min(1),
            title: z.string().min(3).max(120)
        }).optional(),
        course: z.object({
            id: z.string().min(1),
            title: z.string().min(3).max(120)
        }).optional(),
        paths: z.array(z.object({
            id: z.string().min(1),
            title: z.string().min(3).max(120)
        })),
        createdAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
        publishedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).optional(),
        updatedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
        version: z.int().gte(1).lte(9007199254740991),
        feedback: z.object({
            count: z.int().gte(0).lte(9007199254740991),
            helpful: z.int().gte(0).lte(9007199254740991),
            notHelpful: z.int().gte(0).lte(9007199254740991),
            helpfulRate: z.number().gte(0).lte(1).optional(),
            topReason: z.enum([
                'CONFUSING',
                'TOO_BASIC',
                'TOO_DIFFICULT',
                'NOT_RELEVANT',
                'SOMETHING_WRONG'
            ]).optional(),
            lastAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).optional()
        }),
        review: z.object({
            status: z.enum([
                'NEEDS_REVIEW',
                'APPROVED',
                'NEEDS_CHANGES'
            ]),
            reason: z.string().optional()
        }).optional()
    })),
    total: z.int().gte(0).lte(9007199254740991)
});
export const zTagListDtoOutput = z.object({
    tags: z.array(z.object({
        slug: z.string().min(2).max(60).regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/),
        label: z.string().min(1).max(80)
    }))
});
export const zArchiveLessonsDto = z.object({
    lessonIds: z.array(z.string().min(1)).min(1).max(100)
});
export const zArchivedDtoOutput = z.object({
    archived: z.int().gte(0).lte(9007199254740991)
});
export const zRelabelLessonsDto = z.object({
    lessonIds: z.array(z.string().min(1)).min(1).max(100),
    difficulty: z.enum([
        'BEGINNER',
        'INTERMEDIATE',
        'ADVANCED'
    ]).optional(),
    personas: z.array(z.enum([
        'CAREER_STARTER',
        'RISING_MANAGER',
        'FUTURE_EXECUTIVE',
        'FOUNDER_OWNER',
        'EXPERIENCED_IC',
        'CAREER_SWITCHER'
    ])).max(6).optional()
});
export const zRelabelledDtoOutput = z.object({
    relabelled: z.int().gte(0).lte(9007199254740991)
});
export const zCreateCollectionDto = z.object({
    slug: z.string().min(3).max(80).regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/),
    kind: z.enum([
        'COURSE',
        'MODULE',
        'PATH'
    ]),
    title: z.string().min(3).max(120),
    summary: z.string().min(3).max(300),
    parentId: z.string().min(1).optional(),
    position: z.int().gte(0).lte(999).optional(),
    subject: z.enum([
        'MARKETING',
        'FINANCE',
        'STRATEGY',
        'LEADERSHIP',
        'SALES',
        'NEGOTIATION',
        'ENTREPRENEURSHIP',
        'PUBLIC_SPEAKING',
        'COMMUNICATION',
        'OPERATIONS',
        'DECISIONS',
        'BUSINESS_FUNDAMENTALS',
        'TEAM_MANAGEMENT',
        'HIRING',
        'ORGANIZATIONAL_BEHAVIOR',
        'PRODUCT_MANAGEMENT',
        'AI',
        'INNOVATION',
        'PROJECT_MANAGEMENT',
        'BUSINESS_ANALYTICS',
        'CAREER',
        'PERSONAL_FINANCE',
        'ECONOMICS'
    ]).optional(),
    difficulty: z.enum([
        'BEGINNER',
        'INTERMEDIATE',
        'ADVANCED'
    ]).optional(),
    objectName: z.enum([
        'balance',
        'funnel',
        'stack',
        'bridge',
        'steps',
        'podium',
        'chart',
        'pie',
        'gauge',
        'magnifier',
        'beaker',
        'hourglass',
        'calendar',
        'clock',
        'stopwatch',
        'vault',
        'wallet',
        'receipt',
        'calculator',
        'ledger',
        'compass',
        'telescope',
        'map',
        'flag',
        'chess',
        'target',
        'gavel',
        'puzzle',
        'team',
        'network',
        'roundtable',
        'mic',
        'iceberg',
        'chat',
        'gears',
        'pipeline',
        'crate',
        'factory',
        'server',
        'spool',
        'clipboard',
        'tray',
        'basket',
        'folder',
        'bin',
        'lightbulb',
        'rocket',
        'key',
        'trophy',
        'briefcase'
    ]).optional(),
    imageUrl: z.url().optional(),
    palette: z.object({
        primary: z.string().regex(/^#[0-9a-f]{6}$/),
        secondary: z.string().regex(/^#[0-9a-f]{6}$/)
    }).optional(),
    personas: z.array(z.object({
        persona: z.enum([
            'CAREER_STARTER',
            'RISING_MANAGER',
            'FUTURE_EXECUTIVE',
            'FOUNDER_OWNER',
            'EXPERIENCED_IC',
            'CAREER_SWITCHER'
        ]),
        fit: z.enum([
            'IDEAL',
            'SUITABLE',
            'STRETCH',
            'UNSUITABLE'
        ]).optional()
    })).max(6).optional()
});
export const zWrittenDtoOutput = z.object({
    id: z.string().min(1),
    state: z.enum([
        'created',
        'updated',
        'accepted'
    ]).optional()
});
export const zUpdateCollectionDto = z.object({
    slug: z.string().min(3).max(80).regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/).optional(),
    kind: z.enum([
        'COURSE',
        'MODULE',
        'PATH'
    ]).optional(),
    title: z.string().min(3).max(120).optional(),
    summary: z.string().min(3).max(300).optional(),
    parentId: z.string().min(1).optional(),
    position: z.int().gte(0).lte(999).optional(),
    subject: z.enum([
        'MARKETING',
        'FINANCE',
        'STRATEGY',
        'LEADERSHIP',
        'SALES',
        'NEGOTIATION',
        'ENTREPRENEURSHIP',
        'PUBLIC_SPEAKING',
        'COMMUNICATION',
        'OPERATIONS',
        'DECISIONS',
        'BUSINESS_FUNDAMENTALS',
        'TEAM_MANAGEMENT',
        'HIRING',
        'ORGANIZATIONAL_BEHAVIOR',
        'PRODUCT_MANAGEMENT',
        'AI',
        'INNOVATION',
        'PROJECT_MANAGEMENT',
        'BUSINESS_ANALYTICS',
        'CAREER',
        'PERSONAL_FINANCE',
        'ECONOMICS'
    ]).optional(),
    difficulty: z.enum([
        'BEGINNER',
        'INTERMEDIATE',
        'ADVANCED'
    ]).optional(),
    objectName: z.enum([
        'balance',
        'funnel',
        'stack',
        'bridge',
        'steps',
        'podium',
        'chart',
        'pie',
        'gauge',
        'magnifier',
        'beaker',
        'hourglass',
        'calendar',
        'clock',
        'stopwatch',
        'vault',
        'wallet',
        'receipt',
        'calculator',
        'ledger',
        'compass',
        'telescope',
        'map',
        'flag',
        'chess',
        'target',
        'gavel',
        'puzzle',
        'team',
        'network',
        'roundtable',
        'mic',
        'iceberg',
        'chat',
        'gears',
        'pipeline',
        'crate',
        'factory',
        'server',
        'spool',
        'clipboard',
        'tray',
        'basket',
        'folder',
        'bin',
        'lightbulb',
        'rocket',
        'key',
        'trophy',
        'briefcase'
    ]).optional(),
    imageUrl: z.url().optional(),
    palette: z.union([
        z.object({
            primary: z.string().regex(/^#[0-9a-f]{6}$/),
            secondary: z.string().regex(/^#[0-9a-f]{6}$/)
        }),
        z.unknown()
    ]).optional(),
    personas: z.array(z.object({
        persona: z.enum([
            'CAREER_STARTER',
            'RISING_MANAGER',
            'FUTURE_EXECUTIVE',
            'FOUNDER_OWNER',
            'EXPERIENCED_IC',
            'CAREER_SWITCHER'
        ]),
        fit: z.enum([
            'IDEAL',
            'SUITABLE',
            'STRETCH',
            'UNSUITABLE'
        ]).optional()
    })).max(6).optional(),
    status: z.enum([
        'DRAFT',
        'PUBLISHED',
        'ARCHIVED'
    ]).optional()
});
export const zMembershipsDto = z.object({
    lessons: z.array(z.object({
        lessonId: z.string().min(1),
        position: z.int().gte(1).lte(60)
    })).max(60)
});
export const zAttachedDtoOutput = z.object({
    attached: z.int().gte(0).lte(9007199254740991)
});
export const zAddLessonsDto = z.object({
    lessonIds: z.array(z.string().min(1)).min(1).max(60)
});
export const zCollectionLessonsDtoOutput = z.object({
    lessons: z.array(z.object({
        id: z.string().min(1),
        slug: z.string().min(3).max(80).regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/),
        title: z.string().min(3).max(120),
        status: z.enum([
            'DRAFT',
            'PUBLISHED',
            'ARCHIVED'
        ]),
        position: z.int().gte(-9007199254740991).lte(9007199254740991),
        scenes: z.int().gte(0).lte(9007199254740991)
    })),
    generation: z.object({
        jobId: z.string().min(1),
        live: z.boolean(),
        lessons: z.object({
            total: z.int().gte(0).lte(9007199254740991),
            pending: z.int().gte(0).lte(9007199254740991),
            running: z.int().gte(0).lte(9007199254740991),
            succeeded: z.int().gte(0).lte(9007199254740991),
            partial: z.int().gte(0).lte(9007199254740991),
            failed: z.int().gte(0).lte(9007199254740991),
            skipped: z.int().gte(0).lte(9007199254740991)
        })
    }).optional()
});
export const zPlaceModulesDto = z.object({
    moduleIds: z.array(z.string().min(1)).max(60)
});
export const zAddModulesDto = z.object({
    moduleIds: z.array(z.string().min(1)).min(1).max(60)
});
export const zPathModulesDtoOutput = z.object({
    modules: z.array(z.object({
        id: z.string().min(1),
        slug: z.string().min(3).max(80).regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/),
        title: z.string().min(3).max(120),
        status: z.enum([
            'DRAFT',
            'PUBLISHED',
            'ARCHIVED'
        ]),
        position: z.int().gte(1).lte(9007199254740991),
        courseTitle: z.string().min(3).max(120).optional(),
        lessons: z.array(z.object({
            id: z.string().min(1),
            slug: z.string().min(3).max(80).regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/),
            title: z.string().min(3).max(120),
            status: z.enum([
                'DRAFT',
                'PUBLISHED',
                'ARCHIVED'
            ]),
            position: z.int().gte(-9007199254740991).lte(9007199254740991),
            scenes: z.int().gte(0).lte(9007199254740991)
        }))
    }))
});
export const zSubtreeReadinessDtoOutput = z.object({
    status: z.enum([
        'DRAFT',
        'PUBLISHED',
        'ARCHIVED'
    ]),
    issues: z.array(z.object({
        path: z.string(),
        message: z.string(),
        item: z.object({
            kind: z.enum([
                'COURSE',
                'MODULE',
                'PATH',
                'LESSON'
            ]),
            id: z.string().min(1),
            title: z.string()
        })
    })),
    openBlockers: z.int().gte(0).lte(9007199254740991),
    blockers: z.array(z.object({
        path: z.string(),
        message: z.string(),
        item: z.object({
            kind: z.enum([
                'COURSE',
                'MODULE',
                'PATH',
                'LESSON'
            ]),
            id: z.string().min(1),
            title: z.string()
        })
    })),
    stopped: z.array(z.object({
        path: z.string(),
        message: z.string(),
        item: z.object({
            kind: z.enum([
                'COURSE',
                'MODULE',
                'PATH',
                'LESSON'
            ]),
            id: z.string().min(1),
            title: z.string()
        })
    })),
    review: z.enum([
        'NONE',
        'RUNNING',
        'DONE',
        'NOT_RUN'
    ]),
    draftLessons: z.int().gte(0).lte(9007199254740991),
    going: z.array(z.object({
        id: z.string(),
        slug: z.string(),
        title: z.string(),
        change: z.enum(['NEW', 'UPDATE'])
    })),
    held: z.array(z.object({
        id: z.string(),
        slug: z.string(),
        title: z.string(),
        change: z.enum(['NEW', 'UPDATE'])
    })),
    course: z.object({
        id: z.string(),
        title: z.string()
    }).optional()
});
export const zPublishCollectionDto = z.object({
    acknowledgeBlockers: z.boolean(),
    lessonIds: z.array(z.string().min(1)).max(500).optional()
});
export const zPublishedDtoOutput = z.object({
    collections: z.int().gte(0).lte(9007199254740991),
    lessons: z.int().gte(0).lte(9007199254740991),
    course: z.object({
        id: z.string(),
        title: z.string()
    }).optional()
});
export const zCreateLessonDto = z.object({
    slug: z.string().min(3).max(80).regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/),
    title: z.string().min(3).max(120),
    summary: z.string().min(3).max(300),
    format: z.enum([
        'STANDARD',
        'FLASHCARDS',
        'DRILL'
    ]).optional(),
    estimatedMinutes: z.int().gte(1).lte(60),
    difficulty: z.enum([
        'BEGINNER',
        'INTERMEDIATE',
        'ADVANCED'
    ]).optional(),
    objectName: z.enum([
        'balance',
        'funnel',
        'stack',
        'bridge',
        'steps',
        'podium',
        'chart',
        'pie',
        'gauge',
        'magnifier',
        'beaker',
        'hourglass',
        'calendar',
        'clock',
        'stopwatch',
        'vault',
        'wallet',
        'receipt',
        'calculator',
        'ledger',
        'compass',
        'telescope',
        'map',
        'flag',
        'chess',
        'target',
        'gavel',
        'puzzle',
        'team',
        'network',
        'roundtable',
        'mic',
        'iceberg',
        'chat',
        'gears',
        'pipeline',
        'crate',
        'factory',
        'server',
        'spool',
        'clipboard',
        'tray',
        'basket',
        'folder',
        'bin',
        'lightbulb',
        'rocket',
        'key',
        'trophy',
        'briefcase'
    ]).optional(),
    verb: z.enum([
        'decide',
        'allocate',
        'rank',
        'match',
        'predict',
        'diagnose',
        'negotiate',
        'rephrase',
        'pitch',
        'speak',
        'simulate'
    ]).optional(),
    personas: z.array(z.object({
        persona: z.enum([
            'CAREER_STARTER',
            'RISING_MANAGER',
            'FUTURE_EXECUTIVE',
            'FOUNDER_OWNER',
            'EXPERIENCED_IC',
            'CAREER_SWITCHER'
        ]),
        fit: z.enum([
            'IDEAL',
            'SUITABLE',
            'STRETCH',
            'UNSUITABLE'
        ]).optional()
    })).max(6).optional(),
    tags: z.array(z.string().min(2).max(60).regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/)).max(12).optional(),
    terms: z.array(z.object({
        term: z.string().min(1).max(80),
        definition: z.string().min(1).max(300),
        taughtInLessonId: z.string().min(1).optional()
    })).max(12).optional(),
    cast: z.array(z.object({
        character: z.enum([
            'betty',
            'david',
            'rosa',
            'kofi',
            'priya',
            'sam',
            'noor',
            'tomi',
            'biscuit',
            'bolt'
        ]),
        role: z.string().min(1).max(60)
    })).max(3).optional(),
    curriculumLessonId: z.string().min(1).max(64).optional()
});
export const zLessonFeedbackReportDtoOutput = z.object({
    version: z.int().gte(1).lte(9007199254740991),
    versions: z.array(z.object({
        count: z.int().gte(0).lte(9007199254740991),
        helpful: z.int().gte(0).lte(9007199254740991),
        notHelpful: z.int().gte(0).lte(9007199254740991),
        helpfulRate: z.number().gte(0).lte(1).optional(),
        topReason: z.enum([
            'CONFUSING',
            'TOO_BASIC',
            'TOO_DIFFICULT',
            'NOT_RELEVANT',
            'SOMETHING_WRONG'
        ]).optional(),
        lastAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).optional(),
        version: z.int().gte(1).lte(9007199254740991),
        reasons: z.array(z.object({
            reason: z.enum([
                'CONFUSING',
                'TOO_BASIC',
                'TOO_DIFFICULT',
                'NOT_RELEVANT',
                'SOMETHING_WRONG'
            ]),
            count: z.int().gte(1).lte(9007199254740991)
        }))
    })),
    named: z.array(z.object({
        name: z.string().min(1),
        email: z.string().min(1),
        helpful: z.boolean(),
        reasons: z.array(z.enum([
            'CONFUSING',
            'TOO_BASIC',
            'TOO_DIFFICULT',
            'NOT_RELEVANT',
            'SOMETHING_WRONG'
        ])),
        lessonVersion: z.int().gte(1).lte(9007199254740991),
        scorePct: z.int().gte(0).lte(100),
        answeredAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/)
    })).max(100)
});
export const zUpdateLessonDto = z.object({
    slug: z.string().min(3).max(80).regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/).optional(),
    title: z.string().min(3).max(120).optional(),
    summary: z.string().min(3).max(300).optional(),
    format: z.enum([
        'STANDARD',
        'FLASHCARDS',
        'DRILL'
    ]).optional(),
    estimatedMinutes: z.int().gte(1).lte(60).optional(),
    difficulty: z.enum([
        'BEGINNER',
        'INTERMEDIATE',
        'ADVANCED'
    ]).optional(),
    objectName: z.enum([
        'balance',
        'funnel',
        'stack',
        'bridge',
        'steps',
        'podium',
        'chart',
        'pie',
        'gauge',
        'magnifier',
        'beaker',
        'hourglass',
        'calendar',
        'clock',
        'stopwatch',
        'vault',
        'wallet',
        'receipt',
        'calculator',
        'ledger',
        'compass',
        'telescope',
        'map',
        'flag',
        'chess',
        'target',
        'gavel',
        'puzzle',
        'team',
        'network',
        'roundtable',
        'mic',
        'iceberg',
        'chat',
        'gears',
        'pipeline',
        'crate',
        'factory',
        'server',
        'spool',
        'clipboard',
        'tray',
        'basket',
        'folder',
        'bin',
        'lightbulb',
        'rocket',
        'key',
        'trophy',
        'briefcase'
    ]).optional(),
    verb: z.enum([
        'decide',
        'allocate',
        'rank',
        'match',
        'predict',
        'diagnose',
        'negotiate',
        'rephrase',
        'pitch',
        'speak',
        'simulate'
    ]).optional(),
    personas: z.array(z.object({
        persona: z.enum([
            'CAREER_STARTER',
            'RISING_MANAGER',
            'FUTURE_EXECUTIVE',
            'FOUNDER_OWNER',
            'EXPERIENCED_IC',
            'CAREER_SWITCHER'
        ]),
        fit: z.enum([
            'IDEAL',
            'SUITABLE',
            'STRETCH',
            'UNSUITABLE'
        ]).optional()
    })).max(6).optional(),
    tags: z.array(z.string().min(2).max(60).regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/)).max(12).optional(),
    terms: z.array(z.object({
        term: z.string().min(1).max(80),
        definition: z.string().min(1).max(300),
        taughtInLessonId: z.string().min(1).optional()
    })).max(12).optional(),
    cast: z.array(z.object({
        character: z.enum([
            'betty',
            'david',
            'rosa',
            'kofi',
            'priya',
            'sam',
            'noor',
            'tomi',
            'biscuit',
            'bolt'
        ]),
        role: z.string().min(1).max(60)
    })).max(3).optional(),
    status: z.enum([
        'DRAFT',
        'PUBLISHED',
        'ARCHIVED'
    ]).optional()
});
export const zPlacementsDto = z.object({
    scenes: z.array(z.object({
        sceneId: z.string().min(1),
        position: z.int().gte(1).lte(64),
        timeLimitMs: z.int().gte(1000).lte(600000).optional()
    })).min(1).max(64)
});
export const zPlacedDtoOutput = z.object({
    placed: z.int().gte(0).lte(9007199254740991)
});
export const zLessonReviewDtoOutput = z.object({
    slug: z.string().min(1).max(200).regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/),
    title: z.string().min(1).max(120),
    summary: z.string().min(1).max(300),
    difficulty: z.enum([
        'BEGINNER',
        'INTERMEDIATE',
        'ADVANCED'
    ]).optional(),
    objectName: z.enum([
        'balance',
        'funnel',
        'stack',
        'bridge',
        'steps',
        'podium',
        'chart',
        'pie',
        'gauge',
        'magnifier',
        'beaker',
        'hourglass',
        'calendar',
        'clock',
        'stopwatch',
        'vault',
        'wallet',
        'receipt',
        'calculator',
        'ledger',
        'compass',
        'telescope',
        'map',
        'flag',
        'chess',
        'target',
        'gavel',
        'puzzle',
        'team',
        'network',
        'roundtable',
        'mic',
        'iceberg',
        'chat',
        'gears',
        'pipeline',
        'crate',
        'factory',
        'server',
        'spool',
        'clipboard',
        'tray',
        'basket',
        'folder',
        'bin',
        'lightbulb',
        'rocket',
        'key',
        'trophy',
        'briefcase'
    ]).optional(),
    id: z.string().min(1),
    format: z.enum([
        'STANDARD',
        'FLASHCARDS',
        'DRILL'
    ]),
    verb: z.enum([
        'decide',
        'allocate',
        'rank',
        'match',
        'predict',
        'diagnose',
        'negotiate',
        'rephrase',
        'pitch',
        'speak',
        'simulate'
    ]).optional(),
    estimatedMinutes: z.int().gte(1).lte(60),
    family: z.enum([
        'growth',
        'finance',
        'people'
    ]),
    palette: z.object({
        primary: z.string().regex(/^#[0-9a-f]{6}$/),
        secondary: z.string().regex(/^#[0-9a-f]{6}$/)
    }).optional(),
    scenes: z.array(z.union([
        z.object({
            id: z.string().min(1),
            position: z.int().gte(1).lte(9007199254740991),
            prompt: z.string().min(1).max(400),
            verb: z.enum([
                'decide',
                'allocate',
                'rank',
                'match',
                'predict',
                'diagnose',
                'negotiate',
                'rephrase',
                'pitch',
                'speak',
                'simulate'
            ]).optional(),
            rung: z.enum([
                'RECOGNIZE',
                'DECIDE',
                'MANIPULATE',
                'CREATE',
                'SPEAK',
                'APPLY',
                'SIMULATE'
            ]).optional(),
            timeLimitMs: z.int().gte(1000).lte(9007199254740991).optional(),
            visual: z.union([
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    max: z.number(),
                    rows: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        previous: z.number().optional(),
                        display: z.string().min(1).max(24)
                    })).min(1).max(4)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    figures: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.string().min(1).max(24),
                        tone: z.enum([
                            'default',
                            'up',
                            'down',
                            'accent',
                            'streak'
                        ]).optional()
                    })).min(2).max(4)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    shares: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.number().gte(0),
                        display: z.string().min(1).max(24).optional()
                    })).min(2).max(6)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    stages: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.number().gte(0),
                        display: z.string().min(1).max(24)
                    })).min(2).max(5)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    start: z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24)
                    }),
                    steps: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24)
                    })).min(1).max(5),
                    end: z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24)
                    })
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    max: z.number(),
                    min: z.number().optional(),
                    rows: z.array(z.object({
                        label: z.string().min(1).max(60),
                        before: z.number(),
                        after: z.number(),
                        beforeDisplay: z.string().min(1).max(24),
                        afterDisplay: z.string().min(1).max(24)
                    })).min(1).max(4)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    x: z.object({
                        label: z.string().min(1).max(60),
                        low: z.string().min(1).max(40),
                        high: z.string().min(1).max(40)
                    }),
                    y: z.object({
                        label: z.string().min(1).max(60),
                        low: z.string().min(1).max(40),
                        high: z.string().min(1).max(40)
                    }),
                    quadrants: z.tuple([
                        z.string().min(1).max(40),
                        z.string().min(1).max(40),
                        z.string().min(1).max(40),
                        z.string().min(1).max(40)
                    ]).optional(),
                    items: z.array(z.object({
                        label: z.string().min(1).max(60),
                        x: z.number().gte(0).lte(1),
                        y: z.number().gte(0).lte(1)
                    })).min(1).max(4)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    steps: z.array(z.object({
                        label: z.string().min(1).max(60),
                        note: z.string().min(1).max(80).optional()
                    })).min(2).max(5)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    at: z.array(z.string().min(1).max(16)).min(2).max(8),
                    min: z.number(),
                    max: z.number(),
                    series: z.array(z.object({
                        label: z.string().min(1).max(60),
                        values: z.array(z.number()).min(2).max(8),
                        display: z.string().min(1).max(24)
                    })).min(1).max(6)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    columns: z.array(z.string().min(1).max(40)).min(2).max(3),
                    rows: z.array(z.object({
                        label: z.string().min(1).max(60),
                        cells: z.array(z.string().min(1).max(40)).max(3)
                    })).min(2).max(6)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    left: z.object({
                        name: z.string().min(1).max(60),
                        you: z.boolean().optional(),
                        character: z.enum([
                            'betty',
                            'david',
                            'rosa',
                            'kofi',
                            'priya',
                            'sam',
                            'noor',
                            'tomi',
                            'biscuit',
                            'bolt'
                        ]).optional(),
                        pose: z.enum([
                            'sit',
                            'lean-in',
                            'arms-crossed',
                            'hand-on-chin',
                            'wave'
                        ]).optional(),
                        facing: z.enum(['left', 'right']).optional(),
                        slot: z.enum([
                            'left',
                            'center',
                            'right'
                        ]).optional(),
                        reaction: z.enum([
                            'happy',
                            'worried',
                            'thinking'
                        ]).optional()
                    }),
                    right: z.object({
                        name: z.string().min(1).max(60),
                        you: z.boolean().optional(),
                        character: z.enum([
                            'betty',
                            'david',
                            'rosa',
                            'kofi',
                            'priya',
                            'sam',
                            'noor',
                            'tomi',
                            'biscuit',
                            'bolt'
                        ]).optional(),
                        pose: z.enum([
                            'sit',
                            'lean-in',
                            'arms-crossed',
                            'hand-on-chin',
                            'wave'
                        ]).optional(),
                        facing: z.enum(['left', 'right']).optional(),
                        slot: z.enum([
                            'left',
                            'center',
                            'right'
                        ]).optional(),
                        reaction: z.enum([
                            'happy',
                            'worried',
                            'thinking'
                        ]).optional()
                    }),
                    lines: z.array(z.object({
                        by: z.enum(['left', 'right']),
                        text: z.string().min(1).max(80).optional(),
                        sound: z.enum([
                            'bark',
                            'whine',
                            'growl',
                            'pant',
                            'meow',
                            'purr',
                            'hiss'
                        ]).optional(),
                        mood: z.enum([
                            'happy',
                            'worried',
                            'thinking'
                        ]).optional(),
                        thought: z.boolean().optional()
                    })).min(1).max(4),
                    awaiting: z.enum(['left', 'right']).optional(),
                    props: z.array(z.string().max(40).regex(/^[a-z0-9]+(-[a-z0-9]+)*$/)).min(1).max(3).optional()
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    cast: z.array(z.object({
                        name: z.string().min(1).max(60),
                        you: z.boolean().optional(),
                        character: z.enum([
                            'betty',
                            'david',
                            'rosa',
                            'kofi',
                            'priya',
                            'sam',
                            'noor',
                            'tomi',
                            'biscuit',
                            'bolt'
                        ]).optional(),
                        pose: z.enum([
                            'sit',
                            'lean-in',
                            'arms-crossed',
                            'hand-on-chin',
                            'wave'
                        ]).optional(),
                        facing: z.enum(['left', 'right']).optional(),
                        slot: z.enum([
                            'left',
                            'center',
                            'right'
                        ]).optional(),
                        reaction: z.enum([
                            'happy',
                            'worried',
                            'thinking'
                        ]).optional(),
                        thought: z.string().min(1).max(80).optional()
                    })).min(1).max(3),
                    stakes: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.string().min(1).max(24),
                        tone: z.enum([
                            'default',
                            'up',
                            'down',
                            'accent',
                            'streak'
                        ]).optional()
                    })).min(1).max(4).optional(),
                    props: z.array(z.string().max(40).regex(/^[a-z0-9]+(-[a-z0-9]+)*$/)).min(1).max(3).optional()
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    left: z.object({
                        label: z.string().min(1).max(60),
                        gains: z.array(z.string().min(1).max(40)).min(1).max(3),
                        costs: z.array(z.string().min(1).max(40)).min(1).max(3)
                    }),
                    right: z.object({
                        label: z.string().min(1).max(60),
                        gains: z.array(z.string().min(1).max(40)).min(1).max(3),
                        costs: z.array(z.string().min(1).max(40)).min(1).max(3)
                    })
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    fork: z.string().min(1).max(80),
                    branches: z.array(z.object({
                        label: z.string().min(1).max(60),
                        outcome: z.string().min(1).max(60),
                        tone: z.enum(['up', 'down']).optional()
                    })).min(2).max(3)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    moments: z.array(z.object({
                        at: z.string().min(1).max(16),
                        label: z.string().min(1).max(60)
                    })).min(2).max(5),
                    now: z.int().gte(0).lte(9007199254740991).optional()
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    start: z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24)
                    }),
                    steps: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24),
                        op: z.enum([
                            'plus',
                            'minus',
                            'times',
                            'divide'
                        ])
                    })).min(1).max(2),
                    result: z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24)
                    })
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    price: z.object({
                        low: z.number(),
                        high: z.number()
                    }),
                    demand: z.object({
                        atLow: z.number().gte(0),
                        atHigh: z.number().gte(0)
                    }),
                    readoutLabel: z.string().min(1).max(60),
                    unit: z.string().max(8),
                    from: z.string().min(1).max(40),
                    to: z.string().min(1).max(40)
                })
            ]).optional(),
            hint: z.string().min(1).max(600).optional(),
            body: z.string().optional(),
            imageUrl: z.url().optional(),
            objectName: z.enum([
                'balance',
                'funnel',
                'stack',
                'bridge',
                'steps',
                'podium',
                'chart',
                'pie',
                'gauge',
                'magnifier',
                'beaker',
                'hourglass',
                'calendar',
                'clock',
                'stopwatch',
                'vault',
                'wallet',
                'receipt',
                'calculator',
                'ledger',
                'compass',
                'telescope',
                'map',
                'flag',
                'chess',
                'target',
                'gavel',
                'puzzle',
                'team',
                'network',
                'roundtable',
                'mic',
                'iceberg',
                'chat',
                'gears',
                'pipeline',
                'crate',
                'factory',
                'server',
                'spool',
                'clipboard',
                'tray',
                'basket',
                'folder',
                'bin',
                'lightbulb',
                'rocket',
                'key',
                'trophy',
                'briefcase'
            ]).optional(),
            kind: z.string(),
            hintEnabled: z.boolean(),
            bodyEnabled: z.boolean(),
            bodyPredatesRules: z.boolean(),
            warnings: z.array(z.object({
                field: z.string(),
                message: z.string(),
                fixable: z.boolean(),
                blocks: z.boolean()
            })).default([])
        }),
        z.object({
            id: z.string().min(1),
            position: z.int().gte(1).lte(9007199254740991),
            prompt: z.string().min(1).max(400),
            verb: z.enum([
                'decide',
                'allocate',
                'rank',
                'match',
                'predict',
                'diagnose',
                'negotiate',
                'rephrase',
                'pitch',
                'speak',
                'simulate'
            ]).optional(),
            rung: z.enum([
                'RECOGNIZE',
                'DECIDE',
                'MANIPULATE',
                'CREATE',
                'SPEAK',
                'APPLY',
                'SIMULATE'
            ]).optional(),
            timeLimitMs: z.int().gte(1000).lte(9007199254740991).optional(),
            visual: z.union([
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    max: z.number(),
                    rows: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        previous: z.number().optional(),
                        display: z.string().min(1).max(24)
                    })).min(1).max(4)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    figures: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.string().min(1).max(24),
                        tone: z.enum([
                            'default',
                            'up',
                            'down',
                            'accent',
                            'streak'
                        ]).optional()
                    })).min(2).max(4)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    shares: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.number().gte(0),
                        display: z.string().min(1).max(24).optional()
                    })).min(2).max(6)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    stages: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.number().gte(0),
                        display: z.string().min(1).max(24)
                    })).min(2).max(5)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    start: z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24)
                    }),
                    steps: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24)
                    })).min(1).max(5),
                    end: z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24)
                    })
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    max: z.number(),
                    min: z.number().optional(),
                    rows: z.array(z.object({
                        label: z.string().min(1).max(60),
                        before: z.number(),
                        after: z.number(),
                        beforeDisplay: z.string().min(1).max(24),
                        afterDisplay: z.string().min(1).max(24)
                    })).min(1).max(4)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    x: z.object({
                        label: z.string().min(1).max(60),
                        low: z.string().min(1).max(40),
                        high: z.string().min(1).max(40)
                    }),
                    y: z.object({
                        label: z.string().min(1).max(60),
                        low: z.string().min(1).max(40),
                        high: z.string().min(1).max(40)
                    }),
                    quadrants: z.tuple([
                        z.string().min(1).max(40),
                        z.string().min(1).max(40),
                        z.string().min(1).max(40),
                        z.string().min(1).max(40)
                    ]).optional(),
                    items: z.array(z.object({
                        label: z.string().min(1).max(60),
                        x: z.number().gte(0).lte(1),
                        y: z.number().gte(0).lte(1)
                    })).min(1).max(4)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    steps: z.array(z.object({
                        label: z.string().min(1).max(60),
                        note: z.string().min(1).max(80).optional()
                    })).min(2).max(5)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    at: z.array(z.string().min(1).max(16)).min(2).max(8),
                    min: z.number(),
                    max: z.number(),
                    series: z.array(z.object({
                        label: z.string().min(1).max(60),
                        values: z.array(z.number()).min(2).max(8),
                        display: z.string().min(1).max(24)
                    })).min(1).max(6)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    columns: z.array(z.string().min(1).max(40)).min(2).max(3),
                    rows: z.array(z.object({
                        label: z.string().min(1).max(60),
                        cells: z.array(z.string().min(1).max(40)).max(3)
                    })).min(2).max(6)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    left: z.object({
                        name: z.string().min(1).max(60),
                        you: z.boolean().optional(),
                        character: z.enum([
                            'betty',
                            'david',
                            'rosa',
                            'kofi',
                            'priya',
                            'sam',
                            'noor',
                            'tomi',
                            'biscuit',
                            'bolt'
                        ]).optional(),
                        pose: z.enum([
                            'sit',
                            'lean-in',
                            'arms-crossed',
                            'hand-on-chin',
                            'wave'
                        ]).optional(),
                        facing: z.enum(['left', 'right']).optional(),
                        slot: z.enum([
                            'left',
                            'center',
                            'right'
                        ]).optional(),
                        reaction: z.enum([
                            'happy',
                            'worried',
                            'thinking'
                        ]).optional()
                    }),
                    right: z.object({
                        name: z.string().min(1).max(60),
                        you: z.boolean().optional(),
                        character: z.enum([
                            'betty',
                            'david',
                            'rosa',
                            'kofi',
                            'priya',
                            'sam',
                            'noor',
                            'tomi',
                            'biscuit',
                            'bolt'
                        ]).optional(),
                        pose: z.enum([
                            'sit',
                            'lean-in',
                            'arms-crossed',
                            'hand-on-chin',
                            'wave'
                        ]).optional(),
                        facing: z.enum(['left', 'right']).optional(),
                        slot: z.enum([
                            'left',
                            'center',
                            'right'
                        ]).optional(),
                        reaction: z.enum([
                            'happy',
                            'worried',
                            'thinking'
                        ]).optional()
                    }),
                    lines: z.array(z.object({
                        by: z.enum(['left', 'right']),
                        text: z.string().min(1).max(80).optional(),
                        sound: z.enum([
                            'bark',
                            'whine',
                            'growl',
                            'pant',
                            'meow',
                            'purr',
                            'hiss'
                        ]).optional(),
                        mood: z.enum([
                            'happy',
                            'worried',
                            'thinking'
                        ]).optional(),
                        thought: z.boolean().optional()
                    })).min(1).max(4),
                    awaiting: z.enum(['left', 'right']).optional(),
                    props: z.array(z.string().max(40).regex(/^[a-z0-9]+(-[a-z0-9]+)*$/)).min(1).max(3).optional()
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    cast: z.array(z.object({
                        name: z.string().min(1).max(60),
                        you: z.boolean().optional(),
                        character: z.enum([
                            'betty',
                            'david',
                            'rosa',
                            'kofi',
                            'priya',
                            'sam',
                            'noor',
                            'tomi',
                            'biscuit',
                            'bolt'
                        ]).optional(),
                        pose: z.enum([
                            'sit',
                            'lean-in',
                            'arms-crossed',
                            'hand-on-chin',
                            'wave'
                        ]).optional(),
                        facing: z.enum(['left', 'right']).optional(),
                        slot: z.enum([
                            'left',
                            'center',
                            'right'
                        ]).optional(),
                        reaction: z.enum([
                            'happy',
                            'worried',
                            'thinking'
                        ]).optional(),
                        thought: z.string().min(1).max(80).optional()
                    })).min(1).max(3),
                    stakes: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.string().min(1).max(24),
                        tone: z.enum([
                            'default',
                            'up',
                            'down',
                            'accent',
                            'streak'
                        ]).optional()
                    })).min(1).max(4).optional(),
                    props: z.array(z.string().max(40).regex(/^[a-z0-9]+(-[a-z0-9]+)*$/)).min(1).max(3).optional()
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    left: z.object({
                        label: z.string().min(1).max(60),
                        gains: z.array(z.string().min(1).max(40)).min(1).max(3),
                        costs: z.array(z.string().min(1).max(40)).min(1).max(3)
                    }),
                    right: z.object({
                        label: z.string().min(1).max(60),
                        gains: z.array(z.string().min(1).max(40)).min(1).max(3),
                        costs: z.array(z.string().min(1).max(40)).min(1).max(3)
                    })
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    fork: z.string().min(1).max(80),
                    branches: z.array(z.object({
                        label: z.string().min(1).max(60),
                        outcome: z.string().min(1).max(60),
                        tone: z.enum(['up', 'down']).optional()
                    })).min(2).max(3)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    moments: z.array(z.object({
                        at: z.string().min(1).max(16),
                        label: z.string().min(1).max(60)
                    })).min(2).max(5),
                    now: z.int().gte(0).lte(9007199254740991).optional()
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    start: z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24)
                    }),
                    steps: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24),
                        op: z.enum([
                            'plus',
                            'minus',
                            'times',
                            'divide'
                        ])
                    })).min(1).max(2),
                    result: z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24)
                    })
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    price: z.object({
                        low: z.number(),
                        high: z.number()
                    }),
                    demand: z.object({
                        atLow: z.number().gte(0),
                        atHigh: z.number().gte(0)
                    }),
                    readoutLabel: z.string().min(1).max(60),
                    unit: z.string().max(8),
                    from: z.string().min(1).max(40),
                    to: z.string().min(1).max(40)
                })
            ]).optional(),
            hint: z.string().min(1).max(600).optional(),
            body: z.string().optional(),
            imageUrl: z.url().optional(),
            objectName: z.enum([
                'balance',
                'funnel',
                'stack',
                'bridge',
                'steps',
                'podium',
                'chart',
                'pie',
                'gauge',
                'magnifier',
                'beaker',
                'hourglass',
                'calendar',
                'clock',
                'stopwatch',
                'vault',
                'wallet',
                'receipt',
                'calculator',
                'ledger',
                'compass',
                'telescope',
                'map',
                'flag',
                'chess',
                'target',
                'gavel',
                'puzzle',
                'team',
                'network',
                'roundtable',
                'mic',
                'iceberg',
                'chat',
                'gears',
                'pipeline',
                'crate',
                'factory',
                'server',
                'spool',
                'clipboard',
                'tray',
                'basket',
                'folder',
                'bin',
                'lightbulb',
                'rocket',
                'key',
                'trophy',
                'briefcase'
            ]).optional(),
            kind: z.string(),
            hintEnabled: z.boolean(),
            bodyEnabled: z.boolean(),
            bodyPredatesRules: z.boolean(),
            warnings: z.array(z.object({
                field: z.string(),
                message: z.string(),
                fixable: z.boolean(),
                blocks: z.boolean()
            })).default([])
        }),
        z.object({
            id: z.string().min(1),
            position: z.int().gte(1).lte(9007199254740991),
            prompt: z.string().min(1).max(400),
            verb: z.enum([
                'decide',
                'allocate',
                'rank',
                'match',
                'predict',
                'diagnose',
                'negotiate',
                'rephrase',
                'pitch',
                'speak',
                'simulate'
            ]).optional(),
            rung: z.enum([
                'RECOGNIZE',
                'DECIDE',
                'MANIPULATE',
                'CREATE',
                'SPEAK',
                'APPLY',
                'SIMULATE'
            ]).optional(),
            timeLimitMs: z.int().gte(1000).lte(9007199254740991).optional(),
            visual: z.union([
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    max: z.number(),
                    rows: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        previous: z.number().optional(),
                        display: z.string().min(1).max(24)
                    })).min(1).max(4)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    figures: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.string().min(1).max(24),
                        tone: z.enum([
                            'default',
                            'up',
                            'down',
                            'accent',
                            'streak'
                        ]).optional()
                    })).min(2).max(4)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    shares: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.number().gte(0),
                        display: z.string().min(1).max(24).optional()
                    })).min(2).max(6)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    stages: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.number().gte(0),
                        display: z.string().min(1).max(24)
                    })).min(2).max(5)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    start: z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24)
                    }),
                    steps: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24)
                    })).min(1).max(5),
                    end: z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24)
                    })
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    max: z.number(),
                    min: z.number().optional(),
                    rows: z.array(z.object({
                        label: z.string().min(1).max(60),
                        before: z.number(),
                        after: z.number(),
                        beforeDisplay: z.string().min(1).max(24),
                        afterDisplay: z.string().min(1).max(24)
                    })).min(1).max(4)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    x: z.object({
                        label: z.string().min(1).max(60),
                        low: z.string().min(1).max(40),
                        high: z.string().min(1).max(40)
                    }),
                    y: z.object({
                        label: z.string().min(1).max(60),
                        low: z.string().min(1).max(40),
                        high: z.string().min(1).max(40)
                    }),
                    quadrants: z.tuple([
                        z.string().min(1).max(40),
                        z.string().min(1).max(40),
                        z.string().min(1).max(40),
                        z.string().min(1).max(40)
                    ]).optional(),
                    items: z.array(z.object({
                        label: z.string().min(1).max(60),
                        x: z.number().gte(0).lte(1),
                        y: z.number().gte(0).lte(1)
                    })).min(1).max(4)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    steps: z.array(z.object({
                        label: z.string().min(1).max(60),
                        note: z.string().min(1).max(80).optional()
                    })).min(2).max(5)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    at: z.array(z.string().min(1).max(16)).min(2).max(8),
                    min: z.number(),
                    max: z.number(),
                    series: z.array(z.object({
                        label: z.string().min(1).max(60),
                        values: z.array(z.number()).min(2).max(8),
                        display: z.string().min(1).max(24)
                    })).min(1).max(6)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    columns: z.array(z.string().min(1).max(40)).min(2).max(3),
                    rows: z.array(z.object({
                        label: z.string().min(1).max(60),
                        cells: z.array(z.string().min(1).max(40)).max(3)
                    })).min(2).max(6)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    left: z.object({
                        name: z.string().min(1).max(60),
                        you: z.boolean().optional(),
                        character: z.enum([
                            'betty',
                            'david',
                            'rosa',
                            'kofi',
                            'priya',
                            'sam',
                            'noor',
                            'tomi',
                            'biscuit',
                            'bolt'
                        ]).optional(),
                        pose: z.enum([
                            'sit',
                            'lean-in',
                            'arms-crossed',
                            'hand-on-chin',
                            'wave'
                        ]).optional(),
                        facing: z.enum(['left', 'right']).optional(),
                        slot: z.enum([
                            'left',
                            'center',
                            'right'
                        ]).optional(),
                        reaction: z.enum([
                            'happy',
                            'worried',
                            'thinking'
                        ]).optional()
                    }),
                    right: z.object({
                        name: z.string().min(1).max(60),
                        you: z.boolean().optional(),
                        character: z.enum([
                            'betty',
                            'david',
                            'rosa',
                            'kofi',
                            'priya',
                            'sam',
                            'noor',
                            'tomi',
                            'biscuit',
                            'bolt'
                        ]).optional(),
                        pose: z.enum([
                            'sit',
                            'lean-in',
                            'arms-crossed',
                            'hand-on-chin',
                            'wave'
                        ]).optional(),
                        facing: z.enum(['left', 'right']).optional(),
                        slot: z.enum([
                            'left',
                            'center',
                            'right'
                        ]).optional(),
                        reaction: z.enum([
                            'happy',
                            'worried',
                            'thinking'
                        ]).optional()
                    }),
                    lines: z.array(z.object({
                        by: z.enum(['left', 'right']),
                        text: z.string().min(1).max(80).optional(),
                        sound: z.enum([
                            'bark',
                            'whine',
                            'growl',
                            'pant',
                            'meow',
                            'purr',
                            'hiss'
                        ]).optional(),
                        mood: z.enum([
                            'happy',
                            'worried',
                            'thinking'
                        ]).optional(),
                        thought: z.boolean().optional()
                    })).min(1).max(4),
                    awaiting: z.enum(['left', 'right']).optional(),
                    props: z.array(z.string().max(40).regex(/^[a-z0-9]+(-[a-z0-9]+)*$/)).min(1).max(3).optional()
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    cast: z.array(z.object({
                        name: z.string().min(1).max(60),
                        you: z.boolean().optional(),
                        character: z.enum([
                            'betty',
                            'david',
                            'rosa',
                            'kofi',
                            'priya',
                            'sam',
                            'noor',
                            'tomi',
                            'biscuit',
                            'bolt'
                        ]).optional(),
                        pose: z.enum([
                            'sit',
                            'lean-in',
                            'arms-crossed',
                            'hand-on-chin',
                            'wave'
                        ]).optional(),
                        facing: z.enum(['left', 'right']).optional(),
                        slot: z.enum([
                            'left',
                            'center',
                            'right'
                        ]).optional(),
                        reaction: z.enum([
                            'happy',
                            'worried',
                            'thinking'
                        ]).optional(),
                        thought: z.string().min(1).max(80).optional()
                    })).min(1).max(3),
                    stakes: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.string().min(1).max(24),
                        tone: z.enum([
                            'default',
                            'up',
                            'down',
                            'accent',
                            'streak'
                        ]).optional()
                    })).min(1).max(4).optional(),
                    props: z.array(z.string().max(40).regex(/^[a-z0-9]+(-[a-z0-9]+)*$/)).min(1).max(3).optional()
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    left: z.object({
                        label: z.string().min(1).max(60),
                        gains: z.array(z.string().min(1).max(40)).min(1).max(3),
                        costs: z.array(z.string().min(1).max(40)).min(1).max(3)
                    }),
                    right: z.object({
                        label: z.string().min(1).max(60),
                        gains: z.array(z.string().min(1).max(40)).min(1).max(3),
                        costs: z.array(z.string().min(1).max(40)).min(1).max(3)
                    })
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    fork: z.string().min(1).max(80),
                    branches: z.array(z.object({
                        label: z.string().min(1).max(60),
                        outcome: z.string().min(1).max(60),
                        tone: z.enum(['up', 'down']).optional()
                    })).min(2).max(3)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    moments: z.array(z.object({
                        at: z.string().min(1).max(16),
                        label: z.string().min(1).max(60)
                    })).min(2).max(5),
                    now: z.int().gte(0).lte(9007199254740991).optional()
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    start: z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24)
                    }),
                    steps: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24),
                        op: z.enum([
                            'plus',
                            'minus',
                            'times',
                            'divide'
                        ])
                    })).min(1).max(2),
                    result: z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24)
                    })
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    price: z.object({
                        low: z.number(),
                        high: z.number()
                    }),
                    demand: z.object({
                        atLow: z.number().gte(0),
                        atHigh: z.number().gte(0)
                    }),
                    readoutLabel: z.string().min(1).max(60),
                    unit: z.string().max(8),
                    from: z.string().min(1).max(40),
                    to: z.string().min(1).max(40)
                })
            ]).optional(),
            hint: z.string().min(1).max(600).optional(),
            body: z.string().optional(),
            imageUrl: z.url().optional(),
            objectName: z.enum([
                'balance',
                'funnel',
                'stack',
                'bridge',
                'steps',
                'podium',
                'chart',
                'pie',
                'gauge',
                'magnifier',
                'beaker',
                'hourglass',
                'calendar',
                'clock',
                'stopwatch',
                'vault',
                'wallet',
                'receipt',
                'calculator',
                'ledger',
                'compass',
                'telescope',
                'map',
                'flag',
                'chess',
                'target',
                'gavel',
                'puzzle',
                'team',
                'network',
                'roundtable',
                'mic',
                'iceberg',
                'chat',
                'gears',
                'pipeline',
                'crate',
                'factory',
                'server',
                'spool',
                'clipboard',
                'tray',
                'basket',
                'folder',
                'bin',
                'lightbulb',
                'rocket',
                'key',
                'trophy',
                'briefcase'
            ]).optional(),
            kind: z.string(),
            hintEnabled: z.boolean(),
            bodyEnabled: z.boolean(),
            bodyPredatesRules: z.boolean(),
            warnings: z.array(z.object({
                field: z.string(),
                message: z.string(),
                fixable: z.boolean(),
                blocks: z.boolean()
            })).default([])
        }),
        z.object({
            id: z.string().min(1),
            position: z.int().gte(1).lte(9007199254740991),
            prompt: z.string().min(1).max(400),
            verb: z.enum([
                'decide',
                'allocate',
                'rank',
                'match',
                'predict',
                'diagnose',
                'negotiate',
                'rephrase',
                'pitch',
                'speak',
                'simulate'
            ]).optional(),
            rung: z.enum([
                'RECOGNIZE',
                'DECIDE',
                'MANIPULATE',
                'CREATE',
                'SPEAK',
                'APPLY',
                'SIMULATE'
            ]).optional(),
            timeLimitMs: z.int().gte(1000).lte(9007199254740991).optional(),
            visual: z.union([
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    max: z.number(),
                    rows: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        previous: z.number().optional(),
                        display: z.string().min(1).max(24)
                    })).min(1).max(4)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    figures: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.string().min(1).max(24),
                        tone: z.enum([
                            'default',
                            'up',
                            'down',
                            'accent',
                            'streak'
                        ]).optional()
                    })).min(2).max(4)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    shares: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.number().gte(0),
                        display: z.string().min(1).max(24).optional()
                    })).min(2).max(6)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    stages: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.number().gte(0),
                        display: z.string().min(1).max(24)
                    })).min(2).max(5)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    start: z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24)
                    }),
                    steps: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24)
                    })).min(1).max(5),
                    end: z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24)
                    })
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    max: z.number(),
                    min: z.number().optional(),
                    rows: z.array(z.object({
                        label: z.string().min(1).max(60),
                        before: z.number(),
                        after: z.number(),
                        beforeDisplay: z.string().min(1).max(24),
                        afterDisplay: z.string().min(1).max(24)
                    })).min(1).max(4)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    x: z.object({
                        label: z.string().min(1).max(60),
                        low: z.string().min(1).max(40),
                        high: z.string().min(1).max(40)
                    }),
                    y: z.object({
                        label: z.string().min(1).max(60),
                        low: z.string().min(1).max(40),
                        high: z.string().min(1).max(40)
                    }),
                    quadrants: z.tuple([
                        z.string().min(1).max(40),
                        z.string().min(1).max(40),
                        z.string().min(1).max(40),
                        z.string().min(1).max(40)
                    ]).optional(),
                    items: z.array(z.object({
                        label: z.string().min(1).max(60),
                        x: z.number().gte(0).lte(1),
                        y: z.number().gte(0).lte(1)
                    })).min(1).max(4)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    steps: z.array(z.object({
                        label: z.string().min(1).max(60),
                        note: z.string().min(1).max(80).optional()
                    })).min(2).max(5)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    at: z.array(z.string().min(1).max(16)).min(2).max(8),
                    min: z.number(),
                    max: z.number(),
                    series: z.array(z.object({
                        label: z.string().min(1).max(60),
                        values: z.array(z.number()).min(2).max(8),
                        display: z.string().min(1).max(24)
                    })).min(1).max(6)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    columns: z.array(z.string().min(1).max(40)).min(2).max(3),
                    rows: z.array(z.object({
                        label: z.string().min(1).max(60),
                        cells: z.array(z.string().min(1).max(40)).max(3)
                    })).min(2).max(6)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    left: z.object({
                        name: z.string().min(1).max(60),
                        you: z.boolean().optional(),
                        character: z.enum([
                            'betty',
                            'david',
                            'rosa',
                            'kofi',
                            'priya',
                            'sam',
                            'noor',
                            'tomi',
                            'biscuit',
                            'bolt'
                        ]).optional(),
                        pose: z.enum([
                            'sit',
                            'lean-in',
                            'arms-crossed',
                            'hand-on-chin',
                            'wave'
                        ]).optional(),
                        facing: z.enum(['left', 'right']).optional(),
                        slot: z.enum([
                            'left',
                            'center',
                            'right'
                        ]).optional(),
                        reaction: z.enum([
                            'happy',
                            'worried',
                            'thinking'
                        ]).optional()
                    }),
                    right: z.object({
                        name: z.string().min(1).max(60),
                        you: z.boolean().optional(),
                        character: z.enum([
                            'betty',
                            'david',
                            'rosa',
                            'kofi',
                            'priya',
                            'sam',
                            'noor',
                            'tomi',
                            'biscuit',
                            'bolt'
                        ]).optional(),
                        pose: z.enum([
                            'sit',
                            'lean-in',
                            'arms-crossed',
                            'hand-on-chin',
                            'wave'
                        ]).optional(),
                        facing: z.enum(['left', 'right']).optional(),
                        slot: z.enum([
                            'left',
                            'center',
                            'right'
                        ]).optional(),
                        reaction: z.enum([
                            'happy',
                            'worried',
                            'thinking'
                        ]).optional()
                    }),
                    lines: z.array(z.object({
                        by: z.enum(['left', 'right']),
                        text: z.string().min(1).max(80).optional(),
                        sound: z.enum([
                            'bark',
                            'whine',
                            'growl',
                            'pant',
                            'meow',
                            'purr',
                            'hiss'
                        ]).optional(),
                        mood: z.enum([
                            'happy',
                            'worried',
                            'thinking'
                        ]).optional(),
                        thought: z.boolean().optional()
                    })).min(1).max(4),
                    awaiting: z.enum(['left', 'right']).optional(),
                    props: z.array(z.string().max(40).regex(/^[a-z0-9]+(-[a-z0-9]+)*$/)).min(1).max(3).optional()
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    cast: z.array(z.object({
                        name: z.string().min(1).max(60),
                        you: z.boolean().optional(),
                        character: z.enum([
                            'betty',
                            'david',
                            'rosa',
                            'kofi',
                            'priya',
                            'sam',
                            'noor',
                            'tomi',
                            'biscuit',
                            'bolt'
                        ]).optional(),
                        pose: z.enum([
                            'sit',
                            'lean-in',
                            'arms-crossed',
                            'hand-on-chin',
                            'wave'
                        ]).optional(),
                        facing: z.enum(['left', 'right']).optional(),
                        slot: z.enum([
                            'left',
                            'center',
                            'right'
                        ]).optional(),
                        reaction: z.enum([
                            'happy',
                            'worried',
                            'thinking'
                        ]).optional(),
                        thought: z.string().min(1).max(80).optional()
                    })).min(1).max(3),
                    stakes: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.string().min(1).max(24),
                        tone: z.enum([
                            'default',
                            'up',
                            'down',
                            'accent',
                            'streak'
                        ]).optional()
                    })).min(1).max(4).optional(),
                    props: z.array(z.string().max(40).regex(/^[a-z0-9]+(-[a-z0-9]+)*$/)).min(1).max(3).optional()
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    left: z.object({
                        label: z.string().min(1).max(60),
                        gains: z.array(z.string().min(1).max(40)).min(1).max(3),
                        costs: z.array(z.string().min(1).max(40)).min(1).max(3)
                    }),
                    right: z.object({
                        label: z.string().min(1).max(60),
                        gains: z.array(z.string().min(1).max(40)).min(1).max(3),
                        costs: z.array(z.string().min(1).max(40)).min(1).max(3)
                    })
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    fork: z.string().min(1).max(80),
                    branches: z.array(z.object({
                        label: z.string().min(1).max(60),
                        outcome: z.string().min(1).max(60),
                        tone: z.enum(['up', 'down']).optional()
                    })).min(2).max(3)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    moments: z.array(z.object({
                        at: z.string().min(1).max(16),
                        label: z.string().min(1).max(60)
                    })).min(2).max(5),
                    now: z.int().gte(0).lte(9007199254740991).optional()
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    start: z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24)
                    }),
                    steps: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24),
                        op: z.enum([
                            'plus',
                            'minus',
                            'times',
                            'divide'
                        ])
                    })).min(1).max(2),
                    result: z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24)
                    })
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    price: z.object({
                        low: z.number(),
                        high: z.number()
                    }),
                    demand: z.object({
                        atLow: z.number().gte(0),
                        atHigh: z.number().gte(0)
                    }),
                    readoutLabel: z.string().min(1).max(60),
                    unit: z.string().max(8),
                    from: z.string().min(1).max(40),
                    to: z.string().min(1).max(40)
                })
            ]).optional(),
            hint: z.string().min(1).max(600).optional(),
            body: z.string().optional(),
            imageUrl: z.url().optional(),
            objectName: z.enum([
                'balance',
                'funnel',
                'stack',
                'bridge',
                'steps',
                'podium',
                'chart',
                'pie',
                'gauge',
                'magnifier',
                'beaker',
                'hourglass',
                'calendar',
                'clock',
                'stopwatch',
                'vault',
                'wallet',
                'receipt',
                'calculator',
                'ledger',
                'compass',
                'telescope',
                'map',
                'flag',
                'chess',
                'target',
                'gavel',
                'puzzle',
                'team',
                'network',
                'roundtable',
                'mic',
                'iceberg',
                'chat',
                'gears',
                'pipeline',
                'crate',
                'factory',
                'server',
                'spool',
                'clipboard',
                'tray',
                'basket',
                'folder',
                'bin',
                'lightbulb',
                'rocket',
                'key',
                'trophy',
                'briefcase'
            ]).optional(),
            kind: z.string(),
            sourceId: z.string().min(1).optional(),
            sourceTitle: z.string().min(1).optional(),
            sourceUrl: z.url().optional(),
            citation: z.string().optional(),
            hintEnabled: z.boolean(),
            bodyEnabled: z.boolean(),
            bodyPredatesRules: z.boolean(),
            warnings: z.array(z.object({
                field: z.string(),
                message: z.string(),
                fixable: z.boolean(),
                blocks: z.boolean()
            })).default([])
        }),
        z.object({
            id: z.string().min(1),
            position: z.int().gte(1).lte(9007199254740991),
            prompt: z.string().min(1).max(400),
            verb: z.enum([
                'decide',
                'allocate',
                'rank',
                'match',
                'predict',
                'diagnose',
                'negotiate',
                'rephrase',
                'pitch',
                'speak',
                'simulate'
            ]).optional(),
            rung: z.enum([
                'RECOGNIZE',
                'DECIDE',
                'MANIPULATE',
                'CREATE',
                'SPEAK',
                'APPLY',
                'SIMULATE'
            ]).optional(),
            timeLimitMs: z.int().gte(1000).lte(9007199254740991).optional(),
            visual: z.union([
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    max: z.number(),
                    rows: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        previous: z.number().optional(),
                        display: z.string().min(1).max(24)
                    })).min(1).max(4)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    figures: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.string().min(1).max(24),
                        tone: z.enum([
                            'default',
                            'up',
                            'down',
                            'accent',
                            'streak'
                        ]).optional()
                    })).min(2).max(4)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    shares: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.number().gte(0),
                        display: z.string().min(1).max(24).optional()
                    })).min(2).max(6)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    stages: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.number().gte(0),
                        display: z.string().min(1).max(24)
                    })).min(2).max(5)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    start: z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24)
                    }),
                    steps: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24)
                    })).min(1).max(5),
                    end: z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24)
                    })
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    max: z.number(),
                    min: z.number().optional(),
                    rows: z.array(z.object({
                        label: z.string().min(1).max(60),
                        before: z.number(),
                        after: z.number(),
                        beforeDisplay: z.string().min(1).max(24),
                        afterDisplay: z.string().min(1).max(24)
                    })).min(1).max(4)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    x: z.object({
                        label: z.string().min(1).max(60),
                        low: z.string().min(1).max(40),
                        high: z.string().min(1).max(40)
                    }),
                    y: z.object({
                        label: z.string().min(1).max(60),
                        low: z.string().min(1).max(40),
                        high: z.string().min(1).max(40)
                    }),
                    quadrants: z.tuple([
                        z.string().min(1).max(40),
                        z.string().min(1).max(40),
                        z.string().min(1).max(40),
                        z.string().min(1).max(40)
                    ]).optional(),
                    items: z.array(z.object({
                        label: z.string().min(1).max(60),
                        x: z.number().gte(0).lte(1),
                        y: z.number().gte(0).lte(1)
                    })).min(1).max(4)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    steps: z.array(z.object({
                        label: z.string().min(1).max(60),
                        note: z.string().min(1).max(80).optional()
                    })).min(2).max(5)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    at: z.array(z.string().min(1).max(16)).min(2).max(8),
                    min: z.number(),
                    max: z.number(),
                    series: z.array(z.object({
                        label: z.string().min(1).max(60),
                        values: z.array(z.number()).min(2).max(8),
                        display: z.string().min(1).max(24)
                    })).min(1).max(6)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    columns: z.array(z.string().min(1).max(40)).min(2).max(3),
                    rows: z.array(z.object({
                        label: z.string().min(1).max(60),
                        cells: z.array(z.string().min(1).max(40)).max(3)
                    })).min(2).max(6)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    left: z.object({
                        name: z.string().min(1).max(60),
                        you: z.boolean().optional(),
                        character: z.enum([
                            'betty',
                            'david',
                            'rosa',
                            'kofi',
                            'priya',
                            'sam',
                            'noor',
                            'tomi',
                            'biscuit',
                            'bolt'
                        ]).optional(),
                        pose: z.enum([
                            'sit',
                            'lean-in',
                            'arms-crossed',
                            'hand-on-chin',
                            'wave'
                        ]).optional(),
                        facing: z.enum(['left', 'right']).optional(),
                        slot: z.enum([
                            'left',
                            'center',
                            'right'
                        ]).optional(),
                        reaction: z.enum([
                            'happy',
                            'worried',
                            'thinking'
                        ]).optional()
                    }),
                    right: z.object({
                        name: z.string().min(1).max(60),
                        you: z.boolean().optional(),
                        character: z.enum([
                            'betty',
                            'david',
                            'rosa',
                            'kofi',
                            'priya',
                            'sam',
                            'noor',
                            'tomi',
                            'biscuit',
                            'bolt'
                        ]).optional(),
                        pose: z.enum([
                            'sit',
                            'lean-in',
                            'arms-crossed',
                            'hand-on-chin',
                            'wave'
                        ]).optional(),
                        facing: z.enum(['left', 'right']).optional(),
                        slot: z.enum([
                            'left',
                            'center',
                            'right'
                        ]).optional(),
                        reaction: z.enum([
                            'happy',
                            'worried',
                            'thinking'
                        ]).optional()
                    }),
                    lines: z.array(z.object({
                        by: z.enum(['left', 'right']),
                        text: z.string().min(1).max(80).optional(),
                        sound: z.enum([
                            'bark',
                            'whine',
                            'growl',
                            'pant',
                            'meow',
                            'purr',
                            'hiss'
                        ]).optional(),
                        mood: z.enum([
                            'happy',
                            'worried',
                            'thinking'
                        ]).optional(),
                        thought: z.boolean().optional()
                    })).min(1).max(4),
                    awaiting: z.enum(['left', 'right']).optional(),
                    props: z.array(z.string().max(40).regex(/^[a-z0-9]+(-[a-z0-9]+)*$/)).min(1).max(3).optional()
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    cast: z.array(z.object({
                        name: z.string().min(1).max(60),
                        you: z.boolean().optional(),
                        character: z.enum([
                            'betty',
                            'david',
                            'rosa',
                            'kofi',
                            'priya',
                            'sam',
                            'noor',
                            'tomi',
                            'biscuit',
                            'bolt'
                        ]).optional(),
                        pose: z.enum([
                            'sit',
                            'lean-in',
                            'arms-crossed',
                            'hand-on-chin',
                            'wave'
                        ]).optional(),
                        facing: z.enum(['left', 'right']).optional(),
                        slot: z.enum([
                            'left',
                            'center',
                            'right'
                        ]).optional(),
                        reaction: z.enum([
                            'happy',
                            'worried',
                            'thinking'
                        ]).optional(),
                        thought: z.string().min(1).max(80).optional()
                    })).min(1).max(3),
                    stakes: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.string().min(1).max(24),
                        tone: z.enum([
                            'default',
                            'up',
                            'down',
                            'accent',
                            'streak'
                        ]).optional()
                    })).min(1).max(4).optional(),
                    props: z.array(z.string().max(40).regex(/^[a-z0-9]+(-[a-z0-9]+)*$/)).min(1).max(3).optional()
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    left: z.object({
                        label: z.string().min(1).max(60),
                        gains: z.array(z.string().min(1).max(40)).min(1).max(3),
                        costs: z.array(z.string().min(1).max(40)).min(1).max(3)
                    }),
                    right: z.object({
                        label: z.string().min(1).max(60),
                        gains: z.array(z.string().min(1).max(40)).min(1).max(3),
                        costs: z.array(z.string().min(1).max(40)).min(1).max(3)
                    })
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    fork: z.string().min(1).max(80),
                    branches: z.array(z.object({
                        label: z.string().min(1).max(60),
                        outcome: z.string().min(1).max(60),
                        tone: z.enum(['up', 'down']).optional()
                    })).min(2).max(3)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    moments: z.array(z.object({
                        at: z.string().min(1).max(16),
                        label: z.string().min(1).max(60)
                    })).min(2).max(5),
                    now: z.int().gte(0).lte(9007199254740991).optional()
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    start: z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24)
                    }),
                    steps: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24),
                        op: z.enum([
                            'plus',
                            'minus',
                            'times',
                            'divide'
                        ])
                    })).min(1).max(2),
                    result: z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24)
                    })
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    price: z.object({
                        low: z.number(),
                        high: z.number()
                    }),
                    demand: z.object({
                        atLow: z.number().gte(0),
                        atHigh: z.number().gte(0)
                    }),
                    readoutLabel: z.string().min(1).max(60),
                    unit: z.string().max(8),
                    from: z.string().min(1).max(40),
                    to: z.string().min(1).max(40)
                })
            ]).optional(),
            hint: z.string().min(1).max(600).optional(),
            body: z.string().optional(),
            imageUrl: z.url().optional(),
            objectName: z.enum([
                'balance',
                'funnel',
                'stack',
                'bridge',
                'steps',
                'podium',
                'chart',
                'pie',
                'gauge',
                'magnifier',
                'beaker',
                'hourglass',
                'calendar',
                'clock',
                'stopwatch',
                'vault',
                'wallet',
                'receipt',
                'calculator',
                'ledger',
                'compass',
                'telescope',
                'map',
                'flag',
                'chess',
                'target',
                'gavel',
                'puzzle',
                'team',
                'network',
                'roundtable',
                'mic',
                'iceberg',
                'chat',
                'gears',
                'pipeline',
                'crate',
                'factory',
                'server',
                'spool',
                'clipboard',
                'tray',
                'basket',
                'folder',
                'bin',
                'lightbulb',
                'rocket',
                'key',
                'trophy',
                'briefcase'
            ]).optional(),
            kind: z.string(),
            hintEnabled: z.boolean(),
            bodyEnabled: z.boolean(),
            bodyPredatesRules: z.boolean(),
            warnings: z.array(z.object({
                field: z.string(),
                message: z.string(),
                fixable: z.boolean(),
                blocks: z.boolean()
            })).default([])
        }),
        z.object({
            id: z.string().min(1),
            position: z.int().gte(1).lte(9007199254740991),
            prompt: z.string().min(1).max(400),
            verb: z.enum([
                'decide',
                'allocate',
                'rank',
                'match',
                'predict',
                'diagnose',
                'negotiate',
                'rephrase',
                'pitch',
                'speak',
                'simulate'
            ]).optional(),
            rung: z.enum([
                'RECOGNIZE',
                'DECIDE',
                'MANIPULATE',
                'CREATE',
                'SPEAK',
                'APPLY',
                'SIMULATE'
            ]).optional(),
            timeLimitMs: z.int().gte(1000).lte(9007199254740991).optional(),
            visual: z.union([
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    max: z.number(),
                    rows: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        previous: z.number().optional(),
                        display: z.string().min(1).max(24)
                    })).min(1).max(4)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    figures: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.string().min(1).max(24),
                        tone: z.enum([
                            'default',
                            'up',
                            'down',
                            'accent',
                            'streak'
                        ]).optional()
                    })).min(2).max(4)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    shares: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.number().gte(0),
                        display: z.string().min(1).max(24).optional()
                    })).min(2).max(6)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    stages: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.number().gte(0),
                        display: z.string().min(1).max(24)
                    })).min(2).max(5)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    start: z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24)
                    }),
                    steps: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24)
                    })).min(1).max(5),
                    end: z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24)
                    })
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    max: z.number(),
                    min: z.number().optional(),
                    rows: z.array(z.object({
                        label: z.string().min(1).max(60),
                        before: z.number(),
                        after: z.number(),
                        beforeDisplay: z.string().min(1).max(24),
                        afterDisplay: z.string().min(1).max(24)
                    })).min(1).max(4)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    x: z.object({
                        label: z.string().min(1).max(60),
                        low: z.string().min(1).max(40),
                        high: z.string().min(1).max(40)
                    }),
                    y: z.object({
                        label: z.string().min(1).max(60),
                        low: z.string().min(1).max(40),
                        high: z.string().min(1).max(40)
                    }),
                    quadrants: z.tuple([
                        z.string().min(1).max(40),
                        z.string().min(1).max(40),
                        z.string().min(1).max(40),
                        z.string().min(1).max(40)
                    ]).optional(),
                    items: z.array(z.object({
                        label: z.string().min(1).max(60),
                        x: z.number().gte(0).lte(1),
                        y: z.number().gte(0).lte(1)
                    })).min(1).max(4)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    steps: z.array(z.object({
                        label: z.string().min(1).max(60),
                        note: z.string().min(1).max(80).optional()
                    })).min(2).max(5)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    at: z.array(z.string().min(1).max(16)).min(2).max(8),
                    min: z.number(),
                    max: z.number(),
                    series: z.array(z.object({
                        label: z.string().min(1).max(60),
                        values: z.array(z.number()).min(2).max(8),
                        display: z.string().min(1).max(24)
                    })).min(1).max(6)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    columns: z.array(z.string().min(1).max(40)).min(2).max(3),
                    rows: z.array(z.object({
                        label: z.string().min(1).max(60),
                        cells: z.array(z.string().min(1).max(40)).max(3)
                    })).min(2).max(6)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    left: z.object({
                        name: z.string().min(1).max(60),
                        you: z.boolean().optional(),
                        character: z.enum([
                            'betty',
                            'david',
                            'rosa',
                            'kofi',
                            'priya',
                            'sam',
                            'noor',
                            'tomi',
                            'biscuit',
                            'bolt'
                        ]).optional(),
                        pose: z.enum([
                            'sit',
                            'lean-in',
                            'arms-crossed',
                            'hand-on-chin',
                            'wave'
                        ]).optional(),
                        facing: z.enum(['left', 'right']).optional(),
                        slot: z.enum([
                            'left',
                            'center',
                            'right'
                        ]).optional(),
                        reaction: z.enum([
                            'happy',
                            'worried',
                            'thinking'
                        ]).optional()
                    }),
                    right: z.object({
                        name: z.string().min(1).max(60),
                        you: z.boolean().optional(),
                        character: z.enum([
                            'betty',
                            'david',
                            'rosa',
                            'kofi',
                            'priya',
                            'sam',
                            'noor',
                            'tomi',
                            'biscuit',
                            'bolt'
                        ]).optional(),
                        pose: z.enum([
                            'sit',
                            'lean-in',
                            'arms-crossed',
                            'hand-on-chin',
                            'wave'
                        ]).optional(),
                        facing: z.enum(['left', 'right']).optional(),
                        slot: z.enum([
                            'left',
                            'center',
                            'right'
                        ]).optional(),
                        reaction: z.enum([
                            'happy',
                            'worried',
                            'thinking'
                        ]).optional()
                    }),
                    lines: z.array(z.object({
                        by: z.enum(['left', 'right']),
                        text: z.string().min(1).max(80).optional(),
                        sound: z.enum([
                            'bark',
                            'whine',
                            'growl',
                            'pant',
                            'meow',
                            'purr',
                            'hiss'
                        ]).optional(),
                        mood: z.enum([
                            'happy',
                            'worried',
                            'thinking'
                        ]).optional(),
                        thought: z.boolean().optional()
                    })).min(1).max(4),
                    awaiting: z.enum(['left', 'right']).optional(),
                    props: z.array(z.string().max(40).regex(/^[a-z0-9]+(-[a-z0-9]+)*$/)).min(1).max(3).optional()
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    cast: z.array(z.object({
                        name: z.string().min(1).max(60),
                        you: z.boolean().optional(),
                        character: z.enum([
                            'betty',
                            'david',
                            'rosa',
                            'kofi',
                            'priya',
                            'sam',
                            'noor',
                            'tomi',
                            'biscuit',
                            'bolt'
                        ]).optional(),
                        pose: z.enum([
                            'sit',
                            'lean-in',
                            'arms-crossed',
                            'hand-on-chin',
                            'wave'
                        ]).optional(),
                        facing: z.enum(['left', 'right']).optional(),
                        slot: z.enum([
                            'left',
                            'center',
                            'right'
                        ]).optional(),
                        reaction: z.enum([
                            'happy',
                            'worried',
                            'thinking'
                        ]).optional(),
                        thought: z.string().min(1).max(80).optional()
                    })).min(1).max(3),
                    stakes: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.string().min(1).max(24),
                        tone: z.enum([
                            'default',
                            'up',
                            'down',
                            'accent',
                            'streak'
                        ]).optional()
                    })).min(1).max(4).optional(),
                    props: z.array(z.string().max(40).regex(/^[a-z0-9]+(-[a-z0-9]+)*$/)).min(1).max(3).optional()
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    left: z.object({
                        label: z.string().min(1).max(60),
                        gains: z.array(z.string().min(1).max(40)).min(1).max(3),
                        costs: z.array(z.string().min(1).max(40)).min(1).max(3)
                    }),
                    right: z.object({
                        label: z.string().min(1).max(60),
                        gains: z.array(z.string().min(1).max(40)).min(1).max(3),
                        costs: z.array(z.string().min(1).max(40)).min(1).max(3)
                    })
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    fork: z.string().min(1).max(80),
                    branches: z.array(z.object({
                        label: z.string().min(1).max(60),
                        outcome: z.string().min(1).max(60),
                        tone: z.enum(['up', 'down']).optional()
                    })).min(2).max(3)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    moments: z.array(z.object({
                        at: z.string().min(1).max(16),
                        label: z.string().min(1).max(60)
                    })).min(2).max(5),
                    now: z.int().gte(0).lte(9007199254740991).optional()
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    start: z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24)
                    }),
                    steps: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24),
                        op: z.enum([
                            'plus',
                            'minus',
                            'times',
                            'divide'
                        ])
                    })).min(1).max(2),
                    result: z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24)
                    })
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    price: z.object({
                        low: z.number(),
                        high: z.number()
                    }),
                    demand: z.object({
                        atLow: z.number().gte(0),
                        atHigh: z.number().gte(0)
                    }),
                    readoutLabel: z.string().min(1).max(60),
                    unit: z.string().max(8),
                    from: z.string().min(1).max(40),
                    to: z.string().min(1).max(40)
                })
            ]).optional(),
            hint: z.string().min(1).max(600).optional(),
            body: z.string().optional(),
            imageUrl: z.url().optional(),
            objectName: z.enum([
                'balance',
                'funnel',
                'stack',
                'bridge',
                'steps',
                'podium',
                'chart',
                'pie',
                'gauge',
                'magnifier',
                'beaker',
                'hourglass',
                'calendar',
                'clock',
                'stopwatch',
                'vault',
                'wallet',
                'receipt',
                'calculator',
                'ledger',
                'compass',
                'telescope',
                'map',
                'flag',
                'chess',
                'target',
                'gavel',
                'puzzle',
                'team',
                'network',
                'roundtable',
                'mic',
                'iceberg',
                'chat',
                'gears',
                'pipeline',
                'crate',
                'factory',
                'server',
                'spool',
                'clipboard',
                'tray',
                'basket',
                'folder',
                'bin',
                'lightbulb',
                'rocket',
                'key',
                'trophy',
                'briefcase'
            ]).optional(),
            kind: z.string(),
            hintEnabled: z.boolean(),
            bodyEnabled: z.boolean(),
            bodyPredatesRules: z.boolean(),
            warnings: z.array(z.object({
                field: z.string(),
                message: z.string(),
                fixable: z.boolean(),
                blocks: z.boolean()
            })).default([])
        }),
        z.object({
            id: z.string().min(1),
            position: z.int().gte(1).lte(9007199254740991),
            prompt: z.string().min(1).max(400),
            verb: z.enum([
                'decide',
                'allocate',
                'rank',
                'match',
                'predict',
                'diagnose',
                'negotiate',
                'rephrase',
                'pitch',
                'speak',
                'simulate'
            ]).optional(),
            rung: z.enum([
                'RECOGNIZE',
                'DECIDE',
                'MANIPULATE',
                'CREATE',
                'SPEAK',
                'APPLY',
                'SIMULATE'
            ]).optional(),
            timeLimitMs: z.int().gte(1000).lte(9007199254740991).optional(),
            visual: z.union([
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    max: z.number(),
                    rows: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        previous: z.number().optional(),
                        display: z.string().min(1).max(24)
                    })).min(1).max(4)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    figures: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.string().min(1).max(24),
                        tone: z.enum([
                            'default',
                            'up',
                            'down',
                            'accent',
                            'streak'
                        ]).optional()
                    })).min(2).max(4)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    shares: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.number().gte(0),
                        display: z.string().min(1).max(24).optional()
                    })).min(2).max(6)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    stages: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.number().gte(0),
                        display: z.string().min(1).max(24)
                    })).min(2).max(5)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    start: z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24)
                    }),
                    steps: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24)
                    })).min(1).max(5),
                    end: z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24)
                    })
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    max: z.number(),
                    min: z.number().optional(),
                    rows: z.array(z.object({
                        label: z.string().min(1).max(60),
                        before: z.number(),
                        after: z.number(),
                        beforeDisplay: z.string().min(1).max(24),
                        afterDisplay: z.string().min(1).max(24)
                    })).min(1).max(4)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    x: z.object({
                        label: z.string().min(1).max(60),
                        low: z.string().min(1).max(40),
                        high: z.string().min(1).max(40)
                    }),
                    y: z.object({
                        label: z.string().min(1).max(60),
                        low: z.string().min(1).max(40),
                        high: z.string().min(1).max(40)
                    }),
                    quadrants: z.tuple([
                        z.string().min(1).max(40),
                        z.string().min(1).max(40),
                        z.string().min(1).max(40),
                        z.string().min(1).max(40)
                    ]).optional(),
                    items: z.array(z.object({
                        label: z.string().min(1).max(60),
                        x: z.number().gte(0).lte(1),
                        y: z.number().gte(0).lte(1)
                    })).min(1).max(4)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    steps: z.array(z.object({
                        label: z.string().min(1).max(60),
                        note: z.string().min(1).max(80).optional()
                    })).min(2).max(5)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    at: z.array(z.string().min(1).max(16)).min(2).max(8),
                    min: z.number(),
                    max: z.number(),
                    series: z.array(z.object({
                        label: z.string().min(1).max(60),
                        values: z.array(z.number()).min(2).max(8),
                        display: z.string().min(1).max(24)
                    })).min(1).max(6)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    columns: z.array(z.string().min(1).max(40)).min(2).max(3),
                    rows: z.array(z.object({
                        label: z.string().min(1).max(60),
                        cells: z.array(z.string().min(1).max(40)).max(3)
                    })).min(2).max(6)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    left: z.object({
                        name: z.string().min(1).max(60),
                        you: z.boolean().optional(),
                        character: z.enum([
                            'betty',
                            'david',
                            'rosa',
                            'kofi',
                            'priya',
                            'sam',
                            'noor',
                            'tomi',
                            'biscuit',
                            'bolt'
                        ]).optional(),
                        pose: z.enum([
                            'sit',
                            'lean-in',
                            'arms-crossed',
                            'hand-on-chin',
                            'wave'
                        ]).optional(),
                        facing: z.enum(['left', 'right']).optional(),
                        slot: z.enum([
                            'left',
                            'center',
                            'right'
                        ]).optional(),
                        reaction: z.enum([
                            'happy',
                            'worried',
                            'thinking'
                        ]).optional()
                    }),
                    right: z.object({
                        name: z.string().min(1).max(60),
                        you: z.boolean().optional(),
                        character: z.enum([
                            'betty',
                            'david',
                            'rosa',
                            'kofi',
                            'priya',
                            'sam',
                            'noor',
                            'tomi',
                            'biscuit',
                            'bolt'
                        ]).optional(),
                        pose: z.enum([
                            'sit',
                            'lean-in',
                            'arms-crossed',
                            'hand-on-chin',
                            'wave'
                        ]).optional(),
                        facing: z.enum(['left', 'right']).optional(),
                        slot: z.enum([
                            'left',
                            'center',
                            'right'
                        ]).optional(),
                        reaction: z.enum([
                            'happy',
                            'worried',
                            'thinking'
                        ]).optional()
                    }),
                    lines: z.array(z.object({
                        by: z.enum(['left', 'right']),
                        text: z.string().min(1).max(80).optional(),
                        sound: z.enum([
                            'bark',
                            'whine',
                            'growl',
                            'pant',
                            'meow',
                            'purr',
                            'hiss'
                        ]).optional(),
                        mood: z.enum([
                            'happy',
                            'worried',
                            'thinking'
                        ]).optional(),
                        thought: z.boolean().optional()
                    })).min(1).max(4),
                    awaiting: z.enum(['left', 'right']).optional(),
                    props: z.array(z.string().max(40).regex(/^[a-z0-9]+(-[a-z0-9]+)*$/)).min(1).max(3).optional()
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    cast: z.array(z.object({
                        name: z.string().min(1).max(60),
                        you: z.boolean().optional(),
                        character: z.enum([
                            'betty',
                            'david',
                            'rosa',
                            'kofi',
                            'priya',
                            'sam',
                            'noor',
                            'tomi',
                            'biscuit',
                            'bolt'
                        ]).optional(),
                        pose: z.enum([
                            'sit',
                            'lean-in',
                            'arms-crossed',
                            'hand-on-chin',
                            'wave'
                        ]).optional(),
                        facing: z.enum(['left', 'right']).optional(),
                        slot: z.enum([
                            'left',
                            'center',
                            'right'
                        ]).optional(),
                        reaction: z.enum([
                            'happy',
                            'worried',
                            'thinking'
                        ]).optional(),
                        thought: z.string().min(1).max(80).optional()
                    })).min(1).max(3),
                    stakes: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.string().min(1).max(24),
                        tone: z.enum([
                            'default',
                            'up',
                            'down',
                            'accent',
                            'streak'
                        ]).optional()
                    })).min(1).max(4).optional(),
                    props: z.array(z.string().max(40).regex(/^[a-z0-9]+(-[a-z0-9]+)*$/)).min(1).max(3).optional()
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    left: z.object({
                        label: z.string().min(1).max(60),
                        gains: z.array(z.string().min(1).max(40)).min(1).max(3),
                        costs: z.array(z.string().min(1).max(40)).min(1).max(3)
                    }),
                    right: z.object({
                        label: z.string().min(1).max(60),
                        gains: z.array(z.string().min(1).max(40)).min(1).max(3),
                        costs: z.array(z.string().min(1).max(40)).min(1).max(3)
                    })
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    fork: z.string().min(1).max(80),
                    branches: z.array(z.object({
                        label: z.string().min(1).max(60),
                        outcome: z.string().min(1).max(60),
                        tone: z.enum(['up', 'down']).optional()
                    })).min(2).max(3)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    moments: z.array(z.object({
                        at: z.string().min(1).max(16),
                        label: z.string().min(1).max(60)
                    })).min(2).max(5),
                    now: z.int().gte(0).lte(9007199254740991).optional()
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    start: z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24)
                    }),
                    steps: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24),
                        op: z.enum([
                            'plus',
                            'minus',
                            'times',
                            'divide'
                        ])
                    })).min(1).max(2),
                    result: z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24)
                    })
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    price: z.object({
                        low: z.number(),
                        high: z.number()
                    }),
                    demand: z.object({
                        atLow: z.number().gte(0),
                        atHigh: z.number().gte(0)
                    }),
                    readoutLabel: z.string().min(1).max(60),
                    unit: z.string().max(8),
                    from: z.string().min(1).max(40),
                    to: z.string().min(1).max(40)
                })
            ]).optional(),
            hint: z.string().min(1).max(600).optional(),
            body: z.string().optional(),
            kind: z.string(),
            imageUrl: z.url().optional(),
            options: z.array(z.object({
                id: z.string().min(1),
                label: z.string().min(1).max(200),
                isCorrect: z.boolean().optional(),
                correctPosition: z.int().gte(-9007199254740991).lte(9007199254740991).optional(),
                correctBucketId: z.string().optional(),
                correctAmount: z.number().optional(),
                amountTolerance: z.number().optional(),
                feedback: z.string().optional()
            })).max(8),
            maxSelections: z.int().gte(1).lte(9007199254740991).optional(),
            requireSubmit: z.boolean().optional(),
            hintEnabled: z.boolean(),
            bodyEnabled: z.boolean(),
            bodyPredatesRules: z.boolean(),
            warnings: z.array(z.object({
                field: z.string(),
                message: z.string(),
                fixable: z.boolean(),
                blocks: z.boolean()
            })).default([]),
            questionId: z.string().optional(),
            explanation: z.string().optional()
        }),
        z.object({
            id: z.string().min(1),
            position: z.int().gte(1).lte(9007199254740991),
            prompt: z.string().min(1).max(400),
            verb: z.enum([
                'decide',
                'allocate',
                'rank',
                'match',
                'predict',
                'diagnose',
                'negotiate',
                'rephrase',
                'pitch',
                'speak',
                'simulate'
            ]).optional(),
            rung: z.enum([
                'RECOGNIZE',
                'DECIDE',
                'MANIPULATE',
                'CREATE',
                'SPEAK',
                'APPLY',
                'SIMULATE'
            ]).optional(),
            timeLimitMs: z.int().gte(1000).lte(9007199254740991).optional(),
            visual: z.union([
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    max: z.number(),
                    rows: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        previous: z.number().optional(),
                        display: z.string().min(1).max(24)
                    })).min(1).max(4)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    figures: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.string().min(1).max(24),
                        tone: z.enum([
                            'default',
                            'up',
                            'down',
                            'accent',
                            'streak'
                        ]).optional()
                    })).min(2).max(4)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    shares: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.number().gte(0),
                        display: z.string().min(1).max(24).optional()
                    })).min(2).max(6)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    stages: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.number().gte(0),
                        display: z.string().min(1).max(24)
                    })).min(2).max(5)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    start: z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24)
                    }),
                    steps: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24)
                    })).min(1).max(5),
                    end: z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24)
                    })
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    max: z.number(),
                    min: z.number().optional(),
                    rows: z.array(z.object({
                        label: z.string().min(1).max(60),
                        before: z.number(),
                        after: z.number(),
                        beforeDisplay: z.string().min(1).max(24),
                        afterDisplay: z.string().min(1).max(24)
                    })).min(1).max(4)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    x: z.object({
                        label: z.string().min(1).max(60),
                        low: z.string().min(1).max(40),
                        high: z.string().min(1).max(40)
                    }),
                    y: z.object({
                        label: z.string().min(1).max(60),
                        low: z.string().min(1).max(40),
                        high: z.string().min(1).max(40)
                    }),
                    quadrants: z.tuple([
                        z.string().min(1).max(40),
                        z.string().min(1).max(40),
                        z.string().min(1).max(40),
                        z.string().min(1).max(40)
                    ]).optional(),
                    items: z.array(z.object({
                        label: z.string().min(1).max(60),
                        x: z.number().gte(0).lte(1),
                        y: z.number().gte(0).lte(1)
                    })).min(1).max(4)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    steps: z.array(z.object({
                        label: z.string().min(1).max(60),
                        note: z.string().min(1).max(80).optional()
                    })).min(2).max(5)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    at: z.array(z.string().min(1).max(16)).min(2).max(8),
                    min: z.number(),
                    max: z.number(),
                    series: z.array(z.object({
                        label: z.string().min(1).max(60),
                        values: z.array(z.number()).min(2).max(8),
                        display: z.string().min(1).max(24)
                    })).min(1).max(6)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    columns: z.array(z.string().min(1).max(40)).min(2).max(3),
                    rows: z.array(z.object({
                        label: z.string().min(1).max(60),
                        cells: z.array(z.string().min(1).max(40)).max(3)
                    })).min(2).max(6)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    left: z.object({
                        name: z.string().min(1).max(60),
                        you: z.boolean().optional(),
                        character: z.enum([
                            'betty',
                            'david',
                            'rosa',
                            'kofi',
                            'priya',
                            'sam',
                            'noor',
                            'tomi',
                            'biscuit',
                            'bolt'
                        ]).optional(),
                        pose: z.enum([
                            'sit',
                            'lean-in',
                            'arms-crossed',
                            'hand-on-chin',
                            'wave'
                        ]).optional(),
                        facing: z.enum(['left', 'right']).optional(),
                        slot: z.enum([
                            'left',
                            'center',
                            'right'
                        ]).optional(),
                        reaction: z.enum([
                            'happy',
                            'worried',
                            'thinking'
                        ]).optional()
                    }),
                    right: z.object({
                        name: z.string().min(1).max(60),
                        you: z.boolean().optional(),
                        character: z.enum([
                            'betty',
                            'david',
                            'rosa',
                            'kofi',
                            'priya',
                            'sam',
                            'noor',
                            'tomi',
                            'biscuit',
                            'bolt'
                        ]).optional(),
                        pose: z.enum([
                            'sit',
                            'lean-in',
                            'arms-crossed',
                            'hand-on-chin',
                            'wave'
                        ]).optional(),
                        facing: z.enum(['left', 'right']).optional(),
                        slot: z.enum([
                            'left',
                            'center',
                            'right'
                        ]).optional(),
                        reaction: z.enum([
                            'happy',
                            'worried',
                            'thinking'
                        ]).optional()
                    }),
                    lines: z.array(z.object({
                        by: z.enum(['left', 'right']),
                        text: z.string().min(1).max(80).optional(),
                        sound: z.enum([
                            'bark',
                            'whine',
                            'growl',
                            'pant',
                            'meow',
                            'purr',
                            'hiss'
                        ]).optional(),
                        mood: z.enum([
                            'happy',
                            'worried',
                            'thinking'
                        ]).optional(),
                        thought: z.boolean().optional()
                    })).min(1).max(4),
                    awaiting: z.enum(['left', 'right']).optional(),
                    props: z.array(z.string().max(40).regex(/^[a-z0-9]+(-[a-z0-9]+)*$/)).min(1).max(3).optional()
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    cast: z.array(z.object({
                        name: z.string().min(1).max(60),
                        you: z.boolean().optional(),
                        character: z.enum([
                            'betty',
                            'david',
                            'rosa',
                            'kofi',
                            'priya',
                            'sam',
                            'noor',
                            'tomi',
                            'biscuit',
                            'bolt'
                        ]).optional(),
                        pose: z.enum([
                            'sit',
                            'lean-in',
                            'arms-crossed',
                            'hand-on-chin',
                            'wave'
                        ]).optional(),
                        facing: z.enum(['left', 'right']).optional(),
                        slot: z.enum([
                            'left',
                            'center',
                            'right'
                        ]).optional(),
                        reaction: z.enum([
                            'happy',
                            'worried',
                            'thinking'
                        ]).optional(),
                        thought: z.string().min(1).max(80).optional()
                    })).min(1).max(3),
                    stakes: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.string().min(1).max(24),
                        tone: z.enum([
                            'default',
                            'up',
                            'down',
                            'accent',
                            'streak'
                        ]).optional()
                    })).min(1).max(4).optional(),
                    props: z.array(z.string().max(40).regex(/^[a-z0-9]+(-[a-z0-9]+)*$/)).min(1).max(3).optional()
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    left: z.object({
                        label: z.string().min(1).max(60),
                        gains: z.array(z.string().min(1).max(40)).min(1).max(3),
                        costs: z.array(z.string().min(1).max(40)).min(1).max(3)
                    }),
                    right: z.object({
                        label: z.string().min(1).max(60),
                        gains: z.array(z.string().min(1).max(40)).min(1).max(3),
                        costs: z.array(z.string().min(1).max(40)).min(1).max(3)
                    })
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    fork: z.string().min(1).max(80),
                    branches: z.array(z.object({
                        label: z.string().min(1).max(60),
                        outcome: z.string().min(1).max(60),
                        tone: z.enum(['up', 'down']).optional()
                    })).min(2).max(3)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    moments: z.array(z.object({
                        at: z.string().min(1).max(16),
                        label: z.string().min(1).max(60)
                    })).min(2).max(5),
                    now: z.int().gte(0).lte(9007199254740991).optional()
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    start: z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24)
                    }),
                    steps: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24),
                        op: z.enum([
                            'plus',
                            'minus',
                            'times',
                            'divide'
                        ])
                    })).min(1).max(2),
                    result: z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24)
                    })
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    price: z.object({
                        low: z.number(),
                        high: z.number()
                    }),
                    demand: z.object({
                        atLow: z.number().gte(0),
                        atHigh: z.number().gte(0)
                    }),
                    readoutLabel: z.string().min(1).max(60),
                    unit: z.string().max(8),
                    from: z.string().min(1).max(40),
                    to: z.string().min(1).max(40)
                })
            ]).optional(),
            hint: z.string().min(1).max(600).optional(),
            body: z.string().optional(),
            kind: z.string(),
            items: z.array(z.object({
                id: z.string().min(1),
                label: z.string().min(1).max(200),
                isCorrect: z.boolean().optional(),
                correctPosition: z.int().gte(-9007199254740991).lte(9007199254740991).optional(),
                correctBucketId: z.string().optional(),
                correctAmount: z.number().optional(),
                amountTolerance: z.number().optional(),
                feedback: z.string().optional()
            })).max(8),
            hintEnabled: z.boolean(),
            bodyEnabled: z.boolean(),
            bodyPredatesRules: z.boolean(),
            warnings: z.array(z.object({
                field: z.string(),
                message: z.string(),
                fixable: z.boolean(),
                blocks: z.boolean()
            })).default([]),
            questionId: z.string().optional(),
            explanation: z.string().optional()
        }),
        z.object({
            id: z.string().min(1),
            position: z.int().gte(1).lte(9007199254740991),
            prompt: z.string().min(1).max(400),
            verb: z.enum([
                'decide',
                'allocate',
                'rank',
                'match',
                'predict',
                'diagnose',
                'negotiate',
                'rephrase',
                'pitch',
                'speak',
                'simulate'
            ]).optional(),
            rung: z.enum([
                'RECOGNIZE',
                'DECIDE',
                'MANIPULATE',
                'CREATE',
                'SPEAK',
                'APPLY',
                'SIMULATE'
            ]).optional(),
            timeLimitMs: z.int().gte(1000).lte(9007199254740991).optional(),
            visual: z.union([
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    max: z.number(),
                    rows: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        previous: z.number().optional(),
                        display: z.string().min(1).max(24)
                    })).min(1).max(4)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    figures: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.string().min(1).max(24),
                        tone: z.enum([
                            'default',
                            'up',
                            'down',
                            'accent',
                            'streak'
                        ]).optional()
                    })).min(2).max(4)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    shares: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.number().gte(0),
                        display: z.string().min(1).max(24).optional()
                    })).min(2).max(6)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    stages: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.number().gte(0),
                        display: z.string().min(1).max(24)
                    })).min(2).max(5)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    start: z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24)
                    }),
                    steps: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24)
                    })).min(1).max(5),
                    end: z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24)
                    })
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    max: z.number(),
                    min: z.number().optional(),
                    rows: z.array(z.object({
                        label: z.string().min(1).max(60),
                        before: z.number(),
                        after: z.number(),
                        beforeDisplay: z.string().min(1).max(24),
                        afterDisplay: z.string().min(1).max(24)
                    })).min(1).max(4)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    x: z.object({
                        label: z.string().min(1).max(60),
                        low: z.string().min(1).max(40),
                        high: z.string().min(1).max(40)
                    }),
                    y: z.object({
                        label: z.string().min(1).max(60),
                        low: z.string().min(1).max(40),
                        high: z.string().min(1).max(40)
                    }),
                    quadrants: z.tuple([
                        z.string().min(1).max(40),
                        z.string().min(1).max(40),
                        z.string().min(1).max(40),
                        z.string().min(1).max(40)
                    ]).optional(),
                    items: z.array(z.object({
                        label: z.string().min(1).max(60),
                        x: z.number().gte(0).lte(1),
                        y: z.number().gte(0).lte(1)
                    })).min(1).max(4)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    steps: z.array(z.object({
                        label: z.string().min(1).max(60),
                        note: z.string().min(1).max(80).optional()
                    })).min(2).max(5)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    at: z.array(z.string().min(1).max(16)).min(2).max(8),
                    min: z.number(),
                    max: z.number(),
                    series: z.array(z.object({
                        label: z.string().min(1).max(60),
                        values: z.array(z.number()).min(2).max(8),
                        display: z.string().min(1).max(24)
                    })).min(1).max(6)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    columns: z.array(z.string().min(1).max(40)).min(2).max(3),
                    rows: z.array(z.object({
                        label: z.string().min(1).max(60),
                        cells: z.array(z.string().min(1).max(40)).max(3)
                    })).min(2).max(6)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    left: z.object({
                        name: z.string().min(1).max(60),
                        you: z.boolean().optional(),
                        character: z.enum([
                            'betty',
                            'david',
                            'rosa',
                            'kofi',
                            'priya',
                            'sam',
                            'noor',
                            'tomi',
                            'biscuit',
                            'bolt'
                        ]).optional(),
                        pose: z.enum([
                            'sit',
                            'lean-in',
                            'arms-crossed',
                            'hand-on-chin',
                            'wave'
                        ]).optional(),
                        facing: z.enum(['left', 'right']).optional(),
                        slot: z.enum([
                            'left',
                            'center',
                            'right'
                        ]).optional(),
                        reaction: z.enum([
                            'happy',
                            'worried',
                            'thinking'
                        ]).optional()
                    }),
                    right: z.object({
                        name: z.string().min(1).max(60),
                        you: z.boolean().optional(),
                        character: z.enum([
                            'betty',
                            'david',
                            'rosa',
                            'kofi',
                            'priya',
                            'sam',
                            'noor',
                            'tomi',
                            'biscuit',
                            'bolt'
                        ]).optional(),
                        pose: z.enum([
                            'sit',
                            'lean-in',
                            'arms-crossed',
                            'hand-on-chin',
                            'wave'
                        ]).optional(),
                        facing: z.enum(['left', 'right']).optional(),
                        slot: z.enum([
                            'left',
                            'center',
                            'right'
                        ]).optional(),
                        reaction: z.enum([
                            'happy',
                            'worried',
                            'thinking'
                        ]).optional()
                    }),
                    lines: z.array(z.object({
                        by: z.enum(['left', 'right']),
                        text: z.string().min(1).max(80).optional(),
                        sound: z.enum([
                            'bark',
                            'whine',
                            'growl',
                            'pant',
                            'meow',
                            'purr',
                            'hiss'
                        ]).optional(),
                        mood: z.enum([
                            'happy',
                            'worried',
                            'thinking'
                        ]).optional(),
                        thought: z.boolean().optional()
                    })).min(1).max(4),
                    awaiting: z.enum(['left', 'right']).optional(),
                    props: z.array(z.string().max(40).regex(/^[a-z0-9]+(-[a-z0-9]+)*$/)).min(1).max(3).optional()
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    cast: z.array(z.object({
                        name: z.string().min(1).max(60),
                        you: z.boolean().optional(),
                        character: z.enum([
                            'betty',
                            'david',
                            'rosa',
                            'kofi',
                            'priya',
                            'sam',
                            'noor',
                            'tomi',
                            'biscuit',
                            'bolt'
                        ]).optional(),
                        pose: z.enum([
                            'sit',
                            'lean-in',
                            'arms-crossed',
                            'hand-on-chin',
                            'wave'
                        ]).optional(),
                        facing: z.enum(['left', 'right']).optional(),
                        slot: z.enum([
                            'left',
                            'center',
                            'right'
                        ]).optional(),
                        reaction: z.enum([
                            'happy',
                            'worried',
                            'thinking'
                        ]).optional(),
                        thought: z.string().min(1).max(80).optional()
                    })).min(1).max(3),
                    stakes: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.string().min(1).max(24),
                        tone: z.enum([
                            'default',
                            'up',
                            'down',
                            'accent',
                            'streak'
                        ]).optional()
                    })).min(1).max(4).optional(),
                    props: z.array(z.string().max(40).regex(/^[a-z0-9]+(-[a-z0-9]+)*$/)).min(1).max(3).optional()
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    left: z.object({
                        label: z.string().min(1).max(60),
                        gains: z.array(z.string().min(1).max(40)).min(1).max(3),
                        costs: z.array(z.string().min(1).max(40)).min(1).max(3)
                    }),
                    right: z.object({
                        label: z.string().min(1).max(60),
                        gains: z.array(z.string().min(1).max(40)).min(1).max(3),
                        costs: z.array(z.string().min(1).max(40)).min(1).max(3)
                    })
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    fork: z.string().min(1).max(80),
                    branches: z.array(z.object({
                        label: z.string().min(1).max(60),
                        outcome: z.string().min(1).max(60),
                        tone: z.enum(['up', 'down']).optional()
                    })).min(2).max(3)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    moments: z.array(z.object({
                        at: z.string().min(1).max(16),
                        label: z.string().min(1).max(60)
                    })).min(2).max(5),
                    now: z.int().gte(0).lte(9007199254740991).optional()
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    start: z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24)
                    }),
                    steps: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24),
                        op: z.enum([
                            'plus',
                            'minus',
                            'times',
                            'divide'
                        ])
                    })).min(1).max(2),
                    result: z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24)
                    })
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    price: z.object({
                        low: z.number(),
                        high: z.number()
                    }),
                    demand: z.object({
                        atLow: z.number().gte(0),
                        atHigh: z.number().gte(0)
                    }),
                    readoutLabel: z.string().min(1).max(60),
                    unit: z.string().max(8),
                    from: z.string().min(1).max(40),
                    to: z.string().min(1).max(40)
                })
            ]).optional(),
            hint: z.string().min(1).max(600).optional(),
            body: z.string().optional(),
            kind: z.string(),
            items: z.array(z.object({
                id: z.string().min(1),
                label: z.string().min(1).max(200),
                isCorrect: z.boolean().optional(),
                correctPosition: z.int().gte(-9007199254740991).lte(9007199254740991).optional(),
                correctBucketId: z.string().optional(),
                correctAmount: z.number().optional(),
                amountTolerance: z.number().optional(),
                feedback: z.string().optional()
            })).max(12),
            buckets: z.array(z.object({
                id: z.string().min(1),
                label: z.string().min(1).max(120)
            })).max(4),
            hintEnabled: z.boolean(),
            bodyEnabled: z.boolean(),
            bodyPredatesRules: z.boolean(),
            warnings: z.array(z.object({
                field: z.string(),
                message: z.string(),
                fixable: z.boolean(),
                blocks: z.boolean()
            })).default([]),
            questionId: z.string().optional(),
            explanation: z.string().optional()
        }),
        z.object({
            id: z.string().min(1),
            position: z.int().gte(1).lte(9007199254740991),
            prompt: z.string().min(1).max(400),
            verb: z.enum([
                'decide',
                'allocate',
                'rank',
                'match',
                'predict',
                'diagnose',
                'negotiate',
                'rephrase',
                'pitch',
                'speak',
                'simulate'
            ]).optional(),
            rung: z.enum([
                'RECOGNIZE',
                'DECIDE',
                'MANIPULATE',
                'CREATE',
                'SPEAK',
                'APPLY',
                'SIMULATE'
            ]).optional(),
            timeLimitMs: z.int().gte(1000).lte(9007199254740991).optional(),
            visual: z.union([
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    max: z.number(),
                    rows: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        previous: z.number().optional(),
                        display: z.string().min(1).max(24)
                    })).min(1).max(4)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    figures: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.string().min(1).max(24),
                        tone: z.enum([
                            'default',
                            'up',
                            'down',
                            'accent',
                            'streak'
                        ]).optional()
                    })).min(2).max(4)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    shares: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.number().gte(0),
                        display: z.string().min(1).max(24).optional()
                    })).min(2).max(6)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    stages: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.number().gte(0),
                        display: z.string().min(1).max(24)
                    })).min(2).max(5)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    start: z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24)
                    }),
                    steps: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24)
                    })).min(1).max(5),
                    end: z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24)
                    })
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    max: z.number(),
                    min: z.number().optional(),
                    rows: z.array(z.object({
                        label: z.string().min(1).max(60),
                        before: z.number(),
                        after: z.number(),
                        beforeDisplay: z.string().min(1).max(24),
                        afterDisplay: z.string().min(1).max(24)
                    })).min(1).max(4)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    x: z.object({
                        label: z.string().min(1).max(60),
                        low: z.string().min(1).max(40),
                        high: z.string().min(1).max(40)
                    }),
                    y: z.object({
                        label: z.string().min(1).max(60),
                        low: z.string().min(1).max(40),
                        high: z.string().min(1).max(40)
                    }),
                    quadrants: z.tuple([
                        z.string().min(1).max(40),
                        z.string().min(1).max(40),
                        z.string().min(1).max(40),
                        z.string().min(1).max(40)
                    ]).optional(),
                    items: z.array(z.object({
                        label: z.string().min(1).max(60),
                        x: z.number().gte(0).lte(1),
                        y: z.number().gte(0).lte(1)
                    })).min(1).max(4)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    steps: z.array(z.object({
                        label: z.string().min(1).max(60),
                        note: z.string().min(1).max(80).optional()
                    })).min(2).max(5)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    at: z.array(z.string().min(1).max(16)).min(2).max(8),
                    min: z.number(),
                    max: z.number(),
                    series: z.array(z.object({
                        label: z.string().min(1).max(60),
                        values: z.array(z.number()).min(2).max(8),
                        display: z.string().min(1).max(24)
                    })).min(1).max(6)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    columns: z.array(z.string().min(1).max(40)).min(2).max(3),
                    rows: z.array(z.object({
                        label: z.string().min(1).max(60),
                        cells: z.array(z.string().min(1).max(40)).max(3)
                    })).min(2).max(6)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    left: z.object({
                        name: z.string().min(1).max(60),
                        you: z.boolean().optional(),
                        character: z.enum([
                            'betty',
                            'david',
                            'rosa',
                            'kofi',
                            'priya',
                            'sam',
                            'noor',
                            'tomi',
                            'biscuit',
                            'bolt'
                        ]).optional(),
                        pose: z.enum([
                            'sit',
                            'lean-in',
                            'arms-crossed',
                            'hand-on-chin',
                            'wave'
                        ]).optional(),
                        facing: z.enum(['left', 'right']).optional(),
                        slot: z.enum([
                            'left',
                            'center',
                            'right'
                        ]).optional(),
                        reaction: z.enum([
                            'happy',
                            'worried',
                            'thinking'
                        ]).optional()
                    }),
                    right: z.object({
                        name: z.string().min(1).max(60),
                        you: z.boolean().optional(),
                        character: z.enum([
                            'betty',
                            'david',
                            'rosa',
                            'kofi',
                            'priya',
                            'sam',
                            'noor',
                            'tomi',
                            'biscuit',
                            'bolt'
                        ]).optional(),
                        pose: z.enum([
                            'sit',
                            'lean-in',
                            'arms-crossed',
                            'hand-on-chin',
                            'wave'
                        ]).optional(),
                        facing: z.enum(['left', 'right']).optional(),
                        slot: z.enum([
                            'left',
                            'center',
                            'right'
                        ]).optional(),
                        reaction: z.enum([
                            'happy',
                            'worried',
                            'thinking'
                        ]).optional()
                    }),
                    lines: z.array(z.object({
                        by: z.enum(['left', 'right']),
                        text: z.string().min(1).max(80).optional(),
                        sound: z.enum([
                            'bark',
                            'whine',
                            'growl',
                            'pant',
                            'meow',
                            'purr',
                            'hiss'
                        ]).optional(),
                        mood: z.enum([
                            'happy',
                            'worried',
                            'thinking'
                        ]).optional(),
                        thought: z.boolean().optional()
                    })).min(1).max(4),
                    awaiting: z.enum(['left', 'right']).optional(),
                    props: z.array(z.string().max(40).regex(/^[a-z0-9]+(-[a-z0-9]+)*$/)).min(1).max(3).optional()
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    cast: z.array(z.object({
                        name: z.string().min(1).max(60),
                        you: z.boolean().optional(),
                        character: z.enum([
                            'betty',
                            'david',
                            'rosa',
                            'kofi',
                            'priya',
                            'sam',
                            'noor',
                            'tomi',
                            'biscuit',
                            'bolt'
                        ]).optional(),
                        pose: z.enum([
                            'sit',
                            'lean-in',
                            'arms-crossed',
                            'hand-on-chin',
                            'wave'
                        ]).optional(),
                        facing: z.enum(['left', 'right']).optional(),
                        slot: z.enum([
                            'left',
                            'center',
                            'right'
                        ]).optional(),
                        reaction: z.enum([
                            'happy',
                            'worried',
                            'thinking'
                        ]).optional(),
                        thought: z.string().min(1).max(80).optional()
                    })).min(1).max(3),
                    stakes: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.string().min(1).max(24),
                        tone: z.enum([
                            'default',
                            'up',
                            'down',
                            'accent',
                            'streak'
                        ]).optional()
                    })).min(1).max(4).optional(),
                    props: z.array(z.string().max(40).regex(/^[a-z0-9]+(-[a-z0-9]+)*$/)).min(1).max(3).optional()
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    left: z.object({
                        label: z.string().min(1).max(60),
                        gains: z.array(z.string().min(1).max(40)).min(1).max(3),
                        costs: z.array(z.string().min(1).max(40)).min(1).max(3)
                    }),
                    right: z.object({
                        label: z.string().min(1).max(60),
                        gains: z.array(z.string().min(1).max(40)).min(1).max(3),
                        costs: z.array(z.string().min(1).max(40)).min(1).max(3)
                    })
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    fork: z.string().min(1).max(80),
                    branches: z.array(z.object({
                        label: z.string().min(1).max(60),
                        outcome: z.string().min(1).max(60),
                        tone: z.enum(['up', 'down']).optional()
                    })).min(2).max(3)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    moments: z.array(z.object({
                        at: z.string().min(1).max(16),
                        label: z.string().min(1).max(60)
                    })).min(2).max(5),
                    now: z.int().gte(0).lte(9007199254740991).optional()
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    start: z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24)
                    }),
                    steps: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24),
                        op: z.enum([
                            'plus',
                            'minus',
                            'times',
                            'divide'
                        ])
                    })).min(1).max(2),
                    result: z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24)
                    })
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    price: z.object({
                        low: z.number(),
                        high: z.number()
                    }),
                    demand: z.object({
                        atLow: z.number().gte(0),
                        atHigh: z.number().gte(0)
                    }),
                    readoutLabel: z.string().min(1).max(60),
                    unit: z.string().max(8),
                    from: z.string().min(1).max(40),
                    to: z.string().min(1).max(40)
                })
            ]).optional(),
            hint: z.string().min(1).max(600).optional(),
            body: z.string().optional(),
            kind: z.string(),
            min: z.number().optional(),
            max: z.number().optional(),
            step: z.number().optional(),
            unit: z.string().max(24).optional(),
            hintEnabled: z.boolean(),
            bodyEnabled: z.boolean(),
            bodyPredatesRules: z.boolean(),
            warnings: z.array(z.object({
                field: z.string(),
                message: z.string(),
                fixable: z.boolean(),
                blocks: z.boolean()
            })).default([]),
            questionId: z.string().optional(),
            explanation: z.string().optional(),
            targetMin: z.number().optional(),
            targetMax: z.number().optional()
        }),
        z.object({
            id: z.string().min(1),
            position: z.int().gte(1).lte(9007199254740991),
            prompt: z.string().min(1).max(400),
            verb: z.enum([
                'decide',
                'allocate',
                'rank',
                'match',
                'predict',
                'diagnose',
                'negotiate',
                'rephrase',
                'pitch',
                'speak',
                'simulate'
            ]).optional(),
            rung: z.enum([
                'RECOGNIZE',
                'DECIDE',
                'MANIPULATE',
                'CREATE',
                'SPEAK',
                'APPLY',
                'SIMULATE'
            ]).optional(),
            timeLimitMs: z.int().gte(1000).lte(9007199254740991).optional(),
            visual: z.union([
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    max: z.number(),
                    rows: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        previous: z.number().optional(),
                        display: z.string().min(1).max(24)
                    })).min(1).max(4)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    figures: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.string().min(1).max(24),
                        tone: z.enum([
                            'default',
                            'up',
                            'down',
                            'accent',
                            'streak'
                        ]).optional()
                    })).min(2).max(4)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    shares: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.number().gte(0),
                        display: z.string().min(1).max(24).optional()
                    })).min(2).max(6)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    stages: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.number().gte(0),
                        display: z.string().min(1).max(24)
                    })).min(2).max(5)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    start: z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24)
                    }),
                    steps: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24)
                    })).min(1).max(5),
                    end: z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24)
                    })
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    max: z.number(),
                    min: z.number().optional(),
                    rows: z.array(z.object({
                        label: z.string().min(1).max(60),
                        before: z.number(),
                        after: z.number(),
                        beforeDisplay: z.string().min(1).max(24),
                        afterDisplay: z.string().min(1).max(24)
                    })).min(1).max(4)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    x: z.object({
                        label: z.string().min(1).max(60),
                        low: z.string().min(1).max(40),
                        high: z.string().min(1).max(40)
                    }),
                    y: z.object({
                        label: z.string().min(1).max(60),
                        low: z.string().min(1).max(40),
                        high: z.string().min(1).max(40)
                    }),
                    quadrants: z.tuple([
                        z.string().min(1).max(40),
                        z.string().min(1).max(40),
                        z.string().min(1).max(40),
                        z.string().min(1).max(40)
                    ]).optional(),
                    items: z.array(z.object({
                        label: z.string().min(1).max(60),
                        x: z.number().gte(0).lte(1),
                        y: z.number().gte(0).lte(1)
                    })).min(1).max(4)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    steps: z.array(z.object({
                        label: z.string().min(1).max(60),
                        note: z.string().min(1).max(80).optional()
                    })).min(2).max(5)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    at: z.array(z.string().min(1).max(16)).min(2).max(8),
                    min: z.number(),
                    max: z.number(),
                    series: z.array(z.object({
                        label: z.string().min(1).max(60),
                        values: z.array(z.number()).min(2).max(8),
                        display: z.string().min(1).max(24)
                    })).min(1).max(6)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    columns: z.array(z.string().min(1).max(40)).min(2).max(3),
                    rows: z.array(z.object({
                        label: z.string().min(1).max(60),
                        cells: z.array(z.string().min(1).max(40)).max(3)
                    })).min(2).max(6)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    left: z.object({
                        name: z.string().min(1).max(60),
                        you: z.boolean().optional(),
                        character: z.enum([
                            'betty',
                            'david',
                            'rosa',
                            'kofi',
                            'priya',
                            'sam',
                            'noor',
                            'tomi',
                            'biscuit',
                            'bolt'
                        ]).optional(),
                        pose: z.enum([
                            'sit',
                            'lean-in',
                            'arms-crossed',
                            'hand-on-chin',
                            'wave'
                        ]).optional(),
                        facing: z.enum(['left', 'right']).optional(),
                        slot: z.enum([
                            'left',
                            'center',
                            'right'
                        ]).optional(),
                        reaction: z.enum([
                            'happy',
                            'worried',
                            'thinking'
                        ]).optional()
                    }),
                    right: z.object({
                        name: z.string().min(1).max(60),
                        you: z.boolean().optional(),
                        character: z.enum([
                            'betty',
                            'david',
                            'rosa',
                            'kofi',
                            'priya',
                            'sam',
                            'noor',
                            'tomi',
                            'biscuit',
                            'bolt'
                        ]).optional(),
                        pose: z.enum([
                            'sit',
                            'lean-in',
                            'arms-crossed',
                            'hand-on-chin',
                            'wave'
                        ]).optional(),
                        facing: z.enum(['left', 'right']).optional(),
                        slot: z.enum([
                            'left',
                            'center',
                            'right'
                        ]).optional(),
                        reaction: z.enum([
                            'happy',
                            'worried',
                            'thinking'
                        ]).optional()
                    }),
                    lines: z.array(z.object({
                        by: z.enum(['left', 'right']),
                        text: z.string().min(1).max(80).optional(),
                        sound: z.enum([
                            'bark',
                            'whine',
                            'growl',
                            'pant',
                            'meow',
                            'purr',
                            'hiss'
                        ]).optional(),
                        mood: z.enum([
                            'happy',
                            'worried',
                            'thinking'
                        ]).optional(),
                        thought: z.boolean().optional()
                    })).min(1).max(4),
                    awaiting: z.enum(['left', 'right']).optional(),
                    props: z.array(z.string().max(40).regex(/^[a-z0-9]+(-[a-z0-9]+)*$/)).min(1).max(3).optional()
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    cast: z.array(z.object({
                        name: z.string().min(1).max(60),
                        you: z.boolean().optional(),
                        character: z.enum([
                            'betty',
                            'david',
                            'rosa',
                            'kofi',
                            'priya',
                            'sam',
                            'noor',
                            'tomi',
                            'biscuit',
                            'bolt'
                        ]).optional(),
                        pose: z.enum([
                            'sit',
                            'lean-in',
                            'arms-crossed',
                            'hand-on-chin',
                            'wave'
                        ]).optional(),
                        facing: z.enum(['left', 'right']).optional(),
                        slot: z.enum([
                            'left',
                            'center',
                            'right'
                        ]).optional(),
                        reaction: z.enum([
                            'happy',
                            'worried',
                            'thinking'
                        ]).optional(),
                        thought: z.string().min(1).max(80).optional()
                    })).min(1).max(3),
                    stakes: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.string().min(1).max(24),
                        tone: z.enum([
                            'default',
                            'up',
                            'down',
                            'accent',
                            'streak'
                        ]).optional()
                    })).min(1).max(4).optional(),
                    props: z.array(z.string().max(40).regex(/^[a-z0-9]+(-[a-z0-9]+)*$/)).min(1).max(3).optional()
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    left: z.object({
                        label: z.string().min(1).max(60),
                        gains: z.array(z.string().min(1).max(40)).min(1).max(3),
                        costs: z.array(z.string().min(1).max(40)).min(1).max(3)
                    }),
                    right: z.object({
                        label: z.string().min(1).max(60),
                        gains: z.array(z.string().min(1).max(40)).min(1).max(3),
                        costs: z.array(z.string().min(1).max(40)).min(1).max(3)
                    })
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    fork: z.string().min(1).max(80),
                    branches: z.array(z.object({
                        label: z.string().min(1).max(60),
                        outcome: z.string().min(1).max(60),
                        tone: z.enum(['up', 'down']).optional()
                    })).min(2).max(3)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    moments: z.array(z.object({
                        at: z.string().min(1).max(16),
                        label: z.string().min(1).max(60)
                    })).min(2).max(5),
                    now: z.int().gte(0).lte(9007199254740991).optional()
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    start: z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24)
                    }),
                    steps: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24),
                        op: z.enum([
                            'plus',
                            'minus',
                            'times',
                            'divide'
                        ])
                    })).min(1).max(2),
                    result: z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24)
                    })
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    price: z.object({
                        low: z.number(),
                        high: z.number()
                    }),
                    demand: z.object({
                        atLow: z.number().gte(0),
                        atHigh: z.number().gte(0)
                    }),
                    readoutLabel: z.string().min(1).max(60),
                    unit: z.string().max(8),
                    from: z.string().min(1).max(40),
                    to: z.string().min(1).max(40)
                })
            ]).optional(),
            hint: z.string().min(1).max(600).optional(),
            body: z.string().optional(),
            kind: z.string(),
            categories: z.array(z.object({
                id: z.string().min(1),
                label: z.string().min(1).max(200),
                isCorrect: z.boolean().optional(),
                correctPosition: z.int().gte(-9007199254740991).lte(9007199254740991).optional(),
                correctBucketId: z.string().optional(),
                correctAmount: z.number().optional(),
                amountTolerance: z.number().optional(),
                feedback: z.string().optional()
            })).max(8),
            poolTotal: z.number().optional(),
            unit: z.string().max(24).optional(),
            hintEnabled: z.boolean(),
            bodyEnabled: z.boolean(),
            bodyPredatesRules: z.boolean(),
            warnings: z.array(z.object({
                field: z.string(),
                message: z.string(),
                fixable: z.boolean(),
                blocks: z.boolean()
            })).default([]),
            questionId: z.string().optional(),
            explanation: z.string().optional()
        }),
        z.object({
            id: z.string().min(1),
            position: z.int().gte(1).lte(9007199254740991),
            prompt: z.string().min(1).max(400),
            verb: z.enum([
                'decide',
                'allocate',
                'rank',
                'match',
                'predict',
                'diagnose',
                'negotiate',
                'rephrase',
                'pitch',
                'speak',
                'simulate'
            ]).optional(),
            rung: z.enum([
                'RECOGNIZE',
                'DECIDE',
                'MANIPULATE',
                'CREATE',
                'SPEAK',
                'APPLY',
                'SIMULATE'
            ]).optional(),
            timeLimitMs: z.int().gte(1000).lte(9007199254740991).optional(),
            visual: z.union([
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    max: z.number(),
                    rows: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        previous: z.number().optional(),
                        display: z.string().min(1).max(24)
                    })).min(1).max(4)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    figures: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.string().min(1).max(24),
                        tone: z.enum([
                            'default',
                            'up',
                            'down',
                            'accent',
                            'streak'
                        ]).optional()
                    })).min(2).max(4)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    shares: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.number().gte(0),
                        display: z.string().min(1).max(24).optional()
                    })).min(2).max(6)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    stages: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.number().gte(0),
                        display: z.string().min(1).max(24)
                    })).min(2).max(5)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    start: z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24)
                    }),
                    steps: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24)
                    })).min(1).max(5),
                    end: z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24)
                    })
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    max: z.number(),
                    min: z.number().optional(),
                    rows: z.array(z.object({
                        label: z.string().min(1).max(60),
                        before: z.number(),
                        after: z.number(),
                        beforeDisplay: z.string().min(1).max(24),
                        afterDisplay: z.string().min(1).max(24)
                    })).min(1).max(4)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    x: z.object({
                        label: z.string().min(1).max(60),
                        low: z.string().min(1).max(40),
                        high: z.string().min(1).max(40)
                    }),
                    y: z.object({
                        label: z.string().min(1).max(60),
                        low: z.string().min(1).max(40),
                        high: z.string().min(1).max(40)
                    }),
                    quadrants: z.tuple([
                        z.string().min(1).max(40),
                        z.string().min(1).max(40),
                        z.string().min(1).max(40),
                        z.string().min(1).max(40)
                    ]).optional(),
                    items: z.array(z.object({
                        label: z.string().min(1).max(60),
                        x: z.number().gte(0).lte(1),
                        y: z.number().gte(0).lte(1)
                    })).min(1).max(4)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    steps: z.array(z.object({
                        label: z.string().min(1).max(60),
                        note: z.string().min(1).max(80).optional()
                    })).min(2).max(5)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    at: z.array(z.string().min(1).max(16)).min(2).max(8),
                    min: z.number(),
                    max: z.number(),
                    series: z.array(z.object({
                        label: z.string().min(1).max(60),
                        values: z.array(z.number()).min(2).max(8),
                        display: z.string().min(1).max(24)
                    })).min(1).max(6)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    columns: z.array(z.string().min(1).max(40)).min(2).max(3),
                    rows: z.array(z.object({
                        label: z.string().min(1).max(60),
                        cells: z.array(z.string().min(1).max(40)).max(3)
                    })).min(2).max(6)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    left: z.object({
                        name: z.string().min(1).max(60),
                        you: z.boolean().optional(),
                        character: z.enum([
                            'betty',
                            'david',
                            'rosa',
                            'kofi',
                            'priya',
                            'sam',
                            'noor',
                            'tomi',
                            'biscuit',
                            'bolt'
                        ]).optional(),
                        pose: z.enum([
                            'sit',
                            'lean-in',
                            'arms-crossed',
                            'hand-on-chin',
                            'wave'
                        ]).optional(),
                        facing: z.enum(['left', 'right']).optional(),
                        slot: z.enum([
                            'left',
                            'center',
                            'right'
                        ]).optional(),
                        reaction: z.enum([
                            'happy',
                            'worried',
                            'thinking'
                        ]).optional()
                    }),
                    right: z.object({
                        name: z.string().min(1).max(60),
                        you: z.boolean().optional(),
                        character: z.enum([
                            'betty',
                            'david',
                            'rosa',
                            'kofi',
                            'priya',
                            'sam',
                            'noor',
                            'tomi',
                            'biscuit',
                            'bolt'
                        ]).optional(),
                        pose: z.enum([
                            'sit',
                            'lean-in',
                            'arms-crossed',
                            'hand-on-chin',
                            'wave'
                        ]).optional(),
                        facing: z.enum(['left', 'right']).optional(),
                        slot: z.enum([
                            'left',
                            'center',
                            'right'
                        ]).optional(),
                        reaction: z.enum([
                            'happy',
                            'worried',
                            'thinking'
                        ]).optional()
                    }),
                    lines: z.array(z.object({
                        by: z.enum(['left', 'right']),
                        text: z.string().min(1).max(80).optional(),
                        sound: z.enum([
                            'bark',
                            'whine',
                            'growl',
                            'pant',
                            'meow',
                            'purr',
                            'hiss'
                        ]).optional(),
                        mood: z.enum([
                            'happy',
                            'worried',
                            'thinking'
                        ]).optional(),
                        thought: z.boolean().optional()
                    })).min(1).max(4),
                    awaiting: z.enum(['left', 'right']).optional(),
                    props: z.array(z.string().max(40).regex(/^[a-z0-9]+(-[a-z0-9]+)*$/)).min(1).max(3).optional()
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    cast: z.array(z.object({
                        name: z.string().min(1).max(60),
                        you: z.boolean().optional(),
                        character: z.enum([
                            'betty',
                            'david',
                            'rosa',
                            'kofi',
                            'priya',
                            'sam',
                            'noor',
                            'tomi',
                            'biscuit',
                            'bolt'
                        ]).optional(),
                        pose: z.enum([
                            'sit',
                            'lean-in',
                            'arms-crossed',
                            'hand-on-chin',
                            'wave'
                        ]).optional(),
                        facing: z.enum(['left', 'right']).optional(),
                        slot: z.enum([
                            'left',
                            'center',
                            'right'
                        ]).optional(),
                        reaction: z.enum([
                            'happy',
                            'worried',
                            'thinking'
                        ]).optional(),
                        thought: z.string().min(1).max(80).optional()
                    })).min(1).max(3),
                    stakes: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.string().min(1).max(24),
                        tone: z.enum([
                            'default',
                            'up',
                            'down',
                            'accent',
                            'streak'
                        ]).optional()
                    })).min(1).max(4).optional(),
                    props: z.array(z.string().max(40).regex(/^[a-z0-9]+(-[a-z0-9]+)*$/)).min(1).max(3).optional()
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    left: z.object({
                        label: z.string().min(1).max(60),
                        gains: z.array(z.string().min(1).max(40)).min(1).max(3),
                        costs: z.array(z.string().min(1).max(40)).min(1).max(3)
                    }),
                    right: z.object({
                        label: z.string().min(1).max(60),
                        gains: z.array(z.string().min(1).max(40)).min(1).max(3),
                        costs: z.array(z.string().min(1).max(40)).min(1).max(3)
                    })
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    fork: z.string().min(1).max(80),
                    branches: z.array(z.object({
                        label: z.string().min(1).max(60),
                        outcome: z.string().min(1).max(60),
                        tone: z.enum(['up', 'down']).optional()
                    })).min(2).max(3)
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    moments: z.array(z.object({
                        at: z.string().min(1).max(16),
                        label: z.string().min(1).max(60)
                    })).min(2).max(5),
                    now: z.int().gte(0).lte(9007199254740991).optional()
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    start: z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24)
                    }),
                    steps: z.array(z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24),
                        op: z.enum([
                            'plus',
                            'minus',
                            'times',
                            'divide'
                        ])
                    })).min(1).max(2),
                    result: z.object({
                        label: z.string().min(1).max(60),
                        value: z.number(),
                        display: z.string().min(1).max(24)
                    })
                }),
                z.object({
                    kind: z.string(),
                    caption: z.string().min(1).max(120),
                    price: z.object({
                        low: z.number(),
                        high: z.number()
                    }),
                    demand: z.object({
                        atLow: z.number().gte(0),
                        atHigh: z.number().gte(0)
                    }),
                    readoutLabel: z.string().min(1).max(60),
                    unit: z.string().max(8),
                    from: z.string().min(1).max(40),
                    to: z.string().min(1).max(40)
                })
            ]).optional(),
            hint: z.string().min(1).max(600).optional(),
            body: z.string().optional(),
            kind: z.string(),
            hintEnabled: z.boolean(),
            bodyEnabled: z.boolean(),
            bodyPredatesRules: z.boolean(),
            warnings: z.array(z.object({
                field: z.string(),
                message: z.string(),
                fixable: z.boolean(),
                blocks: z.boolean()
            })).default([]),
            questionId: z.string().optional(),
            explanation: z.string().optional(),
            counterpartBrief: z.string().optional()
        })
    ])),
    cast: z.array(z.object({
        character: z.enum([
            'betty',
            'david',
            'rosa',
            'kofi',
            'priya',
            'sam',
            'noor',
            'tomi',
            'biscuit',
            'bolt'
        ]),
        role: z.string().min(1).max(60)
    })).max(3).optional(),
    props: z.array(z.object({
        slug: z.string().max(40).regex(/^[a-z0-9]+(-[a-z0-9]+)*$/),
        label: z.string().min(1).max(40),
        readiness: z.enum([
            'ready',
            'limited',
            'pending'
        ])
    })).optional(),
    terms: z.array(z.object({
        term: z.string().min(1).max(80),
        definition: z.string().min(1),
        taughtIn: z.object({
            id: z.string().min(1),
            slug: z.string().min(1).max(200).regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/),
            title: z.string().min(1)
        }).optional()
    })),
    status: z.enum([
        'DRAFT',
        'PUBLISHED',
        'ARCHIVED'
    ]),
    writing: z.boolean(),
    personas: z.array(z.object({
        persona: z.enum([
            'CAREER_STARTER',
            'RISING_MANAGER',
            'FUTURE_EXECUTIVE',
            'FOUNDER_OWNER',
            'EXPERIENCED_IC',
            'CAREER_SWITCHER'
        ]),
        fit: z.enum([
            'IDEAL',
            'SUITABLE',
            'STRETCH',
            'UNSUITABLE'
        ]).optional()
    })),
    tags: z.array(z.string().min(2).max(60).regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/)),
    usage: z.array(z.object({
        sceneId: z.string(),
        lessons: z.int().gte(-9007199254740991).lte(9007199254740991)
    })),
    handEdited: z.array(z.string()),
    findings: z.array(z.object({
        id: z.string().min(1),
        targetType: z.enum([
            'COLLECTION',
            'LESSON',
            'SCENE',
            'QUESTION'
        ]),
        targetId: z.string().min(1),
        severity: z.enum([
            'BLOCKER',
            'WARN',
            'NOTE'
        ]),
        category: z.enum([
            'GROUNDING',
            'COMPREHENSION',
            'INSTRUCTIONAL_DESIGN',
            'MECHANICS',
            'WRITING',
            'RELEVANCE'
        ]).optional(),
        finding: z.string().min(1),
        suggestion: z.string().min(1),
        status: z.enum([
            'OPEN',
            'PROPOSED',
            'ACCEPTED',
            'DISMISSED',
            'SUPERSEDED'
        ]),
        appliedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).optional(),
        revertedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).optional(),
        changes: z.object({
            changes: z.array(z.object({
                field: z.string(),
                before: z.string(),
                after: z.string()
            })),
            rationale: z.string().optional()
        }).optional(),
        editorNote: z.string().optional(),
        outcome: z.enum([
            'FIXED',
            'UNRESOLVED',
            'DISPUTED',
            'NEW'
        ]).optional(),
        lessonVersionId: z.string().optional(),
        recheckedVersionId: z.string().optional(),
        createdAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/)
    })),
    coverUrl: z.url().optional(),
    pictures: z.object({
        missing: z.array(z.object({
            position: z.int().gte(-9007199254740991).lte(9007199254740991).optional(),
            message: z.string()
        })),
        pending: z.boolean(),
        blocks: z.boolean()
    }),
    storySentences: z.array(z.object({
        position: z.int().gte(1).lte(9007199254740991),
        field: z.string().min(1).max(100),
        sentence: z.string().min(1).max(500)
    })).max(20),
    qa: z.object({
        scores: z.object({
            GROUNDING: z.int().gte(0).lte(100),
            COMPREHENSION: z.int().gte(0).lte(100),
            INSTRUCTIONAL_DESIGN: z.int().gte(0).lte(100),
            MECHANICS: z.int().gte(0).lte(100),
            WRITING: z.int().gte(0).lte(100),
            RELEVANCE: z.int().gte(0).lte(100)
        }),
        overall: z.int().gte(0).lte(100),
        status: z.enum([
            'PASSED',
            'NEEDS_REVIEW',
            'FAILED'
        ]),
        blockers: z.int().gte(0).lte(9007199254740991),
        uncategorised: z.int().gte(0).lte(9007199254740991),
        rubric: z.union([
            z.int().gte(0).lte(100),
            z.unknown()
        ]).optional(),
        rubricFailure: z.enum([
            'OUT_OF_CREDITS',
            'UNREACHABLE',
            'TIMED_OUT'
        ]).optional(),
        claimsFailure: z.enum([
            'OUT_OF_CREDITS',
            'UNREACHABLE',
            'TIMED_OUT'
        ]).optional(),
        cited: z.boolean().optional(),
        breakdown: z.object({
            costs: z.object({
                BLOCKER: z.int().gte(0).lte(9007199254740991),
                WARN: z.int().gte(0).lte(9007199254740991),
                NOTE: z.int().gte(0).lte(9007199254740991)
            }),
            categories: z.array(z.object({
                category: z.enum([
                    'GROUNDING',
                    'COMPREHENSION',
                    'INSTRUCTIONAL_DESIGN',
                    'MECHANICS',
                    'WRITING',
                    'RELEVANCE'
                ]),
                blockers: z.int().gte(0).lte(9007199254740991),
                warnings: z.int().gte(0).lte(9007199254740991),
                notes: z.int().gte(0).lte(9007199254740991),
                lost: z.int().gte(0).lte(9007199254740991),
                score: z.int().gte(0).lte(100),
                weight: z.number().gte(0).lte(1)
            })),
            blend: z.number(),
            passAt: z.int().gte(0).lte(100),
            reviewAt: z.int().gte(0).lte(100),
            rubricPassAt: z.int().gte(0).lte(100),
            reasons: z.array(z.object({
                rule: z.enum([
                    'OPEN_BLOCKERS',
                    'CATEGORY_BELOW',
                    'BLEND_BELOW',
                    'RUBRIC_BELOW',
                    'RUBRIC_UNSCORED',
                    'UNCITED'
                ]),
                category: z.enum([
                    'GROUNDING',
                    'COMPREHENSION',
                    'INSTRUCTIONAL_DESIGN',
                    'MECHANICS',
                    'WRITING',
                    'RELEVANCE'
                ]).optional(),
                value: z.int().gte(-9007199254740991).lte(9007199254740991).optional(),
                line: z.int().gte(0).lte(100).optional()
            }))
        })
    })
});
export const zRerolledObjectDtoOutput = z.object({
    objectName: z.union([
        z.enum([
            'balance',
            'funnel',
            'stack',
            'bridge',
            'steps',
            'podium',
            'chart',
            'pie',
            'gauge',
            'magnifier',
            'beaker',
            'hourglass',
            'calendar',
            'clock',
            'stopwatch',
            'vault',
            'wallet',
            'receipt',
            'calculator',
            'ledger',
            'compass',
            'telescope',
            'map',
            'flag',
            'chess',
            'target',
            'gavel',
            'puzzle',
            'team',
            'network',
            'roundtable',
            'mic',
            'iceberg',
            'chat',
            'gears',
            'pipeline',
            'crate',
            'factory',
            'server',
            'spool',
            'clipboard',
            'tray',
            'basket',
            'folder',
            'bin',
            'lightbulb',
            'rocket',
            'key',
            'trophy',
            'briefcase'
        ]),
        z.unknown()
    ])
});
export const zPublishReadinessDtoOutput = z.object({
    issues: z.array(z.object({
        path: z.string(),
        message: z.string()
    }))
});
export const zCreateQuestionDto = z.object({
    subject: z.enum([
        'MARKETING',
        'FINANCE',
        'STRATEGY',
        'LEADERSHIP',
        'SALES',
        'NEGOTIATION',
        'ENTREPRENEURSHIP',
        'PUBLIC_SPEAKING',
        'COMMUNICATION',
        'OPERATIONS',
        'DECISIONS',
        'BUSINESS_FUNDAMENTALS',
        'TEAM_MANAGEMENT',
        'HIRING',
        'ORGANIZATIONAL_BEHAVIOR',
        'PRODUCT_MANAGEMENT',
        'AI',
        'INNOVATION',
        'PROJECT_MANAGEMENT',
        'BUSINESS_ANALYTICS',
        'CAREER',
        'PERSONAL_FINANCE',
        'ECONOMICS'
    ]),
    difficulty: z.enum([
        'BEGINNER',
        'INTERMEDIATE',
        'ADVANCED'
    ]),
    stem: z.string().min(3).max(400),
    explanation: z.string().min(3).max(1200),
    tags: z.array(z.string().min(2).max(60).regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/)).max(12).optional()
});
export const zUpdateQuestionDto = z.object({
    subject: z.enum([
        'MARKETING',
        'FINANCE',
        'STRATEGY',
        'LEADERSHIP',
        'SALES',
        'NEGOTIATION',
        'ENTREPRENEURSHIP',
        'PUBLIC_SPEAKING',
        'COMMUNICATION',
        'OPERATIONS',
        'DECISIONS',
        'BUSINESS_FUNDAMENTALS',
        'TEAM_MANAGEMENT',
        'HIRING',
        'ORGANIZATIONAL_BEHAVIOR',
        'PRODUCT_MANAGEMENT',
        'AI',
        'INNOVATION',
        'PROJECT_MANAGEMENT',
        'BUSINESS_ANALYTICS',
        'CAREER',
        'PERSONAL_FINANCE',
        'ECONOMICS'
    ]).optional(),
    difficulty: z.enum([
        'BEGINNER',
        'INTERMEDIATE',
        'ADVANCED'
    ]).optional(),
    stem: z.string().min(3).max(400).optional(),
    explanation: z.string().min(3).max(1200).optional(),
    tags: z.array(z.string().min(2).max(60).regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/)).max(12).optional(),
    status: z.enum([
        'DRAFT',
        'PUBLISHED',
        'ARCHIVED'
    ]).optional()
});
export const zCreateSourceDto = z.object({
    type: z.enum([
        'ARTICLE',
        'RESEARCH',
        'LINK',
        'TEXT'
    ]),
    title: z.string().min(3).max(500),
    url: z.url().optional(),
    citation: z.string().min(3).max(400).optional()
});
export const zCreateSceneDto = z.object({
    kind: z.enum([
        'HOOK',
        'CONCEPT',
        'CASE',
        'ARTICLE',
        'RECAP',
        'CHOICE',
        'RANK',
        'BUCKET',
        'SLIDER',
        'ALLOCATE',
        'SPEAK'
    ]),
    prompt: z.string().min(3).max(400),
    body: z.string().max(2000).optional(),
    bodyEnabled: z.boolean().optional(),
    hint: z.string().max(600).optional(),
    hintEnabled: z.boolean().optional(),
    imageUrl: z.url().optional(),
    objectName: z.enum([
        'balance',
        'funnel',
        'stack',
        'bridge',
        'steps',
        'podium',
        'chart',
        'pie',
        'gauge',
        'magnifier',
        'beaker',
        'hourglass',
        'calendar',
        'clock',
        'stopwatch',
        'vault',
        'wallet',
        'receipt',
        'calculator',
        'ledger',
        'compass',
        'telescope',
        'map',
        'flag',
        'chess',
        'target',
        'gavel',
        'puzzle',
        'team',
        'network',
        'roundtable',
        'mic',
        'iceberg',
        'chat',
        'gears',
        'pipeline',
        'crate',
        'factory',
        'server',
        'spool',
        'clipboard',
        'tray',
        'basket',
        'folder',
        'bin',
        'lightbulb',
        'rocket',
        'key',
        'trophy',
        'briefcase'
    ]).optional(),
    questionId: z.string().min(1).optional(),
    sourceId: z.string().min(1).optional(),
    maxSelections: z.int().gte(1).lte(8).optional(),
    requireSubmit: z.boolean().optional(),
    min: z.number().optional(),
    max: z.number().optional(),
    step: z.number().optional(),
    unit: z.string().max(24).optional(),
    targetMin: z.number().optional(),
    targetMax: z.number().optional(),
    poolTotal: z.number().optional(),
    counterpartBrief: z.string().max(2000).optional(),
    items: z.array(z.object({
        position: z.int().gte(1).lte(12),
        label: z.string().min(1).max(200),
        imageUrl: z.url().optional(),
        isCorrect: z.boolean().optional(),
        correctPosition: z.int().gte(1).lte(12).optional(),
        correctBucketId: z.string().min(1).optional(),
        correctAmount: z.number().gte(0).lte(1000000).optional(),
        amountTolerance: z.number().gte(0).lte(1000000).optional(),
        feedback: z.string().min(3).max(190).optional()
    })).max(12).optional(),
    buckets: z.array(z.object({
        position: z.int().gte(1).lte(4),
        label: z.string().min(1).max(120)
    })).max(4).optional()
});
export const zUpdateSceneDto = z.object({
    prompt: z.string().min(3).max(400).optional(),
    body: z.string().max(2000).optional(),
    bodyEnabled: z.boolean().optional(),
    hint: z.string().max(600).optional(),
    hintEnabled: z.boolean().optional(),
    visual: z.union([
        z.union([
            z.object({
                kind: z.string(),
                caption: z.string().min(1).max(120),
                max: z.number(),
                rows: z.array(z.object({
                    label: z.string().min(1).max(60),
                    value: z.number(),
                    previous: z.number().optional(),
                    display: z.string().min(1).max(24)
                })).min(1).max(4)
            }),
            z.object({
                kind: z.string(),
                caption: z.string().min(1).max(120),
                figures: z.array(z.object({
                    label: z.string().min(1).max(60),
                    value: z.string().min(1).max(24),
                    tone: z.enum([
                        'default',
                        'up',
                        'down',
                        'accent',
                        'streak'
                    ]).optional()
                })).min(2).max(4)
            }),
            z.object({
                kind: z.string(),
                caption: z.string().min(1).max(120),
                shares: z.array(z.object({
                    label: z.string().min(1).max(60),
                    value: z.number().gte(0),
                    display: z.string().min(1).max(24).optional()
                })).min(2).max(6)
            }),
            z.object({
                kind: z.string(),
                caption: z.string().min(1).max(120),
                stages: z.array(z.object({
                    label: z.string().min(1).max(60),
                    value: z.number().gte(0),
                    display: z.string().min(1).max(24)
                })).min(2).max(5)
            }),
            z.object({
                kind: z.string(),
                caption: z.string().min(1).max(120),
                start: z.object({
                    label: z.string().min(1).max(60),
                    value: z.number(),
                    display: z.string().min(1).max(24)
                }),
                steps: z.array(z.object({
                    label: z.string().min(1).max(60),
                    value: z.number(),
                    display: z.string().min(1).max(24)
                })).min(1).max(5),
                end: z.object({
                    label: z.string().min(1).max(60),
                    value: z.number(),
                    display: z.string().min(1).max(24)
                })
            }),
            z.object({
                kind: z.string(),
                caption: z.string().min(1).max(120),
                max: z.number(),
                min: z.number().optional(),
                rows: z.array(z.object({
                    label: z.string().min(1).max(60),
                    before: z.number(),
                    after: z.number(),
                    beforeDisplay: z.string().min(1).max(24),
                    afterDisplay: z.string().min(1).max(24)
                })).min(1).max(4)
            }),
            z.object({
                kind: z.string(),
                caption: z.string().min(1).max(120),
                x: z.object({
                    label: z.string().min(1).max(60),
                    low: z.string().min(1).max(40),
                    high: z.string().min(1).max(40)
                }),
                y: z.object({
                    label: z.string().min(1).max(60),
                    low: z.string().min(1).max(40),
                    high: z.string().min(1).max(40)
                }),
                quadrants: z.tuple([
                    z.string().min(1).max(40),
                    z.string().min(1).max(40),
                    z.string().min(1).max(40),
                    z.string().min(1).max(40)
                ]).optional(),
                items: z.array(z.object({
                    label: z.string().min(1).max(60),
                    x: z.number().gte(0).lte(1),
                    y: z.number().gte(0).lte(1)
                })).min(1).max(4)
            }),
            z.object({
                kind: z.string(),
                caption: z.string().min(1).max(120),
                steps: z.array(z.object({
                    label: z.string().min(1).max(60),
                    note: z.string().min(1).max(80).optional()
                })).min(2).max(5)
            }),
            z.object({
                kind: z.string(),
                caption: z.string().min(1).max(120),
                at: z.array(z.string().min(1).max(16)).min(2).max(8),
                min: z.number(),
                max: z.number(),
                series: z.array(z.object({
                    label: z.string().min(1).max(60),
                    values: z.array(z.number()).min(2).max(8),
                    display: z.string().min(1).max(24)
                })).min(1).max(6)
            }),
            z.object({
                kind: z.string(),
                caption: z.string().min(1).max(120),
                columns: z.array(z.string().min(1).max(40)).min(2).max(3),
                rows: z.array(z.object({
                    label: z.string().min(1).max(60),
                    cells: z.array(z.string().min(1).max(40)).max(3)
                })).min(2).max(6)
            }),
            z.object({
                kind: z.string(),
                caption: z.string().min(1).max(120),
                left: z.object({
                    name: z.string().min(1).max(60),
                    you: z.boolean().optional(),
                    character: z.enum([
                        'betty',
                        'david',
                        'rosa',
                        'kofi',
                        'priya',
                        'sam',
                        'noor',
                        'tomi',
                        'biscuit',
                        'bolt'
                    ]).optional(),
                    pose: z.enum([
                        'sit',
                        'lean-in',
                        'arms-crossed',
                        'hand-on-chin',
                        'wave'
                    ]).optional(),
                    facing: z.enum(['left', 'right']).optional(),
                    slot: z.enum([
                        'left',
                        'center',
                        'right'
                    ]).optional(),
                    reaction: z.enum([
                        'happy',
                        'worried',
                        'thinking'
                    ]).optional()
                }),
                right: z.object({
                    name: z.string().min(1).max(60),
                    you: z.boolean().optional(),
                    character: z.enum([
                        'betty',
                        'david',
                        'rosa',
                        'kofi',
                        'priya',
                        'sam',
                        'noor',
                        'tomi',
                        'biscuit',
                        'bolt'
                    ]).optional(),
                    pose: z.enum([
                        'sit',
                        'lean-in',
                        'arms-crossed',
                        'hand-on-chin',
                        'wave'
                    ]).optional(),
                    facing: z.enum(['left', 'right']).optional(),
                    slot: z.enum([
                        'left',
                        'center',
                        'right'
                    ]).optional(),
                    reaction: z.enum([
                        'happy',
                        'worried',
                        'thinking'
                    ]).optional()
                }),
                lines: z.array(z.object({
                    by: z.enum(['left', 'right']),
                    text: z.string().min(1).max(80).optional(),
                    sound: z.enum([
                        'bark',
                        'whine',
                        'growl',
                        'pant',
                        'meow',
                        'purr',
                        'hiss'
                    ]).optional(),
                    mood: z.enum([
                        'happy',
                        'worried',
                        'thinking'
                    ]).optional(),
                    thought: z.boolean().optional()
                })).min(1).max(4),
                awaiting: z.enum(['left', 'right']).optional(),
                props: z.array(z.string().max(40).regex(/^[a-z0-9]+(-[a-z0-9]+)*$/)).min(1).max(3).optional()
            }),
            z.object({
                kind: z.string(),
                caption: z.string().min(1).max(120),
                cast: z.array(z.object({
                    name: z.string().min(1).max(60),
                    you: z.boolean().optional(),
                    character: z.enum([
                        'betty',
                        'david',
                        'rosa',
                        'kofi',
                        'priya',
                        'sam',
                        'noor',
                        'tomi',
                        'biscuit',
                        'bolt'
                    ]).optional(),
                    pose: z.enum([
                        'sit',
                        'lean-in',
                        'arms-crossed',
                        'hand-on-chin',
                        'wave'
                    ]).optional(),
                    facing: z.enum(['left', 'right']).optional(),
                    slot: z.enum([
                        'left',
                        'center',
                        'right'
                    ]).optional(),
                    reaction: z.enum([
                        'happy',
                        'worried',
                        'thinking'
                    ]).optional(),
                    thought: z.string().min(1).max(80).optional()
                })).min(1).max(3),
                stakes: z.array(z.object({
                    label: z.string().min(1).max(60),
                    value: z.string().min(1).max(24),
                    tone: z.enum([
                        'default',
                        'up',
                        'down',
                        'accent',
                        'streak'
                    ]).optional()
                })).min(1).max(4).optional(),
                props: z.array(z.string().max(40).regex(/^[a-z0-9]+(-[a-z0-9]+)*$/)).min(1).max(3).optional()
            }),
            z.object({
                kind: z.string(),
                caption: z.string().min(1).max(120),
                left: z.object({
                    label: z.string().min(1).max(60),
                    gains: z.array(z.string().min(1).max(40)).min(1).max(3),
                    costs: z.array(z.string().min(1).max(40)).min(1).max(3)
                }),
                right: z.object({
                    label: z.string().min(1).max(60),
                    gains: z.array(z.string().min(1).max(40)).min(1).max(3),
                    costs: z.array(z.string().min(1).max(40)).min(1).max(3)
                })
            }),
            z.object({
                kind: z.string(),
                caption: z.string().min(1).max(120),
                fork: z.string().min(1).max(80),
                branches: z.array(z.object({
                    label: z.string().min(1).max(60),
                    outcome: z.string().min(1).max(60),
                    tone: z.enum(['up', 'down']).optional()
                })).min(2).max(3)
            }),
            z.object({
                kind: z.string(),
                caption: z.string().min(1).max(120),
                moments: z.array(z.object({
                    at: z.string().min(1).max(16),
                    label: z.string().min(1).max(60)
                })).min(2).max(5),
                now: z.int().gte(0).lte(9007199254740991).optional()
            }),
            z.object({
                kind: z.string(),
                caption: z.string().min(1).max(120),
                start: z.object({
                    label: z.string().min(1).max(60),
                    value: z.number(),
                    display: z.string().min(1).max(24)
                }),
                steps: z.array(z.object({
                    label: z.string().min(1).max(60),
                    value: z.number(),
                    display: z.string().min(1).max(24),
                    op: z.enum([
                        'plus',
                        'minus',
                        'times',
                        'divide'
                    ])
                })).min(1).max(2),
                result: z.object({
                    label: z.string().min(1).max(60),
                    value: z.number(),
                    display: z.string().min(1).max(24)
                })
            }),
            z.object({
                kind: z.string(),
                caption: z.string().min(1).max(120),
                price: z.object({
                    low: z.number(),
                    high: z.number()
                }),
                demand: z.object({
                    atLow: z.number().gte(0),
                    atHigh: z.number().gte(0)
                }),
                readoutLabel: z.string().min(1).max(60),
                unit: z.string().max(8),
                from: z.string().min(1).max(40),
                to: z.string().min(1).max(40)
            })
        ]),
        z.unknown()
    ]).optional(),
    items: z.array(z.object({
        id: z.string().min(1),
        label: z.string().min(1).max(200)
    })).max(12).optional(),
    keys: z.array(z.object({
        id: z.string().min(1),
        isCorrect: z.boolean().optional(),
        correctPosition: z.int().gte(1).lte(12).optional(),
        correctAmount: z.number().gte(0).lte(1000000).optional(),
        amountTolerance: z.number().gte(0).lte(1000000).optional()
    })).max(12).optional(),
    min: z.number().optional(),
    max: z.number().optional(),
    step: z.number().optional(),
    unit: z.string().max(24).optional(),
    targetMin: z.number().optional(),
    targetMax: z.number().optional(),
    poolTotal: z.number().optional(),
    requireSubmit: z.boolean().optional(),
    sourceId: z.string().min(1).optional()
});
export const zSwitchMechanicDto = z.object({
    kind: z.enum([
        'HOOK',
        'CONCEPT',
        'CASE',
        'ARTICLE',
        'RECAP',
        'CHOICE',
        'RANK',
        'BUCKET',
        'SLIDER',
        'ALLOCATE',
        'SPEAK'
    ])
});
export const zLessonResearchDtoOutput = z.object({
    sources: z.array(z.object({
        type: z.enum([
            'ARTICLE',
            'RESEARCH',
            'LINK',
            'TEXT'
        ]),
        title: z.string().min(3).max(500),
        url: z.string().optional(),
        citation: z.string().optional(),
        id: z.string().min(1),
        note: z.string().optional()
    })),
    notes: z.string(),
    review: z.union([
        z.object({
            status: z.enum([
                'NEEDS_REVIEW',
                'APPROVED',
                'NEEDS_CHANGES'
            ]),
            reason: z.string().optional(),
            handSet: z.boolean(),
            reviewer: z.string().optional(),
            reviewedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).optional()
        }),
        z.unknown()
    ])
});
export const zAttachSourceDto = z.object({
    sourceId: z.string().min(1),
    note: z.string().min(1).max(400).optional()
});
export const zUpdateSourceNoteDto = z.object({
    note: z.union([
        z.string().min(1).max(400),
        z.unknown()
    ])
});
export const zUpdateNotesDto = z.object({
    notes: z.string().max(4000)
});
export const zSetReviewDto = z.object({
    status: z.union([
        z.enum([
            'NEEDS_REVIEW',
            'APPROVED',
            'NEEDS_CHANGES'
        ]),
        z.unknown()
    ]),
    reason: z.string().min(1).max(400).optional()
});
export const zSceneImagesDtoOutput = z.object({
    suggestedPrompt: z.string(),
    versions: z.array(z.object({
        id: z.string().min(1),
        prompt: z.string(),
        feedback: z.union([
            z.string(),
            z.unknown()
        ]),
        basedOnId: z.union([
            z.string().min(1),
            z.unknown()
        ]),
        light: z.string(),
        dark: z.string(),
        refusal: z.union([
            z.string(),
            z.unknown()
        ]),
        approved: z.boolean(),
        createdAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/)
    }))
});
export const zGenerateSceneImageDto = z.object({
    prompt: z.string().min(1).max(2000),
    feedback: z.string().min(1).max(500).optional(),
    basedOnId: z.string().min(1).optional()
});
export const zSceneImageVersionDtoOutput = z.object({
    id: z.string().min(1),
    prompt: z.string(),
    feedback: z.union([
        z.string(),
        z.unknown()
    ]),
    basedOnId: z.union([
        z.string().min(1),
        z.unknown()
    ]),
    light: z.string(),
    dark: z.string(),
    refusal: z.union([
        z.string(),
        z.unknown()
    ]),
    approved: z.boolean(),
    createdAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/)
});
export const zApprovedSceneImageDtoOutput = z.object({
    imageUrl: z.url()
});
export const zRedrawLessonPictureDto = z.object({
    position: z.int().gte(1).lte(9007199254740991).optional()
});
export const zChooseSceneImageDto = z.object({
    imageUrl: z.union([
        z.url(),
        z.unknown()
    ])
});
export const zChooseSceneImageDtoOutput = z.object({
    imageUrl: z.union([
        z.url(),
        z.unknown()
    ])
});
export const zDrawOnboardingArtDto = z.object({
    screen: z.string().min(1).max(300),
    prompt: z.string().min(1).max(2000),
    refine: z.object({
        drawing: z.string().min(1).max(32000),
        feedback: z.string().min(1).max(2000)
    }).optional()
});
export const zOnboardingArtCandidateDtoOutput = z.object({
    uri: z.union([
        z.string(),
        z.unknown()
    ]),
    drawing: z.union([
        z.string(),
        z.unknown()
    ]),
    refusal: z.union([
        z.string(),
        z.unknown()
    ]),
    warning: z.union([
        z.string(),
        z.unknown()
    ])
});
export const zCastListDtoOutput = z.object({
    cast: z.array(z.object({
        id: z.enum([
            'betty',
            'david',
            'rosa',
            'kofi',
            'priya',
            'sam',
            'noor',
            'tomi',
            'biscuit',
            'bolt'
        ]),
        name: z.string(),
        kind: z.enum([
            'adult',
            'child',
            'animal'
        ]),
        age: z.union([
            z.int().gte(-9007199254740991).lte(9007199254740991),
            z.unknown()
        ]),
        personality: z.string(),
        readiness: z.enum([
            'ready',
            'limited',
            'pending'
        ]),
        moods: z.array(z.enum([
            'happy',
            'worried',
            'thinking'
        ])),
        poses: z.array(z.enum([
            'sit',
            'lean-in',
            'arms-crossed',
            'hand-on-chin',
            'wave'
        ])),
        facings: z.array(z.enum(['left', 'right'])),
        reactions: z.array(z.enum([
            'happy',
            'worried',
            'thinking'
        ])),
        portrait: z.union([
            z.string(),
            z.unknown()
        ])
    })),
    props: z.array(z.object({
        slug: z.string().max(40).regex(/^[a-z0-9]+(-[a-z0-9]+)*$/),
        label: z.string().min(1).max(40),
        readiness: z.enum([
            'ready',
            'limited',
            'pending'
        ])
    }))
});
export const zCreateScenePropDto = z.object({
    slug: z.string().max(40).regex(/^[a-z0-9]+(-[a-z0-9]+)*$/),
    label: z.string().min(1).max(40)
});
export const zScenePropDtoOutput = z.object({
    slug: z.string().max(40).regex(/^[a-z0-9]+(-[a-z0-9]+)*$/),
    label: z.string().min(1).max(40),
    readiness: z.enum([
        'ready',
        'limited',
        'pending'
    ])
});
export const zCurriculumImportDto = z.object({
    csv: z.string().min(1).max(4000000)
});
export const zImportPreviewDtoOutput = z.object({
    rowCount: z.int().gte(0).lte(9007199254740991),
    columns: z.array(z.object({
        header: z.string(),
        field: z.union([
            z.enum([
                'lessonId',
                'course',
                'module',
                'name',
                'description',
                'writerBrief',
                'primarySourceName',
                'primarySourceUrl',
                'additionalSourceName',
                'additionalSourceUrl'
            ]),
            z.unknown()
        ])
    })),
    courses: z.array(z.object({
        name: z.string(),
        isNew: z.boolean(),
        modules: z.array(z.object({
            name: z.string(),
            lessons: z.int().gte(0).lte(9007199254740991),
            isNew: z.boolean()
        }))
    })),
    issues: z.array(z.object({
        line: z.union([
            z.int().gte(1).lte(9007199254740991),
            z.unknown()
        ]),
        message: z.string()
    })),
    additions: z.array(z.string()),
    changes: z.array(z.object({
        lessonId: z.string(),
        field: z.union([
            z.enum([
                'lessonId',
                'course',
                'module',
                'name',
                'description',
                'writerBrief',
                'primarySourceName',
                'primarySourceUrl',
                'additionalSourceName',
                'additionalSourceUrl'
            ]),
            z.unknown()
        ]),
        column: z.string(),
        before: z.string(),
        after: z.string(),
        kept: z.boolean()
    })),
    missing: z.array(z.string())
});
export const zImportResultDtoOutput = z.object({
    added: z.int().gte(0).lte(9007199254740991),
    changed: z.int().gte(0).lte(9007199254740991),
    kept: z.int().gte(0).lte(9007199254740991),
    coursesAdded: z.int().gte(0).lte(9007199254740991),
    modulesAdded: z.int().gte(0).lte(9007199254740991),
    total: z.int().gte(0).lte(9007199254740991),
    skipped: z.array(z.object({
        line: z.union([
            z.int().gte(1).lte(9007199254740991),
            z.unknown()
        ]),
        message: z.string()
    }))
});
export const zPlannedLessonListDtoOutput = z.object({
    lessons: z.array(z.object({
        id: z.string(),
        lessonId: z.string(),
        position: z.int().gte(1).lte(9007199254740991),
        courseId: z.string(),
        course: z.string(),
        courseCollectionId: z.union([
            z.string(),
            z.unknown()
        ]),
        moduleId: z.string(),
        module: z.string(),
        moduleCollectionId: z.union([
            z.string(),
            z.unknown()
        ]),
        name: z.string(),
        description: z.string(),
        writerBrief: z.string(),
        storyBeat: z.string(),
        moduleStoryRevision: z.int().gte(0).lte(9007199254740991),
        builtStoryRevision: z.union([
            z.int().gte(0).lte(9007199254740991),
            z.unknown()
        ]),
        storyChanged: z.boolean(),
        primarySourceName: z.string(),
        primarySourceUrl: z.string(),
        additionalSourceName: z.string(),
        additionalSourceUrl: z.string(),
        extra: z.array(z.object({
            column: z.string().min(1),
            value: z.string()
        })),
        status: z.enum([
            'NOT_BUILT',
            'QUEUED',
            'BUILDING',
            'BUILT_DRAFT',
            'IN_REVIEW',
            'PUBLISHED',
            'BUILD_FAILED'
        ]),
        builtLessonId: z.union([
            z.string(),
            z.unknown()
        ]),
        buildJobId: z.union([
            z.string(),
            z.unknown()
        ]),
        buildStep: z.union([
            z.enum([
                'CHECKING_STORY',
                'BUILDING_SCENES',
                'CHECKING_CONTINUITY',
                'DRAFT_READY'
            ]),
            z.unknown()
        ]),
        rebuilding: z.boolean(),
        buildError: z.union([
            z.string(),
            z.unknown()
        ]),
        published: z.boolean(),
        publishedAt: z.union([
            z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
            z.unknown()
        ]),
        appPlacements: z.array(z.object({
            moduleCollectionId: z.string(),
            module: z.string(),
            courseCollectionId: z.union([
                z.string(),
                z.unknown()
            ]),
            course: z.union([
                z.string(),
                z.unknown()
            ]),
            plannedModuleId: z.union([
                z.string(),
                z.unknown()
            ])
        })),
        placementMismatch: z.boolean(),
        createdAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
        updatedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/)
    })),
    total: z.int().gte(0).lte(9007199254740991)
});
export const zPlannedLessonDetailsDtoOutput = z.object({
    lesson: z.object({
        id: z.string(),
        lessonId: z.string(),
        position: z.int().gte(1).lte(9007199254740991),
        courseId: z.string(),
        course: z.string(),
        courseCollectionId: z.union([
            z.string(),
            z.unknown()
        ]),
        moduleId: z.string(),
        module: z.string(),
        moduleCollectionId: z.union([
            z.string(),
            z.unknown()
        ]),
        name: z.string(),
        description: z.string(),
        writerBrief: z.string(),
        storyBeat: z.string(),
        moduleStoryRevision: z.int().gte(0).lte(9007199254740991),
        builtStoryRevision: z.union([
            z.int().gte(0).lte(9007199254740991),
            z.unknown()
        ]),
        storyChanged: z.boolean(),
        primarySourceName: z.string(),
        primarySourceUrl: z.string(),
        additionalSourceName: z.string(),
        additionalSourceUrl: z.string(),
        extra: z.array(z.object({
            column: z.string().min(1),
            value: z.string()
        })),
        status: z.enum([
            'NOT_BUILT',
            'QUEUED',
            'BUILDING',
            'BUILT_DRAFT',
            'IN_REVIEW',
            'PUBLISHED',
            'BUILD_FAILED'
        ]),
        builtLessonId: z.union([
            z.string(),
            z.unknown()
        ]),
        buildJobId: z.union([
            z.string(),
            z.unknown()
        ]),
        buildStep: z.union([
            z.enum([
                'CHECKING_STORY',
                'BUILDING_SCENES',
                'CHECKING_CONTINUITY',
                'DRAFT_READY'
            ]),
            z.unknown()
        ]),
        rebuilding: z.boolean(),
        buildError: z.union([
            z.string(),
            z.unknown()
        ]),
        published: z.boolean(),
        publishedAt: z.union([
            z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
            z.unknown()
        ]),
        appPlacements: z.array(z.object({
            moduleCollectionId: z.string(),
            module: z.string(),
            courseCollectionId: z.union([
                z.string(),
                z.unknown()
            ]),
            course: z.union([
                z.string(),
                z.unknown()
            ]),
            plannedModuleId: z.union([
                z.string(),
                z.unknown()
            ])
        })),
        placementMismatch: z.boolean(),
        createdAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
        updatedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/)
    }),
    build: z.object({
        builtAt: z.union([
            z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
            z.unknown()
        ]),
        planningRevisionId: z.union([
            z.string(),
            z.unknown()
        ]),
        planningChangedSince: z.union([
            z.boolean(),
            z.unknown()
        ]),
        latestFailure: z.union([
            z.object({
                at: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
                message: z.string(),
                jobId: z.string()
            }),
            z.unknown()
        ])
    }),
    approval: z.union([
        z.object({
            status: z.union([
                z.enum([
                    'NEEDS_REVIEW',
                    'APPROVED',
                    'NEEDS_CHANGES'
                ]),
                z.unknown()
            ]),
            reason: z.union([
                z.string(),
                z.unknown()
            ]),
            by: z.union([
                z.string(),
                z.unknown()
            ]),
            at: z.union([
                z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
                z.unknown()
            ])
        }),
        z.unknown()
    ]),
    publications: z.array(z.object({
        kind: z.enum(['PUBLISHED', 'UNPUBLISHED']),
        version: z.int().gte(1).lte(9007199254740991),
        at: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/)
    })),
    links: z.union([
        z.object({
            builtLessonId: z.string(),
            version: z.int().gte(1).lte(9007199254740991),
            editorPath: z.string()
        }),
        z.unknown()
    ]),
    history: z.array(z.object({
        at: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
        kind: z.enum([
            'CREATED',
            'EDITED',
            'REVERTED',
            'BUILD_QUEUED',
            'BUILT',
            'BUILD_FAILED',
            'PUBLISHED',
            'UNPUBLISHED',
            'SYNCED'
        ]),
        what: z.string(),
        who: z.union([
            z.string(),
            z.unknown()
        ]),
        revisionId: z.union([
            z.string(),
            z.unknown()
        ])
    })).max(10),
    learners: z.union([
        z.object({
            period: z.enum([
                'all',
                '7d',
                '30d'
            ]),
            from: z.union([
                z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
                z.unknown()
            ]),
            to: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
            started: z.int().gte(0).lte(9007199254740991),
            completed: z.int().gte(0).lte(9007199254740991)
        }),
        z.unknown()
    ])
});
export const zCreatedInAppDtoOutput = z.object({
    courses: z.array(z.object({
        id: z.string(),
        collectionId: z.string(),
        created: z.boolean()
    })),
    modules: z.array(z.object({
        id: z.string(),
        collectionId: z.string(),
        created: z.boolean()
    }))
});
export const zCreateInAppRequestDto = z.object({
    courseIds: z.array(z.string().min(1)).max(500).optional().default([]),
    moduleIds: z.array(z.string().min(1)).max(500).optional().default([])
});
export const zBuildPreflightRequestDto = z.object({
    lessonIds: z.array(z.string().min(1).max(64)).min(1).max(5000)
});
export const zBuildPreflightDtoOutput = z.object({
    count: z.int().gte(0).lte(9007199254740991),
    limit: z.number(),
    coursesToCreate: z.array(z.object({
        id: z.string(),
        name: z.string()
    })),
    modulesToCreate: z.array(z.object({
        id: z.string(),
        name: z.string(),
        course: z.string()
    })),
    modulesInApp: z.array(z.object({
        id: z.string(),
        name: z.string(),
        course: z.string()
    })),
    unavailable: z.array(z.object({
        lessonId: z.string(),
        status: z.enum([
            'NOT_BUILT',
            'QUEUED',
            'BUILDING',
            'BUILT_DRAFT',
            'IN_REVIEW',
            'PUBLISHED',
            'BUILD_FAILED'
        ])
    })),
    blocked: z.array(z.object({
        lessonId: z.string(),
        issues: z.array(z.string())
    })),
    warnings: z.array(z.object({
        lessonId: z.string(),
        message: z.string()
    })),
    unknown: z.array(z.string()),
    storyMissing: z.array(z.object({
        id: z.string(),
        name: z.string(),
        course: z.string()
    })),
    castMissing: z.array(z.object({
        id: z.string(),
        name: z.string(),
        course: z.string()
    })),
    estimate: z.object({
        minutes: z.int().gte(0).lte(9007199254740991),
        label: z.string()
    }),
    ready: z.boolean()
});
export const zBuildRequestDto = z.object({
    lessonIds: z.array(z.string().min(1).max(64)).min(1).max(50),
    verify: z.boolean().optional().default(false),
    research: z.boolean().optional().default(false)
});
export const zBuildDtoOutput = z.object({
    jobId: z.string(),
    created: z.boolean(),
    lessons: z.int().gte(1).lte(9007199254740991)
});
export const zCurriculumVerifyRequestDto = z.object({
    lessonIds: z.array(z.string().min(1).max(64)).min(1).max(50)
});
export const zCurriculumVerifyDtoOutput = z.object({
    jobId: z.string(),
    lessons: z.int().gte(1).lte(9007199254740991),
    notBuilt: z.array(z.string())
});
export const zLessonBuildStateDtoOutput = z.object({
    lessonId: z.string(),
    status: z.enum([
        'NOT_BUILT',
        'QUEUED',
        'BUILDING',
        'BUILT_DRAFT',
        'IN_REVIEW',
        'PUBLISHED',
        'BUILD_FAILED'
    ])
});
export const zRebuildRequestDto = z.object({
    research: z.boolean().optional().default(false)
});
export const zStoryReviewDto = z.object({
    storyRevision: z.int().gte(0).lte(9007199254740991)
});
export const zPlannedLessonDtoOutput = z.object({
    id: z.string(),
    lessonId: z.string(),
    position: z.int().gte(1).lte(9007199254740991),
    courseId: z.string(),
    course: z.string(),
    courseCollectionId: z.union([
        z.string(),
        z.unknown()
    ]),
    moduleId: z.string(),
    module: z.string(),
    moduleCollectionId: z.union([
        z.string(),
        z.unknown()
    ]),
    name: z.string(),
    description: z.string(),
    writerBrief: z.string(),
    storyBeat: z.string(),
    moduleStoryRevision: z.int().gte(0).lte(9007199254740991),
    builtStoryRevision: z.union([
        z.int().gte(0).lte(9007199254740991),
        z.unknown()
    ]),
    storyChanged: z.boolean(),
    primarySourceName: z.string(),
    primarySourceUrl: z.string(),
    additionalSourceName: z.string(),
    additionalSourceUrl: z.string(),
    extra: z.array(z.object({
        column: z.string().min(1),
        value: z.string()
    })),
    status: z.enum([
        'NOT_BUILT',
        'QUEUED',
        'BUILDING',
        'BUILT_DRAFT',
        'IN_REVIEW',
        'PUBLISHED',
        'BUILD_FAILED'
    ]),
    builtLessonId: z.union([
        z.string(),
        z.unknown()
    ]),
    buildJobId: z.union([
        z.string(),
        z.unknown()
    ]),
    buildStep: z.union([
        z.enum([
            'CHECKING_STORY',
            'BUILDING_SCENES',
            'CHECKING_CONTINUITY',
            'DRAFT_READY'
        ]),
        z.unknown()
    ]),
    rebuilding: z.boolean(),
    buildError: z.union([
        z.string(),
        z.unknown()
    ]),
    published: z.boolean(),
    publishedAt: z.union([
        z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
        z.unknown()
    ]),
    appPlacements: z.array(z.object({
        moduleCollectionId: z.string(),
        module: z.string(),
        courseCollectionId: z.union([
            z.string(),
            z.unknown()
        ]),
        course: z.union([
            z.string(),
            z.unknown()
        ]),
        plannedModuleId: z.union([
            z.string(),
            z.unknown()
        ])
    })),
    placementMismatch: z.boolean(),
    createdAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
    updatedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/)
});
export const zLessonVersionsDtoOutput = z.object({
    lessonId: z.string(),
    builtLessonId: z.string(),
    versions: z.array(z.object({
        id: z.string(),
        reason: z.enum([
            'REBUILD',
            'RESTORE',
            'FIX',
            'PUBLISH',
            'REVIEW'
        ]),
        jobId: z.string().optional(),
        title: z.string(),
        scenes: z.int().gte(0).lte(9007199254740991),
        createdAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/)
    }))
});
export const zPlacementDtoOutput = z.object({
    lessonId: z.string(),
    builtLessonId: z.union([
        z.string(),
        z.unknown()
    ]),
    planned: z.object({
        moduleId: z.string(),
        module: z.string(),
        course: z.string(),
        moduleCollectionId: z.union([
            z.string(),
            z.unknown()
        ])
    }),
    app: z.array(z.object({
        moduleCollectionId: z.string(),
        module: z.string(),
        courseCollectionId: z.union([
            z.string(),
            z.unknown()
        ]),
        course: z.union([
            z.string(),
            z.unknown()
        ]),
        plannedModuleId: z.union([
            z.string(),
            z.unknown()
        ])
    })),
    mismatch: z.boolean(),
    live: z.boolean(),
    updatePlan: z.object({
        available: z.boolean(),
        from: z.union([
            z.string(),
            z.unknown()
        ]),
        to: z.union([
            z.string(),
            z.unknown()
        ]),
        message: z.string()
    }),
    moveAppLesson: z.object({
        available: z.boolean(),
        from: z.union([
            z.string(),
            z.unknown()
        ]),
        to: z.union([
            z.string(),
            z.unknown()
        ]),
        message: z.string()
    })
});
export const zPlannedCourseListDtoOutput = z.object({
    courses: z.array(z.object({
        id: z.string(),
        name: z.string(),
        position: z.int().gte(1).lte(9007199254740991),
        collectionId: z.union([
            z.string(),
            z.unknown()
        ]),
        differsFromApp: z.array(z.enum(['name', 'course'])),
        modules: z.array(z.object({
            id: z.string(),
            courseId: z.string(),
            name: z.string(),
            position: z.int().gte(1).lte(9007199254740991),
            lessons: z.int().gte(0).lte(9007199254740991),
            collectionId: z.union([
                z.string(),
                z.unknown()
            ]),
            differsFromApp: z.array(z.enum(['name', 'course']))
        }))
    }))
});
export const zCreatePlannedCourseDto = z.object({
    name: z.string().min(1).max(200)
});
export const zPlannedCourseDtoOutput = z.object({
    id: z.string(),
    name: z.string(),
    position: z.int().gte(1).lte(9007199254740991),
    collectionId: z.union([
        z.string(),
        z.unknown()
    ]),
    differsFromApp: z.array(z.enum(['name', 'course'])),
    modules: z.array(z.object({
        id: z.string(),
        courseId: z.string(),
        name: z.string(),
        position: z.int().gte(1).lte(9007199254740991),
        lessons: z.int().gte(0).lte(9007199254740991),
        collectionId: z.union([
            z.string(),
            z.unknown()
        ]),
        differsFromApp: z.array(z.enum(['name', 'course']))
    }))
});
export const zUpdatePlannedCourseDto = z.object({
    name: z.string().min(1).max(200).optional(),
    position: z.int().gte(1).lte(9007199254740991).optional()
});
export const zDeletionPreviewDtoOutput = z.object({
    courses: z.int().gte(0).lte(9007199254740991),
    modules: z.int().gte(0).lte(9007199254740991),
    lessons: z.int().gte(0).lte(9007199254740991),
    lessonIds: z.array(z.string()),
    linkedCollections: z.array(z.object({
        id: z.string(),
        title: z.string(),
        status: z.string()
    })),
    linkedLessons: z.array(z.object({
        id: z.string(),
        title: z.string(),
        status: z.string()
    })),
    cancelledBuilds: z.array(z.string()),
    leftEmpty: z.array(z.string()),
    affects: z.string(),
    blocked: z.boolean(),
    message: z.union([
        z.string(),
        z.unknown()
    ])
});
export const zCreatePlannedModuleDto = z.object({
    courseId: z.string().min(1),
    name: z.string().min(1).max(200),
    story: z.string().max(50000)
});
export const zPlannedModuleDtoOutput = z.object({
    id: z.string(),
    courseId: z.string(),
    name: z.string(),
    position: z.int().gte(1).lte(9007199254740991),
    lessons: z.int().gte(0).lte(9007199254740991),
    collectionId: z.union([
        z.string(),
        z.unknown()
    ]),
    differsFromApp: z.array(z.enum(['name', 'course']))
});
export const zUpdatePlannedModuleDto = z.object({
    name: z.string().min(1).max(200).optional(),
    courseId: z.string().min(1).optional(),
    position: z.int().gte(1).lte(9007199254740991).optional(),
    story: z.string().max(50000).optional(),
    figures: z.array(z.string().min(1).max(200)).max(12).optional(),
    writerNotes: z.string().max(2000).optional(),
    cast: z.array(z.object({
        id: z.string().min(1).max(64),
        character: z.enum([
            'betty',
            'david',
            'rosa',
            'kofi',
            'priya',
            'sam',
            'noor',
            'tomi',
            'biscuit',
            'bolt'
        ]).optional(),
        name: z.string().min(1).max(60).optional(),
        part: z.enum(['lead', 'supporting']),
        role: z.string().min(1).max(60),
        goal: z.string().max(500).optional().default(''),
        constraint: z.string().max(500).optional().default(''),
        relationship: z.string().max(500).optional().default(''),
        continuity: z.array(z.string().min(1).max(200)).max(10).optional().default([])
    })).max(3).optional(),
    lessonCasts: z.array(z.object({
        lessonId: z.string().min(1).max(64),
        cast: z.array(z.string().min(1).max(64)).max(3)
    })).max(500).optional(),
    storyRevision: z.int().gte(0).lte(9007199254740991).optional()
});
export const zPlannedModuleStoryDtoOutput = z.object({
    id: z.string(),
    name: z.string(),
    story: z.string(),
    figures: z.array(z.string().min(1).max(200)).max(12),
    writerNotes: z.string().max(2000),
    storyRevision: z.int().gte(0).lte(9007199254740991),
    cast: z.array(z.object({
        id: z.string().min(1).max(64),
        character: z.enum([
            'betty',
            'david',
            'rosa',
            'kofi',
            'priya',
            'sam',
            'noor',
            'tomi',
            'biscuit',
            'bolt'
        ]).optional(),
        name: z.string().min(1).max(60).optional(),
        part: z.enum(['lead', 'supporting']),
        role: z.string().min(1).max(60),
        goal: z.string().max(500).default(''),
        constraint: z.string().max(500).default(''),
        relationship: z.string().max(500).default(''),
        continuity: z.array(z.string().min(1).max(200)).max(10).default([])
    })),
    castProblem: z.union([
        z.string(),
        z.unknown()
    ]),
    lessons: z.array(z.object({
        lessonId: z.string().min(1).max(64),
        cast: z.array(z.string().min(1).max(64)).max(3),
        built: z.array(z.object({
            character: z.enum([
                'betty',
                'david',
                'rosa',
                'kofi',
                'priya',
                'sam',
                'noor',
                'tomi',
                'biscuit',
                'bolt'
            ]),
            role: z.string().min(1).max(60)
        })).max(3)
    }))
});
export const zNextLessonIdDtoOutput = z.object({
    lessonId: z.string()
});
export const zCreatePlannedLessonDto = z.object({
    moduleId: z.string().min(1),
    lessonId: z.string().min(1).max(64).optional(),
    name: z.string().min(1).max(200),
    description: z.string().max(20000).optional().default(''),
    writerBrief: z.string().max(50000).optional().default(''),
    primarySourceName: z.string().max(500).optional().default(''),
    primarySourceUrl: z.string().max(2000).optional().default(''),
    additionalSourceName: z.string().max(500).optional().default(''),
    additionalSourceUrl: z.string().max(2000).optional().default('')
});
export const zUpdatePlannedLessonDto = z.object({
    name: z.string().min(1).max(200).optional(),
    description: z.string().max(20000).optional(),
    writerBrief: z.string().max(50000).optional(),
    primarySourceName: z.string().max(500).optional(),
    primarySourceUrl: z.string().max(2000).optional(),
    additionalSourceName: z.string().max(500).optional(),
    additionalSourceUrl: z.string().max(2000).optional(),
    storyBeat: z.string().max(10000).optional(),
    storyRevision: z.int().gte(0).lte(9007199254740991).optional(),
    extra: z.array(z.object({
        column: z.string().min(1),
        value: z.string()
    })).optional(),
    moduleId: z.string().min(1).optional(),
    position: z.int().gte(1).lte(9007199254740991).optional()
});
export const zApplyPlanningProposalsDto = z.object({
    proposals: z.array(z.object({
        lessonId: z.string().min(1).max(64),
        before: z.object({
            name: z.string().min(1).max(200).optional(),
            description: z.string().max(20000).optional(),
            writerBrief: z.string().max(50000).optional(),
            primarySourceName: z.string().max(500).optional(),
            primarySourceUrl: z.string().max(2000).optional(),
            additionalSourceName: z.string().max(500).optional(),
            additionalSourceUrl: z.string().max(2000).optional()
        }),
        after: z.object({
            name: z.string().min(1).max(200).optional(),
            description: z.string().max(20000).optional(),
            writerBrief: z.string().max(50000).optional(),
            primarySourceName: z.string().max(500).optional(),
            primarySourceUrl: z.string().max(2000).optional(),
            additionalSourceName: z.string().max(500).optional(),
            additionalSourceUrl: z.string().max(2000).optional()
        }),
        built: z.boolean()
    })).min(1).max(1000)
});
export const zAppliedProposalsDtoOutput = z.object({
    applied: z.array(z.object({
        id: z.string(),
        lessonId: z.string(),
        position: z.int().gte(1).lte(9007199254740991),
        courseId: z.string(),
        course: z.string(),
        courseCollectionId: z.union([
            z.string(),
            z.unknown()
        ]),
        moduleId: z.string(),
        module: z.string(),
        moduleCollectionId: z.union([
            z.string(),
            z.unknown()
        ]),
        name: z.string(),
        description: z.string(),
        writerBrief: z.string(),
        storyBeat: z.string(),
        moduleStoryRevision: z.int().gte(0).lte(9007199254740991),
        builtStoryRevision: z.union([
            z.int().gte(0).lte(9007199254740991),
            z.unknown()
        ]),
        storyChanged: z.boolean(),
        primarySourceName: z.string(),
        primarySourceUrl: z.string(),
        additionalSourceName: z.string(),
        additionalSourceUrl: z.string(),
        extra: z.array(z.object({
            column: z.string().min(1),
            value: z.string()
        })),
        status: z.enum([
            'NOT_BUILT',
            'QUEUED',
            'BUILDING',
            'BUILT_DRAFT',
            'IN_REVIEW',
            'PUBLISHED',
            'BUILD_FAILED'
        ]),
        builtLessonId: z.union([
            z.string(),
            z.unknown()
        ]),
        buildJobId: z.union([
            z.string(),
            z.unknown()
        ]),
        buildStep: z.union([
            z.enum([
                'CHECKING_STORY',
                'BUILDING_SCENES',
                'CHECKING_CONTINUITY',
                'DRAFT_READY'
            ]),
            z.unknown()
        ]),
        rebuilding: z.boolean(),
        buildError: z.union([
            z.string(),
            z.unknown()
        ]),
        published: z.boolean(),
        publishedAt: z.union([
            z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
            z.unknown()
        ]),
        appPlacements: z.array(z.object({
            moduleCollectionId: z.string(),
            module: z.string(),
            courseCollectionId: z.union([
                z.string(),
                z.unknown()
            ]),
            course: z.union([
                z.string(),
                z.unknown()
            ]),
            plannedModuleId: z.union([
                z.string(),
                z.unknown()
            ])
        })),
        placementMismatch: z.boolean(),
        createdAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
        updatedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/)
    })),
    refused: z.array(z.object({
        lessonId: z.string().min(1).max(64),
        reason: z.enum(['missing', 'stale']),
        message: z.string()
    }))
});
export const zApplyStoryProposalDto = z.object({
    moduleId: z.string(),
    module: z.string(),
    storyRevision: z.int().gte(0).lte(9007199254740991),
    before: z.string(),
    after: z.string().max(50000),
    figures: z.object({
        before: z.array(z.string().min(1).max(200)).max(12),
        after: z.array(z.string().min(1).max(200)).max(12)
    }),
    beats: z.array(z.object({
        lessonId: z.string().min(1).max(64),
        name: z.string(),
        before: z.string(),
        after: z.string().min(1).max(10000)
    })).min(1),
    compared: z.object({
        inCourse: z.int().gte(0).lte(9007199254740991),
        elsewhere: z.int().gte(0).lte(9007199254740991)
    })
});
export const zPlanningRevisionListDtoOutput = z.object({
    revisions: z.array(z.object({
        id: z.string(),
        entity: z.enum([
            'COURSE',
            'MODULE',
            'LESSON'
        ]),
        entityId: z.string(),
        lessonId: z.union([
            z.string(),
            z.unknown()
        ]),
        action: z.enum([
            'CREATE',
            'UPDATE',
            'DELETE',
            'REVERT'
        ]),
        before: z.union([
            z.object({
                name: z.string(),
                parentId: z.union([
                    z.string(),
                    z.unknown()
                ]),
                position: z.int().gte(1).lte(9007199254740991),
                lessonId: z.union([
                    z.string(),
                    z.unknown()
                ]),
                description: z.union([
                    z.string(),
                    z.unknown()
                ]),
                writerBrief: z.union([
                    z.string(),
                    z.unknown()
                ]),
                primarySourceName: z.union([
                    z.string(),
                    z.unknown()
                ]),
                primarySourceUrl: z.union([
                    z.string(),
                    z.unknown()
                ]),
                additionalSourceName: z.union([
                    z.string(),
                    z.unknown()
                ]),
                additionalSourceUrl: z.union([
                    z.string(),
                    z.unknown()
                ]),
                extra: z.union([
                    z.array(z.object({
                        column: z.string().min(1),
                        value: z.string()
                    })),
                    z.unknown()
                ]),
                editedFields: z.union([
                    z.array(z.string()),
                    z.unknown()
                ])
            }),
            z.unknown()
        ]),
        after: z.union([
            z.object({
                name: z.string(),
                parentId: z.union([
                    z.string(),
                    z.unknown()
                ]),
                position: z.int().gte(1).lte(9007199254740991),
                lessonId: z.union([
                    z.string(),
                    z.unknown()
                ]),
                description: z.union([
                    z.string(),
                    z.unknown()
                ]),
                writerBrief: z.union([
                    z.string(),
                    z.unknown()
                ]),
                primarySourceName: z.union([
                    z.string(),
                    z.unknown()
                ]),
                primarySourceUrl: z.union([
                    z.string(),
                    z.unknown()
                ]),
                additionalSourceName: z.union([
                    z.string(),
                    z.unknown()
                ]),
                additionalSourceUrl: z.union([
                    z.string(),
                    z.unknown()
                ]),
                extra: z.union([
                    z.array(z.object({
                        column: z.string().min(1),
                        value: z.string()
                    })),
                    z.unknown()
                ]),
                editedFields: z.union([
                    z.array(z.string()),
                    z.unknown()
                ])
            }),
            z.unknown()
        ]),
        batchId: z.union([
            z.string(),
            z.unknown()
        ]),
        revertOfId: z.union([
            z.string(),
            z.unknown()
        ]),
        actorId: z.string(),
        createdAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/)
    })),
    total: z.int().gte(0).lte(9007199254740991)
});
export const zRevertResultDtoOutput = z.object({
    revisions: z.array(z.object({
        id: z.string(),
        entity: z.enum([
            'COURSE',
            'MODULE',
            'LESSON'
        ]),
        entityId: z.string(),
        lessonId: z.union([
            z.string(),
            z.unknown()
        ]),
        action: z.enum([
            'CREATE',
            'UPDATE',
            'DELETE',
            'REVERT'
        ]),
        before: z.union([
            z.object({
                name: z.string(),
                parentId: z.union([
                    z.string(),
                    z.unknown()
                ]),
                position: z.int().gte(1).lte(9007199254740991),
                lessonId: z.union([
                    z.string(),
                    z.unknown()
                ]),
                description: z.union([
                    z.string(),
                    z.unknown()
                ]),
                writerBrief: z.union([
                    z.string(),
                    z.unknown()
                ]),
                primarySourceName: z.union([
                    z.string(),
                    z.unknown()
                ]),
                primarySourceUrl: z.union([
                    z.string(),
                    z.unknown()
                ]),
                additionalSourceName: z.union([
                    z.string(),
                    z.unknown()
                ]),
                additionalSourceUrl: z.union([
                    z.string(),
                    z.unknown()
                ]),
                extra: z.union([
                    z.array(z.object({
                        column: z.string().min(1),
                        value: z.string()
                    })),
                    z.unknown()
                ]),
                editedFields: z.union([
                    z.array(z.string()),
                    z.unknown()
                ])
            }),
            z.unknown()
        ]),
        after: z.union([
            z.object({
                name: z.string(),
                parentId: z.union([
                    z.string(),
                    z.unknown()
                ]),
                position: z.int().gte(1).lte(9007199254740991),
                lessonId: z.union([
                    z.string(),
                    z.unknown()
                ]),
                description: z.union([
                    z.string(),
                    z.unknown()
                ]),
                writerBrief: z.union([
                    z.string(),
                    z.unknown()
                ]),
                primarySourceName: z.union([
                    z.string(),
                    z.unknown()
                ]),
                primarySourceUrl: z.union([
                    z.string(),
                    z.unknown()
                ]),
                additionalSourceName: z.union([
                    z.string(),
                    z.unknown()
                ]),
                additionalSourceUrl: z.union([
                    z.string(),
                    z.unknown()
                ]),
                extra: z.union([
                    z.array(z.object({
                        column: z.string().min(1),
                        value: z.string()
                    })),
                    z.unknown()
                ]),
                editedFields: z.union([
                    z.array(z.string()),
                    z.unknown()
                ])
            }),
            z.unknown()
        ]),
        batchId: z.union([
            z.string(),
            z.unknown()
        ]),
        revertOfId: z.union([
            z.string(),
            z.unknown()
        ]),
        actorId: z.string(),
        createdAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/)
    })),
    notes: z.array(z.string())
});
export const zModuleRenameListDtoOutput = z.object({
    renames: z.array(z.object({
        id: z.string(),
        proposedName: z.string(),
        reason: z.string(),
        linked: z.union([
            z.object({
                id: z.string(),
                title: z.string(),
                status: z.enum([
                    'DRAFT',
                    'PUBLISHED',
                    'ARCHIVED'
                ])
            }),
            z.unknown()
        ]),
        renameLinked: z.boolean(),
        touches: z.enum(['planning', 'both']),
        skipped: z.boolean(),
        applied: z.boolean(),
        course: z.string(),
        module: z.string(),
        moduleId: z.union([
            z.string(),
            z.unknown()
        ]),
        currentName: z.union([
            z.string(),
            z.unknown()
        ]),
        lessons: z.array(z.string()),
        matches: z.array(z.object({
            moduleId: z.union([
                z.string(),
                z.unknown()
            ]),
            course: z.string(),
            currentName: z.union([
                z.string(),
                z.unknown()
            ])
        }))
    })),
    pending: z.int().gte(0).lte(9007199254740991)
});
export const zUpdateRenameDto = z.object({
    proposedName: z.string().min(1).max(200).optional(),
    renameLinked: z.boolean().optional(),
    skipped: z.boolean().optional()
});
export const zApplyRenamesResultDtoOutput = z.object({
    renamed: z.int().gte(0).lte(9007199254740991),
    batchId: z.union([
        z.string(),
        z.unknown()
    ])
});
export const zLessonRenameListDtoOutput = z.object({
    renames: z.array(z.object({
        id: z.string(),
        proposedName: z.string(),
        reason: z.string(),
        linked: z.union([
            z.object({
                id: z.string(),
                title: z.string(),
                status: z.enum([
                    'DRAFT',
                    'PUBLISHED',
                    'ARCHIVED'
                ])
            }),
            z.unknown()
        ]),
        renameLinked: z.boolean(),
        touches: z.enum(['planning', 'both']),
        skipped: z.boolean(),
        applied: z.boolean(),
        lessonId: z.string().min(1).max(64),
        name: z.string(),
        course: z.union([
            z.string(),
            z.unknown()
        ]),
        module: z.union([
            z.string(),
            z.unknown()
        ]),
        currentName: z.union([
            z.string(),
            z.unknown()
        ]),
        description: z.string(),
        matches: z.array(z.object({
            lessonId: z.string().min(1).max(64),
            course: z.union([
                z.string(),
                z.unknown()
            ]),
            module: z.union([
                z.string(),
                z.unknown()
            ]),
            currentName: z.union([
                z.string(),
                z.unknown()
            ])
        }))
    })),
    pending: z.int().gte(0).lte(9007199254740991)
});
export const zAskCurriculumDto = z.object({
    turns: z.array(z.object({
        role: z.enum(['operator', 'planner']),
        text: z.string().min(1).max(4000)
    })).min(1).max(20),
    scope: z.union([
        z.object({
            kind: z.string(),
            lessonId: z.string().min(1).max(64)
        }),
        z.object({
            kind: z.string(),
            lessonIds: z.array(z.string().min(1).max(64)).min(1).max(1000)
        }),
        z.object({
            kind: z.string(),
            filter: z.object({
                q: z.string().min(1).max(120).optional(),
                courseId: z.string().min(1).optional(),
                moduleId: z.string().min(1).optional(),
                status: z.enum([
                    'NOT_BUILT',
                    'QUEUED',
                    'BUILDING',
                    'BUILT_DRAFT',
                    'IN_REVIEW',
                    'PUBLISHED',
                    'BUILD_FAILED'
                ]).optional(),
                published: z.enum(['yes', 'no']).optional(),
                publishedFrom: z.iso.date().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))$/).optional(),
                publishedTo: z.iso.date().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))$/).optional()
            })
        }),
        z.object({
            kind: z.string()
        })
    ]),
    briefPart: z.int().gte(1).lte(9007199254740991).optional().default(1)
});
export const zCurriculumAnswerDtoOutput = z.object({
    text: z.string().min(1),
    costUsd: z.number().gte(0),
    inputTokens: z.int().gte(0).lte(9007199254740991),
    outputTokens: z.int().gte(0).lte(9007199254740991),
    examined: z.string(),
    scope: z.object({
        kind: z.enum([
            'lesson',
            'selected',
            'filter',
            'curriculum'
        ]),
        label: z.string()
    }),
    coverage: z.object({
        inScope: z.int().gte(0).lte(9007199254740991),
        read: z.int().gte(0).lte(9007199254740991),
        briefsRead: z.int().gte(0).lte(9007199254740991),
        briefPart: z.int().gte(1).lte(9007199254740991),
        briefParts: z.int().gte(1).lte(9007199254740991),
        notFound: z.array(z.string().min(1).max(64))
    }),
    lessonIds: z.array(z.string().min(1).max(64)),
    proposals: z.array(z.object({
        lessonId: z.string().min(1).max(64),
        before: z.object({
            name: z.string().min(1).max(200).optional(),
            description: z.string().max(20000).optional(),
            writerBrief: z.string().max(50000).optional(),
            primarySourceName: z.string().max(500).optional(),
            primarySourceUrl: z.string().max(2000).optional(),
            additionalSourceName: z.string().max(500).optional(),
            additionalSourceUrl: z.string().max(2000).optional()
        }),
        after: z.object({
            name: z.string().min(1).max(200).optional(),
            description: z.string().max(20000).optional(),
            writerBrief: z.string().max(50000).optional(),
            primarySourceName: z.string().max(500).optional(),
            primarySourceUrl: z.string().max(2000).optional(),
            additionalSourceName: z.string().max(500).optional(),
            additionalSourceUrl: z.string().max(2000).optional()
        }),
        built: z.boolean()
    })),
    storyProposals: z.array(z.object({
        moduleId: z.string(),
        module: z.string(),
        storyRevision: z.int().gte(0).lte(9007199254740991),
        before: z.string(),
        after: z.string().max(50000),
        figures: z.object({
            before: z.array(z.string().min(1).max(200)).max(12),
            after: z.array(z.string().min(1).max(200)).max(12)
        }),
        beats: z.array(z.object({
            lessonId: z.string().min(1).max(64),
            name: z.string(),
            before: z.string(),
            after: z.string().min(1).max(10000)
        })).min(1),
        compared: z.object({
            inCourse: z.int().gte(0).lte(9007199254740991),
            elsewhere: z.int().gte(0).lte(9007199254740991)
        })
    })).max(1),
    castProposals: z.array(z.object({
        moduleId: z.string(),
        module: z.string(),
        storyRevision: z.int().gte(0).lte(9007199254740991),
        before: z.array(z.object({
            id: z.string().min(1).max(64),
            character: z.enum([
                'betty',
                'david',
                'rosa',
                'kofi',
                'priya',
                'sam',
                'noor',
                'tomi',
                'biscuit',
                'bolt'
            ]).optional(),
            name: z.string().min(1).max(60).optional(),
            part: z.enum(['lead', 'supporting']),
            role: z.string().min(1).max(60),
            goal: z.string().max(500).default(''),
            constraint: z.string().max(500).default(''),
            relationship: z.string().max(500).default(''),
            continuity: z.array(z.string().min(1).max(200)).max(10).default([])
        })),
        after: z.array(z.object({
            id: z.string().min(1).max(64),
            character: z.enum([
                'betty',
                'david',
                'rosa',
                'kofi',
                'priya',
                'sam',
                'noor',
                'tomi',
                'biscuit',
                'bolt'
            ]).optional(),
            name: z.string().min(1).max(60).optional(),
            part: z.enum(['lead', 'supporting']),
            role: z.string().min(1).max(60),
            goal: z.string().max(500).default(''),
            constraint: z.string().max(500).default(''),
            relationship: z.string().max(500).default(''),
            continuity: z.array(z.string().min(1).max(200)).max(10).default([])
        })).max(3),
        lessons: z.array(z.object({
            lessonId: z.string().min(1).max(64),
            name: z.string(),
            before: z.array(z.string().min(1).max(64)).max(3),
            after: z.array(z.string().min(1).max(64)).max(3)
        })).min(1)
    })).max(1)
});
export const zDescribePlanningScopeDto = z.object({
    scope: z.union([
        z.object({
            kind: z.string(),
            lessonId: z.string().min(1).max(64)
        }),
        z.object({
            kind: z.string(),
            lessonIds: z.array(z.string().min(1).max(64)).min(1).max(1000)
        }),
        z.object({
            kind: z.string(),
            filter: z.object({
                q: z.string().min(1).max(120).optional(),
                courseId: z.string().min(1).optional(),
                moduleId: z.string().min(1).optional(),
                status: z.enum([
                    'NOT_BUILT',
                    'QUEUED',
                    'BUILDING',
                    'BUILT_DRAFT',
                    'IN_REVIEW',
                    'PUBLISHED',
                    'BUILD_FAILED'
                ]).optional(),
                published: z.enum(['yes', 'no']).optional(),
                publishedFrom: z.iso.date().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))$/).optional(),
                publishedTo: z.iso.date().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))$/).optional()
            })
        }),
        z.object({
            kind: z.string()
        })
    ])
});
export const zPlanningScopeSummaryDtoOutput = z.object({
    label: z.string(),
    lessonCount: z.int().gte(0).lte(9007199254740991),
    courses: z.array(z.object({
        name: z.string(),
        modules: z.array(z.string())
    })),
    lessons: z.array(z.object({
        lessonId: z.string(),
        name: z.string()
    })).max(100)
});
export const zFixModuleDto = z.object({
    request: z.string().min(1).max(300),
    storyRevision: z.int().gte(0).lte(9007199254740991)
});
export const zModuleFixDtoOutput = z.object({
    recast: z.union([
        z.object({
            id: z.string().min(1),
            moduleId: z.string().min(1),
            assignmentId: z.string().min(1).max(64),
            from: z.object({
                character: z.enum([
                    'betty',
                    'david',
                    'rosa',
                    'kofi',
                    'priya',
                    'sam',
                    'noor',
                    'tomi',
                    'biscuit',
                    'bolt'
                ]),
                role: z.string().min(1).max(60)
            }),
            to: z.object({
                character: z.enum([
                    'betty',
                    'david',
                    'rosa',
                    'kofi',
                    'priya',
                    'sam',
                    'noor',
                    'tomi',
                    'biscuit',
                    'bolt'
                ]),
                role: z.string().min(1).max(60)
            }),
            request: z.string(),
            status: z.enum([
                'PROPOSED',
                'APPLIED',
                'DISCARDED'
            ]),
            why: z.string(),
            lacks: z.array(z.string()),
            lessons: z.array(z.object({
                lessonId: z.string().min(1),
                curriculumLessonId: z.string(),
                title: z.string(),
                published: z.boolean(),
                outside: z.boolean(),
                changes: z.array(z.object({
                    field: z.string(),
                    before: z.string(),
                    after: z.string()
                })),
                scenes: z.array(z.object({
                    sceneId: z.string().min(1),
                    position: z.int().gte(1).lte(9007199254740991),
                    changes: z.array(z.object({
                        field: z.string(),
                        before: z.string(),
                        after: z.string()
                    }))
                }))
            })),
            createdAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
            appliedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).optional()
        }),
        z.unknown()
    ]),
    story: z.union([
        z.object({
            moduleId: z.string(),
            module: z.string(),
            storyRevision: z.int().gte(0).lte(9007199254740991),
            before: z.string(),
            after: z.string().max(50000),
            figures: z.object({
                before: z.array(z.string().min(1).max(200)).max(12),
                after: z.array(z.string().min(1).max(200)).max(12)
            }),
            beats: z.array(z.object({
                lessonId: z.string().min(1).max(64),
                name: z.string(),
                before: z.string(),
                after: z.string().min(1).max(10000)
            })).min(1),
            compared: z.object({
                inCourse: z.int().gte(0).lte(9007199254740991),
                elsewhere: z.int().gte(0).lte(9007199254740991)
            })
        }),
        z.unknown()
    ])
});
export const zRequestRecastDto = z.object({
    assignmentId: z.string().min(1).max(64).optional(),
    character: z.enum([
        'betty',
        'david',
        'rosa',
        'kofi',
        'priya',
        'sam',
        'noor',
        'tomi',
        'biscuit',
        'bolt'
    ]).optional(),
    role: z.string().min(1).max(60).optional(),
    request: z.string().min(1).max(300).optional(),
    storyRevision: z.int().gte(0).lte(9007199254740991)
});
export const zRecastDtoOutput = z.object({
    id: z.string().min(1),
    moduleId: z.string().min(1),
    assignmentId: z.string().min(1).max(64),
    from: z.object({
        character: z.enum([
            'betty',
            'david',
            'rosa',
            'kofi',
            'priya',
            'sam',
            'noor',
            'tomi',
            'biscuit',
            'bolt'
        ]),
        role: z.string().min(1).max(60)
    }),
    to: z.object({
        character: z.enum([
            'betty',
            'david',
            'rosa',
            'kofi',
            'priya',
            'sam',
            'noor',
            'tomi',
            'biscuit',
            'bolt'
        ]),
        role: z.string().min(1).max(60)
    }),
    request: z.string(),
    status: z.enum([
        'PROPOSED',
        'APPLIED',
        'DISCARDED'
    ]),
    why: z.string(),
    lacks: z.array(z.string()),
    lessons: z.array(z.object({
        lessonId: z.string().min(1),
        curriculumLessonId: z.string(),
        title: z.string(),
        published: z.boolean(),
        outside: z.boolean(),
        changes: z.array(z.object({
            field: z.string(),
            before: z.string(),
            after: z.string()
        })),
        scenes: z.array(z.object({
            sceneId: z.string().min(1),
            position: z.int().gte(1).lte(9007199254740991),
            changes: z.array(z.object({
                field: z.string(),
                before: z.string(),
                after: z.string()
            }))
        }))
    })),
    createdAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
    appliedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).optional()
});
export const zMeResponseDto = z.object({
    id: z.string().min(1),
    roles: z.array(z.enum(['user', 'admin'])),
    createdAt: z.string().regex(/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/)
});
export const zHomeResponseDtoOutput = z.object({
    stats: z.object({
        xpTotal: z.int().gte(0).lte(9007199254740991),
        streakCurrent: z.int().gte(0).lte(9007199254740991),
        streakLongest: z.int().gte(0).lte(9007199254740991),
        lessonsCompleted: z.int().gte(0).lte(9007199254740991)
    }),
    journey: z.object({
        slug: z.string().min(1).max(200).regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/),
        kind: z.enum([
            'COURSE',
            'MODULE',
            'PATH'
        ]),
        title: z.string().min(1).max(120),
        completed: z.int().gte(0).lte(9007199254740991),
        total: z.int().gte(1).lte(9007199254740991),
        lessons: z.array(z.object({
            slug: z.string().min(1).max(200).regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/),
            title: z.string().min(1).max(120),
            summary: z.string().min(1).max(300),
            verb: z.enum([
                'decide',
                'allocate',
                'rank',
                'match',
                'predict',
                'diagnose',
                'negotiate',
                'rephrase',
                'pitch',
                'speak',
                'simulate'
            ]).optional(),
            estimatedMinutes: z.int().gte(1).lte(60),
            objectName: z.enum([
                'balance',
                'funnel',
                'stack',
                'bridge',
                'steps',
                'podium',
                'chart',
                'pie',
                'gauge',
                'magnifier',
                'beaker',
                'hourglass',
                'calendar',
                'clock',
                'stopwatch',
                'vault',
                'wallet',
                'receipt',
                'calculator',
                'ledger',
                'compass',
                'telescope',
                'map',
                'flag',
                'chess',
                'target',
                'gavel',
                'puzzle',
                'team',
                'network',
                'roundtable',
                'mic',
                'iceberg',
                'chat',
                'gears',
                'pipeline',
                'crate',
                'factory',
                'server',
                'spool',
                'clipboard',
                'tray',
                'basket',
                'folder',
                'bin',
                'lightbulb',
                'rocket',
                'key',
                'trophy',
                'briefcase'
            ]).optional(),
            family: z.enum([
                'growth',
                'finance',
                'people'
            ]),
            palette: z.object({
                primary: z.string().regex(/^#[0-9a-f]{6}$/),
                secondary: z.string().regex(/^#[0-9a-f]{6}$/)
            }).optional(),
            state: z.enum([
                'done',
                'now',
                'locked'
            ]),
            score: z.object({
                correct: z.int().gte(0).lte(9007199254740991),
                total: z.int().gte(0).lte(9007199254740991)
            }).optional(),
            checkpoint: z.boolean()
        })).min(1)
    }).optional(),
    next: z.object({
        slug: z.string().min(1).max(200).regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/),
        title: z.string().min(1).max(120),
        summary: z.string().min(1).max(300),
        verb: z.enum([
            'decide',
            'allocate',
            'rank',
            'match',
            'predict',
            'diagnose',
            'negotiate',
            'rephrase',
            'pitch',
            'speak',
            'simulate'
        ]).optional(),
        estimatedMinutes: z.int().gte(1).lte(60),
        objectName: z.enum([
            'balance',
            'funnel',
            'stack',
            'bridge',
            'steps',
            'podium',
            'chart',
            'pie',
            'gauge',
            'magnifier',
            'beaker',
            'hourglass',
            'calendar',
            'clock',
            'stopwatch',
            'vault',
            'wallet',
            'receipt',
            'calculator',
            'ledger',
            'compass',
            'telescope',
            'map',
            'flag',
            'chess',
            'target',
            'gavel',
            'puzzle',
            'team',
            'network',
            'roundtable',
            'mic',
            'iceberg',
            'chat',
            'gears',
            'pipeline',
            'crate',
            'factory',
            'server',
            'spool',
            'clipboard',
            'tray',
            'basket',
            'folder',
            'bin',
            'lightbulb',
            'rocket',
            'key',
            'trophy',
            'briefcase'
        ]).optional(),
        family: z.enum([
            'growth',
            'finance',
            'people'
        ]),
        palette: z.object({
            primary: z.string().regex(/^#[0-9a-f]{6}$/),
            secondary: z.string().regex(/^#[0-9a-f]{6}$/)
        }).optional(),
        state: z.enum([
            'done',
            'now',
            'locked'
        ]),
        score: z.object({
            correct: z.int().gte(0).lte(9007199254740991),
            total: z.int().gte(0).lte(9007199254740991)
        }).optional(),
        checkpoint: z.boolean()
    }).optional(),
    partway: z.object({
        scene: z.int().gte(1).lte(9007199254740991),
        total: z.int().gte(1).lte(9007199254740991)
    }).optional(),
    goalMet: z.boolean(),
    today: z.object({
        done: z.int().gte(0).lte(9007199254740991),
        target: z.int().gte(1).lte(9007199254740991)
    }),
    streakReturn: z.object({
        kind: z.enum(['kept', 'broken']),
        days: z.int().gte(1).lte(9007199254740991)
    }).optional(),
    nextUp: z.object({
        reason: z.enum([
            'start',
            'resume',
            'next',
            'review'
        ]),
        collection: z.string().min(1).max(120),
        progress: z.object({
            completed: z.int().gte(0).lte(9007199254740991),
            total: z.int().gte(1).lte(9007199254740991)
        }).optional(),
        lesson: z.object({
            slug: z.string().min(1).max(200).regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/),
            title: z.string().min(1).max(120),
            family: z.enum([
                'growth',
                'finance',
                'people'
            ]),
            palette: z.object({
                primary: z.string().regex(/^#[0-9a-f]{6}$/),
                secondary: z.string().regex(/^#[0-9a-f]{6}$/)
            }).optional()
        })
    }).optional(),
    pathReturn: z.object({
        reason: z.enum([
            'start',
            'resume',
            'next',
            'review'
        ]),
        collection: z.string().min(1).max(120),
        progress: z.object({
            completed: z.int().gte(0).lte(9007199254740991),
            total: z.int().gte(1).lte(9007199254740991)
        }).optional(),
        lesson: z.object({
            slug: z.string().min(1).max(200).regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/),
            title: z.string().min(1).max(120),
            family: z.enum([
                'growth',
                'finance',
                'people'
            ]),
            palette: z.object({
                primary: z.string().regex(/^#[0-9a-f]{6}$/),
                secondary: z.string().regex(/^#[0-9a-f]{6}$/)
            }).optional()
        })
    }).optional(),
    newTopics: z.array(z.object({
        topic: z.enum([
            'MARKETING',
            'FINANCE',
            'STRATEGY',
            'LEADERSHIP',
            'SALES',
            'NEGOTIATION',
            'ENTREPRENEURSHIP',
            'PUBLIC_SPEAKING',
            'COMMUNICATION',
            'OPERATIONS',
            'DECISIONS',
            'BUSINESS_FUNDAMENTALS',
            'TEAM_MANAGEMENT',
            'HIRING',
            'ORGANIZATIONAL_BEHAVIOR',
            'PRODUCT_MANAGEMENT',
            'AI',
            'INNOVATION',
            'PROJECT_MANAGEMENT',
            'BUSINESS_ANALYTICS',
            'CAREER',
            'PERSONAL_FINANCE',
            'ECONOMICS'
        ]),
        family: z.enum([
            'growth',
            'finance',
            'people'
        ]),
        firstLesson: z.string().min(1).max(200).regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/)
    }))
});
export const zBadgeWallDtoOutput = z.object({
    badges: z.array(z.object({
        id: z.string().min(1),
        name: z.string().min(1).max(40),
        hint: z.string().min(1).max(120),
        tone: z.enum([
            'brand',
            'streak',
            'mastery'
        ]),
        glyph: z.enum([
            'check',
            'flame',
            'price',
            'chart',
            'mic',
            'route'
        ]),
        earned: z.boolean()
    })),
    earnedCount: z.int().gte(0).lte(9007199254740991),
    totalCount: z.int().gte(0).lte(9007199254740991),
    xpTotal: z.int().gte(0).lte(9007199254740991),
    streakCurrent: z.int().gte(0).lte(9007199254740991)
});
export const zStreakGoalStateDtoOutput = z.object({
    goal: z.union([
        z.object({
            days: z.number(),
            bonusXp: z.int().gte(1).lte(9007199254740991),
            progress: z.int().gte(0).lte(9007199254740991),
            startedOn: z.iso.date().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))$/)
        }),
        z.unknown()
    ]),
    offers: z.array(z.number()),
    streakCurrent: z.int().gte(0).lte(9007199254740991),
    freezes: z.object({
        held: z.int().gte(0).lte(2),
        daysToNext: z.union([
            z.int().gte(1).lte(3),
            z.unknown()
        ])
    }),
    events: z.array(z.union([
        z.object({
            kind: z.string(),
            id: z.string().regex(/^(freeze-earned|freezes-used|streak-broken|goal-completed):\d{4}-\d{2}-\d{2}$/)
        }),
        z.object({
            kind: z.string(),
            id: z.string().regex(/^(freeze-earned|freezes-used|streak-broken|goal-completed):\d{4}-\d{2}-\d{2}$/),
            count: z.int().gte(1).lte(9007199254740991)
        }),
        z.object({
            kind: z.string(),
            id: z.string().regex(/^(freeze-earned|freezes-used|streak-broken|goal-completed):\d{4}-\d{2}-\d{2}$/),
            goalDays: z.number().optional()
        }),
        z.object({
            kind: z.string(),
            id: z.string().regex(/^(freeze-earned|freezes-used|streak-broken|goal-completed):\d{4}-\d{2}-\d{2}$/),
            days: z.number(),
            bonusXp: z.int().gte(1).lte(9007199254740991),
            offers: z.array(z.number())
        })
    ]))
});
export const zSetStreakGoalDto = z.object({
    days: z.number()
});
export const zStreakEventsSeenDto = z.object({
    ids: z.array(z.string().regex(/^(freeze-earned|freezes-used|streak-broken|goal-completed):\d{4}-\d{2}-\d{2}$/)).min(1)
});
export const zExploreResponseDtoOutput = z.object({
    streakCurrent: z.int().gte(0).lte(9007199254740991),
    paths: z.array(z.object({
        slug: z.string().min(1).max(200).regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/),
        title: z.string().min(1).max(120),
        summary: z.string().min(1).max(300),
        subject: z.enum([
            'MARKETING',
            'FINANCE',
            'STRATEGY',
            'LEADERSHIP',
            'SALES',
            'NEGOTIATION',
            'ENTREPRENEURSHIP',
            'PUBLIC_SPEAKING',
            'COMMUNICATION',
            'OPERATIONS',
            'DECISIONS',
            'BUSINESS_FUNDAMENTALS',
            'TEAM_MANAGEMENT',
            'HIRING',
            'ORGANIZATIONAL_BEHAVIOR',
            'PRODUCT_MANAGEMENT',
            'AI',
            'INNOVATION',
            'PROJECT_MANAGEMENT',
            'BUSINESS_ANALYTICS',
            'CAREER',
            'PERSONAL_FINANCE',
            'ECONOMICS'
        ]).optional(),
        family: z.enum([
            'growth',
            'finance',
            'people'
        ]),
        palette: z.object({
            primary: z.string().regex(/^#[0-9a-f]{6}$/),
            secondary: z.string().regex(/^#[0-9a-f]{6}$/)
        }).optional(),
        objectName: z.enum([
            'balance',
            'funnel',
            'stack',
            'bridge',
            'steps',
            'podium',
            'chart',
            'pie',
            'gauge',
            'magnifier',
            'beaker',
            'hourglass',
            'calendar',
            'clock',
            'stopwatch',
            'vault',
            'wallet',
            'receipt',
            'calculator',
            'ledger',
            'compass',
            'telescope',
            'map',
            'flag',
            'chess',
            'target',
            'gavel',
            'puzzle',
            'team',
            'network',
            'roundtable',
            'mic',
            'iceberg',
            'chat',
            'gears',
            'pipeline',
            'crate',
            'factory',
            'server',
            'spool',
            'clipboard',
            'tray',
            'basket',
            'folder',
            'bin',
            'lightbulb',
            'rocket',
            'key',
            'trophy',
            'briefcase'
        ]).optional(),
        imageUrl: z.url().optional(),
        lessonCount: z.int().gte(1).lte(9007199254740991),
        completed: z.int().gte(0).lte(9007199254740991),
        estimatedMinutes: z.int().gte(0).lte(9007199254740991)
    })),
    courses: z.array(z.object({
        slug: z.string().min(1).max(200).regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/),
        title: z.string().min(1).max(120),
        summary: z.string().min(1).max(300),
        subject: z.enum([
            'MARKETING',
            'FINANCE',
            'STRATEGY',
            'LEADERSHIP',
            'SALES',
            'NEGOTIATION',
            'ENTREPRENEURSHIP',
            'PUBLIC_SPEAKING',
            'COMMUNICATION',
            'OPERATIONS',
            'DECISIONS',
            'BUSINESS_FUNDAMENTALS',
            'TEAM_MANAGEMENT',
            'HIRING',
            'ORGANIZATIONAL_BEHAVIOR',
            'PRODUCT_MANAGEMENT',
            'AI',
            'INNOVATION',
            'PROJECT_MANAGEMENT',
            'BUSINESS_ANALYTICS',
            'CAREER',
            'PERSONAL_FINANCE',
            'ECONOMICS'
        ]).optional(),
        family: z.enum([
            'growth',
            'finance',
            'people'
        ]),
        palette: z.object({
            primary: z.string().regex(/^#[0-9a-f]{6}$/),
            secondary: z.string().regex(/^#[0-9a-f]{6}$/)
        }).optional(),
        objectName: z.enum([
            'balance',
            'funnel',
            'stack',
            'bridge',
            'steps',
            'podium',
            'chart',
            'pie',
            'gauge',
            'magnifier',
            'beaker',
            'hourglass',
            'calendar',
            'clock',
            'stopwatch',
            'vault',
            'wallet',
            'receipt',
            'calculator',
            'ledger',
            'compass',
            'telescope',
            'map',
            'flag',
            'chess',
            'target',
            'gavel',
            'puzzle',
            'team',
            'network',
            'roundtable',
            'mic',
            'iceberg',
            'chat',
            'gears',
            'pipeline',
            'crate',
            'factory',
            'server',
            'spool',
            'clipboard',
            'tray',
            'basket',
            'folder',
            'bin',
            'lightbulb',
            'rocket',
            'key',
            'trophy',
            'briefcase'
        ]).optional(),
        imageUrl: z.url().optional(),
        lessonCount: z.int().gte(1).lte(9007199254740991),
        completed: z.int().gte(0).lte(9007199254740991),
        estimatedMinutes: z.int().gte(0).lte(9007199254740991)
    })),
    resume: z.object({
        slug: z.string().min(1).max(200).regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/),
        title: z.string().min(1).max(120),
        summary: z.string().min(1).max(300),
        subject: z.enum([
            'MARKETING',
            'FINANCE',
            'STRATEGY',
            'LEADERSHIP',
            'SALES',
            'NEGOTIATION',
            'ENTREPRENEURSHIP',
            'PUBLIC_SPEAKING',
            'COMMUNICATION',
            'OPERATIONS',
            'DECISIONS',
            'BUSINESS_FUNDAMENTALS',
            'TEAM_MANAGEMENT',
            'HIRING',
            'ORGANIZATIONAL_BEHAVIOR',
            'PRODUCT_MANAGEMENT',
            'AI',
            'INNOVATION',
            'PROJECT_MANAGEMENT',
            'BUSINESS_ANALYTICS',
            'CAREER',
            'PERSONAL_FINANCE',
            'ECONOMICS'
        ]).optional(),
        family: z.enum([
            'growth',
            'finance',
            'people'
        ]),
        palette: z.object({
            primary: z.string().regex(/^#[0-9a-f]{6}$/),
            secondary: z.string().regex(/^#[0-9a-f]{6}$/)
        }).optional(),
        objectName: z.enum([
            'balance',
            'funnel',
            'stack',
            'bridge',
            'steps',
            'podium',
            'chart',
            'pie',
            'gauge',
            'magnifier',
            'beaker',
            'hourglass',
            'calendar',
            'clock',
            'stopwatch',
            'vault',
            'wallet',
            'receipt',
            'calculator',
            'ledger',
            'compass',
            'telescope',
            'map',
            'flag',
            'chess',
            'target',
            'gavel',
            'puzzle',
            'team',
            'network',
            'roundtable',
            'mic',
            'iceberg',
            'chat',
            'gears',
            'pipeline',
            'crate',
            'factory',
            'server',
            'spool',
            'clipboard',
            'tray',
            'basket',
            'folder',
            'bin',
            'lightbulb',
            'rocket',
            'key',
            'trophy',
            'briefcase'
        ]).optional(),
        imageUrl: z.url().optional(),
        lessonCount: z.int().gte(1).lte(9007199254740991),
        completed: z.int().gte(0).lte(9007199254740991),
        estimatedMinutes: z.int().gte(0).lte(9007199254740991)
    }).optional(),
    nextUp: z.object({
        reason: z.enum([
            'start',
            'resume',
            'next',
            'review'
        ]),
        collection: z.string().min(1).max(120),
        progress: z.object({
            completed: z.int().gte(0).lte(9007199254740991),
            total: z.int().gte(1).lte(9007199254740991)
        }).optional(),
        lesson: z.object({
            slug: z.string().min(1).max(200).regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/),
            title: z.string().min(1).max(120),
            family: z.enum([
                'growth',
                'finance',
                'people'
            ]),
            palette: z.object({
                primary: z.string().regex(/^#[0-9a-f]{6}$/),
                secondary: z.string().regex(/^#[0-9a-f]{6}$/)
            }).optional()
        })
    }).optional()
});
export const zCollectionProgressDtoOutput = z.object({
    standing: z.object({
        done: z.array(z.string().min(1).max(200).regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/)),
        next: z.string().min(1).max(200).regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/).optional()
    }).optional()
});
export const zOnboardingOptionsDtoOutput = z.object({
    topics: z.array(z.object({
        topic: z.enum([
            'MARKETING',
            'FINANCE',
            'STRATEGY',
            'LEADERSHIP',
            'SALES',
            'NEGOTIATION',
            'ENTREPRENEURSHIP',
            'PUBLIC_SPEAKING',
            'COMMUNICATION',
            'OPERATIONS',
            'DECISIONS',
            'BUSINESS_FUNDAMENTALS',
            'TEAM_MANAGEMENT',
            'HIRING',
            'ORGANIZATIONAL_BEHAVIOR',
            'PRODUCT_MANAGEMENT',
            'AI',
            'INNOVATION',
            'PROJECT_MANAGEMENT',
            'BUSINESS_ANALYTICS',
            'CAREER',
            'PERSONAL_FINANCE',
            'ECONOMICS'
        ]),
        ready: z.boolean()
    })),
    suggestions: z.array(z.object({
        goal: z.enum([
            'CURRENT_JOB',
            'NEXT_ROLE',
            'CAREER_CHANGE',
            'GROW_BUSINESS',
            'LEAD_PEOPLE',
            'UNDERSTAND_BUSINESS',
            'MONEY_DECISIONS',
            'SOMETHING_ELSE',
            'EXPLORING'
        ]),
        topics: z.array(z.enum([
            'MARKETING',
            'FINANCE',
            'STRATEGY',
            'LEADERSHIP',
            'SALES',
            'NEGOTIATION',
            'ENTREPRENEURSHIP',
            'PUBLIC_SPEAKING',
            'COMMUNICATION',
            'OPERATIONS',
            'DECISIONS',
            'BUSINESS_FUNDAMENTALS',
            'TEAM_MANAGEMENT',
            'HIRING',
            'ORGANIZATIONAL_BEHAVIOR',
            'PRODUCT_MANAGEMENT',
            'AI',
            'INNOVATION',
            'PROJECT_MANAGEMENT',
            'BUSINESS_ANALYTICS',
            'CAREER',
            'PERSONAL_FINANCE',
            'ECONOMICS'
        ])).min(1).max(5)
    })),
    copy: z.array(z.object({
        key: z.string().max(80).regex(/^[A-Za-z0-9_.]+$/),
        text: z.string().min(1).max(300)
    })).max(500),
    flow: z.array(z.union([
        z.object({
            kind: z.string(),
            id: z.enum([
                'WELCOME',
                'THEME',
                'MEET_LEO',
                'GOAL',
                'INTERESTS',
                'STARTING_FOCUS',
                'WORK_CONTEXT',
                'FAMILIARITY',
                'DAILY_PACE',
                'STREAK_INTRO',
                'STREAK_GOAL',
                'PATH',
                'FIRST_CHALLENGE',
                'COMPLETION',
                'REMINDER',
                'ACCOUNT'
            ]),
            enabled: z.boolean().default(true),
            showIf: z.union([
                z.object({
                    answer: z.string(),
                    anyOf: z.array(z.enum([
                        'CURRENT_JOB',
                        'NEXT_ROLE',
                        'CAREER_CHANGE',
                        'GROW_BUSINESS',
                        'LEAD_PEOPLE',
                        'UNDERSTAND_BUSINESS',
                        'MONEY_DECISIONS',
                        'SOMETHING_ELSE',
                        'EXPLORING'
                    ])).min(1)
                }),
                z.object({
                    answer: z.string(),
                    anyOf: z.array(z.enum([
                        'STUDENT',
                        'EARLY_CAREER',
                        'PROFESSIONAL',
                        'MANAGER',
                        'DEPARTMENT_HEAD',
                        'EXECUTIVE',
                        'FOUNDER',
                        'FREELANCER',
                        'BETWEEN_ROLES',
                        'SOMETHING_ELSE'
                    ])).min(1)
                })
            ]).optional(),
            art: z.union([
                z.object({
                    kind: z.string()
                }),
                z.object({
                    kind: z.string(),
                    uri: z.string().max(200000).regex(/^(https:\/\/|data:image\/(png|jpeg|webp|svg\+xml)[;,])/),
                    size: z.enum([
                        'small',
                        'medium',
                        'large'
                    ]).default('medium'),
                    fit: z.enum(['contain', 'cover']).default('contain'),
                    description: z.string().max(300).optional(),
                    decorative: z.boolean().default(false)
                })
            ]).optional(),
            limit: z.union([
                z.literal(1),
                z.literal(2),
                z.literal(3)
            ]).optional(),
            order: z.array(z.string()).optional()
        }),
        z.object({
            kind: z.string(),
            id: z.string().regex(/^custom-[a-z0-9]{4,24}$/),
            enabled: z.boolean().default(true),
            showIf: z.union([
                z.object({
                    answer: z.string(),
                    anyOf: z.array(z.enum([
                        'CURRENT_JOB',
                        'NEXT_ROLE',
                        'CAREER_CHANGE',
                        'GROW_BUSINESS',
                        'LEAD_PEOPLE',
                        'UNDERSTAND_BUSINESS',
                        'MONEY_DECISIONS',
                        'SOMETHING_ELSE',
                        'EXPLORING'
                    ])).min(1)
                }),
                z.object({
                    answer: z.string(),
                    anyOf: z.array(z.enum([
                        'STUDENT',
                        'EARLY_CAREER',
                        'PROFESSIONAL',
                        'MANAGER',
                        'DEPARTMENT_HEAD',
                        'EXECUTIVE',
                        'FOUNDER',
                        'FREELANCER',
                        'BETWEEN_ROLES',
                        'SOMETHING_ELSE'
                    ])).min(1)
                })
            ]).optional(),
            art: z.union([
                z.object({
                    kind: z.string()
                }),
                z.object({
                    kind: z.string(),
                    uri: z.string().max(200000).regex(/^(https:\/\/|data:image\/(png|jpeg|webp|svg\+xml)[;,])/),
                    size: z.enum([
                        'small',
                        'medium',
                        'large'
                    ]).default('medium'),
                    fit: z.enum(['contain', 'cover']).default('contain'),
                    description: z.string().max(300).optional(),
                    decorative: z.boolean().default(false)
                })
            ]).optional(),
            name: z.string().min(1).max(300),
            title: z.string().min(1).max(300),
            body: z.string().min(1).max(300).optional(),
            button: z.string().min(1).max(300)
        }),
        z.object({
            kind: z.string(),
            id: z.string().regex(/^custom-[a-z0-9]{4,24}$/),
            enabled: z.boolean().default(true),
            showIf: z.union([
                z.object({
                    answer: z.string(),
                    anyOf: z.array(z.enum([
                        'CURRENT_JOB',
                        'NEXT_ROLE',
                        'CAREER_CHANGE',
                        'GROW_BUSINESS',
                        'LEAD_PEOPLE',
                        'UNDERSTAND_BUSINESS',
                        'MONEY_DECISIONS',
                        'SOMETHING_ELSE',
                        'EXPLORING'
                    ])).min(1)
                }),
                z.object({
                    answer: z.string(),
                    anyOf: z.array(z.enum([
                        'STUDENT',
                        'EARLY_CAREER',
                        'PROFESSIONAL',
                        'MANAGER',
                        'DEPARTMENT_HEAD',
                        'EXECUTIVE',
                        'FOUNDER',
                        'FREELANCER',
                        'BETWEEN_ROLES',
                        'SOMETHING_ELSE'
                    ])).min(1)
                })
            ]).optional(),
            art: z.union([
                z.object({
                    kind: z.string()
                }),
                z.object({
                    kind: z.string(),
                    uri: z.string().max(200000).regex(/^(https:\/\/|data:image\/(png|jpeg|webp|svg\+xml)[;,])/),
                    size: z.enum([
                        'small',
                        'medium',
                        'large'
                    ]).default('medium'),
                    fit: z.enum(['contain', 'cover']).default('contain'),
                    description: z.string().max(300).optional(),
                    decorative: z.boolean().default(false)
                })
            ]).optional(),
            name: z.string().min(1).max(300),
            title: z.string().min(1).max(300),
            body: z.string().min(1).max(300).optional(),
            options: z.array(z.object({
                id: z.string().regex(/^[a-z0-9-]{1,40}$/),
                label: z.string().min(1).max(300)
            })).max(12),
            multiple: z.boolean().default(false),
            optional: z.boolean().default(false),
            button: z.string().min(1).max(300),
            skipLabel: z.string().min(1).max(300).optional()
        })
    ])).max(60),
    version: z.union([
        z.int().gte(-9007199254740991).lte(9007199254740991),
        z.unknown()
    ])
});
export const zOnboardingAnswersDto = z.object({
    step: z.enum([
        'WELCOME',
        'THEME',
        'MEET_LEO',
        'GOAL',
        'INTERESTS',
        'STARTING_FOCUS',
        'WORK_CONTEXT',
        'FAMILIARITY',
        'DAILY_PACE',
        'STREAK_INTRO',
        'STREAK_GOAL',
        'PATH',
        'FIRST_CHALLENGE',
        'COMPLETION',
        'REMINDER',
        'ACCOUNT',
        'HOME'
    ]),
    goals: z.array(z.enum([
        'CURRENT_JOB',
        'NEXT_ROLE',
        'CAREER_CHANGE',
        'GROW_BUSINESS',
        'LEAD_PEOPLE',
        'UNDERSTAND_BUSINESS',
        'MONEY_DECISIONS',
        'SOMETHING_ELSE',
        'EXPLORING'
    ])).max(3).optional(),
    goalText: z.string().max(60).optional(),
    interests: z.array(z.enum([
        'MARKETING',
        'FINANCE',
        'STRATEGY',
        'LEADERSHIP',
        'SALES',
        'NEGOTIATION',
        'ENTREPRENEURSHIP',
        'PUBLIC_SPEAKING',
        'COMMUNICATION',
        'OPERATIONS',
        'DECISIONS',
        'BUSINESS_FUNDAMENTALS',
        'TEAM_MANAGEMENT',
        'HIRING',
        'ORGANIZATIONAL_BEHAVIOR',
        'PRODUCT_MANAGEMENT',
        'AI',
        'INNOVATION',
        'PROJECT_MANAGEMENT',
        'BUSINESS_ANALYTICS',
        'CAREER',
        'PERSONAL_FINANCE',
        'ECONOMICS'
    ])).max(23).optional(),
    startingTopic: z.enum([
        'MARKETING',
        'FINANCE',
        'STRATEGY',
        'LEADERSHIP',
        'SALES',
        'NEGOTIATION',
        'ENTREPRENEURSHIP',
        'PUBLIC_SPEAKING',
        'COMMUNICATION',
        'OPERATIONS',
        'DECISIONS',
        'BUSINESS_FUNDAMENTALS',
        'TEAM_MANAGEMENT',
        'HIRING',
        'ORGANIZATIONAL_BEHAVIOR',
        'PRODUCT_MANAGEMENT',
        'AI',
        'INNOVATION',
        'PROJECT_MANAGEMENT',
        'BUSINESS_ANALYTICS',
        'CAREER',
        'PERSONAL_FINANCE',
        'ECONOMICS'
    ]).optional(),
    workContext: z.enum([
        'STUDENT',
        'EARLY_CAREER',
        'PROFESSIONAL',
        'MANAGER',
        'DEPARTMENT_HEAD',
        'EXECUTIVE',
        'FOUNDER',
        'FREELANCER',
        'BETWEEN_ROLES',
        'SOMETHING_ELSE'
    ]).optional(),
    roleTitle: z.string().max(80).optional(),
    familiarity: z.array(z.object({
        topic: z.enum([
            'MARKETING',
            'FINANCE',
            'STRATEGY',
            'LEADERSHIP',
            'SALES',
            'NEGOTIATION',
            'ENTREPRENEURSHIP',
            'PUBLIC_SPEAKING',
            'COMMUNICATION',
            'OPERATIONS',
            'DECISIONS',
            'BUSINESS_FUNDAMENTALS',
            'TEAM_MANAGEMENT',
            'HIRING',
            'ORGANIZATIONAL_BEHAVIOR',
            'PRODUCT_MANAGEMENT',
            'AI',
            'INNOVATION',
            'PROJECT_MANAGEMENT',
            'BUSINESS_ANALYTICS',
            'CAREER',
            'PERSONAL_FINANCE',
            'ECONOMICS'
        ]),
        level: z.enum([
            'NEW',
            'BASICS',
            'SOMETIMES',
            'OFTEN'
        ])
    })).max(23).optional(),
    dailyTarget: z.int().gte(1).lte(3).optional(),
    reminder: z.union([
        z.object({
            time: z.string().regex(/^([01]\d|2[0-3]):[0-5]\d$/),
            timezone: z.string().min(1).max(64)
        }),
        z.unknown()
    ]).optional()
});
export const zOnboardingDtoOutput = z.object({
    profile: z.object({
        step: z.enum([
            'WELCOME',
            'THEME',
            'MEET_LEO',
            'GOAL',
            'INTERESTS',
            'STARTING_FOCUS',
            'WORK_CONTEXT',
            'FAMILIARITY',
            'DAILY_PACE',
            'STREAK_INTRO',
            'STREAK_GOAL',
            'PATH',
            'FIRST_CHALLENGE',
            'COMPLETION',
            'REMINDER',
            'ACCOUNT',
            'HOME'
        ]),
        goals: z.array(z.enum([
            'CURRENT_JOB',
            'NEXT_ROLE',
            'CAREER_CHANGE',
            'GROW_BUSINESS',
            'LEAD_PEOPLE',
            'UNDERSTAND_BUSINESS',
            'MONEY_DECISIONS',
            'SOMETHING_ELSE',
            'EXPLORING'
        ])),
        goalText: z.union([
            z.string(),
            z.unknown()
        ]),
        interests: z.array(z.enum([
            'MARKETING',
            'FINANCE',
            'STRATEGY',
            'LEADERSHIP',
            'SALES',
            'NEGOTIATION',
            'ENTREPRENEURSHIP',
            'PUBLIC_SPEAKING',
            'COMMUNICATION',
            'OPERATIONS',
            'DECISIONS',
            'BUSINESS_FUNDAMENTALS',
            'TEAM_MANAGEMENT',
            'HIRING',
            'ORGANIZATIONAL_BEHAVIOR',
            'PRODUCT_MANAGEMENT',
            'AI',
            'INNOVATION',
            'PROJECT_MANAGEMENT',
            'BUSINESS_ANALYTICS',
            'CAREER',
            'PERSONAL_FINANCE',
            'ECONOMICS'
        ])),
        startingTopic: z.union([
            z.enum([
                'MARKETING',
                'FINANCE',
                'STRATEGY',
                'LEADERSHIP',
                'SALES',
                'NEGOTIATION',
                'ENTREPRENEURSHIP',
                'PUBLIC_SPEAKING',
                'COMMUNICATION',
                'OPERATIONS',
                'DECISIONS',
                'BUSINESS_FUNDAMENTALS',
                'TEAM_MANAGEMENT',
                'HIRING',
                'ORGANIZATIONAL_BEHAVIOR',
                'PRODUCT_MANAGEMENT',
                'AI',
                'INNOVATION',
                'PROJECT_MANAGEMENT',
                'BUSINESS_ANALYTICS',
                'CAREER',
                'PERSONAL_FINANCE',
                'ECONOMICS'
            ]),
            z.unknown()
        ]),
        startingTopicMethod: z.union([
            z.enum([
                'CHOSEN',
                'RECOMMENDED',
                'SINGLE_INTEREST'
            ]),
            z.unknown()
        ]),
        workContext: z.union([
            z.enum([
                'STUDENT',
                'EARLY_CAREER',
                'PROFESSIONAL',
                'MANAGER',
                'DEPARTMENT_HEAD',
                'EXECUTIVE',
                'FOUNDER',
                'FREELANCER',
                'BETWEEN_ROLES',
                'SOMETHING_ELSE'
            ]),
            z.unknown()
        ]),
        roleTitle: z.union([
            z.string(),
            z.unknown()
        ]),
        familiarity: z.array(z.object({
            topic: z.enum([
                'MARKETING',
                'FINANCE',
                'STRATEGY',
                'LEADERSHIP',
                'SALES',
                'NEGOTIATION',
                'ENTREPRENEURSHIP',
                'PUBLIC_SPEAKING',
                'COMMUNICATION',
                'OPERATIONS',
                'DECISIONS',
                'BUSINESS_FUNDAMENTALS',
                'TEAM_MANAGEMENT',
                'HIRING',
                'ORGANIZATIONAL_BEHAVIOR',
                'PRODUCT_MANAGEMENT',
                'AI',
                'INNOVATION',
                'PROJECT_MANAGEMENT',
                'BUSINESS_ANALYTICS',
                'CAREER',
                'PERSONAL_FINANCE',
                'ECONOMICS'
            ]),
            level: z.enum([
                'NEW',
                'BASICS',
                'SOMETIMES',
                'OFTEN'
            ])
        })),
        dailyTarget: z.int().gte(1).lte(3),
        reminder: z.union([
            z.object({
                time: z.string().regex(/^([01]\d|2[0-3]):[0-5]\d$/),
                timezone: z.string().min(1).max(64)
            }),
            z.unknown()
        ])
    }),
    suggestedStartingTopic: z.union([
        z.enum([
            'MARKETING',
            'FINANCE',
            'STRATEGY',
            'LEADERSHIP',
            'SALES',
            'NEGOTIATION',
            'ENTREPRENEURSHIP',
            'PUBLIC_SPEAKING',
            'COMMUNICATION',
            'OPERATIONS',
            'DECISIONS',
            'BUSINESS_FUNDAMENTALS',
            'TEAM_MANAGEMENT',
            'HIRING',
            'ORGANIZATIONAL_BEHAVIOR',
            'PRODUCT_MANAGEMENT',
            'AI',
            'INNOVATION',
            'PROJECT_MANAGEMENT',
            'BUSINESS_ANALYTICS',
            'CAREER',
            'PERSONAL_FINANCE',
            'ECONOMICS'
        ]),
        z.unknown()
    ]),
    path: z.union([
        z.object({
            firstChallenge: z.object({
                slug: z.string().min(1).max(200).regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/),
                title: z.string(),
                estimatedMinutes: z.int().gte(-9007199254740991).lte(9007199254740991)
            }),
            lessons: z.array(z.object({
                slug: z.string().min(1).max(200).regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/),
                title: z.string(),
                topic: z.enum([
                    'MARKETING',
                    'FINANCE',
                    'STRATEGY',
                    'LEADERSHIP',
                    'SALES',
                    'NEGOTIATION',
                    'ENTREPRENEURSHIP',
                    'PUBLIC_SPEAKING',
                    'COMMUNICATION',
                    'OPERATIONS',
                    'DECISIONS',
                    'BUSINESS_FUNDAMENTALS',
                    'TEAM_MANAGEMENT',
                    'HIRING',
                    'ORGANIZATIONAL_BEHAVIOR',
                    'PRODUCT_MANAGEMENT',
                    'AI',
                    'INNOVATION',
                    'PROJECT_MANAGEMENT',
                    'BUSINESS_ANALYTICS',
                    'CAREER',
                    'PERSONAL_FINANCE',
                    'ECONOMICS'
                ]),
                estimatedMinutes: z.int().gte(-9007199254740991).lte(9007199254740991)
            }))
        }),
        z.unknown()
    ])
});
export const zChallengeAnswerDto = z.object({
    sceneId: z.string().min(1),
    answer: z.union([
        z.object({
            kind: z.string(),
            selected: z.array(z.string().min(1)).min(1).max(8)
        }),
        z.object({
            kind: z.string(),
            order: z.array(z.string().min(1)).min(2).max(8)
        }),
        z.object({
            kind: z.string(),
            placements: z.array(z.object({
                itemId: z.string().min(1),
                bucketId: z.string().min(1)
            })).min(1).max(12)
        }),
        z.object({
            kind: z.string(),
            value: z.number()
        }),
        z.object({
            kind: z.string(),
            allocations: z.array(z.object({
                itemId: z.string().min(1),
                amount: z.number().gte(0)
            })).min(1).max(8)
        }),
        z.object({
            kind: z.string(),
            text: z.string().min(1).max(4000)
        })
    ])
});
export const zChallengeVerdictDtoOutput = z.object({
    correct: z.boolean(),
    scorePct: z.int().gte(0).lte(100),
    explanation: z.string(),
    feedback: z.string().optional(),
    allocation: z.array(z.object({
        itemId: z.string().min(1),
        amount: z.number(),
        min: z.number(),
        max: z.number(),
        example: z.number()
    })).max(8).optional(),
    placement: z.array(z.object({
        itemId: z.string().min(1),
        bucketId: z.union([
            z.string().min(1),
            z.unknown()
        ]),
        correctBucketId: z.string().min(1)
    })).max(12).optional(),
    ranking: z.array(z.object({
        itemId: z.string().min(1),
        position: z.union([
            z.int().gte(1).lte(9007199254740991),
            z.unknown()
        ]),
        correctPosition: z.int().gte(1).lte(9007199254740991)
    })).max(8).optional(),
    estimate: z.object({
        value: z.number(),
        min: z.number(),
        max: z.number()
    }).optional(),
    correctOptionIds: z.array(z.string().min(1)).max(8).optional(),
    scored: z.boolean().optional(),
    strength: z.union([
        z.enum([
            'MARKETING',
            'FINANCE',
            'STRATEGY',
            'LEADERSHIP',
            'SALES',
            'NEGOTIATION',
            'ENTREPRENEURSHIP',
            'PUBLIC_SPEAKING',
            'COMMUNICATION',
            'OPERATIONS',
            'DECISIONS',
            'BUSINESS_FUNDAMENTALS',
            'TEAM_MANAGEMENT',
            'HIRING',
            'ORGANIZATIONAL_BEHAVIOR',
            'PRODUCT_MANAGEMENT',
            'AI',
            'INNOVATION',
            'PROJECT_MANAGEMENT',
            'BUSINESS_ANALYTICS',
            'CAREER',
            'PERSONAL_FINANCE',
            'ECONOMICS'
        ]),
        z.unknown()
    ])
});
export const zOnboardingEventDto = z.object({
    event: z.enum([
        'CHALLENGE_STARTED',
        'CHALLENGE_LEFT',
        'CHALLENGE_COMPLETED'
    ]),
    sceneId: z.string().min(1).optional()
});
export const zOnboardingCopyCatalogDtoOutput = z.object({
    entries: z.array(z.object({
        key: z.string(),
        english: z.string()
    }))
});
export const zOnboardingConfigsDtoOutput = z.object({
    live: z.union([
        z.int().gte(-9007199254740991).lte(9007199254740991),
        z.unknown()
    ]),
    versions: z.array(z.object({
        version: z.int().gte(-9007199254740991).lte(9007199254740991),
        status: z.enum(['DRAFT', 'PUBLISHED']),
        config: z.object({
            starts: z.array(z.object({
                topic: z.enum([
                    'MARKETING',
                    'FINANCE',
                    'STRATEGY',
                    'LEADERSHIP',
                    'SALES',
                    'NEGOTIATION',
                    'ENTREPRENEURSHIP',
                    'PUBLIC_SPEAKING',
                    'COMMUNICATION',
                    'OPERATIONS',
                    'DECISIONS',
                    'BUSINESS_FUNDAMENTALS',
                    'TEAM_MANAGEMENT',
                    'HIRING',
                    'ORGANIZATIONAL_BEHAVIOR',
                    'PRODUCT_MANAGEMENT',
                    'AI',
                    'INNOVATION',
                    'PROJECT_MANAGEMENT',
                    'BUSINESS_ANALYTICS',
                    'CAREER',
                    'PERSONAL_FINANCE',
                    'ECONOMICS'
                ]),
                next: z.array(z.string().min(1).max(200).regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/)).min(1).max(20)
            })).max(23),
            suggestions: z.array(z.object({
                goal: z.enum([
                    'CURRENT_JOB',
                    'NEXT_ROLE',
                    'CAREER_CHANGE',
                    'GROW_BUSINESS',
                    'LEAD_PEOPLE',
                    'UNDERSTAND_BUSINESS',
                    'MONEY_DECISIONS',
                    'SOMETHING_ELSE',
                    'EXPLORING'
                ]),
                topics: z.array(z.enum([
                    'MARKETING',
                    'FINANCE',
                    'STRATEGY',
                    'LEADERSHIP',
                    'SALES',
                    'NEGOTIATION',
                    'ENTREPRENEURSHIP',
                    'PUBLIC_SPEAKING',
                    'COMMUNICATION',
                    'OPERATIONS',
                    'DECISIONS',
                    'BUSINESS_FUNDAMENTALS',
                    'TEAM_MANAGEMENT',
                    'HIRING',
                    'ORGANIZATIONAL_BEHAVIOR',
                    'PRODUCT_MANAGEMENT',
                    'AI',
                    'INNOVATION',
                    'PROJECT_MANAGEMENT',
                    'BUSINESS_ANALYTICS',
                    'CAREER',
                    'PERSONAL_FINANCE',
                    'ECONOMICS'
                ])).min(1).max(5)
            })).max(9),
            copy: z.array(z.object({
                key: z.string().max(80).regex(/^[A-Za-z0-9_.]+$/),
                text: z.string().min(1).max(300)
            })).max(500).default([]),
            flow: z.array(z.union([
                z.object({
                    kind: z.string(),
                    id: z.enum([
                        'WELCOME',
                        'THEME',
                        'MEET_LEO',
                        'GOAL',
                        'INTERESTS',
                        'STARTING_FOCUS',
                        'WORK_CONTEXT',
                        'FAMILIARITY',
                        'DAILY_PACE',
                        'STREAK_INTRO',
                        'STREAK_GOAL',
                        'PATH',
                        'FIRST_CHALLENGE',
                        'COMPLETION',
                        'REMINDER',
                        'ACCOUNT'
                    ]),
                    enabled: z.boolean().default(true),
                    showIf: z.union([
                        z.object({
                            answer: z.string(),
                            anyOf: z.array(z.enum([
                                'CURRENT_JOB',
                                'NEXT_ROLE',
                                'CAREER_CHANGE',
                                'GROW_BUSINESS',
                                'LEAD_PEOPLE',
                                'UNDERSTAND_BUSINESS',
                                'MONEY_DECISIONS',
                                'SOMETHING_ELSE',
                                'EXPLORING'
                            ])).min(1)
                        }),
                        z.object({
                            answer: z.string(),
                            anyOf: z.array(z.enum([
                                'STUDENT',
                                'EARLY_CAREER',
                                'PROFESSIONAL',
                                'MANAGER',
                                'DEPARTMENT_HEAD',
                                'EXECUTIVE',
                                'FOUNDER',
                                'FREELANCER',
                                'BETWEEN_ROLES',
                                'SOMETHING_ELSE'
                            ])).min(1)
                        })
                    ]).optional(),
                    art: z.union([
                        z.object({
                            kind: z.string()
                        }),
                        z.object({
                            kind: z.string(),
                            uri: z.string().max(200000).regex(/^(https:\/\/|data:image\/(png|jpeg|webp|svg\+xml)[;,])/),
                            size: z.enum([
                                'small',
                                'medium',
                                'large'
                            ]).default('medium'),
                            fit: z.enum(['contain', 'cover']).default('contain'),
                            description: z.string().max(300).optional(),
                            decorative: z.boolean().default(false)
                        })
                    ]).optional(),
                    limit: z.union([
                        z.literal(1),
                        z.literal(2),
                        z.literal(3)
                    ]).optional(),
                    order: z.array(z.string()).optional()
                }),
                z.object({
                    kind: z.string(),
                    id: z.string().regex(/^custom-[a-z0-9]{4,24}$/),
                    enabled: z.boolean().default(true),
                    showIf: z.union([
                        z.object({
                            answer: z.string(),
                            anyOf: z.array(z.enum([
                                'CURRENT_JOB',
                                'NEXT_ROLE',
                                'CAREER_CHANGE',
                                'GROW_BUSINESS',
                                'LEAD_PEOPLE',
                                'UNDERSTAND_BUSINESS',
                                'MONEY_DECISIONS',
                                'SOMETHING_ELSE',
                                'EXPLORING'
                            ])).min(1)
                        }),
                        z.object({
                            answer: z.string(),
                            anyOf: z.array(z.enum([
                                'STUDENT',
                                'EARLY_CAREER',
                                'PROFESSIONAL',
                                'MANAGER',
                                'DEPARTMENT_HEAD',
                                'EXECUTIVE',
                                'FOUNDER',
                                'FREELANCER',
                                'BETWEEN_ROLES',
                                'SOMETHING_ELSE'
                            ])).min(1)
                        })
                    ]).optional(),
                    art: z.union([
                        z.object({
                            kind: z.string()
                        }),
                        z.object({
                            kind: z.string(),
                            uri: z.string().max(200000).regex(/^(https:\/\/|data:image\/(png|jpeg|webp|svg\+xml)[;,])/),
                            size: z.enum([
                                'small',
                                'medium',
                                'large'
                            ]).default('medium'),
                            fit: z.enum(['contain', 'cover']).default('contain'),
                            description: z.string().max(300).optional(),
                            decorative: z.boolean().default(false)
                        })
                    ]).optional(),
                    name: z.string().min(1).max(300),
                    title: z.string().min(1).max(300),
                    body: z.string().min(1).max(300).optional(),
                    button: z.string().min(1).max(300)
                }),
                z.object({
                    kind: z.string(),
                    id: z.string().regex(/^custom-[a-z0-9]{4,24}$/),
                    enabled: z.boolean().default(true),
                    showIf: z.union([
                        z.object({
                            answer: z.string(),
                            anyOf: z.array(z.enum([
                                'CURRENT_JOB',
                                'NEXT_ROLE',
                                'CAREER_CHANGE',
                                'GROW_BUSINESS',
                                'LEAD_PEOPLE',
                                'UNDERSTAND_BUSINESS',
                                'MONEY_DECISIONS',
                                'SOMETHING_ELSE',
                                'EXPLORING'
                            ])).min(1)
                        }),
                        z.object({
                            answer: z.string(),
                            anyOf: z.array(z.enum([
                                'STUDENT',
                                'EARLY_CAREER',
                                'PROFESSIONAL',
                                'MANAGER',
                                'DEPARTMENT_HEAD',
                                'EXECUTIVE',
                                'FOUNDER',
                                'FREELANCER',
                                'BETWEEN_ROLES',
                                'SOMETHING_ELSE'
                            ])).min(1)
                        })
                    ]).optional(),
                    art: z.union([
                        z.object({
                            kind: z.string()
                        }),
                        z.object({
                            kind: z.string(),
                            uri: z.string().max(200000).regex(/^(https:\/\/|data:image\/(png|jpeg|webp|svg\+xml)[;,])/),
                            size: z.enum([
                                'small',
                                'medium',
                                'large'
                            ]).default('medium'),
                            fit: z.enum(['contain', 'cover']).default('contain'),
                            description: z.string().max(300).optional(),
                            decorative: z.boolean().default(false)
                        })
                    ]).optional(),
                    name: z.string().min(1).max(300),
                    title: z.string().min(1).max(300),
                    body: z.string().min(1).max(300).optional(),
                    options: z.array(z.object({
                        id: z.string().regex(/^[a-z0-9-]{1,40}$/),
                        label: z.string().min(1).max(300)
                    })).max(12),
                    multiple: z.boolean().default(false),
                    optional: z.boolean().default(false),
                    button: z.string().min(1).max(300),
                    skipLabel: z.string().min(1).max(300).optional()
                })
            ])).max(60).default([
                {
                    kind: 'BUILT_IN',
                    id: 'WELCOME',
                    enabled: true
                },
                {
                    kind: 'BUILT_IN',
                    id: 'THEME',
                    enabled: true
                },
                {
                    kind: 'BUILT_IN',
                    id: 'MEET_LEO',
                    enabled: true
                },
                {
                    kind: 'BUILT_IN',
                    id: 'GOAL',
                    enabled: true
                },
                {
                    kind: 'BUILT_IN',
                    id: 'INTERESTS',
                    enabled: true
                },
                {
                    kind: 'BUILT_IN',
                    id: 'STARTING_FOCUS',
                    enabled: true
                },
                {
                    kind: 'BUILT_IN',
                    id: 'WORK_CONTEXT',
                    enabled: true
                },
                {
                    kind: 'BUILT_IN',
                    id: 'FAMILIARITY',
                    enabled: true
                },
                {
                    kind: 'BUILT_IN',
                    id: 'DAILY_PACE',
                    enabled: true
                },
                {
                    kind: 'BUILT_IN',
                    id: 'STREAK_INTRO',
                    enabled: true
                },
                {
                    kind: 'BUILT_IN',
                    id: 'STREAK_GOAL',
                    enabled: true
                },
                {
                    kind: 'BUILT_IN',
                    id: 'PATH',
                    enabled: true
                },
                {
                    kind: 'BUILT_IN',
                    id: 'FIRST_CHALLENGE',
                    enabled: true
                },
                {
                    kind: 'BUILT_IN',
                    id: 'COMPLETION',
                    enabled: true
                },
                {
                    kind: 'BUILT_IN',
                    id: 'REMINDER',
                    enabled: true
                },
                {
                    kind: 'BUILT_IN',
                    id: 'ACCOUNT',
                    enabled: true
                }
            ])
        }),
        publishedAt: z.union([
            z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
            z.unknown()
        ]),
        restoredFrom: z.union([
            z.int().gte(-9007199254740991).lte(9007199254740991),
            z.unknown()
        ]),
        updatedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/)
    })),
    editing: z.object({
        starts: z.array(z.object({
            topic: z.enum([
                'MARKETING',
                'FINANCE',
                'STRATEGY',
                'LEADERSHIP',
                'SALES',
                'NEGOTIATION',
                'ENTREPRENEURSHIP',
                'PUBLIC_SPEAKING',
                'COMMUNICATION',
                'OPERATIONS',
                'DECISIONS',
                'BUSINESS_FUNDAMENTALS',
                'TEAM_MANAGEMENT',
                'HIRING',
                'ORGANIZATIONAL_BEHAVIOR',
                'PRODUCT_MANAGEMENT',
                'AI',
                'INNOVATION',
                'PROJECT_MANAGEMENT',
                'BUSINESS_ANALYTICS',
                'CAREER',
                'PERSONAL_FINANCE',
                'ECONOMICS'
            ]),
            next: z.array(z.string().min(1).max(200).regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/)).min(1).max(20)
        })).max(23),
        suggestions: z.array(z.object({
            goal: z.enum([
                'CURRENT_JOB',
                'NEXT_ROLE',
                'CAREER_CHANGE',
                'GROW_BUSINESS',
                'LEAD_PEOPLE',
                'UNDERSTAND_BUSINESS',
                'MONEY_DECISIONS',
                'SOMETHING_ELSE',
                'EXPLORING'
            ]),
            topics: z.array(z.enum([
                'MARKETING',
                'FINANCE',
                'STRATEGY',
                'LEADERSHIP',
                'SALES',
                'NEGOTIATION',
                'ENTREPRENEURSHIP',
                'PUBLIC_SPEAKING',
                'COMMUNICATION',
                'OPERATIONS',
                'DECISIONS',
                'BUSINESS_FUNDAMENTALS',
                'TEAM_MANAGEMENT',
                'HIRING',
                'ORGANIZATIONAL_BEHAVIOR',
                'PRODUCT_MANAGEMENT',
                'AI',
                'INNOVATION',
                'PROJECT_MANAGEMENT',
                'BUSINESS_ANALYTICS',
                'CAREER',
                'PERSONAL_FINANCE',
                'ECONOMICS'
            ])).min(1).max(5)
        })).max(9),
        copy: z.array(z.object({
            key: z.string().max(80).regex(/^[A-Za-z0-9_.]+$/),
            text: z.string().min(1).max(300)
        })).max(500).default([]),
        flow: z.array(z.union([
            z.object({
                kind: z.string(),
                id: z.enum([
                    'WELCOME',
                    'THEME',
                    'MEET_LEO',
                    'GOAL',
                    'INTERESTS',
                    'STARTING_FOCUS',
                    'WORK_CONTEXT',
                    'FAMILIARITY',
                    'DAILY_PACE',
                    'STREAK_INTRO',
                    'STREAK_GOAL',
                    'PATH',
                    'FIRST_CHALLENGE',
                    'COMPLETION',
                    'REMINDER',
                    'ACCOUNT'
                ]),
                enabled: z.boolean().default(true),
                showIf: z.union([
                    z.object({
                        answer: z.string(),
                        anyOf: z.array(z.enum([
                            'CURRENT_JOB',
                            'NEXT_ROLE',
                            'CAREER_CHANGE',
                            'GROW_BUSINESS',
                            'LEAD_PEOPLE',
                            'UNDERSTAND_BUSINESS',
                            'MONEY_DECISIONS',
                            'SOMETHING_ELSE',
                            'EXPLORING'
                        ])).min(1)
                    }),
                    z.object({
                        answer: z.string(),
                        anyOf: z.array(z.enum([
                            'STUDENT',
                            'EARLY_CAREER',
                            'PROFESSIONAL',
                            'MANAGER',
                            'DEPARTMENT_HEAD',
                            'EXECUTIVE',
                            'FOUNDER',
                            'FREELANCER',
                            'BETWEEN_ROLES',
                            'SOMETHING_ELSE'
                        ])).min(1)
                    })
                ]).optional(),
                art: z.union([
                    z.object({
                        kind: z.string()
                    }),
                    z.object({
                        kind: z.string(),
                        uri: z.string().max(200000).regex(/^(https:\/\/|data:image\/(png|jpeg|webp|svg\+xml)[;,])/),
                        size: z.enum([
                            'small',
                            'medium',
                            'large'
                        ]).default('medium'),
                        fit: z.enum(['contain', 'cover']).default('contain'),
                        description: z.string().max(300).optional(),
                        decorative: z.boolean().default(false)
                    })
                ]).optional(),
                limit: z.union([
                    z.literal(1),
                    z.literal(2),
                    z.literal(3)
                ]).optional(),
                order: z.array(z.string()).optional()
            }),
            z.object({
                kind: z.string(),
                id: z.string().regex(/^custom-[a-z0-9]{4,24}$/),
                enabled: z.boolean().default(true),
                showIf: z.union([
                    z.object({
                        answer: z.string(),
                        anyOf: z.array(z.enum([
                            'CURRENT_JOB',
                            'NEXT_ROLE',
                            'CAREER_CHANGE',
                            'GROW_BUSINESS',
                            'LEAD_PEOPLE',
                            'UNDERSTAND_BUSINESS',
                            'MONEY_DECISIONS',
                            'SOMETHING_ELSE',
                            'EXPLORING'
                        ])).min(1)
                    }),
                    z.object({
                        answer: z.string(),
                        anyOf: z.array(z.enum([
                            'STUDENT',
                            'EARLY_CAREER',
                            'PROFESSIONAL',
                            'MANAGER',
                            'DEPARTMENT_HEAD',
                            'EXECUTIVE',
                            'FOUNDER',
                            'FREELANCER',
                            'BETWEEN_ROLES',
                            'SOMETHING_ELSE'
                        ])).min(1)
                    })
                ]).optional(),
                art: z.union([
                    z.object({
                        kind: z.string()
                    }),
                    z.object({
                        kind: z.string(),
                        uri: z.string().max(200000).regex(/^(https:\/\/|data:image\/(png|jpeg|webp|svg\+xml)[;,])/),
                        size: z.enum([
                            'small',
                            'medium',
                            'large'
                        ]).default('medium'),
                        fit: z.enum(['contain', 'cover']).default('contain'),
                        description: z.string().max(300).optional(),
                        decorative: z.boolean().default(false)
                    })
                ]).optional(),
                name: z.string().min(1).max(300),
                title: z.string().min(1).max(300),
                body: z.string().min(1).max(300).optional(),
                button: z.string().min(1).max(300)
            }),
            z.object({
                kind: z.string(),
                id: z.string().regex(/^custom-[a-z0-9]{4,24}$/),
                enabled: z.boolean().default(true),
                showIf: z.union([
                    z.object({
                        answer: z.string(),
                        anyOf: z.array(z.enum([
                            'CURRENT_JOB',
                            'NEXT_ROLE',
                            'CAREER_CHANGE',
                            'GROW_BUSINESS',
                            'LEAD_PEOPLE',
                            'UNDERSTAND_BUSINESS',
                            'MONEY_DECISIONS',
                            'SOMETHING_ELSE',
                            'EXPLORING'
                        ])).min(1)
                    }),
                    z.object({
                        answer: z.string(),
                        anyOf: z.array(z.enum([
                            'STUDENT',
                            'EARLY_CAREER',
                            'PROFESSIONAL',
                            'MANAGER',
                            'DEPARTMENT_HEAD',
                            'EXECUTIVE',
                            'FOUNDER',
                            'FREELANCER',
                            'BETWEEN_ROLES',
                            'SOMETHING_ELSE'
                        ])).min(1)
                    })
                ]).optional(),
                art: z.union([
                    z.object({
                        kind: z.string()
                    }),
                    z.object({
                        kind: z.string(),
                        uri: z.string().max(200000).regex(/^(https:\/\/|data:image\/(png|jpeg|webp|svg\+xml)[;,])/),
                        size: z.enum([
                            'small',
                            'medium',
                            'large'
                        ]).default('medium'),
                        fit: z.enum(['contain', 'cover']).default('contain'),
                        description: z.string().max(300).optional(),
                        decorative: z.boolean().default(false)
                    })
                ]).optional(),
                name: z.string().min(1).max(300),
                title: z.string().min(1).max(300),
                body: z.string().min(1).max(300).optional(),
                options: z.array(z.object({
                    id: z.string().regex(/^[a-z0-9-]{1,40}$/),
                    label: z.string().min(1).max(300)
                })).max(12),
                multiple: z.boolean().default(false),
                optional: z.boolean().default(false),
                button: z.string().min(1).max(300),
                skipLabel: z.string().min(1).max(300).optional()
            })
        ])).max(60).default([
            {
                kind: 'BUILT_IN',
                id: 'WELCOME',
                enabled: true
            },
            {
                kind: 'BUILT_IN',
                id: 'THEME',
                enabled: true
            },
            {
                kind: 'BUILT_IN',
                id: 'MEET_LEO',
                enabled: true
            },
            {
                kind: 'BUILT_IN',
                id: 'GOAL',
                enabled: true
            },
            {
                kind: 'BUILT_IN',
                id: 'INTERESTS',
                enabled: true
            },
            {
                kind: 'BUILT_IN',
                id: 'STARTING_FOCUS',
                enabled: true
            },
            {
                kind: 'BUILT_IN',
                id: 'WORK_CONTEXT',
                enabled: true
            },
            {
                kind: 'BUILT_IN',
                id: 'FAMILIARITY',
                enabled: true
            },
            {
                kind: 'BUILT_IN',
                id: 'DAILY_PACE',
                enabled: true
            },
            {
                kind: 'BUILT_IN',
                id: 'STREAK_INTRO',
                enabled: true
            },
            {
                kind: 'BUILT_IN',
                id: 'STREAK_GOAL',
                enabled: true
            },
            {
                kind: 'BUILT_IN',
                id: 'PATH',
                enabled: true
            },
            {
                kind: 'BUILT_IN',
                id: 'FIRST_CHALLENGE',
                enabled: true
            },
            {
                kind: 'BUILT_IN',
                id: 'COMPLETION',
                enabled: true
            },
            {
                kind: 'BUILT_IN',
                id: 'REMINDER',
                enabled: true
            },
            {
                kind: 'BUILT_IN',
                id: 'ACCOUNT',
                enabled: true
            }
        ])
    }),
    checks: z.array(z.object({
        topic: z.enum([
            'MARKETING',
            'FINANCE',
            'STRATEGY',
            'LEADERSHIP',
            'SALES',
            'NEGOTIATION',
            'ENTREPRENEURSHIP',
            'PUBLIC_SPEAKING',
            'COMMUNICATION',
            'OPERATIONS',
            'DECISIONS',
            'BUSINESS_FUNDAMENTALS',
            'TEAM_MANAGEMENT',
            'HIRING',
            'ORGANIZATIONAL_BEHAVIOR',
            'PRODUCT_MANAGEMENT',
            'AI',
            'INNOVATION',
            'PROJECT_MANAGEMENT',
            'BUSINESS_ANALYTICS',
            'CAREER',
            'PERSONAL_FINANCE',
            'ECONOMICS'
        ]),
        problem: z.union([
            z.enum(['NO_NEXT_PUBLISHED']),
            z.unknown()
        ])
    })),
    problems: z.array(z.object({
        step: z.string(),
        level: z.enum(['block', 'warn']),
        message: z.string()
    })),
    challenge: z.union([
        z.object({
            lessonId: z.string().min(1),
            title: z.string(),
            questions: z.array(z.object({
                sceneId: z.string().min(1),
                kind: z.string(),
                prompt: z.string()
            }))
        }),
        z.unknown()
    ])
});
export const zOnboardingConfigDto = z.object({
    starts: z.array(z.object({
        topic: z.enum([
            'MARKETING',
            'FINANCE',
            'STRATEGY',
            'LEADERSHIP',
            'SALES',
            'NEGOTIATION',
            'ENTREPRENEURSHIP',
            'PUBLIC_SPEAKING',
            'COMMUNICATION',
            'OPERATIONS',
            'DECISIONS',
            'BUSINESS_FUNDAMENTALS',
            'TEAM_MANAGEMENT',
            'HIRING',
            'ORGANIZATIONAL_BEHAVIOR',
            'PRODUCT_MANAGEMENT',
            'AI',
            'INNOVATION',
            'PROJECT_MANAGEMENT',
            'BUSINESS_ANALYTICS',
            'CAREER',
            'PERSONAL_FINANCE',
            'ECONOMICS'
        ]),
        next: z.array(z.string().min(1).max(200).regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/)).min(1).max(20)
    })).max(23),
    suggestions: z.array(z.object({
        goal: z.enum([
            'CURRENT_JOB',
            'NEXT_ROLE',
            'CAREER_CHANGE',
            'GROW_BUSINESS',
            'LEAD_PEOPLE',
            'UNDERSTAND_BUSINESS',
            'MONEY_DECISIONS',
            'SOMETHING_ELSE',
            'EXPLORING'
        ]),
        topics: z.array(z.enum([
            'MARKETING',
            'FINANCE',
            'STRATEGY',
            'LEADERSHIP',
            'SALES',
            'NEGOTIATION',
            'ENTREPRENEURSHIP',
            'PUBLIC_SPEAKING',
            'COMMUNICATION',
            'OPERATIONS',
            'DECISIONS',
            'BUSINESS_FUNDAMENTALS',
            'TEAM_MANAGEMENT',
            'HIRING',
            'ORGANIZATIONAL_BEHAVIOR',
            'PRODUCT_MANAGEMENT',
            'AI',
            'INNOVATION',
            'PROJECT_MANAGEMENT',
            'BUSINESS_ANALYTICS',
            'CAREER',
            'PERSONAL_FINANCE',
            'ECONOMICS'
        ])).min(1).max(5)
    })).max(9),
    copy: z.array(z.object({
        key: z.string().max(80).regex(/^[A-Za-z0-9_.]+$/),
        text: z.string().min(1).max(300)
    })).max(500).optional().default([]),
    flow: z.array(z.union([
        z.object({
            kind: z.string(),
            id: z.enum([
                'WELCOME',
                'THEME',
                'MEET_LEO',
                'GOAL',
                'INTERESTS',
                'STARTING_FOCUS',
                'WORK_CONTEXT',
                'FAMILIARITY',
                'DAILY_PACE',
                'STREAK_INTRO',
                'STREAK_GOAL',
                'PATH',
                'FIRST_CHALLENGE',
                'COMPLETION',
                'REMINDER',
                'ACCOUNT'
            ]),
            enabled: z.boolean().optional().default(true),
            showIf: z.union([
                z.object({
                    answer: z.string(),
                    anyOf: z.array(z.enum([
                        'CURRENT_JOB',
                        'NEXT_ROLE',
                        'CAREER_CHANGE',
                        'GROW_BUSINESS',
                        'LEAD_PEOPLE',
                        'UNDERSTAND_BUSINESS',
                        'MONEY_DECISIONS',
                        'SOMETHING_ELSE',
                        'EXPLORING'
                    ])).min(1)
                }),
                z.object({
                    answer: z.string(),
                    anyOf: z.array(z.enum([
                        'STUDENT',
                        'EARLY_CAREER',
                        'PROFESSIONAL',
                        'MANAGER',
                        'DEPARTMENT_HEAD',
                        'EXECUTIVE',
                        'FOUNDER',
                        'FREELANCER',
                        'BETWEEN_ROLES',
                        'SOMETHING_ELSE'
                    ])).min(1)
                })
            ]).optional(),
            art: z.union([
                z.object({
                    kind: z.string()
                }),
                z.object({
                    kind: z.string(),
                    uri: z.string().max(200000).regex(/^(https:\/\/|data:image\/(png|jpeg|webp|svg\+xml)[;,])/),
                    size: z.enum([
                        'small',
                        'medium',
                        'large'
                    ]).optional().default('medium'),
                    fit: z.enum(['contain', 'cover']).optional().default('contain'),
                    description: z.string().max(300).optional(),
                    decorative: z.boolean().optional().default(false)
                })
            ]).optional(),
            limit: z.union([
                z.literal(1),
                z.literal(2),
                z.literal(3)
            ]).optional(),
            order: z.array(z.string()).optional()
        }),
        z.object({
            kind: z.string(),
            id: z.string().regex(/^custom-[a-z0-9]{4,24}$/),
            enabled: z.boolean().optional().default(true),
            showIf: z.union([
                z.object({
                    answer: z.string(),
                    anyOf: z.array(z.enum([
                        'CURRENT_JOB',
                        'NEXT_ROLE',
                        'CAREER_CHANGE',
                        'GROW_BUSINESS',
                        'LEAD_PEOPLE',
                        'UNDERSTAND_BUSINESS',
                        'MONEY_DECISIONS',
                        'SOMETHING_ELSE',
                        'EXPLORING'
                    ])).min(1)
                }),
                z.object({
                    answer: z.string(),
                    anyOf: z.array(z.enum([
                        'STUDENT',
                        'EARLY_CAREER',
                        'PROFESSIONAL',
                        'MANAGER',
                        'DEPARTMENT_HEAD',
                        'EXECUTIVE',
                        'FOUNDER',
                        'FREELANCER',
                        'BETWEEN_ROLES',
                        'SOMETHING_ELSE'
                    ])).min(1)
                })
            ]).optional(),
            art: z.union([
                z.object({
                    kind: z.string()
                }),
                z.object({
                    kind: z.string(),
                    uri: z.string().max(200000).regex(/^(https:\/\/|data:image\/(png|jpeg|webp|svg\+xml)[;,])/),
                    size: z.enum([
                        'small',
                        'medium',
                        'large'
                    ]).optional().default('medium'),
                    fit: z.enum(['contain', 'cover']).optional().default('contain'),
                    description: z.string().max(300).optional(),
                    decorative: z.boolean().optional().default(false)
                })
            ]).optional(),
            name: z.string().min(1).max(300),
            title: z.string().min(1).max(300),
            body: z.string().min(1).max(300).optional(),
            button: z.string().min(1).max(300)
        }),
        z.object({
            kind: z.string(),
            id: z.string().regex(/^custom-[a-z0-9]{4,24}$/),
            enabled: z.boolean().optional().default(true),
            showIf: z.union([
                z.object({
                    answer: z.string(),
                    anyOf: z.array(z.enum([
                        'CURRENT_JOB',
                        'NEXT_ROLE',
                        'CAREER_CHANGE',
                        'GROW_BUSINESS',
                        'LEAD_PEOPLE',
                        'UNDERSTAND_BUSINESS',
                        'MONEY_DECISIONS',
                        'SOMETHING_ELSE',
                        'EXPLORING'
                    ])).min(1)
                }),
                z.object({
                    answer: z.string(),
                    anyOf: z.array(z.enum([
                        'STUDENT',
                        'EARLY_CAREER',
                        'PROFESSIONAL',
                        'MANAGER',
                        'DEPARTMENT_HEAD',
                        'EXECUTIVE',
                        'FOUNDER',
                        'FREELANCER',
                        'BETWEEN_ROLES',
                        'SOMETHING_ELSE'
                    ])).min(1)
                })
            ]).optional(),
            art: z.union([
                z.object({
                    kind: z.string()
                }),
                z.object({
                    kind: z.string(),
                    uri: z.string().max(200000).regex(/^(https:\/\/|data:image\/(png|jpeg|webp|svg\+xml)[;,])/),
                    size: z.enum([
                        'small',
                        'medium',
                        'large'
                    ]).optional().default('medium'),
                    fit: z.enum(['contain', 'cover']).optional().default('contain'),
                    description: z.string().max(300).optional(),
                    decorative: z.boolean().optional().default(false)
                })
            ]).optional(),
            name: z.string().min(1).max(300),
            title: z.string().min(1).max(300),
            body: z.string().min(1).max(300).optional(),
            options: z.array(z.object({
                id: z.string().regex(/^[a-z0-9-]{1,40}$/),
                label: z.string().min(1).max(300)
            })).max(12),
            multiple: z.boolean().optional().default(false),
            optional: z.boolean().optional().default(false),
            button: z.string().min(1).max(300),
            skipLabel: z.string().min(1).max(300).optional()
        })
    ])).max(60).optional().default([
        {
            kind: 'BUILT_IN',
            id: 'WELCOME',
            enabled: true
        },
        {
            kind: 'BUILT_IN',
            id: 'THEME',
            enabled: true
        },
        {
            kind: 'BUILT_IN',
            id: 'MEET_LEO',
            enabled: true
        },
        {
            kind: 'BUILT_IN',
            id: 'GOAL',
            enabled: true
        },
        {
            kind: 'BUILT_IN',
            id: 'INTERESTS',
            enabled: true
        },
        {
            kind: 'BUILT_IN',
            id: 'STARTING_FOCUS',
            enabled: true
        },
        {
            kind: 'BUILT_IN',
            id: 'WORK_CONTEXT',
            enabled: true
        },
        {
            kind: 'BUILT_IN',
            id: 'FAMILIARITY',
            enabled: true
        },
        {
            kind: 'BUILT_IN',
            id: 'DAILY_PACE',
            enabled: true
        },
        {
            kind: 'BUILT_IN',
            id: 'STREAK_INTRO',
            enabled: true
        },
        {
            kind: 'BUILT_IN',
            id: 'STREAK_GOAL',
            enabled: true
        },
        {
            kind: 'BUILT_IN',
            id: 'PATH',
            enabled: true
        },
        {
            kind: 'BUILT_IN',
            id: 'FIRST_CHALLENGE',
            enabled: true
        },
        {
            kind: 'BUILT_IN',
            id: 'COMPLETION',
            enabled: true
        },
        {
            kind: 'BUILT_IN',
            id: 'REMINDER',
            enabled: true
        },
        {
            kind: 'BUILT_IN',
            id: 'ACCOUNT',
            enabled: true
        }
    ])
});
export const zOnboardingConfigVersionDtoOutput = z.object({
    version: z.int().gte(-9007199254740991).lte(9007199254740991),
    status: z.enum(['DRAFT', 'PUBLISHED']),
    config: z.object({
        starts: z.array(z.object({
            topic: z.enum([
                'MARKETING',
                'FINANCE',
                'STRATEGY',
                'LEADERSHIP',
                'SALES',
                'NEGOTIATION',
                'ENTREPRENEURSHIP',
                'PUBLIC_SPEAKING',
                'COMMUNICATION',
                'OPERATIONS',
                'DECISIONS',
                'BUSINESS_FUNDAMENTALS',
                'TEAM_MANAGEMENT',
                'HIRING',
                'ORGANIZATIONAL_BEHAVIOR',
                'PRODUCT_MANAGEMENT',
                'AI',
                'INNOVATION',
                'PROJECT_MANAGEMENT',
                'BUSINESS_ANALYTICS',
                'CAREER',
                'PERSONAL_FINANCE',
                'ECONOMICS'
            ]),
            next: z.array(z.string().min(1).max(200).regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/)).min(1).max(20)
        })).max(23),
        suggestions: z.array(z.object({
            goal: z.enum([
                'CURRENT_JOB',
                'NEXT_ROLE',
                'CAREER_CHANGE',
                'GROW_BUSINESS',
                'LEAD_PEOPLE',
                'UNDERSTAND_BUSINESS',
                'MONEY_DECISIONS',
                'SOMETHING_ELSE',
                'EXPLORING'
            ]),
            topics: z.array(z.enum([
                'MARKETING',
                'FINANCE',
                'STRATEGY',
                'LEADERSHIP',
                'SALES',
                'NEGOTIATION',
                'ENTREPRENEURSHIP',
                'PUBLIC_SPEAKING',
                'COMMUNICATION',
                'OPERATIONS',
                'DECISIONS',
                'BUSINESS_FUNDAMENTALS',
                'TEAM_MANAGEMENT',
                'HIRING',
                'ORGANIZATIONAL_BEHAVIOR',
                'PRODUCT_MANAGEMENT',
                'AI',
                'INNOVATION',
                'PROJECT_MANAGEMENT',
                'BUSINESS_ANALYTICS',
                'CAREER',
                'PERSONAL_FINANCE',
                'ECONOMICS'
            ])).min(1).max(5)
        })).max(9),
        copy: z.array(z.object({
            key: z.string().max(80).regex(/^[A-Za-z0-9_.]+$/),
            text: z.string().min(1).max(300)
        })).max(500).default([]),
        flow: z.array(z.union([
            z.object({
                kind: z.string(),
                id: z.enum([
                    'WELCOME',
                    'THEME',
                    'MEET_LEO',
                    'GOAL',
                    'INTERESTS',
                    'STARTING_FOCUS',
                    'WORK_CONTEXT',
                    'FAMILIARITY',
                    'DAILY_PACE',
                    'STREAK_INTRO',
                    'STREAK_GOAL',
                    'PATH',
                    'FIRST_CHALLENGE',
                    'COMPLETION',
                    'REMINDER',
                    'ACCOUNT'
                ]),
                enabled: z.boolean().default(true),
                showIf: z.union([
                    z.object({
                        answer: z.string(),
                        anyOf: z.array(z.enum([
                            'CURRENT_JOB',
                            'NEXT_ROLE',
                            'CAREER_CHANGE',
                            'GROW_BUSINESS',
                            'LEAD_PEOPLE',
                            'UNDERSTAND_BUSINESS',
                            'MONEY_DECISIONS',
                            'SOMETHING_ELSE',
                            'EXPLORING'
                        ])).min(1)
                    }),
                    z.object({
                        answer: z.string(),
                        anyOf: z.array(z.enum([
                            'STUDENT',
                            'EARLY_CAREER',
                            'PROFESSIONAL',
                            'MANAGER',
                            'DEPARTMENT_HEAD',
                            'EXECUTIVE',
                            'FOUNDER',
                            'FREELANCER',
                            'BETWEEN_ROLES',
                            'SOMETHING_ELSE'
                        ])).min(1)
                    })
                ]).optional(),
                art: z.union([
                    z.object({
                        kind: z.string()
                    }),
                    z.object({
                        kind: z.string(),
                        uri: z.string().max(200000).regex(/^(https:\/\/|data:image\/(png|jpeg|webp|svg\+xml)[;,])/),
                        size: z.enum([
                            'small',
                            'medium',
                            'large'
                        ]).default('medium'),
                        fit: z.enum(['contain', 'cover']).default('contain'),
                        description: z.string().max(300).optional(),
                        decorative: z.boolean().default(false)
                    })
                ]).optional(),
                limit: z.union([
                    z.literal(1),
                    z.literal(2),
                    z.literal(3)
                ]).optional(),
                order: z.array(z.string()).optional()
            }),
            z.object({
                kind: z.string(),
                id: z.string().regex(/^custom-[a-z0-9]{4,24}$/),
                enabled: z.boolean().default(true),
                showIf: z.union([
                    z.object({
                        answer: z.string(),
                        anyOf: z.array(z.enum([
                            'CURRENT_JOB',
                            'NEXT_ROLE',
                            'CAREER_CHANGE',
                            'GROW_BUSINESS',
                            'LEAD_PEOPLE',
                            'UNDERSTAND_BUSINESS',
                            'MONEY_DECISIONS',
                            'SOMETHING_ELSE',
                            'EXPLORING'
                        ])).min(1)
                    }),
                    z.object({
                        answer: z.string(),
                        anyOf: z.array(z.enum([
                            'STUDENT',
                            'EARLY_CAREER',
                            'PROFESSIONAL',
                            'MANAGER',
                            'DEPARTMENT_HEAD',
                            'EXECUTIVE',
                            'FOUNDER',
                            'FREELANCER',
                            'BETWEEN_ROLES',
                            'SOMETHING_ELSE'
                        ])).min(1)
                    })
                ]).optional(),
                art: z.union([
                    z.object({
                        kind: z.string()
                    }),
                    z.object({
                        kind: z.string(),
                        uri: z.string().max(200000).regex(/^(https:\/\/|data:image\/(png|jpeg|webp|svg\+xml)[;,])/),
                        size: z.enum([
                            'small',
                            'medium',
                            'large'
                        ]).default('medium'),
                        fit: z.enum(['contain', 'cover']).default('contain'),
                        description: z.string().max(300).optional(),
                        decorative: z.boolean().default(false)
                    })
                ]).optional(),
                name: z.string().min(1).max(300),
                title: z.string().min(1).max(300),
                body: z.string().min(1).max(300).optional(),
                button: z.string().min(1).max(300)
            }),
            z.object({
                kind: z.string(),
                id: z.string().regex(/^custom-[a-z0-9]{4,24}$/),
                enabled: z.boolean().default(true),
                showIf: z.union([
                    z.object({
                        answer: z.string(),
                        anyOf: z.array(z.enum([
                            'CURRENT_JOB',
                            'NEXT_ROLE',
                            'CAREER_CHANGE',
                            'GROW_BUSINESS',
                            'LEAD_PEOPLE',
                            'UNDERSTAND_BUSINESS',
                            'MONEY_DECISIONS',
                            'SOMETHING_ELSE',
                            'EXPLORING'
                        ])).min(1)
                    }),
                    z.object({
                        answer: z.string(),
                        anyOf: z.array(z.enum([
                            'STUDENT',
                            'EARLY_CAREER',
                            'PROFESSIONAL',
                            'MANAGER',
                            'DEPARTMENT_HEAD',
                            'EXECUTIVE',
                            'FOUNDER',
                            'FREELANCER',
                            'BETWEEN_ROLES',
                            'SOMETHING_ELSE'
                        ])).min(1)
                    })
                ]).optional(),
                art: z.union([
                    z.object({
                        kind: z.string()
                    }),
                    z.object({
                        kind: z.string(),
                        uri: z.string().max(200000).regex(/^(https:\/\/|data:image\/(png|jpeg|webp|svg\+xml)[;,])/),
                        size: z.enum([
                            'small',
                            'medium',
                            'large'
                        ]).default('medium'),
                        fit: z.enum(['contain', 'cover']).default('contain'),
                        description: z.string().max(300).optional(),
                        decorative: z.boolean().default(false)
                    })
                ]).optional(),
                name: z.string().min(1).max(300),
                title: z.string().min(1).max(300),
                body: z.string().min(1).max(300).optional(),
                options: z.array(z.object({
                    id: z.string().regex(/^[a-z0-9-]{1,40}$/),
                    label: z.string().min(1).max(300)
                })).max(12),
                multiple: z.boolean().default(false),
                optional: z.boolean().default(false),
                button: z.string().min(1).max(300),
                skipLabel: z.string().min(1).max(300).optional()
            })
        ])).max(60).default([
            {
                kind: 'BUILT_IN',
                id: 'WELCOME',
                enabled: true
            },
            {
                kind: 'BUILT_IN',
                id: 'THEME',
                enabled: true
            },
            {
                kind: 'BUILT_IN',
                id: 'MEET_LEO',
                enabled: true
            },
            {
                kind: 'BUILT_IN',
                id: 'GOAL',
                enabled: true
            },
            {
                kind: 'BUILT_IN',
                id: 'INTERESTS',
                enabled: true
            },
            {
                kind: 'BUILT_IN',
                id: 'STARTING_FOCUS',
                enabled: true
            },
            {
                kind: 'BUILT_IN',
                id: 'WORK_CONTEXT',
                enabled: true
            },
            {
                kind: 'BUILT_IN',
                id: 'FAMILIARITY',
                enabled: true
            },
            {
                kind: 'BUILT_IN',
                id: 'DAILY_PACE',
                enabled: true
            },
            {
                kind: 'BUILT_IN',
                id: 'STREAK_INTRO',
                enabled: true
            },
            {
                kind: 'BUILT_IN',
                id: 'STREAK_GOAL',
                enabled: true
            },
            {
                kind: 'BUILT_IN',
                id: 'PATH',
                enabled: true
            },
            {
                kind: 'BUILT_IN',
                id: 'FIRST_CHALLENGE',
                enabled: true
            },
            {
                kind: 'BUILT_IN',
                id: 'COMPLETION',
                enabled: true
            },
            {
                kind: 'BUILT_IN',
                id: 'REMINDER',
                enabled: true
            },
            {
                kind: 'BUILT_IN',
                id: 'ACCOUNT',
                enabled: true
            }
        ])
    }),
    publishedAt: z.union([
        z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
        z.unknown()
    ]),
    restoredFrom: z.union([
        z.int().gte(-9007199254740991).lte(9007199254740991),
        z.unknown()
    ]),
    updatedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/)
});
export const zRestoreOnboardingConfigDto = z.object({
    version: z.int().lte(9007199254740991)
});
export const zStartAttemptDtoOutput = z.object({
    attemptId: z.string().min(1)
});
export const zLessonResumeDtoOutput = z.object({
    finished: z.boolean(),
    resume: z.object({
        attemptId: z.string().min(1),
        openAt: z.string().min(1),
        playedMs: z.int().gte(0).lte(86400000),
        draft: z.union([
            z.object({
                kind: z.string(),
                selected: z.array(z.string().min(1)).min(1).max(8)
            }),
            z.object({
                kind: z.string(),
                order: z.array(z.string().min(1)).min(2).max(8)
            }),
            z.object({
                kind: z.string(),
                placements: z.array(z.object({
                    itemId: z.string().min(1),
                    bucketId: z.string().min(1)
                })).min(1).max(12)
            }),
            z.object({
                kind: z.string(),
                value: z.number()
            }),
            z.object({
                kind: z.string(),
                allocations: z.array(z.object({
                    itemId: z.string().min(1),
                    amount: z.number().gte(0)
                })).min(1).max(8)
            }),
            z.object({
                kind: z.string(),
                text: z.string().min(1).max(4000)
            })
        ]).optional()
    }).optional()
});
export const zSubmitAnswerDto = z.object({
    sceneId: z.string().min(1),
    elapsedMs: z.int().gte(0).lte(3600000),
    answer: z.union([
        z.object({
            kind: z.string(),
            selected: z.array(z.string().min(1)).min(1).max(8)
        }),
        z.object({
            kind: z.string(),
            order: z.array(z.string().min(1)).min(2).max(8)
        }),
        z.object({
            kind: z.string(),
            placements: z.array(z.object({
                itemId: z.string().min(1),
                bucketId: z.string().min(1)
            })).min(1).max(12)
        }),
        z.object({
            kind: z.string(),
            value: z.number()
        }),
        z.object({
            kind: z.string(),
            allocations: z.array(z.object({
                itemId: z.string().min(1),
                amount: z.number().gte(0)
            })).min(1).max(8)
        }),
        z.object({
            kind: z.string(),
            text: z.string().min(1).max(4000)
        })
    ])
});
export const zVerdictDtoOutput = z.object({
    correct: z.boolean(),
    scorePct: z.int().gte(0).lte(100),
    explanation: z.string(),
    feedback: z.string().optional(),
    allocation: z.array(z.object({
        itemId: z.string().min(1),
        amount: z.number(),
        min: z.number(),
        max: z.number(),
        example: z.number()
    })).max(8).optional(),
    placement: z.array(z.object({
        itemId: z.string().min(1),
        bucketId: z.union([
            z.string().min(1),
            z.unknown()
        ]),
        correctBucketId: z.string().min(1)
    })).max(12).optional(),
    ranking: z.array(z.object({
        itemId: z.string().min(1),
        position: z.union([
            z.int().gte(1).lte(9007199254740991),
            z.unknown()
        ]),
        correctPosition: z.int().gte(1).lte(9007199254740991)
    })).max(8).optional(),
    estimate: z.object({
        value: z.number(),
        min: z.number(),
        max: z.number()
    }).optional(),
    correctOptionIds: z.array(z.string().min(1)).max(8).optional(),
    scored: z.boolean().optional()
});
export const zReachSceneDto = z.object({
    sceneId: z.string().min(1),
    playedMs: z.int().gte(0).lte(86400000).optional(),
    draft: z.union([
        z.object({
            kind: z.string(),
            selected: z.array(z.string().min(1)).min(1).max(8)
        }),
        z.object({
            kind: z.string(),
            order: z.array(z.string().min(1)).min(2).max(8)
        }),
        z.object({
            kind: z.string(),
            placements: z.array(z.object({
                itemId: z.string().min(1),
                bucketId: z.string().min(1)
            })).min(1).max(12)
        }),
        z.object({
            kind: z.string(),
            value: z.number()
        }),
        z.object({
            kind: z.string(),
            allocations: z.array(z.object({
                itemId: z.string().min(1),
                amount: z.number().gte(0)
            })).min(1).max(8)
        }),
        z.object({
            kind: z.string(),
            text: z.string().min(1).max(4000)
        })
    ]).optional()
});
export const zAttemptPositionDtoOutput = z.object({
    sceneId: z.string().min(1)
});
export const zCompleteAttemptDto = z.object({
    utcOffsetMinutes: z.int().gte(-720).lte(840),
    collection: z.string().min(1).max(200).regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/).optional()
});
export const zAttemptResultDtoOutput = z.object({
    attemptId: z.string().min(1),
    scorePct: z.int().gte(0).lte(100),
    xpAwarded: z.int().gte(0).lte(9007199254740991),
    localDate: z.iso.date().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))$/),
    tally: z.object({
        correct: z.int().gte(0).lte(9007199254740991),
        total: z.int().gte(0).lte(9007199254740991)
    }),
    reward: z.object({
        xpTotal: z.int().gte(0).lte(9007199254740991),
        streakDays: z.int().gte(0).lte(9007199254740991),
        streakExtended: z.boolean(),
        badgesEarned: z.array(z.object({
            id: z.string().min(1),
            name: z.string().min(1).max(40),
            hint: z.string().min(1).max(120),
            tone: z.enum([
                'brand',
                'streak',
                'mastery'
            ]),
            glyph: z.enum([
                'check',
                'flame',
                'price',
                'chart',
                'mic',
                'route'
            ])
        }))
    }),
    pathComplete: z.object({
        slug: z.string().min(1).max(200).regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/),
        title: z.string().min(1).max(120),
        takeaway: z.string().min(1).max(300),
        lessonsDone: z.int().gte(1).lte(9007199254740991),
        xp: z.int().gte(0).lte(9007199254740991),
        next: z.object({
            slug: z.string().min(1).max(200).regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/),
            kind: z.enum([
                'COURSE',
                'MODULE',
                'PATH'
            ]),
            title: z.string().min(1).max(120),
            summary: z.string().min(1).max(300),
            family: z.enum([
                'growth',
                'finance',
                'people'
            ]),
            palette: z.object({
                primary: z.string().regex(/^#[0-9a-f]{6}$/),
                secondary: z.string().regex(/^#[0-9a-f]{6}$/)
            }).optional(),
            lessonCount: z.int().gte(1).lte(9007199254740991),
            estimatedMinutes: z.int().gte(0).lte(9007199254740991),
            firstLessonSlug: z.string().min(1).max(200).regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/)
        }).optional()
    }).optional(),
    closed: z.union([
        z.object({
            kind: z.string(),
            slug: z.string().min(1).max(200).regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/),
            title: z.string().min(1).max(120)
        }),
        z.object({
            kind: z.string(),
            slug: z.string().min(1).max(200).regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/),
            title: z.string().min(1).max(120),
            can: z.string().min(1).max(300).optional()
        })
    ]).optional(),
    next: z.object({
        slug: z.string().min(1).max(200).regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/),
        title: z.string().min(1)
    }).optional(),
    goalMet: z.boolean(),
    goalReached: z.boolean(),
    replay: z.boolean()
});
export const zSubmitLessonFeedbackDto = z.object({
    helpful: z.boolean(),
    reasons: z.array(z.enum([
        'CONFUSING',
        'TOO_BASIC',
        'TOO_DIFFICULT',
        'NOT_RELEVANT',
        'SOMETHING_WRONG'
    ])).max(5).optional(),
    appVersion: z.string().min(1).max(80),
    platform: z.enum([
        'ios',
        'android',
        'web'
    ]).optional()
});
export const zLessonFeedbackDtoOutput = z.object({
    helpful: z.boolean(),
    reasons: z.array(z.enum([
        'CONFUSING',
        'TOO_BASIC',
        'TOO_DIFFICULT',
        'NOT_RELEVANT',
        'SOMETHING_WRONG'
    ])),
    lessonVersion: z.int().gte(1).lte(9007199254740991),
    answeredAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/)
});
export const zSceneBookmarkDtoOutput = z.object({
    lessonSlug: z.string().min(1).max(200).regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/),
    sceneId: z.string().min(1),
    savedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/)
});
export const zLessonBookmarksDtoOutput = z.object({
    sceneIds: z.array(z.string().min(1)).max(64)
});
export const zSavedScenesDtoOutput = z.object({
    items: z.array(z.object({
        lessonSlug: z.string().min(1).max(200).regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/),
        lessonTitle: z.string().min(1),
        sceneId: z.string().min(1),
        scenePosition: z.int().gte(1).lte(9007199254740991),
        scenePrompt: z.string().min(1),
        savedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/)
    })),
    nextCursor: z.union([
        z.string().min(1),
        z.unknown()
    ])
});
export const zCreateSceneReportDto = z.object({
    kind: z.enum([
        'CONTENT_ERROR',
        'SPEECH_RECOGNITION',
        'TYPO',
        'TECHNICAL',
        'AUDIO',
        'FEEDBACK',
        'OTHER'
    ]),
    details: z.string().min(1).max(1000).optional(),
    appVersion: z.string().min(1).max(80),
    attemptId: z.string().min(1).optional()
});
export const zSceneReportDtoOutput = z.object({
    id: z.string().min(1),
    kind: z.enum([
        'CONTENT_ERROR',
        'SPEECH_RECOGNITION',
        'TYPO',
        'TECHNICAL',
        'AUDIO',
        'FEEDBACK',
        'OTHER'
    ]),
    status: z.enum([
        'OPEN',
        'TRIAGED',
        'RESOLVED',
        'DISMISSED'
    ]),
    createdAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
    updatedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/)
});
export const zSavedTermDtoOutput = z.object({
    term: z.string().min(1).max(80),
    definition: z.string().min(1),
    taughtIn: z.object({
        id: z.string().min(1),
        slug: z.string().min(1).max(200).regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/),
        title: z.string().min(1)
    }).optional(),
    lesson: z.object({
        id: z.string().min(1),
        slug: z.string().min(1).max(200).regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/),
        title: z.string().min(1)
    }),
    savedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/)
});
export const zLessonSavedTermsDtoOutput = z.object({
    terms: z.array(z.string().min(1).max(80)).max(12)
});
export const zSavedTermsDtoOutput = z.object({
    items: z.array(z.object({
        term: z.string().min(1).max(80),
        definition: z.string().min(1),
        taughtIn: z.object({
            id: z.string().min(1),
            slug: z.string().min(1).max(200).regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/),
            title: z.string().min(1)
        }).optional(),
        lesson: z.object({
            id: z.string().min(1),
            slug: z.string().min(1).max(200).regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/),
            title: z.string().min(1)
        }),
        savedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/)
    })),
    nextCursor: z.union([
        z.string().min(1),
        z.unknown()
    ])
});
export const zShareItemDtoOutput = z.object({
    kind: z.enum([
        'LESSON',
        'COURSE',
        'MODULE',
        'PATH',
        'SHORT'
    ]),
    title: z.string().min(1).max(400),
    summary: z.string().min(1).max(300),
    question: z.string().min(1).max(400).optional(),
    imageUrl: z.url().optional(),
    minutes: z.int().gte(1).lte(9007199254740991).optional()
});
export const zSharedScoreDtoOutput = z.object({
    score: z.union([
        z.object({
            kind: z.string(),
            lesson: z.object({
                slug: z.string().min(1).max(200).regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/),
                title: z.string().min(1).max(120)
            }),
            correct: z.int().gte(0).lte(9007199254740991),
            total: z.int().gte(0).lte(9007199254740991),
            xp: z.int().gte(0).lte(9007199254740991),
            date: z.iso.date().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))$/)
        }),
        z.object({
            kind: z.string(),
            path: z.object({
                slug: z.string().min(1).max(200).regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/),
                title: z.string().min(1).max(120)
            }),
            lessonsDone: z.int().gte(0).lte(9007199254740991),
            xp: z.int().gte(0).lte(9007199254740991),
            date: z.iso.date().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))$/)
        })
    ])
});
export const zScoreShareDtoOutput = z.object({
    token: z.string().regex(/^[A-Za-z0-9_-]{22}$/)
});
export const zShortsPageDtoOutput = z.object({
    items: z.array(z.object({
        id: z.string().min(1),
        takeaway: z.string().min(1).max(400),
        detail: z.string().min(1).optional(),
        visual: z.union([
            z.object({
                kind: z.string(),
                caption: z.string().min(1).max(120),
                max: z.number(),
                rows: z.array(z.object({
                    label: z.string().min(1).max(60),
                    value: z.number(),
                    previous: z.number().optional(),
                    display: z.string().min(1).max(24)
                })).min(1).max(4)
            }),
            z.object({
                kind: z.string(),
                caption: z.string().min(1).max(120),
                figures: z.array(z.object({
                    label: z.string().min(1).max(60),
                    value: z.string().min(1).max(24),
                    tone: z.enum([
                        'default',
                        'up',
                        'down',
                        'accent',
                        'streak'
                    ]).optional()
                })).min(2).max(4)
            }),
            z.object({
                kind: z.string(),
                caption: z.string().min(1).max(120),
                shares: z.array(z.object({
                    label: z.string().min(1).max(60),
                    value: z.number().gte(0),
                    display: z.string().min(1).max(24).optional()
                })).min(2).max(6)
            }),
            z.object({
                kind: z.string(),
                caption: z.string().min(1).max(120),
                stages: z.array(z.object({
                    label: z.string().min(1).max(60),
                    value: z.number().gte(0),
                    display: z.string().min(1).max(24)
                })).min(2).max(5)
            }),
            z.object({
                kind: z.string(),
                caption: z.string().min(1).max(120),
                start: z.object({
                    label: z.string().min(1).max(60),
                    value: z.number(),
                    display: z.string().min(1).max(24)
                }),
                steps: z.array(z.object({
                    label: z.string().min(1).max(60),
                    value: z.number(),
                    display: z.string().min(1).max(24)
                })).min(1).max(5),
                end: z.object({
                    label: z.string().min(1).max(60),
                    value: z.number(),
                    display: z.string().min(1).max(24)
                })
            }),
            z.object({
                kind: z.string(),
                caption: z.string().min(1).max(120),
                max: z.number(),
                min: z.number().optional(),
                rows: z.array(z.object({
                    label: z.string().min(1).max(60),
                    before: z.number(),
                    after: z.number(),
                    beforeDisplay: z.string().min(1).max(24),
                    afterDisplay: z.string().min(1).max(24)
                })).min(1).max(4)
            }),
            z.object({
                kind: z.string(),
                caption: z.string().min(1).max(120),
                x: z.object({
                    label: z.string().min(1).max(60),
                    low: z.string().min(1).max(40),
                    high: z.string().min(1).max(40)
                }),
                y: z.object({
                    label: z.string().min(1).max(60),
                    low: z.string().min(1).max(40),
                    high: z.string().min(1).max(40)
                }),
                quadrants: z.tuple([
                    z.string().min(1).max(40),
                    z.string().min(1).max(40),
                    z.string().min(1).max(40),
                    z.string().min(1).max(40)
                ]).optional(),
                items: z.array(z.object({
                    label: z.string().min(1).max(60),
                    x: z.number().gte(0).lte(1),
                    y: z.number().gte(0).lte(1)
                })).min(1).max(4)
            }),
            z.object({
                kind: z.string(),
                caption: z.string().min(1).max(120),
                steps: z.array(z.object({
                    label: z.string().min(1).max(60),
                    note: z.string().min(1).max(80).optional()
                })).min(2).max(5)
            }),
            z.object({
                kind: z.string(),
                caption: z.string().min(1).max(120),
                at: z.array(z.string().min(1).max(16)).min(2).max(8),
                min: z.number(),
                max: z.number(),
                series: z.array(z.object({
                    label: z.string().min(1).max(60),
                    values: z.array(z.number()).min(2).max(8),
                    display: z.string().min(1).max(24)
                })).min(1).max(6)
            }),
            z.object({
                kind: z.string(),
                caption: z.string().min(1).max(120),
                columns: z.array(z.string().min(1).max(40)).min(2).max(3),
                rows: z.array(z.object({
                    label: z.string().min(1).max(60),
                    cells: z.array(z.string().min(1).max(40)).max(3)
                })).min(2).max(6)
            }),
            z.object({
                kind: z.string(),
                caption: z.string().min(1).max(120),
                left: z.object({
                    name: z.string().min(1).max(60),
                    you: z.boolean().optional(),
                    character: z.enum([
                        'betty',
                        'david',
                        'rosa',
                        'kofi',
                        'priya',
                        'sam',
                        'noor',
                        'tomi',
                        'biscuit',
                        'bolt'
                    ]).optional(),
                    pose: z.enum([
                        'sit',
                        'lean-in',
                        'arms-crossed',
                        'hand-on-chin',
                        'wave'
                    ]).optional(),
                    facing: z.enum(['left', 'right']).optional(),
                    slot: z.enum([
                        'left',
                        'center',
                        'right'
                    ]).optional(),
                    reaction: z.enum([
                        'happy',
                        'worried',
                        'thinking'
                    ]).optional()
                }),
                right: z.object({
                    name: z.string().min(1).max(60),
                    you: z.boolean().optional(),
                    character: z.enum([
                        'betty',
                        'david',
                        'rosa',
                        'kofi',
                        'priya',
                        'sam',
                        'noor',
                        'tomi',
                        'biscuit',
                        'bolt'
                    ]).optional(),
                    pose: z.enum([
                        'sit',
                        'lean-in',
                        'arms-crossed',
                        'hand-on-chin',
                        'wave'
                    ]).optional(),
                    facing: z.enum(['left', 'right']).optional(),
                    slot: z.enum([
                        'left',
                        'center',
                        'right'
                    ]).optional(),
                    reaction: z.enum([
                        'happy',
                        'worried',
                        'thinking'
                    ]).optional()
                }),
                lines: z.array(z.object({
                    by: z.enum(['left', 'right']),
                    text: z.string().min(1).max(80).optional(),
                    sound: z.enum([
                        'bark',
                        'whine',
                        'growl',
                        'pant',
                        'meow',
                        'purr',
                        'hiss'
                    ]).optional(),
                    mood: z.enum([
                        'happy',
                        'worried',
                        'thinking'
                    ]).optional(),
                    thought: z.boolean().optional()
                })).min(1).max(4),
                awaiting: z.enum(['left', 'right']).optional(),
                props: z.array(z.string().max(40).regex(/^[a-z0-9]+(-[a-z0-9]+)*$/)).min(1).max(3).optional()
            }),
            z.object({
                kind: z.string(),
                caption: z.string().min(1).max(120),
                cast: z.array(z.object({
                    name: z.string().min(1).max(60),
                    you: z.boolean().optional(),
                    character: z.enum([
                        'betty',
                        'david',
                        'rosa',
                        'kofi',
                        'priya',
                        'sam',
                        'noor',
                        'tomi',
                        'biscuit',
                        'bolt'
                    ]).optional(),
                    pose: z.enum([
                        'sit',
                        'lean-in',
                        'arms-crossed',
                        'hand-on-chin',
                        'wave'
                    ]).optional(),
                    facing: z.enum(['left', 'right']).optional(),
                    slot: z.enum([
                        'left',
                        'center',
                        'right'
                    ]).optional(),
                    reaction: z.enum([
                        'happy',
                        'worried',
                        'thinking'
                    ]).optional(),
                    thought: z.string().min(1).max(80).optional()
                })).min(1).max(3),
                stakes: z.array(z.object({
                    label: z.string().min(1).max(60),
                    value: z.string().min(1).max(24),
                    tone: z.enum([
                        'default',
                        'up',
                        'down',
                        'accent',
                        'streak'
                    ]).optional()
                })).min(1).max(4).optional(),
                props: z.array(z.string().max(40).regex(/^[a-z0-9]+(-[a-z0-9]+)*$/)).min(1).max(3).optional()
            }),
            z.object({
                kind: z.string(),
                caption: z.string().min(1).max(120),
                left: z.object({
                    label: z.string().min(1).max(60),
                    gains: z.array(z.string().min(1).max(40)).min(1).max(3),
                    costs: z.array(z.string().min(1).max(40)).min(1).max(3)
                }),
                right: z.object({
                    label: z.string().min(1).max(60),
                    gains: z.array(z.string().min(1).max(40)).min(1).max(3),
                    costs: z.array(z.string().min(1).max(40)).min(1).max(3)
                })
            }),
            z.object({
                kind: z.string(),
                caption: z.string().min(1).max(120),
                fork: z.string().min(1).max(80),
                branches: z.array(z.object({
                    label: z.string().min(1).max(60),
                    outcome: z.string().min(1).max(60),
                    tone: z.enum(['up', 'down']).optional()
                })).min(2).max(3)
            }),
            z.object({
                kind: z.string(),
                caption: z.string().min(1).max(120),
                moments: z.array(z.object({
                    at: z.string().min(1).max(16),
                    label: z.string().min(1).max(60)
                })).min(2).max(5),
                now: z.int().gte(0).lte(9007199254740991).optional()
            }),
            z.object({
                kind: z.string(),
                caption: z.string().min(1).max(120),
                start: z.object({
                    label: z.string().min(1).max(60),
                    value: z.number(),
                    display: z.string().min(1).max(24)
                }),
                steps: z.array(z.object({
                    label: z.string().min(1).max(60),
                    value: z.number(),
                    display: z.string().min(1).max(24),
                    op: z.enum([
                        'plus',
                        'minus',
                        'times',
                        'divide'
                    ])
                })).min(1).max(2),
                result: z.object({
                    label: z.string().min(1).max(60),
                    value: z.number(),
                    display: z.string().min(1).max(24)
                })
            }),
            z.object({
                kind: z.string(),
                caption: z.string().min(1).max(120),
                price: z.object({
                    low: z.number(),
                    high: z.number()
                }),
                demand: z.object({
                    atLow: z.number().gte(0),
                    atHigh: z.number().gte(0)
                }),
                readoutLabel: z.string().min(1).max(60),
                unit: z.string().max(8),
                from: z.string().min(1).max(40),
                to: z.string().min(1).max(40)
            })
        ]).optional(),
        voiceoverUrl: z.url().optional(),
        lessonSlug: z.string().min(1).max(200).regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/),
        lessonTitle: z.string().min(1).max(120),
        subject: z.enum([
            'MARKETING',
            'FINANCE',
            'STRATEGY',
            'LEADERSHIP',
            'SALES',
            'NEGOTIATION',
            'ENTREPRENEURSHIP',
            'PUBLIC_SPEAKING',
            'COMMUNICATION',
            'OPERATIONS',
            'DECISIONS',
            'BUSINESS_FUNDAMENTALS',
            'TEAM_MANAGEMENT',
            'HIRING',
            'ORGANIZATIONAL_BEHAVIOR',
            'PRODUCT_MANAGEMENT',
            'AI',
            'INNOVATION',
            'PROJECT_MANAGEMENT',
            'BUSINESS_ANALYTICS',
            'CAREER',
            'PERSONAL_FINANCE',
            'ECONOMICS'
        ]).optional(),
        family: z.enum([
            'growth',
            'finance',
            'people'
        ]),
        palette: z.object({
            primary: z.string().regex(/^#[0-9a-f]{6}$/),
            secondary: z.string().regex(/^#[0-9a-f]{6}$/)
        }).optional()
    })),
    nextCursor: z.union([
        z.string().min(1),
        z.unknown()
    ])
});
export const zMarkShortSeenDto = z.object({
    utcOffsetMinutes: z.int().gte(-720).lte(840)
});
export const zCreateSupportRequestDto = z.object({
    requestId: z.string().min(8).max(64),
    topic: z.enum([
        'APP_BUG',
        'LESSON_OR_AI',
        'ACCOUNT',
        'FEEDBACK',
        'WORK_WITH_US',
        'SUBSCRIPTION'
    ]),
    name: z.string().min(1).max(80),
    email: z.email().max(200).regex(/^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/),
    message: z.string().min(1).max(4000),
    appVersion: z.string().min(1).max(80),
    context: z.string().max(200).optional(),
    screenshotPath: z.string().min(1).max(300).optional()
});
export const zSupportRequestDtoOutput = z.object({
    id: z.string().min(1),
    topic: z.enum([
        'APP_BUG',
        'LESSON_OR_AI',
        'ACCOUNT',
        'FEEDBACK',
        'WORK_WITH_US',
        'SUBSCRIPTION'
    ]),
    status: z.enum([
        'OPEN',
        'TRIAGED',
        'RESOLVED',
        'DISMISSED'
    ]),
    createdAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
    updatedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/)
});
export const zTrainListDtoOutput = z.object({
    scenarios: z.array(z.object({
        slug: z.string().min(1).max(200).regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/),
        title: z.string().min(1).max(80),
        topic: z.enum([
            'marketing',
            'finance',
            'entrepreneurship',
            'startups',
            'personal-finance',
            'negotiation',
            'sales',
            'strategy'
        ]),
        verb: z.enum([
            'decide',
            'allocate',
            'rank',
            'match',
            'predict',
            'diagnose',
            'negotiate',
            'rephrase',
            'pitch',
            'speak',
            'simulate'
        ]),
        seconds: z.int().gte(60).lte(900),
        counterpart: z.object({
            name: z.string().min(1).max(40),
            role: z.string().min(1).max(60),
            situation: z.string().min(1).max(120)
        })
    }))
});
export const zTrainScenarioDtoOutput = z.object({
    slug: z.string().min(1).max(200).regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/),
    title: z.string().min(1).max(80),
    topic: z.enum([
        'marketing',
        'finance',
        'entrepreneurship',
        'startups',
        'personal-finance',
        'negotiation',
        'sales',
        'strategy'
    ]),
    verb: z.enum([
        'decide',
        'allocate',
        'rank',
        'match',
        'predict',
        'diagnose',
        'negotiate',
        'rephrase',
        'pitch',
        'speak',
        'simulate'
    ]),
    seconds: z.int().gte(60).lte(900),
    counterpart: z.object({
        name: z.string().min(1).max(40),
        role: z.string().min(1).max(60),
        situation: z.string().min(1).max(120)
    }),
    opening: z.string().min(1).max(300),
    steps: z.array(z.object({
        id: z.string().min(1),
        replies: z.array(z.object({
            id: z.string().min(1),
            text: z.string().min(1).max(200),
            response: z.string().min(1).max(300),
            nudge: z.string().min(1).max(200).optional(),
            scores: z.array(z.object({
                dimension: z.enum([
                    'clarity',
                    'persuasion',
                    'confidence',
                    'structure',
                    'objection handling'
                ]),
                score: z.int().gte(0).lte(5)
            })).min(1)
        })).min(2).max(4)
    })).min(1),
    closing: z.object({
        headline: z.string().min(1).max(80),
        body: z.string().min(1).max(400)
    })
});
export const zTrainCounterpartListDtoOutput = z.object({
    counterparts: z.array(z.object({
        id: z.enum([
            'kofi',
            'rosa',
            'david',
            'betty',
            'priya',
            'morgan',
            'alex',
            'taylor',
            'jordan'
        ]),
        name: z.string().min(1).max(40),
        role: z.string().min(1).max(80),
        responds: z.string().min(1).max(120),
        kind: z.enum(['cast', 'fictional'])
    }))
});
export const zTrainStarterListDtoOutput = z.object({
    starters: z.array(z.object({
        id: z.string().min(1).max(40),
        situation: z.string().min(1).max(60),
        skill: z.string().min(1).max(40),
        minutes: z.int().gte(1).lte(9007199254740991),
        setup: z.object({
            counterpart: z.enum([
                'kofi',
                'rosa',
                'david',
                'betty',
                'priya',
                'morgan',
                'alex',
                'taylor',
                'jordan'
            ]),
            yourRole: z.string().min(1).max(80),
            theirRole: z.string().min(1).max(60),
            situation: z.string().min(1).max(400),
            goal: z.string().min(1).max(200),
            constraints: z.array(z.string().min(1).max(160)).max(4).default([]),
            mode: z.enum(['text', 'voice']).default('text'),
            difficulty: z.enum([
                'guided',
                'standard',
                'challenging'
            ]).default('standard')
        })
    }))
});
export const zTrainSuggestRequestDto = z.object({
    counterpart: z.enum([
        'kofi',
        'rosa',
        'david',
        'betty',
        'priya',
        'morgan',
        'alex',
        'taylor',
        'jordan'
    ]),
    yourRole: z.string().min(1).max(80).optional(),
    theirRole: z.string().min(1).max(60).optional(),
    situation: z.string().min(1).max(400).optional(),
    goal: z.string().min(1).max(200).optional()
});
export const zTrainSuggestionDtoOutput = z.object({
    setup: z.object({
        counterpart: z.enum([
            'kofi',
            'rosa',
            'david',
            'betty',
            'priya',
            'morgan',
            'alex',
            'taylor',
            'jordan'
        ]),
        yourRole: z.string().min(1).max(80),
        theirRole: z.string().min(1).max(60),
        situation: z.string().min(1).max(400),
        goal: z.string().min(1).max(200),
        constraints: z.array(z.string().min(1).max(160)).max(4).default([]),
        mode: z.enum(['text', 'voice']).default('text'),
        difficulty: z.enum([
            'guided',
            'standard',
            'challenging'
        ]).default('standard')
    }),
    suggestions: z.object({
        yourRole: z.string().min(1).max(80).optional(),
        theirRole: z.string().min(1).max(60).optional(),
        situation: z.string().min(1).max(400).optional(),
        goal: z.string().min(1).max(200).optional()
    })
});
export const zTrainSetupRequestDto = z.object({
    counterpart: z.enum([
        'kofi',
        'rosa',
        'david',
        'betty',
        'priya',
        'morgan',
        'alex',
        'taylor',
        'jordan'
    ]),
    yourRole: z.string().min(1).max(80),
    theirRole: z.string().min(1).max(60),
    situation: z.string().min(1).max(400),
    goal: z.string().min(1).max(200),
    constraints: z.array(z.string().min(1).max(160)).max(4).optional().default([]),
    mode: z.enum(['text', 'voice']).optional().default('text'),
    difficulty: z.enum([
        'guided',
        'standard',
        'challenging'
    ]).optional().default('standard'),
    key: z.string().min(1).max(200)
});
export const zTrainBriefResultDtoOutput = z.object({
    brief: z.union([
        z.object({
            topic: z.enum([
                'marketing',
                'finance',
                'entrepreneurship',
                'startups',
                'personal-finance',
                'negotiation',
                'sales',
                'strategy'
            ]),
            situation: z.string().min(1).max(400),
            role: z.string().min(1).max(80),
            counterpart: z.object({
                name: z.string().min(1).max(40),
                role: z.string().min(1).max(60),
                situation: z.string().min(1).max(120)
            }),
            goal: z.string().min(1).max(200),
            constraints: z.array(z.string().min(1).max(160)).max(4),
            opening: z.string().min(1).max(300),
            counterpartId: z.enum([
                'kofi',
                'rosa',
                'david',
                'betty',
                'priya',
                'morgan',
                'alex',
                'taylor',
                'jordan'
            ]),
            difficulty: z.enum([
                'guided',
                'standard',
                'challenging'
            ]),
            mode: z.enum(['text', 'voice']),
            assumptions: z.array(z.object({
                text: z.string().min(1).max(200),
                fictional: z.boolean()
            })).max(8),
            minutes: z.int().gte(1).lte(9007199254740991)
        }),
        z.unknown()
    ]),
    question: z.union([
        z.string(),
        z.unknown()
    ])
});
export const zTrainSessionStartDto = z.object({
    setup: z.object({
        topic: z.enum([
            'marketing',
            'finance',
            'entrepreneurship',
            'startups',
            'personal-finance',
            'negotiation',
            'sales',
            'strategy'
        ]),
        situation: z.string().min(1).max(400),
        role: z.string().min(1).max(80),
        counterpart: z.object({
            name: z.string().min(1).max(40),
            role: z.string().min(1).max(60),
            situation: z.string().min(1).max(120)
        }),
        goal: z.string().min(1).max(200),
        constraints: z.array(z.string().min(1).max(160)).max(4),
        opening: z.string().min(1).max(300),
        counterpartId: z.enum([
            'kofi',
            'rosa',
            'david',
            'betty',
            'priya',
            'morgan',
            'alex',
            'taylor',
            'jordan'
        ]).optional(),
        difficulty: z.enum([
            'guided',
            'standard',
            'challenging'
        ]).optional(),
        mode: z.enum(['text', 'voice']).optional(),
        assumptions: z.array(z.object({
            text: z.string().min(1).max(200),
            fictional: z.boolean()
        })).max(8).optional()
    }),
    key: z.string().min(1).max(200)
});
export const zTrainSessionStartedDtoOutput = z.object({
    session: z.object({
        id: z.string(),
        setup: z.object({
            topic: z.enum([
                'marketing',
                'finance',
                'entrepreneurship',
                'startups',
                'personal-finance',
                'negotiation',
                'sales',
                'strategy'
            ]),
            situation: z.string().min(1).max(400),
            role: z.string().min(1).max(80),
            counterpart: z.object({
                name: z.string().min(1).max(40),
                role: z.string().min(1).max(60),
                situation: z.string().min(1).max(120)
            }),
            goal: z.string().min(1).max(200),
            constraints: z.array(z.string().min(1).max(160)).max(4),
            opening: z.string().min(1).max(300),
            counterpartId: z.enum([
                'kofi',
                'rosa',
                'david',
                'betty',
                'priya',
                'morgan',
                'alex',
                'taylor',
                'jordan'
            ]).optional(),
            difficulty: z.enum([
                'guided',
                'standard',
                'challenging'
            ]).optional(),
            mode: z.enum(['text', 'voice']).optional(),
            assumptions: z.array(z.object({
                text: z.string().min(1).max(200),
                fictional: z.boolean()
            })).max(8).optional()
        }),
        status: z.enum(['active', 'ended']),
        turnLimit: z.int().gte(1).lte(9007199254740991),
        turnsLeft: z.int().gte(0).lte(9007199254740991),
        turns: z.array(z.object({
            id: z.string(),
            text: z.string(),
            reply: z.string(),
            replyId: z.string().min(1),
            createdAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/)
        })),
        debrief: z.union([
            z.object({
                feedback: z.union([
                    z.object({
                        strength: z.string(),
                        missedOpportunity: z.string(),
                        quote: z.object({
                            turn: z.int().gte(1).lte(9007199254740991),
                            text: z.string()
                        }),
                        alternative: z.object({
                            text: z.string(),
                            why: z.string(),
                            source: z.string(),
                            citation: z.object({
                                lesson: z.object({
                                    slug: z.string().min(1).max(200).regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/),
                                    title: z.string()
                                }),
                                sceneId: z.string().min(1).optional(),
                                sourceId: z.string().min(1)
                            }).optional(),
                            limitation: z.string().optional()
                        }),
                        action: z.string()
                    }),
                    z.unknown()
                ]),
                retry: z.object({
                    setup: z.object({
                        topic: z.enum([
                            'marketing',
                            'finance',
                            'entrepreneurship',
                            'startups',
                            'personal-finance',
                            'negotiation',
                            'sales',
                            'strategy'
                        ]),
                        situation: z.string().min(1).max(400),
                        role: z.string().min(1).max(80),
                        counterpart: z.object({
                            name: z.string().min(1).max(40),
                            role: z.string().min(1).max(60),
                            situation: z.string().min(1).max(120)
                        }),
                        goal: z.string().min(1).max(200),
                        constraints: z.array(z.string().min(1).max(160)).max(4),
                        opening: z.string().min(1).max(300),
                        counterpartId: z.enum([
                            'kofi',
                            'rosa',
                            'david',
                            'betty',
                            'priya',
                            'morgan',
                            'alex',
                            'taylor',
                            'jordan'
                        ]).optional(),
                        difficulty: z.enum([
                            'guided',
                            'standard',
                            'challenging'
                        ]).optional(),
                        mode: z.enum(['text', 'voice']).optional(),
                        assumptions: z.array(z.object({
                            text: z.string().min(1).max(200),
                            fictional: z.boolean()
                        })).max(8).optional()
                    })
                })
            }),
            z.unknown()
        ]),
        takeaway: z.union([
            z.string(),
            z.unknown()
        ]),
        firstAttemptId: z.union([
            z.string(),
            z.unknown()
        ]),
        nextRetryFree: z.boolean(),
        createdAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/)
    }),
    remaining: z.int().gte(0).lte(9007199254740991),
    resetAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/)
});
export const zTrainSessionListDtoOutput = z.object({
    sessions: z.array(z.object({
        id: z.string(),
        status: z.enum(['unfinished', 'completed']),
        counterpartId: z.enum([
            'kofi',
            'rosa',
            'david',
            'betty',
            'priya',
            'morgan',
            'alex',
            'taylor',
            'jordan'
        ]).optional(),
        counterpart: z.object({
            name: z.string().min(1).max(40),
            role: z.string().min(1).max(60)
        }),
        situation: z.string(),
        mode: z.enum(['text', 'voice']),
        createdAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/)
    }))
});
export const zTrainSessionDtoOutput = z.object({
    id: z.string(),
    setup: z.object({
        topic: z.enum([
            'marketing',
            'finance',
            'entrepreneurship',
            'startups',
            'personal-finance',
            'negotiation',
            'sales',
            'strategy'
        ]),
        situation: z.string().min(1).max(400),
        role: z.string().min(1).max(80),
        counterpart: z.object({
            name: z.string().min(1).max(40),
            role: z.string().min(1).max(60),
            situation: z.string().min(1).max(120)
        }),
        goal: z.string().min(1).max(200),
        constraints: z.array(z.string().min(1).max(160)).max(4),
        opening: z.string().min(1).max(300),
        counterpartId: z.enum([
            'kofi',
            'rosa',
            'david',
            'betty',
            'priya',
            'morgan',
            'alex',
            'taylor',
            'jordan'
        ]).optional(),
        difficulty: z.enum([
            'guided',
            'standard',
            'challenging'
        ]).optional(),
        mode: z.enum(['text', 'voice']).optional(),
        assumptions: z.array(z.object({
            text: z.string().min(1).max(200),
            fictional: z.boolean()
        })).max(8).optional()
    }),
    status: z.enum(['active', 'ended']),
    turnLimit: z.int().gte(1).lte(9007199254740991),
    turnsLeft: z.int().gte(0).lte(9007199254740991),
    turns: z.array(z.object({
        id: z.string(),
        text: z.string(),
        reply: z.string(),
        replyId: z.string().min(1),
        createdAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/)
    })),
    debrief: z.union([
        z.object({
            feedback: z.union([
                z.object({
                    strength: z.string(),
                    missedOpportunity: z.string(),
                    quote: z.object({
                        turn: z.int().gte(1).lte(9007199254740991),
                        text: z.string()
                    }),
                    alternative: z.object({
                        text: z.string(),
                        why: z.string(),
                        source: z.string(),
                        citation: z.object({
                            lesson: z.object({
                                slug: z.string().min(1).max(200).regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/),
                                title: z.string()
                            }),
                            sceneId: z.string().min(1).optional(),
                            sourceId: z.string().min(1)
                        }).optional(),
                        limitation: z.string().optional()
                    }),
                    action: z.string()
                }),
                z.unknown()
            ]),
            retry: z.object({
                setup: z.object({
                    topic: z.enum([
                        'marketing',
                        'finance',
                        'entrepreneurship',
                        'startups',
                        'personal-finance',
                        'negotiation',
                        'sales',
                        'strategy'
                    ]),
                    situation: z.string().min(1).max(400),
                    role: z.string().min(1).max(80),
                    counterpart: z.object({
                        name: z.string().min(1).max(40),
                        role: z.string().min(1).max(60),
                        situation: z.string().min(1).max(120)
                    }),
                    goal: z.string().min(1).max(200),
                    constraints: z.array(z.string().min(1).max(160)).max(4),
                    opening: z.string().min(1).max(300),
                    counterpartId: z.enum([
                        'kofi',
                        'rosa',
                        'david',
                        'betty',
                        'priya',
                        'morgan',
                        'alex',
                        'taylor',
                        'jordan'
                    ]).optional(),
                    difficulty: z.enum([
                        'guided',
                        'standard',
                        'challenging'
                    ]).optional(),
                    mode: z.enum(['text', 'voice']).optional(),
                    assumptions: z.array(z.object({
                        text: z.string().min(1).max(200),
                        fictional: z.boolean()
                    })).max(8).optional()
                })
            })
        }),
        z.unknown()
    ]),
    takeaway: z.union([
        z.string(),
        z.unknown()
    ]),
    firstAttemptId: z.union([
        z.string(),
        z.unknown()
    ]),
    nextRetryFree: z.boolean(),
    createdAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/)
});
export const zTrainTurnPostDto = z.object({
    text: z.string().min(1).max(600),
    key: z.string().min(1).max(200)
});
export const zTrainTurnResultDtoOutput = z.object({
    turn: z.object({
        id: z.string(),
        text: z.string(),
        reply: z.string(),
        replyId: z.string().min(1),
        createdAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/)
    }),
    turnsLeft: z.int().gte(0).lte(9007199254740991)
});
export const zTrainHelpPostDto = z.object({
    kind: z.enum(['hint', 'example'])
});
export const zTrainHelpDtoOutput = z.object({
    kind: z.enum(['hint', 'example']),
    text: z.string()
});
export const zTrainTakeawayPutDto = z.object({
    text: z.string().min(1).max(300)
});
export const zTrainTwistDtoOutput = z.object({
    id: z.string(),
    replaces: z.union([
        z.string(),
        z.unknown()
    ]),
    constraint: z.string(),
    setup: z.object({
        topic: z.enum([
            'marketing',
            'finance',
            'entrepreneurship',
            'startups',
            'personal-finance',
            'negotiation',
            'sales',
            'strategy'
        ]),
        situation: z.string().min(1).max(400),
        role: z.string().min(1).max(80),
        counterpart: z.object({
            name: z.string().min(1).max(40),
            role: z.string().min(1).max(60),
            situation: z.string().min(1).max(120)
        }),
        goal: z.string().min(1).max(200),
        constraints: z.array(z.string().min(1).max(160)).max(4),
        opening: z.string().min(1).max(300),
        counterpartId: z.enum([
            'kofi',
            'rosa',
            'david',
            'betty',
            'priya',
            'morgan',
            'alex',
            'taylor',
            'jordan'
        ]).optional(),
        difficulty: z.enum([
            'guided',
            'standard',
            'challenging'
        ]).optional(),
        mode: z.enum(['text', 'voice']).optional(),
        assumptions: z.array(z.object({
            text: z.string().min(1).max(200),
            fictional: z.boolean()
        })).max(8).optional()
    })
});
export const zTrainRetryPostDto = z.object({
    key: z.string().min(1).max(200),
    twist: z.string().optional()
});
export const zTrainRetryStartedDtoOutput = z.object({
    session: z.object({
        id: z.string(),
        setup: z.object({
            topic: z.enum([
                'marketing',
                'finance',
                'entrepreneurship',
                'startups',
                'personal-finance',
                'negotiation',
                'sales',
                'strategy'
            ]),
            situation: z.string().min(1).max(400),
            role: z.string().min(1).max(80),
            counterpart: z.object({
                name: z.string().min(1).max(40),
                role: z.string().min(1).max(60),
                situation: z.string().min(1).max(120)
            }),
            goal: z.string().min(1).max(200),
            constraints: z.array(z.string().min(1).max(160)).max(4),
            opening: z.string().min(1).max(300),
            counterpartId: z.enum([
                'kofi',
                'rosa',
                'david',
                'betty',
                'priya',
                'morgan',
                'alex',
                'taylor',
                'jordan'
            ]).optional(),
            difficulty: z.enum([
                'guided',
                'standard',
                'challenging'
            ]).optional(),
            mode: z.enum(['text', 'voice']).optional(),
            assumptions: z.array(z.object({
                text: z.string().min(1).max(200),
                fictional: z.boolean()
            })).max(8).optional()
        }),
        status: z.enum(['active', 'ended']),
        turnLimit: z.int().gte(1).lte(9007199254740991),
        turnsLeft: z.int().gte(0).lte(9007199254740991),
        turns: z.array(z.object({
            id: z.string(),
            text: z.string(),
            reply: z.string(),
            replyId: z.string().min(1),
            createdAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/)
        })),
        debrief: z.union([
            z.object({
                feedback: z.union([
                    z.object({
                        strength: z.string(),
                        missedOpportunity: z.string(),
                        quote: z.object({
                            turn: z.int().gte(1).lte(9007199254740991),
                            text: z.string()
                        }),
                        alternative: z.object({
                            text: z.string(),
                            why: z.string(),
                            source: z.string(),
                            citation: z.object({
                                lesson: z.object({
                                    slug: z.string().min(1).max(200).regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/),
                                    title: z.string()
                                }),
                                sceneId: z.string().min(1).optional(),
                                sourceId: z.string().min(1)
                            }).optional(),
                            limitation: z.string().optional()
                        }),
                        action: z.string()
                    }),
                    z.unknown()
                ]),
                retry: z.object({
                    setup: z.object({
                        topic: z.enum([
                            'marketing',
                            'finance',
                            'entrepreneurship',
                            'startups',
                            'personal-finance',
                            'negotiation',
                            'sales',
                            'strategy'
                        ]),
                        situation: z.string().min(1).max(400),
                        role: z.string().min(1).max(80),
                        counterpart: z.object({
                            name: z.string().min(1).max(40),
                            role: z.string().min(1).max(60),
                            situation: z.string().min(1).max(120)
                        }),
                        goal: z.string().min(1).max(200),
                        constraints: z.array(z.string().min(1).max(160)).max(4),
                        opening: z.string().min(1).max(300),
                        counterpartId: z.enum([
                            'kofi',
                            'rosa',
                            'david',
                            'betty',
                            'priya',
                            'morgan',
                            'alex',
                            'taylor',
                            'jordan'
                        ]).optional(),
                        difficulty: z.enum([
                            'guided',
                            'standard',
                            'challenging'
                        ]).optional(),
                        mode: z.enum(['text', 'voice']).optional(),
                        assumptions: z.array(z.object({
                            text: z.string().min(1).max(200),
                            fictional: z.boolean()
                        })).max(8).optional()
                    })
                })
            }),
            z.unknown()
        ]),
        takeaway: z.union([
            z.string(),
            z.unknown()
        ]),
        firstAttemptId: z.union([
            z.string(),
            z.unknown()
        ]),
        nextRetryFree: z.boolean(),
        createdAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/)
    }),
    remaining: z.int().gte(0).lte(9007199254740991),
    resetAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
    free: z.boolean()
});
export const zTranscribeRequestDto = z.object({
    audio: z.string().max(2796204).regex(/^[A-Za-z0-9+\/]+={0,2}$/),
    type: z.enum([
        'audio/mp4',
        'audio/m4a',
        'audio/aac',
        'audio/mpeg',
        'audio/wav',
        'audio/webm',
        'audio/ogg',
        'audio/3gpp'
    ])
});
export const zTranscriptDtoOutput = z.object({
    text: z.string()
});
export const zSpokenLineDtoOutput = z.object({
    type: z.string(),
    audio: z.string()
});
export const zAllowanceDtoOutput = z.object({
    consultant: z.object({
        limit: z.int().gte(0).lte(9007199254740991),
        remaining: z.int().gte(0).lte(9007199254740991)
    }),
    train: z.object({
        limit: z.int().gte(0).lte(9007199254740991),
        remaining: z.int().gte(0).lte(9007199254740991)
    }),
    resetAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/)
});
export const zSearchEvidenceDto = z.object({
    question: z.string().min(1).max(500),
    limit: z.int().gte(1).lte(20).optional().default(5)
});
export const zEvidenceResultDtoOutput = z.object({
    passages: z.array(z.object({
        lesson: z.object({
            slug: z.string().min(1).max(200).regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/),
            title: z.string()
        }),
        sceneId: z.string().min(1).optional(),
        text: z.string(),
        score: z.number().gte(0).lte(1),
        sources: z.array(z.object({
            id: z.string().min(1),
            type: z.enum([
                'ARTICLE',
                'RESEARCH',
                'LINK',
                'TEXT'
            ]),
            title: z.string(),
            url: z.string().optional(),
            citation: z.string().optional(),
            note: z.string().optional(),
            checkedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).optional()
        })).min(1)
    }))
});
export const zAskSuggestionsDtoOutput = z.object({
    decided: z.boolean(),
    suggestions: z.array(z.object({
        id: z.string(),
        label: z.string()
    })).max(3)
});
export const zAskTutorDto = z.object({
    question: z.string().min(1).max(500),
    attemptId: z.string().min(1).optional(),
    history: z.array(z.object({
        question: z.string().min(1).max(500),
        answer: z.string().max(2000)
    })).max(6).optional().default([])
});
export const zTutorAnswerDtoOutput = z.object({
    text: z.string(),
    replyId: z.string().min(1)
});
export const zConsultantThreadListDtoOutput = z.object({
    threads: z.array(z.object({
        id: z.string(),
        title: z.string(),
        createdAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
        updatedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/)
    }))
});
export const zConsultantPostDto = z.object({
    text: z.string().min(1).max(2000),
    key: z.string().min(1).max(200)
});
export const zConsultantTurnDtoOutput = z.object({
    threadId: z.string(),
    exchange: z.object({
        id: z.string(),
        text: z.string(),
        reply: z.union([
            z.object({
                kind: z.string(),
                because: z.string(),
                asks: z.array(z.string()).min(1).max(3)
            }),
            z.object({
                kind: z.string(),
                summary: z.string(),
                claims: z.array(z.object({
                    text: z.string(),
                    basis: z.enum(['source', 'interpretation']),
                    source: z.string(),
                    limitation: z.string().optional(),
                    citation: z.object({
                        lesson: z.object({
                            slug: z.string().min(1).max(200).regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/),
                            title: z.string()
                        }),
                        sceneId: z.string().min(1).optional(),
                        sourceId: z.string().min(1)
                    }).optional()
                })).min(1),
                nextStep: z.string()
            })
        ]),
        replyId: z.string().min(1),
        createdAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/)
    }),
    remaining: z.int().gte(0).lte(9007199254740991),
    resetAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/)
});
export const zConsultantThreadDtoOutput = z.object({
    id: z.string(),
    title: z.string(),
    createdAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
    updatedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
    exchanges: z.array(z.object({
        id: z.string(),
        text: z.string(),
        reply: z.union([
            z.object({
                kind: z.string(),
                because: z.string(),
                asks: z.array(z.string()).min(1).max(3)
            }),
            z.object({
                kind: z.string(),
                summary: z.string(),
                claims: z.array(z.object({
                    text: z.string(),
                    basis: z.enum(['source', 'interpretation']),
                    source: z.string(),
                    limitation: z.string().optional(),
                    citation: z.object({
                        lesson: z.object({
                            slug: z.string().min(1).max(200).regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/),
                            title: z.string()
                        }),
                        sceneId: z.string().min(1).optional(),
                        sourceId: z.string().min(1)
                    }).optional()
                })).min(1),
                nextStep: z.string()
            })
        ]),
        replyId: z.string().min(1),
        createdAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/)
    }))
});
export const zFrameReportDto = z.object({
    samples: z.array(z.object({
        screen: z.string().min(1).max(64).regex(/^\/[A-Za-z0-9()[\]\/_.-]*$/),
        renderedFrames: z.int().gte(0).lte(100000),
        droppedFrames: z.int().gte(0).lte(100000),
        windowMs: z.int().gte(500).lte(2000)
    })).min(1).max(50)
});
export const zFrameReportAcceptedDto = z.object({
    accepted: z.int().gte(0).lte(9007199254740991)
});
/**
 * The process is up.
 */
export const zGetHealthResponse = zHealthResponseDto;
/**
 * Every dependency is reachable.
 */
export const zGetReadinessResponse = zReadinessResponseDto;
/**
 * The jobs.
 */
export const zListGenerationsResponse = zGenerationListDtoOutput;
export const zStartGenerationBody = zStartGenerationDto;
/**
 * The queued job, with a row per CSV row.
 */
export const zStartGenerationResponse = zGenerationDetailDtoOutput;
export const zFindExistingCollectionsBody = zExistingSlugsDto;
/**
 * Each existing slug with its status. A re-run leaves anything not DRAFT as it is.
 */
export const zFindExistingCollectionsResponse = zExistingCollectionsDtoOutput;
export const zRegenerateBody = zRegenerateDto;
/**
 * The queued job — one row per scene. Regenerations run at HIGH priority.
 */
export const zRegenerateResponse = zGenerationDetailDtoOutput;
export const zGetGenerationPath = z.object({
    id: z.string()
});
/**
 * The job.
 */
export const zGetGenerationResponse = zGenerationDetailDtoOutput;
export const zCancelGenerationPath = z.object({
    id: z.string()
});
/**
 * The job, cancelled. Queued lessons are SKIPPED and can be retried; the one being written is left to finish.
 */
export const zCancelGenerationResponse = zGenerationDetailDtoOutput;
export const zRetryGenerationPath = z.object({
    id: z.string()
});
/**
 * How many rows were re-queued. Lessons that succeeded are left alone — GEN-92.
 */
export const zRetryGenerationResponse = zRetriedDtoOutput;
export const zRetryGenerationRowPath = z.object({
    id: z.string()
});
/**
 * One, or zero if the row had not failed.
 */
export const zRetryGenerationRowResponse = zRetriedDtoOutput;
export const zDiscardRewritePath = z.object({
    id: z.string()
});
/**
 * Whether there was a snapshot to put back.
 */
export const zDiscardRewriteResponse = zDiscardedDtoOutput;
export const zApplyFindingPath = z.object({
    id: z.string()
});
/**
 * The queued job — one row. A model turn is about a minute, so the console follows the job rather than the request.
 */
export const zApplyFindingResponse = zGenerationDetailDtoOutput;
export const zKeepFindingPath = z.object({
    id: z.string()
});
/**
 * The rewrite is written to the scene and the finding is ACCEPTED, so it stops counting against a publish. Until this is called the scene is unchanged. A review of the lesson is queued unless one is already queued or running.
 */
export const zKeepFindingResponse = zKeptDtoOutput;
export const zDiscardFindingPath = z.object({
    id: z.string()
});
/**
 * The finding is OPEN again with no proposal. The scene was never written, so nothing changes.
 */
export const zDiscardFindingResponse = zKeptDtoOutput;
export const zDismissFindingPath = z.object({
    id: z.string()
});
/**
 * The finding is DISMISSED: it counts as passed on the scorecard and against a publish, and a re-review that raises it again files it DISMISSED. Nothing on the lesson changes.
 */
export const zDismissFindingResponse = zKeptDtoOutput;
export const zRevertFindingPath = z.object({
    id: z.string()
});
/**
 * Whether there was an edit to put back. The finding returns to OPEN — the content is once again what the reviewer objected to.
 */
export const zRevertFindingResponse = zDiscardedDtoOutput;
export const zListGenerationLedgerQuery = z.object({
    model: z.string().min(1).optional(),
    research: z.string().optional(),
    from: z.iso.date().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))$/).optional(),
    to: z.iso.date().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))$/).optional(),
    limit: z.int().gte(1).lte(100).optional().default(25),
    offset: z.int().gte(0).lte(9007199254740991).optional().default(0)
});
/**
 * One page.
 */
export const zListGenerationLedgerResponse = zGenerationLedgerPageDtoOutput;
export const zGetGenerationPatternsQuery = z.object({
    days: z.int().gte(1).lte(90).optional().default(14)
});
/**
 * The patterns.
 */
export const zGetGenerationPatternsResponse = zGenerationPatternsDtoOutput;
export const zAskPlannerBody = zAskPlannerDto;
/**
 * The answer, the edit it proposes if it proposed one, and what the exchange cost.
 */
export const zAskPlannerResponse = zPlannerAnswerDtoOutput;
export const zFillCoursePath = z.object({
    id: z.string()
});
/**
 * The fields the fill wrote.
 */
export const zFillCourseResponse = zCourseFilledDtoOutput;
export const zFixSceneFieldBody = zFixSceneDto;
export const zFixSceneFieldPath = z.object({
    id: z.string()
});
/**
 * What changed, what it cleared, and what is left. A review of the lesson is queued unless one is already queued or running.
 */
export const zFixSceneFieldResponse = zSceneFixDtoOutput;
export const zStartVerificationBody = zStartVerificationDto;
/**
 * The queued job, with a row per lesson.
 */
export const zStartVerificationResponse = zGenerationDetailDtoOutput;
export const zListLessonVerificationsPath = z.object({
    id: z.string()
});
/**
 * Newest first.
 */
export const zListLessonVerificationsResponse = zLessonVerificationsDtoOutput;
export const zListLessonSourceChecksPath = z.object({
    id: z.string()
});
/**
 * In the order the lesson cites them.
 */
export const zListLessonSourceChecksResponse = zLessonSourceChecksDtoOutput;
export const zCheckLessonSourcesBody = zCheckSourcesDto;
export const zCheckLessonSourcesPath = z.object({
    id: z.string()
});
/**
 * Every source the lesson cites, with the checks just made.
 */
export const zCheckLessonSourcesResponse = zLessonSourceChecksDtoOutput;
export const zListJobVerificationsPath = z.object({
    id: z.string()
});
/**
 * Oldest first.
 */
export const zListJobVerificationsResponse = zJobVerificationsDtoOutput;
export const zGetVerificationPath = z.object({
    id: z.string()
});
/**
 * The run.
 */
export const zGetVerificationResponse = zVerificationRunDtoOutput;
export const zListLessonFixesPath = z.object({
    id: z.string()
});
/**
 * Newest first.
 */
export const zListLessonFixesResponse = zLessonFixesDtoOutput;
export const zRequestLessonFixBody = zRequestFixDto;
export const zRequestLessonFixPath = z.object({
    id: z.string()
});
/**
 * PROPOSED with what changes, which scenes and sources, and why — nothing is written until Apply. FAILED with what remains and a manual next step when no fix could be proposed.
 */
export const zRequestLessonFixResponse = zLessonFixDtoOutput;
export const zApplyLessonFixPath = z.object({
    id: z.string()
});
/**
 * RESOLVED when the re-check no longer finds it, and the finding is accepted. UNRESOLVED when it still does or could not run: the fix stays applied, the finding open, with what remains and the next step. A review of the lesson is queued unless one is already queued or running.
 */
export const zApplyLessonFixResponse = zLessonFixDtoOutput;
export const zRevertLessonFixPath = z.object({
    id: z.string()
});
/**
 * REVERTED. A finding the fix resolved is open again.
 */
export const zRevertLessonFixResponse = zLessonFixDtoOutput;
export const zDiscardLessonFixPath = z.object({
    id: z.string()
});
/**
 * DISCARDED.
 */
export const zDiscardLessonFixResponse = zLessonFixDtoOutput;
export const zListLessonReviewsPath = z.object({
    id: z.string()
});
/**
 * Newest first.
 */
export const zListLessonReviewsResponse = zLessonReviewsDtoOutput;
export const zReviewLessonAgainPath = z.object({
    id: z.string()
});
/**
 * The queued job — one row. The review is listed once it has read the lesson.
 */
export const zReviewLessonAgainResponse = zGenerationDetailDtoOutput;
export const zGetGenerationPromptPath = z.object({
    digest: z.string()
});
/**
 * The text.
 */
export const zGetGenerationPromptResponse = zGenerationPromptDtoOutput;
/**
 * The agents.
 */
export const zListSystemPromptsResponse = zSystemPromptsDtoOutput;
export const zListVisualFixesPath = z.object({
    id: z.string()
});
/**
 * Newest first.
 */
export const zListVisualFixesResponse = zVisualFixesDtoOutput;
export const zRequestVisualFixBody = zRequestVisualFixDto;
export const zRequestVisualFixPath = z.object({
    id: z.string()
});
/**
 * PROPOSED, with every field of the visual it would change.
 */
export const zRequestVisualFixResponse = zVisualFixDtoOutput;
export const zApplyVisualFixPath = z.object({
    id: z.string()
});
/**
 * APPLIED. A review of the lesson is queued unless one is already queued or running.
 */
export const zApplyVisualFixResponse = zVisualFixDtoOutput;
export const zDiscardVisualFixPath = z.object({
    id: z.string()
});
/**
 * DISCARDED.
 */
export const zDiscardVisualFixResponse = zVisualFixDtoOutput;
export const zRevertVisualFixPath = z.object({
    id: z.string()
});
/**
 * REVERTED.
 */
export const zRevertVisualFixResponse = zVisualFixDtoOutput;
export const zListCollectionsQuery = z.object({
    kind: z.string().optional(),
    subject: z.string().optional(),
    difficulty: z.string().optional(),
    cursor: z.string().min(1).optional(),
    limit: z.int().gte(1).lte(100).optional().default(20)
});
/**
 * One page.
 */
export const zListCollectionsResponse = zCollectionPageDtoOutput;
export const zGetCollectionPath = z.object({
    slug: z.string()
});
/**
 * The collection, with its modules and lessons.
 */
export const zGetCollectionResponse = zCollectionDetailDtoOutput;
/**
 * All six groups, each with its topics.
 */
export const zListTopicsResponse = zTopicsResponseDtoOutput;
export const zListLessonsQuery = z.object({
    difficulty: z.string().optional(),
    format: z.string().optional(),
    collectionSlug: z.string().min(1).max(80).optional(),
    subject: z.string().optional(),
    sceneKind: z.string().optional(),
    cursor: z.string().min(1).optional(),
    limit: z.int().gte(1).lte(100).optional().default(20)
});
/**
 * One page.
 */
export const zListLessonsResponse = zLessonPageDtoOutput;
export const zQueryLessonsBody = zLessonFilterDto;
/**
 * One page.
 */
export const zQueryLessonsResponse = zLessonPageDtoOutput;
export const zGetLessonPath = z.object({
    slug: z.string()
});
/**
 * The lesson, with every scene in placement order.
 */
export const zGetLessonResponse = zLessonDetailDtoOutput;
export const zAttentionQuery = z.object({
    bucket: z.string().optional(),
    jobId: z.string().min(1).optional(),
    limit: z.int().gte(1).lte(100).optional().default(25),
    offset: z.int().gte(0).lte(9007199254740991).optional().default(0)
});
/**
 * Counts for every bucket, and a page of the queue.
 */
export const zAttentionResponse = zAttentionQueueDtoOutput;
/**
 * Every published lesson with an unresolved scene blocker or warning.
 */
export const zQaAuditResponse = zQaAuditDtoOutput;
export const zBrowseCollectionsQuery = z.object({
    id: z.string().min(1).optional(),
    parentId: z.string().min(1).optional(),
    jobId: z.string().min(1).optional(),
    path: z.union([
        z.string(),
        z.string().min(3).max(80).regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/)
    ]).optional(),
    module: z.string().min(3).max(80).regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/).optional(),
    kind: z.string().optional(),
    subject: z.string().optional(),
    status: z.string().optional(),
    sort: z.string().optional().default('UPDATED_DESC'),
    q: z.string().min(1).max(120).optional(),
    limit: z.int().gte(1).lte(100).optional().default(25),
    offset: z.int().gte(0).lte(9007199254740991).optional().default(0)
});
/**
 * A page of collections, newest first.
 */
export const zBrowseCollectionsResponse = zBrowsedCollectionsDtoOutput;
export const zCreateCollectionBody = zCreateCollectionDto;
/**
 * The new collection.
 */
export const zCreateCollectionResponse = zWrittenDtoOutput;
export const zUpsertCollectionBody = zCreateCollectionDto;
/**
 * The collection.
 */
export const zUpsertCollectionResponse = zWrittenDtoOutput;
export const zGetAuthoringCollectionPath = z.object({
    id: z.string()
});
/**
 * The collection, its colours, and lessons another course shares.
 */
export const zGetAuthoringCollectionResponse = zAuthoringCollectionDtoOutput;
export const zUpdateCollectionBody = zUpdateCollectionDto;
export const zUpdateCollectionPath = z.object({
    id: z.string()
});
/**
 * The collection.
 */
export const zUpdateCollectionResponse = zWrittenDtoOutput;
export const zBrowseLessonsQuery = z.object({
    courseId: z.string().min(1).optional(),
    moduleId: z.union([
        z.string(),
        z.string().min(1)
    ]).optional(),
    lessonId: z.string().min(1).optional(),
    subject: z.string().optional(),
    difficulty: z.string().optional(),
    status: z.string().optional(),
    review: z.string().optional(),
    readiness: z.string().optional(),
    persona: z.string().optional(),
    tag: z.string().min(2).max(60).regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/).optional(),
    feedbackDays: z.int().gte(1).lte(365).optional(),
    sort: z.string().optional().default('CREATED_DESC'),
    q: z.string().min(1).max(120).optional(),
    limit: z.int().gte(1).lte(100).optional().default(25),
    offset: z.int().gte(0).lte(9007199254740991).optional().default(0)
});
/**
 * A page of lessons, newest first.
 */
export const zBrowseLessonsResponse = zBrowsedLessonsDtoOutput;
export const zCreateLessonBody = zCreateLessonDto;
/**
 * The new lesson.
 */
export const zCreateLessonResponse = zWrittenDtoOutput;
export const zUpsertLessonBody = zCreateLessonDto;
/**
 * The lesson.
 */
export const zUpsertLessonResponse = zWrittenDtoOutput;
/**
 * Every tag, by slug.
 */
export const zListTagsResponse = zTagListDtoOutput;
export const zArchiveLessonsBody = zArchiveLessonsDto;
/**
 * How many moved. An id that does not exist is not one of them.
 */
export const zArchiveLessonsResponse = zArchivedDtoOutput;
export const zRelabelLessonsBody = zRelabelLessonsDto;
/**
 * How many were relabelled. An id that does not exist is not one of them.
 */
export const zRelabelLessonsResponse = zRelabelledDtoOutput;
export const zCollectionLessonsPath = z.object({
    id: z.string()
});
/**
 * Lessons in placement order.
 */
export const zCollectionLessonsResponse = zCollectionLessonsDtoOutput;
export const zAppendLessonsBody = zAddLessonsDto;
export const zAppendLessonsPath = z.object({
    id: z.string()
});
/**
 * How many were new. A lesson already held is not added twice.
 */
export const zAppendLessonsResponse = zAttachedDtoOutput;
export const zPlaceLessonsBody = zMembershipsDto;
export const zPlaceLessonsPath = z.object({
    id: z.string()
});
/**
 * How many lessons the collection now holds.
 */
export const zPlaceLessonsResponse = zAttachedDtoOutput;
export const zPathModulesPath = z.object({
    id: z.string()
});
/**
 * Modules in path order, lessons in module order.
 */
export const zPathModulesResponse = zPathModulesDtoOutput;
export const zAppendModulesBody = zAddModulesDto;
export const zAppendModulesPath = z.object({
    id: z.string()
});
/**
 * How many were new. A module already held is not added twice.
 */
export const zAppendModulesResponse = zAttachedDtoOutput;
export const zPlaceModulesBody = zPlaceModulesDto;
export const zPlaceModulesPath = z.object({
    id: z.string()
});
/**
 * How many modules the path now holds.
 */
export const zPlaceModulesResponse = zAttachedDtoOutput;
export const zCollectionPublishReadinessPath = z.object({
    id: z.string()
});
/**
 * Validator issues, and the count of open reviewer blockers.
 */
export const zCollectionPublishReadinessResponse = zSubtreeReadinessDtoOutput;
export const zPublishCollectionBody = zPublishCollectionDto;
export const zPublishCollectionPath = z.object({
    id: z.string()
});
/**
 * How many rows moved.
 */
export const zPublishCollectionResponse = zPublishedDtoOutput;
export const zLessonFeedbackPath = z.object({
    id: z.string()
});
/**
 * Totals per version, newest first, and the named answers.
 */
export const zLessonFeedbackResponse = zLessonFeedbackReportDtoOutput;
export const zUpdateLessonBody = zUpdateLessonDto;
export const zUpdateLessonPath = z.object({
    id: z.string()
});
/**
 * The lesson.
 */
export const zUpdateLessonResponse = zWrittenDtoOutput;
export const zPlaceScenesBody = zPlacementsDto;
export const zPlaceScenesPath = z.object({
    id: z.string()
});
/**
 * How many scenes the lesson now has.
 */
export const zPlaceScenesResponse = zPlacedDtoOutput;
export const zReviewLessonPath = z.object({
    id: z.string()
});
/**
 * The lesson as a reviewer reads it.
 */
export const zReviewLessonResponse = zLessonReviewDtoOutput;
export const zSetLessonReviewBody = zSetReviewDto;
export const zSetLessonReviewPath = z.object({
    id: z.string()
});
/**
 * The lesson’s sources, notes and review, as they now stand.
 */
export const zSetLessonReviewResponse = zLessonResearchDtoOutput;
export const zRerollObjectPath = z.object({
    id: z.string()
});
/**
 * The object now on the lesson.
 */
export const zRerollObjectResponse = zRerolledObjectDtoOutput;
export const zLessonPublishReadinessPath = z.object({
    id: z.string()
});
/**
 * One entry per unmet rule.
 */
export const zLessonPublishReadinessResponse = zPublishReadinessDtoOutput;
export const zCreateQuestionBody = zCreateQuestionDto;
/**
 * The new question.
 */
export const zCreateQuestionResponse = zWrittenDtoOutput;
export const zUpdateQuestionBody = zUpdateQuestionDto;
export const zUpdateQuestionPath = z.object({
    id: z.string()
});
/**
 * The question.
 */
export const zUpdateQuestionResponse = zWrittenDtoOutput;
export const zCreateSourceBody = zCreateSourceDto;
/**
 * The new source.
 */
export const zCreateSourceResponse = zWrittenDtoOutput;
export const zCreateSceneBody = zCreateSceneDto;
/**
 * The new scene.
 */
export const zCreateSceneResponse = zWrittenDtoOutput;
export const zUpdateSceneBody = zUpdateSceneDto;
export const zUpdateScenePath = z.object({
    id: z.string()
});
/**
 * The scene.
 */
export const zUpdateSceneResponse = zWrittenDtoOutput;
export const zSwitchMechanicBody = zSwitchMechanicDto;
export const zSwitchMechanicPath = z.object({
    sceneId: z.string(),
    lessonId: z.string()
});
/**
 * The scene the lesson now points at — a new id if it forked.
 */
export const zSwitchMechanicResponse = zWrittenDtoOutput;
export const zLessonResearchPath = z.object({
    id: z.string()
});
/**
 * The lesson’s sources, notes and review, as they now stand.
 */
export const zLessonResearchResponse = zLessonResearchDtoOutput;
export const zAttachLessonSourceBody = zAttachSourceDto;
export const zAttachLessonSourcePath = z.object({
    id: z.string()
});
/**
 * The lesson’s sources, notes and review, as they now stand.
 */
export const zAttachLessonSourceResponse = zLessonResearchDtoOutput;
export const zDetachLessonSourcePath = z.object({
    sourceId: z.string(),
    id: z.string()
});
/**
 * The lesson’s sources, notes and review, as they now stand.
 */
export const zDetachLessonSourceResponse = zLessonResearchDtoOutput;
export const zUpdateLessonSourceNoteBody = zUpdateSourceNoteDto;
export const zUpdateLessonSourceNotePath = z.object({
    sourceId: z.string(),
    id: z.string()
});
/**
 * The lesson’s sources, notes and review, as they now stand.
 */
export const zUpdateLessonSourceNoteResponse = zLessonResearchDtoOutput;
export const zUpdateLessonNotesBody = zUpdateNotesDto;
export const zUpdateLessonNotesPath = z.object({
    id: z.string()
});
/**
 * The lesson’s sources, notes and review, as they now stand.
 */
export const zUpdateLessonNotesResponse = zLessonResearchDtoOutput;
export const zListSceneImagesPath = z.object({
    id: z.string()
});
/**
 * The versions, newest first.
 */
export const zListSceneImagesResponse = zSceneImagesDtoOutput;
export const zGenerateSceneImageBody = zGenerateSceneImageDto;
export const zGenerateSceneImagePath = z.object({
    id: z.string()
});
/**
 * The new version, with why it is refused if it is.
 */
export const zGenerateSceneImageResponse = zSceneImageVersionDtoOutput;
export const zApproveSceneImagePath = z.object({
    id: z.string()
});
/**
 * What the scene now shows.
 */
export const zApproveSceneImageResponse = zApprovedSceneImageDtoOutput;
export const zRedrawLessonPictureBody = zRedrawLessonPictureDto;
export const zRedrawLessonPicturePath = z.object({
    id: z.string()
});
/**
 * The picture is on its slot.
 */
export const zRedrawLessonPictureResponse = z.void();
export const zChooseSceneImageBody = zChooseSceneImageDto;
export const zChooseSceneImagePath = z.object({
    id: z.string()
});
/**
 * What the scene now shows.
 */
export const zChooseSceneImageResponse = zChooseSceneImageDtoOutput;
export const zGetSceneImageFilePath = z.object({
    file: z.string()
});
export const zGetSceneImageFileQuery = z.object({
    scheme: z.string().optional()
});
/**
 * The image.
 */
export const zGetSceneImageFileResponse = z.string();
export const zDrawOnboardingArtBody = zDrawOnboardingArtDto;
/**
 * The candidate, or why there is none. Nothing is stored.
 */
export const zDrawOnboardingArtResponse = zOnboardingArtCandidateDtoOutput;
export const zGetLessonCoverPath = z.object({
    slug: z.string()
});
/**
 * The picture.
 */
export const zGetLessonCoverResponse = z.string();
export const zGetPicturePath = z.object({
    id: z.string()
});
/**
 * The picture.
 */
export const zGetPictureResponse = z.string();
/**
 * All ten characters in contract order, and every prop with readiness, oldest first.
 */
export const zListCastResponse = zCastListDtoOutput;
export const zAddScenePropBody = zCreateScenePropDto;
/**
 * The prop as added.
 */
export const zAddScenePropResponse = zScenePropDtoOutput;
export const zPreviewCurriculumImportBody = zCurriculumImportDto;
/**
 * Row count, column mapping, proposed courses and modules, issues.
 */
export const zPreviewCurriculumImportResponse = zImportPreviewDtoOutput;
export const zImportCurriculumBody = zCurriculumImportDto;
/**
 * What was added, changed and skipped. Never deletes, never overwrites an admin edit, never touches app content.
 */
export const zImportCurriculumResponse = zImportResultDtoOutput;
export const zListPlannedLessonsQuery = z.object({
    q: z.string().min(1).max(120).optional(),
    courseId: z.string().min(1).optional(),
    moduleId: z.string().min(1).optional(),
    status: z.string().optional(),
    published: z.string().optional(),
    publishedFrom: z.iso.date().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))$/).optional(),
    publishedTo: z.iso.date().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))$/).optional(),
    sort: z.string().optional().default('position'),
    order: z.string().optional().default('asc'),
    limit: z.int().gte(1).lte(100).optional().default(25),
    offset: z.int().gte(0).lte(9007199254740991).optional().default(0)
});
/**
 * One page, and the total.
 */
export const zListPlannedLessonsResponse = zPlannedLessonListDtoOutput;
export const zCreatePlannedLessonBody = zCreatePlannedLessonDto;
export const zCreatePlannedLessonResponse = zPlannedLessonDtoOutput;
export const zExportPlannedLessonsQuery = z.object({
    q: z.string().min(1).max(120).optional(),
    courseId: z.string().min(1).optional(),
    moduleId: z.string().min(1).optional(),
    status: z.string().optional(),
    published: z.string().optional(),
    publishedFrom: z.iso.date().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))$/).optional(),
    publishedTo: z.iso.date().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))$/).optional(),
    sort: z.string().optional().default('position'),
    order: z.string().optional().default('asc'),
    limit: z.int().gte(1).lte(100).optional().default(25),
    offset: z.int().gte(0).lte(9007199254740991).optional().default(0),
    mode: z.string(),
    ids: z.string().min(1).optional(),
    exclude: z.string().min(1).optional()
});
/**
 * The CSV.
 */
export const zExportPlannedLessonsResponse = z.string();
export const zDeletePlannedLessonPath = z.object({
    lessonId: z.string()
});
export const zDeletePlannedLessonQuery = z.object({
    archiveDraft: z.string().optional().default('no')
});
/**
 * What was removed.
 */
export const zDeletePlannedLessonResponse = zDeletionPreviewDtoOutput;
export const zGetPlannedLessonDetailsPath = z.object({
    lessonId: z.string()
});
export const zGetPlannedLessonDetailsQuery = z.object({
    period: z.string().optional().default('all')
});
/**
 * What the Curriculum details drawer shows.
 */
export const zGetPlannedLessonDetailsResponse = zPlannedLessonDetailsDtoOutput;
export const zUpdatePlannedLessonBody = zUpdatePlannedLessonDto;
export const zUpdatePlannedLessonPath = z.object({
    lessonId: z.string()
});
export const zUpdatePlannedLessonResponse = zPlannedLessonDtoOutput;
export const zCreatePlannedCourseInAppPath = z.object({
    id: z.string()
});
/**
 * The linked course. Safe to repeat: it never makes a second one.
 */
export const zCreatePlannedCourseInAppResponse = zCreatedInAppDtoOutput;
export const zCreatePlannedModuleInAppPath = z.object({
    id: z.string()
});
/**
 * The linked module and course. Safe to repeat.
 */
export const zCreatePlannedModuleInAppResponse = zCreatedInAppDtoOutput;
export const zCreatePlannedInAppBody = zCreateInAppRequestDto;
/**
 * Each one and the collection it links to. Safe to repeat.
 */
export const zCreatePlannedInAppResponse = zCreatedInAppDtoOutput;
export const zPreflightCurriculumBuildBody = zBuildPreflightRequestDto;
/**
 * The count, the courses and modules to create, lessons already in hand, what blocks a build, and an estimate.
 */
export const zPreflightCurriculumBuildResponse = zBuildPreflightDtoOutput;
export const zBuildPlannedLessonsBody = zBuildRequestDto;
/**
 * The job. Submitting the same selection again returns the same job.
 */
export const zBuildPlannedLessonsResponse = zBuildDtoOutput;
export const zVerifyPlannedLessonsBody = zCurriculumVerifyRequestDto;
/**
 * The job, and the selected lessons left out as not built.
 */
export const zVerifyPlannedLessonsResponse = zCurriculumVerifyDtoOutput;
export const zRetryPlannedLessonBuildPath = z.object({
    lessonId: z.string()
});
/**
 * Its status now.
 */
export const zRetryPlannedLessonBuildResponse = zLessonBuildStateDtoOutput;
export const zCancelPlannedLessonBuildPath = z.object({
    lessonId: z.string()
});
/**
 * Its status now: what it was before it was queued. The job keeps the cancellation.
 */
export const zCancelPlannedLessonBuildResponse = zLessonBuildStateDtoOutput;
export const zRebuildPlannedLessonBody = zRebuildRequestDto;
export const zRebuildPlannedLessonPath = z.object({
    lessonId: z.string()
});
/**
 * The rebuild job. Asking again while it runs returns the same job. The lesson is replaced only once the job has built and reviewed it.
 */
export const zRebuildPlannedLessonResponse = zBuildDtoOutput;
export const zReviewPlannedLessonStoryBody = zStoryReviewDto;
export const zReviewPlannedLessonStoryPath = z.object({
    lessonId: z.string()
});
/**
 * The lesson now, with `storyChanged` false.
 */
export const zReviewPlannedLessonStoryResponse = zPlannedLessonDtoOutput;
export const zListPlannedLessonVersionsPath = z.object({
    lessonId: z.string()
});
/**
 * Newest first.
 */
export const zListPlannedLessonVersionsResponse = zLessonVersionsDtoOutput;
export const zRestorePlannedLessonVersionPath = z.object({
    versionId: z.string(),
    lessonId: z.string()
});
/**
 * The versions now, newest first.
 */
export const zRestorePlannedLessonVersionResponse = zLessonVersionsDtoOutput;
export const zGetPlannedLessonPlacementPath = z.object({
    lessonId: z.string()
});
/**
 * Each sync says what it would do, or why it cannot.
 */
export const zGetPlannedLessonPlacementResponse = zPlacementDtoOutput;
export const zUpdatePlanToMatchAppPath = z.object({
    lessonId: z.string()
});
/**
 * The placement after the sync. The sync is kept in history.
 */
export const zUpdatePlanToMatchAppResponse = zPlacementDtoOutput;
export const zMoveAppLessonToMatchPlanPath = z.object({
    lessonId: z.string()
});
/**
 * The placement after the sync. The sync is kept in history.
 */
export const zMoveAppLessonToMatchPlanResponse = zPlacementDtoOutput;
/**
 * Each with its app link and how it differs from it.
 */
export const zListPlannedCoursesResponse = zPlannedCourseListDtoOutput;
export const zCreatePlannedCourseBody = zCreatePlannedCourseDto;
export const zCreatePlannedCourseResponse = zPlannedCourseDtoOutput;
export const zDeletePlannedCoursePath = z.object({
    id: z.string()
});
/**
 * What was removed.
 */
export const zDeletePlannedCourseResponse = zDeletionPreviewDtoOutput;
export const zUpdatePlannedCourseBody = zUpdatePlannedCourseDto;
export const zUpdatePlannedCoursePath = z.object({
    id: z.string()
});
export const zUpdatePlannedCourseResponse = zPlannedCourseDtoOutput;
export const zPreviewPlannedCourseDeletionPath = z.object({
    id: z.string()
});
export const zPreviewPlannedCourseDeletionResponse = zDeletionPreviewDtoOutput;
export const zCreatePlannedModuleBody = zCreatePlannedModuleDto;
export const zCreatePlannedModuleResponse = zPlannedModuleDtoOutput;
export const zDeletePlannedModulePath = z.object({
    id: z.string()
});
/**
 * What was removed.
 */
export const zDeletePlannedModuleResponse = zDeletionPreviewDtoOutput;
export const zUpdatePlannedModuleBody = zUpdatePlannedModuleDto;
export const zUpdatePlannedModulePath = z.object({
    id: z.string()
});
export const zUpdatePlannedModuleResponse = zPlannedModuleDtoOutput;
export const zGetPlannedModuleStoryPath = z.object({
    id: z.string()
});
export const zGetPlannedModuleStoryResponse = zPlannedModuleStoryDtoOutput;
export const zNextPlannedLessonIdPath = z.object({
    id: z.string()
});
export const zNextPlannedLessonIdResponse = zNextLessonIdDtoOutput;
export const zPreviewPlannedModuleDeletionPath = z.object({
    id: z.string()
});
export const zPreviewPlannedModuleDeletionResponse = zDeletionPreviewDtoOutput;
export const zApplyPlanningProposalsBody = zApplyPlanningProposalsDto;
export const zApplyPlanningProposalsResponse = zAppliedProposalsDtoOutput;
export const zApplyStoryProposalBody = zApplyStoryProposalDto;
export const zApplyStoryProposalResponse = zPlannedModuleStoryDtoOutput;
export const zPreviewPlannedLessonDeletionPath = z.object({
    lessonId: z.string()
});
export const zPreviewPlannedLessonDeletionResponse = zDeletionPreviewDtoOutput;
export const zPreviewCurriculumDatasetDeletionResponse = zDeletionPreviewDtoOutput;
/**
 * What was removed.
 */
export const zDeleteCurriculumDatasetResponse = zDeletionPreviewDtoOutput;
export const zListPlanningRevisionsQuery = z.object({
    entity: z.string().optional(),
    entityId: z.string().min(1).optional(),
    lessonId: z.string().min(1).optional(),
    limit: z.int().gte(1).lte(100).optional().default(50),
    offset: z.int().gte(0).lte(9007199254740991).optional().default(0)
});
export const zListPlanningRevisionsResponse = zPlanningRevisionListDtoOutput;
export const zRevertPlanningRevisionPath = z.object({
    id: z.string()
});
export const zRevertPlanningRevisionResponse = zRevertResultDtoOutput;
export const zListModuleRenamesResponse = zModuleRenameListDtoOutput;
export const zUpdateModuleRenameBody = zUpdateRenameDto;
export const zUpdateModuleRenamePath = z.object({
    id: z.string()
});
export const zUpdateModuleRenameResponse = zModuleRenameListDtoOutput;
export const zApplyModuleRenamesResponse = zApplyRenamesResultDtoOutput;
export const zApplyModuleRenamePath = z.object({
    id: z.string()
});
export const zApplyModuleRenameResponse = zApplyRenamesResultDtoOutput;
export const zListLessonRenamesResponse = zLessonRenameListDtoOutput;
export const zUpdateLessonRenameBody = zUpdateRenameDto;
export const zUpdateLessonRenamePath = z.object({
    id: z.string()
});
export const zUpdateLessonRenameResponse = zLessonRenameListDtoOutput;
export const zApplyLessonRenamesResponse = zApplyRenamesResultDtoOutput;
export const zApplyLessonRenamePath = z.object({
    id: z.string()
});
export const zApplyLessonRenameResponse = zApplyRenamesResultDtoOutput;
export const zAskCurriculumBody = zAskCurriculumDto;
/**
 * The answer, its scope and coverage, the Lesson IDs it names, and its proposals.
 */
export const zAskCurriculumResponse = zCurriculumAnswerDtoOutput;
export const zDescribePlanningScopeBody = zDescribePlanningScopeDto;
/**
 * The scope in words, its counts, and its first lessons.
 */
export const zDescribePlanningScopeResponse = zPlanningScopeSummaryDtoOutput;
export const zFixModuleBody = zFixModuleDto;
export const zFixModulePath = z.object({
    id: z.string()
});
/**
 * A recast to apply at /curriculum/recasts/:id/apply, or a story to apply at /curriculum/proposals/apply-story.
 */
export const zFixModuleResponse = zModuleFixDtoOutput;
export const zRequestRecastBody = zRequestRecastDto;
export const zRequestRecastPath = z.object({
    id: z.string()
});
/**
 * PROPOSED, with every lesson and scene it would change. Replaces any earlier proposal.
 */
export const zRequestRecastResponse = zRecastDtoOutput;
export const zApplyRecastPath = z.object({
    id: z.string()
});
/**
 * APPLIED.
 */
export const zApplyRecastResponse = zRecastDtoOutput;
export const zDiscardRecastPath = z.object({
    id: z.string()
});
/**
 * DISCARDED.
 */
export const zDiscardRecastResponse = zRecastDtoOutput;
/**
 * The caller.
 */
export const zGetMeResponse = zMeResponseDto;
export const zGetHomeQuery = z.object({
    utcOffsetMinutes: z.int().gte(-720).lte(840).optional().default(0)
});
/**
 * Everything Home shows. Every learner gets a `journey` and a `next` while one is unfinished; `nextUp` offers an untouched path once it is done. `journey` is absent only when no path is published and the learner has started nothing.
 */
export const zGetHomeResponse = zHomeResponseDtoOutput;
export const zGetBadgesQuery = z.object({
    utcOffsetMinutes: z.int().gte(-720).lte(840).optional().default(0)
});
/**
 * The whole catalogue in order. A learner with no attempts gets every badge locked, and zeroes above them.
 */
export const zGetBadgesResponse = zBadgeWallDtoOutput;
export const zDropMyStreakGoalQuery = z.object({
    utcOffsetMinutes: z.int().gte(-720).lte(840).optional().default(0)
});
/**
 * The goal, its progress, the freezes held and the unseen events.
 */
export const zDropMyStreakGoalResponse = zStreakGoalStateDtoOutput;
export const zGetMyStreakGoalQuery = z.object({
    utcOffsetMinutes: z.int().gte(-720).lte(840).optional().default(0)
});
/**
 * The goal, its progress, the freezes held and the unseen events.
 */
export const zGetMyStreakGoalResponse = zStreakGoalStateDtoOutput;
export const zSwitchMyStreakGoalBody = zSetStreakGoalDto;
export const zSwitchMyStreakGoalQuery = z.object({
    utcOffsetMinutes: z.int().gte(-720).lte(840).optional().default(0)
});
/**
 * The goal, its progress, the freezes held and the unseen events.
 */
export const zSwitchMyStreakGoalResponse = zStreakGoalStateDtoOutput;
export const zSetMyStreakGoalBody = zSetStreakGoalDto;
export const zSetMyStreakGoalQuery = z.object({
    utcOffsetMinutes: z.int().gte(-720).lte(840).optional().default(0)
});
/**
 * The goal, its progress, the freezes held and the unseen events.
 */
export const zSetMyStreakGoalResponse = zStreakGoalStateDtoOutput;
export const zMarkMyStreakEventsSeenBody = zStreakEventsSeenDto;
export const zMarkMyStreakEventsSeenQuery = z.object({
    utcOffsetMinutes: z.int().gte(-720).lte(840).optional().default(0)
});
/**
 * The goal, its progress, the freezes held and the unseen events.
 */
export const zMarkMyStreakEventsSeenResponse = zStreakGoalStateDtoOutput;
export const zGetExploreQuery = z.object({
    utcOffsetMinutes: z.int().gte(-720).lte(840).optional().default(0)
});
/**
 * Both tabs. `resume` is absent for a learner with nothing in progress.
 */
export const zGetExploreResponse = zExploreResponseDtoOutput;
export const zGetCollectionProgressPath = z.object({
    slug: z.string()
});
/**
 * `standing` is absent until the learner has touched a lesson in it.
 */
export const zGetCollectionProgressResponse = zCollectionProgressDtoOutput;
/**
 * Readiness follows published content; nothing to keep in step.
 */
export const zGetOnboardingOptionsResponse = zOnboardingOptionsDtoOutput;
export const zPlanOnboardingBody = zOnboardingAnswersDto;
/**
 * Nothing is stored.
 */
export const zPlanOnboardingResponse = zOnboardingDtoOutput;
export const zGradeFirstChallengeBody = zChallengeAnswerDto;
export const zGradeFirstChallengePath = z.object({
    slug: z.string()
});
/**
 * Nothing is stored; sign-in records the run.
 */
export const zGradeFirstChallengeResponse = zChallengeVerdictDtoOutput;
export const zReportOnboardingEventBody = zOnboardingEventDto;
/**
 * The saved answers.
 */
export const zGetMyOnboardingResponse = zOnboardingDtoOutput;
export const zSaveMyOnboardingBody = zOnboardingAnswersDto;
/**
 * The answers as saved. Progress is untouched.
 */
export const zSaveMyOnboardingResponse = zOnboardingDtoOutput;
/**
 * In screen order.
 */
export const zGetOnboardingCopyCatalogResponse = zOnboardingCopyCatalogDtoOutput;
/**
 * Newest first.
 */
export const zListOnboardingConfigsResponse = zOnboardingConfigsDtoOutput;
export const zSaveOnboardingConfigDraftBody = zOnboardingConfigDto;
/**
 * The draft.
 */
export const zSaveOnboardingConfigDraftResponse = zOnboardingConfigVersionDtoOutput;
/**
 * The newly live version.
 */
export const zPublishOnboardingConfigResponse = zOnboardingConfigVersionDtoOutput;
export const zRestoreOnboardingConfigBody = zRestoreOnboardingConfigDto;
/**
 * The copy, now live.
 */
export const zRestoreOnboardingConfigResponse = zOnboardingConfigVersionDtoOutput;
export const zStartAttemptPath = z.object({
    slug: z.string()
});
/**
 * The new attempt.
 */
export const zStartAttemptResponse = zStartAttemptDtoOutput;
export const zLessonResumePath = z.object({
    slug: z.string()
});
/**
 * The resume point, or nothing to resume.
 */
export const zLessonResumeResponse = zLessonResumeDtoOutput;
export const zAttemptLessonPath = z.object({
    id: z.string()
});
/**
 * The lesson the attempt plays.
 */
export const zAttemptLessonResponse = zLessonDetailDtoOutput;
export const zAnswerSceneBody = zSubmitAnswerDto;
export const zAnswerScenePath = z.object({
    id: z.string()
});
/**
 * The verdict, with the explanation.
 */
export const zAnswerSceneResponse = zVerdictDtoOutput;
export const zReachSceneBody = zReachSceneDto;
export const zReachScenePath = z.object({
    id: z.string()
});
/**
 * The furthest scene the run has opened.
 */
export const zReachSceneResponse = zAttemptPositionDtoOutput;
export const zCompleteAttemptBody = zCompleteAttemptDto;
export const zCompleteAttemptPath = z.object({
    id: z.string()
});
/**
 * The finished attempt.
 */
export const zCompleteAttemptResponse = zAttemptResultDtoOutput;
export const zSubmitLessonFeedbackBody = zSubmitLessonFeedbackDto;
export const zSubmitLessonFeedbackPath = z.object({
    id: z.string()
});
/**
 * The answer as it now stands.
 */
export const zSubmitLessonFeedbackResponse = zLessonFeedbackDtoOutput;
export const zForgetScenePath = z.object({
    sceneId: z.string(),
    slug: z.string()
});
/**
 * The scene is not saved.
 */
export const zForgetSceneResponse = z.void();
export const zSaveScenePath = z.object({
    sceneId: z.string(),
    slug: z.string()
});
/**
 * The bookmark, as it now stands.
 */
export const zSaveSceneResponse = zSceneBookmarkDtoOutput;
export const zListLessonBookmarksPath = z.object({
    slug: z.string()
});
/**
 * The saved scene ids, unordered.
 */
export const zListLessonBookmarksResponse = zLessonBookmarksDtoOutput;
export const zListSavedScenesQuery = z.object({
    cursor: z.string().min(1).optional(),
    limit: z.int().gte(1).lte(100).optional().default(20)
});
/**
 * One page.
 */
export const zListSavedScenesResponse = zSavedScenesDtoOutput;
export const zReportSceneBody = zCreateSceneReportDto;
export const zReportScenePath = z.object({
    sceneId: z.string(),
    slug: z.string()
});
/**
 * The report, filed.
 */
export const zReportSceneResponse = zSceneReportDtoOutput;
export const zForgetTermPath = z.object({
    term: z.string(),
    slug: z.string()
});
/**
 * The term is not saved.
 */
export const zForgetTermResponse = z.void();
export const zSaveTermPath = z.object({
    term: z.string(),
    slug: z.string()
});
/**
 * The saved term, with its definition and lesson links.
 */
export const zSaveTermResponse = zSavedTermDtoOutput;
export const zListLessonSavedTermsPath = z.object({
    slug: z.string()
});
/**
 * The saved terms, unordered.
 */
export const zListLessonSavedTermsResponse = zLessonSavedTermsDtoOutput;
export const zListSavedTermsQuery = z.object({
    cursor: z.string().min(1).optional(),
    limit: z.int().gte(1).lte(100).optional().default(20)
});
/**
 * One page.
 */
export const zListSavedTermsResponse = zSavedTermsDtoOutput;
export const zGetLessonSharePath = z.object({
    slug: z.string()
});
/**
 * The preview.
 */
export const zGetLessonShareResponse = zShareItemDtoOutput;
export const zGetCollectionSharePath = z.object({
    slug: z.string()
});
/**
 * The preview.
 */
export const zGetCollectionShareResponse = zShareItemDtoOutput;
export const zGetShortSharePath = z.object({
    id: z.string()
});
/**
 * The preview.
 */
export const zGetShortShareResponse = zShareItemDtoOutput;
export const zSharedScorePath = z.object({
    token: z.string()
});
/**
 * The score.
 */
export const zSharedScoreResponse = zSharedScoreDtoOutput;
export const zSharedScoreImagePath = z.object({
    token: z.string()
});
/**
 * The image.
 */
export const zSharedScoreImageResponse = z.string();
export const zShareAttemptPath = z.object({
    id: z.string()
});
/**
 * The token.
 */
export const zShareAttemptResponse = zScoreShareDtoOutput;
export const zSharePathPath = z.object({
    slug: z.string()
});
/**
 * The token.
 */
export const zSharePathResponse = zScoreShareDtoOutput;
export const zGetShortsQuery = z.object({
    cursor: z.string().min(1).optional(),
    limit: z.int().gte(1).lte(100).optional().default(20)
});
/**
 * One page. `nextCursor` is null once nothing unseen is left.
 */
export const zGetShortsResponse = zShortsPageDtoOutput;
export const zMarkShortSeenBody = zMarkShortSeenDto;
export const zMarkShortSeenPath = z.object({
    id: z.string()
});
/**
 * Recorded, or already recorded today.
 */
export const zMarkShortSeenResponse = z.void();
export const zFileSupportRequestBody = zCreateSupportRequestDto;
/**
 * The request, filed.
 */
export const zFileSupportRequestResponse = zSupportRequestDtoOutput;
export const zListScenariosQuery = z.object({
    topic: z.string().optional()
});
/**
 * The picker.
 */
export const zListScenariosResponse = zTrainListDtoOutput;
export const zGetScenarioPath = z.object({
    slug: z.string()
});
/**
 * The whole script.
 */
export const zGetScenarioResponse = zTrainScenarioDtoOutput;
/**
 * The roster.
 */
export const zListTrainCounterpartsResponse = zTrainCounterpartListDtoOutput;
/**
 * The starting scenarios.
 */
export const zListTrainStartersResponse = zTrainStarterListDtoOutput;
export const zSuggestTrainSetupBody = zTrainSuggestRequestDto;
/**
 * A filled, editable setup.
 */
export const zSuggestTrainSetupResponse = zTrainSuggestionDtoOutput;
export const zPrepareTrainBriefBody = zTrainSetupRequestDto;
/**
 * The brief, or a focused question.
 */
export const zPrepareTrainBriefResponse = zTrainBriefResultDtoOutput;
/**
 * Newest first.
 */
export const zListTrainSessionsResponse = zTrainSessionListDtoOutput;
export const zStartTrainSessionBody = zTrainSessionStartDto;
/**
 * The session, opening on the counterpart’s line, and the allowance left.
 */
export const zStartTrainSessionResponse = zTrainSessionStartedDtoOutput;
export const zDeleteTrainSessionPath = z.object({
    id: z.string()
});
/**
 * The session is gone.
 */
export const zDeleteTrainSessionResponse = z.void();
export const zGetTrainSessionPath = z.object({
    id: z.string()
});
/**
 * The session.
 */
export const zGetTrainSessionResponse = zTrainSessionDtoOutput;
export const zPostTrainTurnBody = zTrainTurnPostDto;
export const zPostTrainTurnPath = z.object({
    id: z.string()
});
/**
 * The counterpart’s answer and the replies left.
 */
export const zPostTrainTurnResponse = zTrainTurnResultDtoOutput;
export const zAskTrainHelpBody = zTrainHelpPostDto;
export const zAskTrainHelpPath = z.object({
    id: z.string()
});
/**
 * LEO’s hint or example.
 */
export const zAskTrainHelpResponse = zTrainHelpDtoOutput;
export const zEndTrainSessionPath = z.object({
    id: z.string()
});
/**
 * The ended session with its debrief.
 */
export const zEndTrainSessionResponse = zTrainSessionDtoOutput;
export const zSaveTrainTakeawayBody = zTrainTakeawayPutDto;
export const zSaveTrainTakeawayPath = z.object({
    id: z.string()
});
/**
 * The session, with the takeaway.
 */
export const zSaveTrainTakeawayResponse = zTrainSessionDtoOutput;
export const zProposeTrainTwistPath = z.object({
    id: z.string()
});
/**
 * The proposed change and the setup it makes.
 */
export const zProposeTrainTwistResponse = zTrainTwistDtoOutput;
export const zRetryTrainSessionBody = zTrainRetryPostDto;
export const zRetryTrainSessionPath = z.object({
    id: z.string()
});
/**
 * The new attempt, whether it was free, and the allowance left.
 */
export const zRetryTrainSessionResponse = zTrainRetryStartedDtoOutput;
export const zTranscribeTrainClipBody = zTranscribeRequestDto;
export const zTranscribeTrainClipPath = z.object({
    id: z.string()
});
/**
 * What the learner said.
 */
export const zTranscribeTrainClipResponse = zTranscriptDtoOutput;
export const zSpeakTrainLinePath = z.object({
    line: z.string(),
    id: z.string()
});
/**
 * The line spoken aloud.
 */
export const zSpeakTrainLineResponse = zSpokenLineDtoOutput;
/**
 * The caller’s allowance for the current UTC day.
 */
export const zGetAiAllowanceResponse = zAllowanceDtoOutput;
export const zSearchEvidenceBody = zSearchEvidenceDto;
/**
 * Ranked passages, best first. Empty when no published lesson covers the question.
 */
export const zSearchEvidenceResponse = zEvidenceResultDtoOutput;
export const zAskSuggestionsPath = z.object({
    sceneId: z.string(),
    slug: z.string()
});
export const zAskSuggestionsQuery = z.object({
    attemptId: z.string().min(1).optional()
});
/**
 * Up to three questions, and whether the learner has decided.
 */
export const zAskSuggestionsResponse = zAskSuggestionsDtoOutput;
export const zAskTutorBody = zAskTutorDto;
export const zAskTutorPath = z.object({
    sceneId: z.string(),
    slug: z.string()
});
/**
 * A short answer grounded in the scene.
 */
export const zAskTutorResponse = zTutorAnswerDtoOutput;
/**
 * Newest first.
 */
export const zListConsultantThreadsResponse = zConsultantThreadListDtoOutput;
export const zStartConsultantThreadBody = zConsultantPostDto;
/**
 * A clarifying question or a grounded answer, and the allowance left.
 */
export const zStartConsultantThreadResponse = zConsultantTurnDtoOutput;
export const zGetConsultantThreadPath = z.object({
    id: z.string()
});
/**
 * The thread and every exchange in it.
 */
export const zGetConsultantThreadResponse = zConsultantThreadDtoOutput;
export const zPostConsultantMessageBody = zConsultantPostDto;
export const zPostConsultantMessagePath = z.object({
    id: z.string()
});
/**
 * A clarifying question or a grounded answer, and the allowance left.
 */
export const zPostConsultantMessageResponse = zConsultantTurnDtoOutput;
export const zTranscribeConsultantClipBody = zTranscribeRequestDto;
/**
 * What the user said.
 */
export const zTranscribeConsultantClipResponse = zTranscriptDtoOutput;
export const zReportFramesBody = zFrameReportDto;
/**
 * How many of the submitted samples were recorded.
 */
export const zReportFramesResponse = zFrameReportAcceptedDto;
//# sourceMappingURL=zod.gen.js.map